
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2TweP", function(module, exports) {
/**
 * @generated SignedSource<<e1336375a91dae0f0d03c0e9ef41f3de>>
 * @relayHash 5d42554987a7deb7d918e30e0c782f3d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6ff16a4a9a4ee0c23a78cff28ab639a88978f4bf29a6d1536290b0ed4211323b
const $4f8f3df3514c68cc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "doPublish"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "suppressDraftPropertyUpdate"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "doPublish",
                    "variableName": "doPublish"
                },
                {
                    "kind": "Variable",
                    "name": "suppressDraftPropertyUpdate",
                    "variableName": "suppressDraftPropertyUpdate"
                }
            ],
            "kind": "ScalarField",
            "name": "removeContentState"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorContentStateComponentRemoveContentStateAndPublishMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorContentStateComponentRemoveContentStateAndPublishMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5d42554987a7deb7d918e30e0c782f3d",
            "id": "6ff16a4a9a4ee0c23a78cff28ab639a88978f4bf29a6d1536290b0ed4211323b",
            "metadata": {},
            "name": "EditorContentStateComponentRemoveContentStateAndPublishMutation",
            "operationKind": "mutation",
            "text": "mutation EditorContentStateComponentRemoveContentStateAndPublishMutation($contentId:ID!,$doPublish:Boolean,$suppressDraftPropertyUpdate:Boolean){removeContentState(contentId:$contentId,doPublish:$doPublish,suppressDraftPropertyUpdate:$suppressDraftPropertyUpdate)}"
        }
    };
}();
$4f8f3df3514c68cc$var$node.hash = "026930d5205574a785b2cb15e054e188";
var $4f8f3df3514c68cc$export$2e2bcd8739ae039 = $4f8f3df3514c68cc$var$node;


/**
 * @generated SignedSource<<56065f84f02f59da45589d42de536202>>
 * @relayHash 00432588237c35020eabadd88a19f1e9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 389b5f223a40ee0ff7e763305001da55ecad5e2e73dacfaf2a80a389635ad5c5
const $6e181beeac9c50b9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStateInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "suppressDraftPropertyUpdate"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentState",
                    "variableName": "contentStateInput"
                },
                {
                    "kind": "Variable",
                    "name": "suppressDraftPropertyUpdate",
                    "variableName": "suppressDraftPropertyUpdate"
                }
            ],
            "concreteType": "ContentState",
            "kind": "LinkedField",
            "name": "setContentStateAndPublish",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "color"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "restrictionLevel"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EditorContentStateComponentSetContentStateAndPublishMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EditorContentStateComponentSetContentStateAndPublishMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "00432588237c35020eabadd88a19f1e9",
            "id": "389b5f223a40ee0ff7e763305001da55ecad5e2e73dacfaf2a80a389635ad5c5",
            "metadata": {},
            "name": "EditorContentStateComponentSetContentStateAndPublishMutation",
            "operationKind": "mutation",
            "text": "mutation EditorContentStateComponentSetContentStateAndPublishMutation($contentId:ID!,$contentStateInput:ContentStateInput!,$suppressDraftPropertyUpdate:Boolean,$cloudId:ID!){setContentStateAndPublish(cloudId:$cloudId,contentId:$contentId,contentState:$contentStateInput,suppressDraftPropertyUpdate:$suppressDraftPropertyUpdate){name,color,id,restrictionLevel}}"
        }
    };
}();
$6e181beeac9c50b9$var$node.hash = "ceadf0b25d9333173e88de88519cfc8d";
var $6e181beeac9c50b9$export$2e2bcd8739ae039 = $6e181beeac9c50b9$var$node;


/**
 * @generated SignedSource<<8b488c5bb334f76db16b5b0b46b0d57e>>
 * @relayHash 8b64e3d6c365d87fa02a5d512eef63c1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d2f9a26a26830510346719b87b110bfb2dea343e96245b8c57eb7798ba510c50
const $1e808122b7ef428d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStateId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentStateId",
                    "variableName": "contentStateId"
                }
            ],
            "concreteType": "ConfluenceDisableCustomContentStatePayload",
            "kind": "LinkedField",
            "name": "confluence_disableCustomContentState",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorContentStateComponentDisableCustomContentStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorContentStateComponentDisableCustomContentStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8b64e3d6c365d87fa02a5d512eef63c1",
            "id": "d2f9a26a26830510346719b87b110bfb2dea343e96245b8c57eb7798ba510c50",
            "metadata": {},
            "name": "EditorContentStateComponentDisableCustomContentStateMutation",
            "operationKind": "mutation",
            "text": "mutation EditorContentStateComponentDisableCustomContentStateMutation($cloudId:ID!,$contentStateId:ID!){confluence_disableCustomContentState(cloudId:$cloudId,contentStateId:$contentStateId){success,errors{message}}}"
        }
    };
}();
$1e808122b7ef428d$var$node.hash = "d551accdb1f708ca5aa4d407b67ebc48";
var $1e808122b7ef428d$export$2e2bcd8739ae039 = $1e808122b7ef428d$var$node;


/**
 * @generated SignedSource<<d5ee72efb2f7053115a7a845a2b321d3>>
 * @relayHash 21160f4c08969a5c7a1dd4965219e591
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ffc88b0828b5ecff8c5d4370181b8f3911e255debdd1d51343da5a90c2c445b9
const $428215775b659cb2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStateInput"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentState",
                    "variableName": "contentStateInput"
                }
            ],
            "concreteType": "ContentState",
            "kind": "LinkedField",
            "name": "setContentState",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "color"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "restrictionLevel"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorContentStateComponentSetContentStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorContentStateComponentSetContentStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "21160f4c08969a5c7a1dd4965219e591",
            "id": "ffc88b0828b5ecff8c5d4370181b8f3911e255debdd1d51343da5a90c2c445b9",
            "metadata": {},
            "name": "EditorContentStateComponentSetContentStateMutation",
            "operationKind": "mutation",
            "text": "mutation EditorContentStateComponentSetContentStateMutation($contentId:ID!,$contentStateInput:ContentStateInput!){setContentState(contentId:$contentId,contentState:$contentStateInput){name,color,id,restrictionLevel}}"
        }
    };
}();
$428215775b659cb2$var$node.hash = "60cf99b28a7e5ae862709c088b41effb";
var $428215775b659cb2$export$2e2bcd8739ae039 = $428215775b659cb2$var$node;


/**
 * @generated SignedSource<<edb34cc521024bb2ec4c8ac6862669dc>>
 * @relayHash 370782061cad5b018a7abb99340247cc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5de0f70aba791c6859f3a88d7e11961699651b6e643b08c9b5dd24567157c729
const $da22f1c63dfdcbcc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "kind": "ScalarField",
            "name": "removeContentState"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorContentStateComponentRemoveContentStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorContentStateComponentRemoveContentStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "370782061cad5b018a7abb99340247cc",
            "id": "5de0f70aba791c6859f3a88d7e11961699651b6e643b08c9b5dd24567157c729",
            "metadata": {},
            "name": "EditorContentStateComponentRemoveContentStateMutation",
            "operationKind": "mutation",
            "text": "mutation EditorContentStateComponentRemoveContentStateMutation($contentId:ID!){removeContentState(contentId:$contentId)}"
        }
    };
}();
$da22f1c63dfdcbcc$var$node.hash = "239fd93c05e6cc0bc826fd776d1a8efd";
var $da22f1c63dfdcbcc$export$2e2bcd8739ae039 = $da22f1c63dfdcbcc$var$node;



var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4n1IT = parcelRequire("4n1IT");


var $9DHhW = parcelRequire("9DHhW");


var $jp2Q3 = parcelRequire("jp2Q3");


var $7aRa9 = parcelRequire("7aRa9");


var $laFNM = parcelRequire("laFNM");


var $2QUbq = parcelRequire("2QUbq");


var $bc1oR = parcelRequire("bc1oR");


var $dNj8O = parcelRequire("dNj8O");


var $jmjWc = parcelRequire("jmjWc");


const $b4b201f77954c660$export$64f482d2cfabd4a = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "h7-4D",
    name: "ApprovalActionConfirmationModal",
    loader: async ()=>(await (parcelRequire("eLZIq"))).ApprovalActionConfirmationModal
});






const $b9e4b1108156656e$export$e3890091771f43d6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5zzIF",
    name: "ChangeStatusAndCancelApprovalModal",
    loader: async ()=>(await (parcelRequire("APlbQ"))).ChangeStatusAndCancelApprovalModal
});






const $5fbc7aa463b11615$export$666ae2a1d01b224a = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "gU_WY",
    name: "CancelApprovalModal",
    loader: async ()=>(await (parcelRequire("de8MJ"))).CancelApprovalModal
});



var $3jwuS = parcelRequire("3jwuS");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $308Wd = parcelRequire("308Wd");


var $7Sm4c = parcelRequire("7Sm4c");


var $1vpkQ = parcelRequire("1vpkQ");


var $bTNHJ = parcelRequire("bTNHJ");


var $62JnS = parcelRequire("62JnS");


var $jln20 = parcelRequire("jln20");


var $bQm3c = parcelRequire("bQm3c");


var $8Lx5S = parcelRequire("8Lx5S");


var $e4o8D = parcelRequire("e4o8D");


var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<2eb7280a2b2c3281ce252223bc81fbad>>
 * @relayHash f27419cc2a41803e37b81fbaa9e240db
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f85fe9fd52a5b3bd2cfe98ec4942522a0d6ec515fc73a02aec597a4ccb039edf
const $e0338e3998362f07$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v3 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useUserProfileDataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedPersonList",
                    "kind": "LinkedField",
                    "name": "confluenceUsers",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useUserProfileDataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedPersonList",
                    "kind": "LinkedField",
                    "name": "confluenceUsers",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f27419cc2a41803e37b81fbaa9e240db",
            "id": "f85fe9fd52a5b3bd2cfe98ec4942522a0d6ec515fc73a02aec597a4ccb039edf",
            "metadata": {},
            "name": "useUserProfileDataQuery",
            "operationKind": "query",
            "text": "query useUserProfileDataQuery($accountIds:[String]){confluenceUsers(accountIds:$accountIds){nodes{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}"
        }
    };
}();
$e0338e3998362f07$var$node.hash = "b2eb262782f15f63fa811f144e86e487";
var $e0338e3998362f07$export$2e2bcd8739ae039 = $e0338e3998362f07$var$node;



var $jMyy4 = parcelRequire("jMyy4");

const $1b65ee0f5f746ca1$export$54fd6c163aea68e2 = (accountId)=>{
    const $ = (0, $bDgLe.c)(12);
    let t0;
    if ($[0] !== accountId) {
        t0 = {
            accountIds: accountId ? [
                accountId
            ] : []
        };
        $[0] = accountId;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !accountId;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $e0338e3998362f07$export$2e2bcd8739ae039), {
        ...t2,
        __callerPackage__: "content-state"
    });
    const userNode = data?.confluenceUsers?.nodes?.[0];
    let updatedBy;
    if (userNode && userNode.displayName) {
        const accountIdValue = userNode.accountId;
        if (accountIdValue) {
            const t3 = userNode.profilePicture?.path;
            let t4;
            if ($[5] !== accountIdValue || $[6] !== t3 || $[7] !== userNode.displayName) {
                t4 = {
                    displayName: userNode.displayName,
                    avatarUrl: t3,
                    userId: accountIdValue
                };
                $[5] = accountIdValue;
                $[6] = t3;
                $[7] = userNode.displayName;
                $[8] = t4;
            } else t4 = $[8];
            updatedBy = t4;
        }
    }
    let t3;
    if ($[9] !== loading || $[10] !== updatedBy) {
        t3 = {
            updatedBy: updatedBy,
            loading: loading
        };
        $[9] = loading;
        $[10] = updatedBy;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
};



var $8miSe = parcelRequire("8miSe");











var $ad7Ou = parcelRequire("ad7Ou");


var $I7hWB = parcelRequire("I7hWB");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");











var $lCTy3 = parcelRequire("lCTy3");











var $hBYtq = parcelRequire("hBYtq");

const $3880951f7018d493$var$styles = {
    wrapper: "_39xV02wBC3 _0KLXruoI2d _2OUyjtGk8v",
    changeBtn: "_4FKVYE5zaO _23rrnHyKLB _39xV02N91d _0KLXru66of _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _4GgNws8fU6 _3kIZMx8fU6 _2fwxA5ecOK _34b3D2Ll21 _1eOmH6o126"
};
const $3880951f7018d493$var$i18n = (0, $kSwu1.defineMessages)({
    changeStatus: {
        id: "content-state.popup-base.change-status",
        defaultMessage: "Change status"
    }
});
const $3880951f7018d493$export$7f90d9bc9f9f2bd4 = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, footer: footer, rootRef: rootRef } = t0;
    let t1;
    if ($[0] !== children || $[1] !== footer || $[2] !== rootRef) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            ref: rootRef,
            xcss: $3880951f7018d493$var$styles.wrapper,
            space: "space.050"
        }, children, footer);
        $[0] = children;
        $[1] = footer;
        $[2] = rootRef;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
const $3880951f7018d493$export$4ea950e74969538a = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { onClick: onClick, children: children, testId: testId } = t0;
    let t1;
    if ($[0] !== children || $[1] !== onClick || $[2] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $3880951f7018d493$var$styles.changeBtn,
            onClick: onClick,
            testId: testId
        }, children);
        $[0] = children;
        $[1] = onClick;
        $[2] = testId;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
const $3880951f7018d493$export$1d5dafbf93c17eee = (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { onClick: onClick, label: label } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage || $[1] !== label) {
        t1 = label ?? formatMessage($3880951f7018d493$var$i18n.changeStatus);
        $[0] = formatMessage;
        $[1] = label;
        $[2] = t1;
    } else t1 = $[2];
    const buttonLabel = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))), {
            label: ""
        });
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== buttonLabel) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "medium"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, t2, buttonLabel));
        $[4] = buttonLabel;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== onClick || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3880951f7018d493$export$4ea950e74969538a, {
            onClick: onClick,
            testId: "change-status-footer-button"
        }, t3);
        $[6] = onClick;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
};


const $32917b1aa1050d52$var$styles = {
    body: "_4FKVYE5zaO",
    footer: "_2Y7lL45zaO _0xmtko5zaO"
};
const $32917b1aa1050d52$var$i18n = (0, $kSwu1.defineMessages)({
    title: {
        id: "content-state.contentStateInfoPopup.live-doc-start-approval-popup.title",
        defaultMessage: "Approvals are not available on live docs"
    },
    body: {
        id: "content-state.contentStateInfoPopup.live-doc-start-approval-popup.body",
        defaultMessage: "Convert this live doc to a page to start an approval."
    },
    back: {
        id: "content-state.contentStateInfoPopup.live-doc-start-approval-popup.back",
        defaultMessage: "Back"
    },
    cta: {
        id: "content-state.contentStateInfoPopup.live-doc-start-approval-popup.cta",
        defaultMessage: "Convert to page"
    }
});
const $32917b1aa1050d52$export$85a25e99367817c8 = (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { onBack: onBack, onConvertToPage: onConvertToPage } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($32917b1aa1050d52$var$i18n.back);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== onBack || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: onBack
        }, t1);
        $[2] = onBack;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== formatMessage) {
        t3 = formatMessage($32917b1aa1050d52$var$i18n.cta);
        $[5] = formatMessage;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== onConvertToPage || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onConvertToPage
        }, t3);
        $[7] = onConvertToPage;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== t2 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            testId: "live-doc-start-approval-popup-footer",
            xcss: $32917b1aa1050d52$var$styles.footer,
            alignInline: "end",
            space: "space.100"
        }, t2, t4);
        $[10] = t2;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== formatMessage) {
        t6 = formatMessage($32917b1aa1050d52$var$i18n.title);
        $[13] = formatMessage;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "xsmall"
        }, t6);
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== formatMessage) {
        t8 = formatMessage($32917b1aa1050d52$var$i18n.body);
        $[17] = formatMessage;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle"
        }, t8);
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== t7 || $[22] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            testId: "live-doc-start-approval-popup",
            xcss: $32917b1aa1050d52$var$styles.body,
            space: "space.100"
        }, t7, t9);
        $[21] = t7;
        $[22] = t9;
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] !== t10 || $[25] !== t5) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3880951f7018d493$export$7f90d9bc9f9f2bd4), {
            footer: t5
        }, t10);
        $[24] = t10;
        $[25] = t5;
        $[26] = t11;
    } else t11 = $[26];
    return t11;
};












var $1sCHt = parcelRequire("1sCHt");


var $iZMIZ = parcelRequire("iZMIZ");





var $lMGh1 = parcelRequire("lMGh1");


var $fxbF1 = parcelRequire("fxbF1");


var $k75o7 = parcelRequire("k75o7");


var $dB01C = parcelRequire("dB01C");











var $iMnC5 = parcelRequire("iMnC5");


var $1VhsF = parcelRequire("1VhsF");


var $lfoFx = parcelRequire("lfoFx");

















var $f28S3 = parcelRequire("f28S3");


var $75uOu = parcelRequire("75uOu");





var $euL71 = parcelRequire("euL71");











var $4S6vT = parcelRequire("4S6vT");



var $jb2R2 = parcelRequire("jb2R2");

var $bg9GW = parcelRequire("bg9GW");

var $fNtG8 = parcelRequire("fNtG8");

const $1c1fbaf2024b64b3$export$75233be2408e9faa = ({ lastRelevantDate: lastRelevantDate, intl: intl })=>{
    // Convert string (milliseconds) to Date
    const date = new Date(parseInt(lastRelevantDate, 10));
    const now = new Date();
    const diffInMinutes = (0, $fNtG8.default)(now, date);
    const diffInHours = (0, $bg9GW.default)(now, date);
    const diffInDays = (0, $jb2R2.default)(now, date);
    // Create a RelativeTimeFormat instance for the intl locale
    const rtf = new Intl.RelativeTimeFormat(intl.locale || 'en-US', {
        numeric: 'always',
        style: 'narrow'
    });
    if (diffInMinutes < 1) return {
        type: 'relative',
        value: 'now'
    };
    if (diffInMinutes < 60) // Returns something like "5m ago" with numeric: 'auto'
    return {
        type: 'relative',
        value: rtf.format(-diffInMinutes, 'minute')
    };
    if (diffInHours < 24) // Returns something like "3h ago" with numeric: 'auto'
    return {
        type: 'relative',
        value: rtf.format(-diffInHours, 'hour')
    };
    if (diffInDays <= 7) // Returns something like "2d ago" with numeric: 'auto'
    return {
        type: 'relative',
        value: rtf.format(-diffInDays, 'day')
    };
    // For >7 days, use truncated date format (Aug 8, 2018)
    const formattedDate = intl.formatDate(date, {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
    return {
        type: 'absolute',
        value: formattedDate
    };
};









var $arQY7 = parcelRequire("arQY7");








var $a6t12 = parcelRequire("a6t12");










/** The current normal-user People card width across legacy and migrated implementations. */ const $2519b4b426064b0a$var$PROFILE_CARD_WIDTH = 360;
const $2519b4b426064b0a$var$VIEWPORT_MARGIN = 16;
const $2519b4b426064b0a$var$POPUP_TO_CARD_GAP = 8;
const $2519b4b426064b0a$export$c5f04246ed7d1213 = {
    position: 'bottom-start',
    offset: [
        0,
        $2519b4b426064b0a$var$POPUP_TO_CARD_GAP
    ]
};
const $2519b4b426064b0a$var$hasGeometry = (rect)=>Boolean(rect && rect.width > 0 && rect.height > 0);
const $2519b4b426064b0a$export$253d33c2963ce25d = ({ popupRect: popupRect, triggerRect: triggerRect, viewportWidth: viewportWidth })=>{
    if (!$2519b4b426064b0a$var$hasGeometry(popupRect) || !$2519b4b426064b0a$var$hasGeometry(triggerRect) || viewportWidth <= 0) return $2519b4b426064b0a$export$c5f04246ed7d1213;
    if (popupRect.right + $2519b4b426064b0a$var$POPUP_TO_CARD_GAP + $2519b4b426064b0a$var$PROFILE_CARD_WIDTH <= viewportWidth - $2519b4b426064b0a$var$VIEWPORT_MARGIN) return {
        position: 'right-start',
        offset: [
            popupRect.top - triggerRect.top,
            popupRect.right - triggerRect.right + $2519b4b426064b0a$var$POPUP_TO_CARD_GAP
        ]
    };
    if (popupRect.left - $2519b4b426064b0a$var$POPUP_TO_CARD_GAP - $2519b4b426064b0a$var$PROFILE_CARD_WIDTH >= $2519b4b426064b0a$var$VIEWPORT_MARGIN) return {
        position: 'left-start',
        offset: [
            popupRect.top - triggerRect.top,
            triggerRect.left - popupRect.left + $2519b4b426064b0a$var$POPUP_TO_CARD_GAP
        ]
    };
    return {
        position: 'bottom-start',
        offset: [
            popupRect.left - triggerRect.left,
            popupRect.bottom - triggerRect.bottom + $2519b4b426064b0a$var$POPUP_TO_CARD_GAP
        ]
    };
};


const $382e077ba784756c$var$ContentStateInfoPopupCardPlacementContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $382e077ba784756c$var$placementsAreEqual = (first, second)=>first.position === second.position && first.offset[0] === second.offset[0] && first.offset[1] === second.offset[1];
const $382e077ba784756c$export$68bc03e2a97453a9 = ()=>{
    return (0, $cozmU.useContext)($382e077ba784756c$var$ContentStateInfoPopupCardPlacementContext);
};
const $382e077ba784756c$export$f977b09e4fbab402 = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children } = t0;
    const popupElementRef = (0, $cozmU.useRef)(null);
    const triggerElementRef = (0, $cozmU.useRef)(null);
    const resizeObserverRef = (0, $cozmU.useRef)(null);
    const animationFrameRef = (0, $cozmU.useRef)(null);
    const isMeasurementActiveRef = (0, $cozmU.useRef)(false);
    const [placement, setPlacement] = (0, $cozmU.useState)((0, $2519b4b426064b0a$export$c5f04246ed7d1213));
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            const popupElement = popupElementRef.current;
            const triggerElement = triggerElementRef.current;
            const nextPlacement = (0, $2519b4b426064b0a$export$253d33c2963ce25d)({
                popupRect: popupElement?.getBoundingClientRect() ?? null,
                triggerRect: triggerElement?.getBoundingClientRect() ?? null,
                viewportWidth: window.innerWidth
            });
            setPlacement((currentPlacement)=>$382e077ba784756c$var$placementsAreEqual(currentPlacement, nextPlacement) ? currentPlacement : nextPlacement);
        };
        $[0] = t1;
    } else t1 = $[0];
    const measure = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if (animationFrameRef.current !== null) return;
            if (typeof window.requestAnimationFrame !== "function") {
                measure();
                return;
            }
            animationFrameRef.current = window.requestAnimationFrame(()=>{
                animationFrameRef.current = null;
                measure();
            });
        };
        $[1] = t2;
    } else t2 = $[1];
    const scheduleMeasure = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (elementRef, element)=>{
            if (elementRef.current === element) return;
            if (elementRef.current) resizeObserverRef.current?.unobserve(elementRef.current);
            elementRef.current = element;
            if (!isMeasurementActiveRef.current) return;
            if (element) resizeObserverRef.current?.observe(element);
            scheduleMeasure();
        };
        $[2] = t3;
    } else t3 = $[2];
    const setObservedElement = t3;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (element_0)=>setObservedElement(popupElementRef, element_0);
        $[3] = t4;
    } else t4 = $[3];
    const setPopupElement = t4;
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (element_1)=>setObservedElement(triggerElementRef, element_1);
        $[4] = t5;
    } else t5 = $[4];
    const setTriggerElement = t5;
    let t6;
    let t7;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            isMeasurementActiveRef.current = true;
            if (typeof ResizeObserver !== "undefined") {
                resizeObserverRef.current = new ResizeObserver(measure);
                if (popupElementRef.current) resizeObserverRef.current.observe(popupElementRef.current);
                if (triggerElementRef.current) resizeObserverRef.current.observe(triggerElementRef.current);
            }
            measure();
            if (typeof window.addEventListener === "function") {
                window.addEventListener("resize", scheduleMeasure);
                window.addEventListener("scroll", scheduleMeasure, true);
            }
            return ()=>{
                isMeasurementActiveRef.current = false;
                resizeObserverRef.current?.disconnect();
                resizeObserverRef.current = null;
                if (animationFrameRef.current !== null && typeof window.cancelAnimationFrame === "function") window.cancelAnimationFrame(animationFrameRef.current);
                animationFrameRef.current = null;
                if (typeof window.removeEventListener === "function") {
                    window.removeEventListener("resize", scheduleMeasure);
                    window.removeEventListener("scroll", scheduleMeasure, true);
                }
            };
        };
        t7 = [
            measure,
            scheduleMeasure
        ];
        $[5] = t6;
        $[6] = t7;
    } else {
        t6 = $[5];
        t7 = $[6];
    }
    (0, $cozmU.useLayoutEffect)(t6, t7);
    let t8;
    if ($[7] !== placement) {
        t8 = {
            ...placement,
            setPopupElement: setPopupElement,
            setTriggerElement: setTriggerElement
        };
        $[7] = placement;
        $[8] = t8;
    } else t8 = $[8];
    const contextValue = t8;
    let t9;
    if ($[9] !== children || $[10] !== contextValue) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($382e077ba784756c$var$ContentStateInfoPopupCardPlacementContext.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t9;
    } else t9 = $[11];
    return t9;
};


const $61bfb0a94444c1f4$var$i18n = (0, $kSwu1.defineMessages)({
    openProfileCard: {
        id: "content-state.contentStateInfoPopup.open-profile-card.non-final",
        defaultMessage: "Open profile card for {name}"
    }
});
const $61bfb0a94444c1f4$export$1b0eac9d6652f18c = ({ avatarUrl: avatarUrl, displayName: displayName, userId: userId })=>{
    const intl = (0, $kSwu1.useIntl)();
    const cardPlacement = (0, $382e077ba784756c$export$68bc03e2a97453a9)();
    if (cardPlacement && (0, $6mKj3.expVal)('confluence_approvals_profile_card_updates', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
        key: userId,
        userId: userId,
        trigger: "click",
        fullName: displayName,
        ariaLabel: intl.formatMessage($61bfb0a94444c1f4$var$i18n.openProfileCard, {
            name: displayName
        }),
        position: cardPlacement.position,
        offset: cardPlacement.offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center",
        ref: cardPlacement.setTriggerElement
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        src: avatarUrl,
        name: displayName,
        size: "xxsmall"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, displayName)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
        userId: userId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        src: avatarUrl,
        name: displayName,
        size: "xxsmall"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, displayName)));
};















var $4ez2K = parcelRequire("4ez2K");











var $k12R1 = parcelRequire("k12R1");











var $aDSIl = parcelRequire("aDSIl");





var $hekY6 = parcelRequire("hekY6");




























const $bfdf7c5a7aa26adf$var$ApprovalProfileCardLoading = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);

const $bfdf7c5a7aa26adf$var$LoadableApprovalProfileCard = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "6mID4",
    name: 'ApprovalProfileCard',
    loader: async ()=>(await (parcelRequire("kOLTT"))).ApprovalProfileCard,
    loading: $bfdf7c5a7aa26adf$var$ApprovalProfileCardLoading
});
const $bfdf7c5a7aa26adf$export$e5a8b306f2f33e70 = (props)=>{
    const { children: children, principalId: principalId, principalType: principalType } = props;
    if (principalType !== 'USER' || !principalId || !(0, $6mKj3.expValEquals)('confluence_approvals_profile_card_updates', 'isEnabled', true)) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bfdf7c5a7aa26adf$var$LoadableApprovalProfileCard, props);
};


const $a8c927a4a51ab537$var$MAX_AVATARS_SHOWN = 2;
const $a8c927a4a51ab537$var$styles = {
    facepile: "_3iDTPbQ4SZ _0hPCNLDIqT _2YgrGrP0S5 _1pp6NdYbGa",
    avatarContainer: "_3iDTPbccYA",
    overlap: "_0GTcwR5UaJ",
    moreIndicator: "_0bjKvDS5Zs _3vBAKHlfZc _3hxITi6wH8 _2V7sgO2M4S _3iDTPbccYA _0GTcwR5UaJ _39xV02oWWg _0jFU0VoWWg _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _0KLXruDMqu _1UtDYzy7kJ"
};
const $a8c927a4a51ab537$var$i18n = (0, $kSwu1.defineMessages)({
    profileCardLabel: {
        id: "content-state.contentStateInfoPopup.approvalStatusButton.profile-card-label",
        defaultMessage: "Open profile card for {name}"
    }
});
const $a8c927a4a51ab537$var$getAvatarStatus = (approver)=>{
    if (approver.status === 'REVIEWER_APPROVED') return 'approved';
    if (approver.status === 'REVIEWER_DENIED') return 'declined';
    return undefined;
};
const $a8c927a4a51ab537$export$1506f395f6990789 = (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { approvers: approvers, onPointerClick: onPointerClick } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const hasOverflow = approvers.length > $a8c927a4a51ab537$var$MAX_AVATARS_SHOWN;
    let hiddenCount;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== approvers || $[1] !== formatMessage || $[2] !== hasOverflow || $[3] !== onPointerClick) {
        t4 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const visibleApprovers = approvers.slice(0, hasOverflow ? 1 : $a8c927a4a51ab537$var$MAX_AVATARS_SHOWN);
            hiddenCount = approvers.length - visibleApprovers.length;
            if (visibleApprovers.length === 0) {
                t4 = null;
                break bb0;
            }
            t1 = "approval-profile-avatar-facepile";
            if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
                t2 = (0, $hekY6.default)([
                    $a8c927a4a51ab537$var$styles.facepile
                ]);
                $[9] = t2;
            } else t2 = $[9];
            t3 = visibleApprovers.map((approver, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    as: "span",
                    xcss: (0, $k12R1.cx)($a8c927a4a51ab537$var$styles.avatarContainer, index > 0 && $a8c927a4a51ab537$var$styles.overlap),
                    key: `${approver.principalType}:${approver.principalId}:${approver.decisionId}`
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bfdf7c5a7aa26adf$export$e5a8b306f2f33e70), {
                    ariaLabel: formatMessage($a8c927a4a51ab537$var$i18n.profileCardLabel, {
                        name: approver.name
                    }),
                    fullName: approver.name,
                    onPointerClick: onPointerClick,
                    position: "bottom-end",
                    principalId: approver.principalId,
                    principalType: approver.principalType,
                    trigger: "hover"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                    "aria-hidden": "true"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                    appearance: "circle",
                    size: "small",
                    src: approver.avatarUrl,
                    stackIndex: visibleApprovers.length - index,
                    status: $a8c927a4a51ab537$var$getAvatarStatus(approver),
                    testId: `approval-profile-avatar-${index}`
                })))));
        }
        $[0] = approvers;
        $[1] = formatMessage;
        $[2] = hasOverflow;
        $[3] = onPointerClick;
        $[4] = hiddenCount;
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else {
        hiddenCount = $[4];
        t1 = $[5];
        t2 = $[6];
        t3 = $[7];
        t4 = $[8];
    }
    if (t4 !== Symbol.for("react.early_return_sentinel")) return t4;
    let t5;
    if ($[10] !== hiddenCount) {
        t5 = hiddenCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-hidden": "true",
            "data-testid": "approval-profile-avatar-overflow",
            className: (0, $hekY6.default)([
                $a8c927a4a51ab537$var$styles.moreIndicator
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small"
        }, "+", hiddenCount));
        $[10] = hiddenCount;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": t1,
            className: t2
        }, t3, t5);
        $[12] = t1;
        $[13] = t2;
        $[14] = t3;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
};


const $b46c8b8b93feb0bd$var$styles = {
    approvalStatusCard: "_1mT5xdRAKS",
    approvalStatusButton: "_49OCfRPgdg _0bjKvDKTcp _3vBAKH9r67 _2V7sgONvrM _3hxITi6wH8 _1mT5xdWVPG _1UtDYzy7kJ _0KLXru66of _39xV02N91d _0jFU0VN91d _1eOmH6o126 _3gzVzLN4oS",
    approvalStatusButtonWarning: "_0bjKvDKTcp _3vBAKH9r67 _2V7sgONvrM _3hxITi6wH8 _0KLXruhxIM _1eOmH6dEDW _3gzVzLiJjO",
    visualRow: "_4FKVYE5zaO _1mT5xdRAKS _1pp6NdYbGa",
    approvalStatusContainer: "_2Zuz6Q5zaO _1Znuxb5zaO _1wydGW5zaO",
    fullWidth: "_39xV02N91d",
    chevronContainer: ""
};
const $b46c8b8b93feb0bd$export$6f1e346faba6dd06 = (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { children: children, onClick: onClick, approvers: t1, ariaLabel: ariaLabel, appearance: t2 } = t0;
    let t3;
    if ($[0] !== t1) {
        t3 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t3;
    } else t3 = $[1];
    const approvers = t3;
    const appearance = t2 === undefined ? "default" : t2;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $k12R1.cx)($b46c8b8b93feb0bd$var$styles.fullWidth, $b46c8b8b93feb0bd$var$styles.approvalStatusContainer);
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $k12R1.cx)($b46c8b8b93feb0bd$var$styles.approvalStatusCard, $b46c8b8b93feb0bd$var$styles.fullWidth);
        $[3] = t5;
    } else t5 = $[3];
    const t6 = appearance === "warning" && $b46c8b8b93feb0bd$var$styles.approvalStatusButtonWarning;
    let t7;
    if ($[4] !== t6) {
        t7 = (0, $k12R1.cx)($b46c8b8b93feb0bd$var$styles.approvalStatusButton, t6);
        $[4] = t6;
        $[5] = t7;
    } else t7 = $[5];
    let t8;
    if ($[6] !== ariaLabel || $[7] !== onClick || $[8] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            "aria-label": ariaLabel,
            xcss: t7,
            onClick: onClick,
            testId: "approval-status-button"
        });
        $[6] = ariaLabel;
        $[7] = onClick;
        $[8] = t7;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (0, $k12R1.cx)($b46c8b8b93feb0bd$var$styles.fullWidth, $b46c8b8b93feb0bd$var$styles.visualRow);
        $[10] = t9;
    } else t9 = $[10];
    let t10;
    if ($[11] !== approvers || $[12] !== onClick) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a8c927a4a51ab537$export$1506f395f6990789), {
            approvers: approvers,
            onPointerClick: onClick
        });
        $[11] = approvers;
        $[12] = onClick;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            alignItems: "center",
            justifyContent: "center",
            direction: "column",
            xcss: $b46c8b8b93feb0bd$var$styles.chevronContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: ""
        }));
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    if ($[15] !== t10) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            gap: "space.150",
            alignItems: "center"
        }, t10, t11);
        $[15] = t10;
        $[16] = t12;
    } else t12 = $[16];
    let t13;
    if ($[17] !== children || $[18] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "row",
            xcss: t9,
            justifyContent: "space-between",
            alignItems: "center",
            gap: "space.200"
        }, children, t12);
        $[17] = children;
        $[18] = t12;
        $[19] = t13;
    } else t13 = $[19];
    let t14;
    if ($[20] !== t13 || $[21] !== t8) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t4
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t5
        }, t8, t13));
        $[20] = t13;
        $[21] = t8;
        $[22] = t14;
    } else t14 = $[22];
    return t14;
};


const $90f769427d65b87f$var$i18n = (0, $kSwu1.defineMessages)({
    startApprovalTitle: {
        id: "content-state.contentStateInfoPopup.approvalStatusButton.start-approval-title",
        defaultMessage: "Start approval"
    },
    startApprovalDescription: {
        id: "content-state.contentStateInfoPopup.approvalStatusButton.start-approval-description",
        defaultMessage: "Get feedback and move work forward"
    }
});
const $90f769427d65b87f$export$96dd91754b6dc986 = (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($90f769427d65b87f$var$i18n.startApprovalTitle);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    const title = t1;
    let t2;
    if ($[2] !== title) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, title);
        $[2] = title;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== formatMessage) {
        t3 = formatMessage($90f769427d65b87f$var$i18n.startApprovalDescription);
        $[4] = formatMessage;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, t3);
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t2 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "column",
            alignItems: "start",
            gap: "space.025"
        }, t2, t4);
        $[8] = t2;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== onClick || $[12] !== t5 || $[13] !== title) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b46c8b8b93feb0bd$export$6f1e346faba6dd06), {
            ariaLabel: title,
            onClick: onClick
        }, t5);
        $[11] = onClick;
        $[12] = t5;
        $[13] = title;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
};























var $j3QkC = parcelRequire("j3QkC");


const $71ab3b007df7d173$var$styles = {
    fullWidth: "_39xV02N91d",
    progressRow: "_39xV02yIZ9",
    textContainer: "_3YEZNOdnbC _2fwxA57p2s",
    approvedTextContainer: "_4bt5LAnQyn _2WAcuGnQyn _2fwxA57p2s _1EqgXlyIZ9 _3iDTPbgJ9S _4Gn54RiZR3 _1U1ZhbbI28",
    progressBarContainer: "_2O5Vij7dHp _4ouGXIdnbC"
};
const $71ab3b007df7d173$var$i18n = (0, $kSwu1.defineMessages)({
    inProgressApprovalTitle: {
        id: "content-state.contentStateInfoPopup.approvalStatusButton.in-progress-title",
        defaultMessage: "Approval in progress"
    },
    inProgressApprovalDescription: {
        id: "content-state.contentStateInfoPopup.approvalStatusButton.in-progress-description",
        defaultMessage: "{approvalCount}/{approverCount} approved"
    },
    approvedApprovalTitle: {
        id: "content-state.contentStateInfoPopup.approvalStatusButton.approved-approval-title",
        defaultMessage: "Approved by"
    },
    approvedApprovalDescription: {
        id: "content-state.contentStateInfoPopup.approvalStatusButton.approved-approval-description",
        defaultMessage: "{approver} and {count} {count, plural, one {other} other {others}}"
    },
    declinedApprovalTitle: {
        id: "content-state.contentStateInfoPopup.approvalStatusButton.declined-approval-title",
        defaultMessage: "Approval declined"
    },
    changesRequestedTitle: {
        id: "content-state.contentStateInfoPopup.approvalStatusButton.changes-requested-title",
        defaultMessage: "Changes requested by"
    },
    openApprovalDetails: {
        id: "content-state.contentStateInfoPopup.approvalStatusButton.open-approval-details",
        defaultMessage: "Open approval details: {title}, {description}"
    },
    openApprovalDetailsWithoutDescription: {
        id: "content-state.contentStateInfoPopup.approvalStatusButton.open-approval-details-without-description",
        defaultMessage: "Open approval details: {title}"
    }
});
var $71ab3b007df7d173$export$fe3858f0a023b119 = /*#__PURE__*/ function(InProgressApprovalButtonVariant) {
    InProgressApprovalButtonVariant["IN_PROGRESS"] = "in-progress";
    InProgressApprovalButtonVariant["APPROVED"] = "approved";
    InProgressApprovalButtonVariant["DECLINED"] = "declined";
    InProgressApprovalButtonVariant["CHANGES_REQUESTED"] = "changes-requested";
    return InProgressApprovalButtonVariant;
}({});
const $71ab3b007df7d173$var$getApprovedDescription = (approvers, formatMessage)=>{
    if (approvers.length === 1) return approvers[0].name;
    return formatMessage($71ab3b007df7d173$var$i18n.approvedApprovalDescription, {
        approver: approvers[0].name,
        count: approvers.length - 1
    });
};
const $71ab3b007df7d173$var$getChangesRequestedDescription = (approvers, formatMessage)=>{
    const deniedApprovers = approvers.filter((a)=>a.status === 'REVIEWER_DENIED');
    if (deniedApprovers.length === 0) return '';
    if (deniedApprovers.length === 1) return deniedApprovers[0].name;
    return formatMessage($71ab3b007df7d173$var$i18n.approvedApprovalDescription, {
        approver: deniedApprovers[0].name,
        count: deniedApprovers.length - 1
    });
};
const $71ab3b007df7d173$var$getTitle = (variant, formatMessage)=>{
    switch(variant){
        case "in-progress":
            return formatMessage($71ab3b007df7d173$var$i18n.inProgressApprovalTitle);
        case "approved":
            return formatMessage($71ab3b007df7d173$var$i18n.approvedApprovalTitle);
        case "changes-requested":
            return formatMessage($71ab3b007df7d173$var$i18n.changesRequestedTitle);
        case "declined":
        default:
            return formatMessage($71ab3b007df7d173$var$i18n.declinedApprovalTitle);
    }
};
const $71ab3b007df7d173$var$getDescription = (variant, approvers, approvalCount, approverCount, formatMessage)=>{
    switch(variant){
        case "in-progress":
        case "declined":
            return formatMessage($71ab3b007df7d173$var$i18n.inProgressApprovalDescription, {
                approvalCount: approvalCount,
                approverCount: approverCount
            });
        case "changes-requested":
            return $71ab3b007df7d173$var$getChangesRequestedDescription(approvers, formatMessage);
        case "approved":
        default:
            return $71ab3b007df7d173$var$getApprovedDescription(approvers, formatMessage);
    }
};
const $71ab3b007df7d173$export$c6f6523970aaa235 = (t0)=>{
    const $ = (0, $bDgLe.c)(33);
    const { onClick: onClick, approvalCount: approvalCount, approverCount: approverCount, approvers: approvers, variant: t1 } = t0;
    const variant = t1 === undefined ? "in-progress" : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let T0;
    let description;
    let t2;
    let t3;
    let t4;
    let title;
    if ($[0] !== approvalCount || $[1] !== approverCount || $[2] !== approvers || $[3] !== formatMessage || $[4] !== onClick || $[5] !== variant) {
        title = $71ab3b007df7d173$var$getTitle(variant, formatMessage);
        description = $71ab3b007df7d173$var$getDescription(variant, approvers, approvalCount, approverCount, formatMessage);
        T0 = (0, $b46c8b8b93feb0bd$export$6f1e346faba6dd06);
        t2 = onClick;
        t3 = approvers;
        t4 = formatMessage(description ? $71ab3b007df7d173$var$i18n.openApprovalDetails : $71ab3b007df7d173$var$i18n.openApprovalDetailsWithoutDescription, description ? {
            title: title,
            description: description
        } : {
            title: title
        });
        $[0] = approvalCount;
        $[1] = approverCount;
        $[2] = approvers;
        $[3] = formatMessage;
        $[4] = onClick;
        $[5] = variant;
        $[6] = T0;
        $[7] = description;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = title;
    } else {
        T0 = $[6];
        description = $[7];
        t2 = $[8];
        t3 = $[9];
        t4 = $[10];
        title = $[11];
    }
    let t5;
    if ($[12] !== title) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, title);
        $[12] = title;
        $[13] = t5;
    } else t5 = $[13];
    const t6 = variant === "approved" || variant === "changes-requested" ? $71ab3b007df7d173$var$styles.approvedTextContainer : $71ab3b007df7d173$var$styles.textContainer;
    let t7;
    if ($[14] !== description) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "medium"
        }, description);
        $[14] = description;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== t6 || $[17] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t6
        }, t7);
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== variant) {
        t9 = variant === "in-progress" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $71ab3b007df7d173$var$styles.progressBarContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j3QkC.ApprovalsProgressBar), null));
        $[19] = variant;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== t8 || $[22] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "row",
            gap: "space.100",
            alignItems: "center",
            xcss: $71ab3b007df7d173$var$styles.progressRow
        }, t8, t9);
        $[21] = t8;
        $[22] = t9;
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] !== t10 || $[25] !== t5) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "column",
            alignItems: "start",
            gap: "space.025",
            xcss: $71ab3b007df7d173$var$styles.fullWidth
        }, t5, t10);
        $[24] = t10;
        $[25] = t5;
        $[26] = t11;
    } else t11 = $[26];
    let t12;
    if ($[27] !== T0 || $[28] !== t11 || $[29] !== t2 || $[30] !== t3 || $[31] !== t4) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            onClick: t2,
            approvers: t3,
            ariaLabel: t4
        }, t11);
        $[27] = T0;
        $[28] = t11;
        $[29] = t2;
        $[30] = t3;
        $[31] = t4;
        $[32] = t12;
    } else t12 = $[32];
    return t12;
};



const $df5c0845c72ee01f$var$styles = {
    statusInfo: "_4FKVYE5zaO",
    statusHeader: "_39xV02N91d",
    updateMetadata: "_3TGfC9HnLE",
    otherModeWarningWrapper: "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _2YLqiK5zaO _0rIjyk8HPE"
};
const $df5c0845c72ee01f$var$i18n = (0, $kSwu1.defineMessages)({
    cancelApproval: {
        id: "content-state.contentStateInfoPopup.cancel-approval-button.text",
        defaultMessage: "Cancel approval"
    },
    updatedByUser: {
        id: "content-state.contentStateInfoPopup.updated-by-user",
        defaultMessage: "Updated {time} by"
    },
    updated: {
        id: "content-state.contentStateInfoPopup.updated",
        defaultMessage: "Updated {time}"
    },
    updatedOnByUser: {
        id: "content-state.contentStateInfoPopup.updated-on-by-user",
        defaultMessage: "Updated on {date} by"
    },
    updatedOn: {
        id: "content-state.contentStateInfoPopup.updated-on",
        defaultMessage: "Updated on {date}"
    },
    updatedByUserOnly: {
        id: "content-state.contentStateInfoPopup.updated-by-user-only",
        defaultMessage: "Updated by"
    },
    otherModeReviewWarningEdit: {
        id: "content-state.contentStateInfoPopup.other-mode-review-warning-edit",
        defaultMessage: "The published version of this page is under review. Complete or cancel that review in order to start a new one here in the editor."
    },
    otherModeReviewWarningView: {
        id: "content-state.contentStateInfoPopup.other-mode-review-warning-view",
        defaultMessage: "The draft version of this page is under review. Complete or cancel that review in order to start a new one here in the published view."
    },
    approvalNeedsAttention: {
        id: "content-state.contentStateInfoPopup.approval-needs-attention",
        defaultMessage: "Approval needs attention"
    },
    openApprovalDetails: {
        id: "content-state.contentStateInfoPopup.open-approval-details",
        defaultMessage: "Open approval details: {status}"
    },
    viewApprovalHistory: {
        id: "content-state.contentStateInfoPopup.view-approval-history",
        defaultMessage: "View approval history"
    }
});
const $df5c0845c72ee01f$var$ContentStateInfoPopupContent = ({ contentState: contentState, activeWorkflowStatus: activeWorkflowStatus, updatedBy: updatedBy, updatedAt: updatedAt, loading: loading = false, onChangeStatus: onChangeStatus, onClearRequest: onClearRequest, onClose: onClose, onConvertLiveDocToPage: onConvertLiveDocToPage, canEdit: canEdit = true, contentType: contentType, isViewMode: isViewMode = false })=>{
    const cardPlacement = (0, $382e077ba784756c$export$68bc03e2a97453a9)();
    const intl = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId, edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { approvalRequest: approvalRequest, hasEditPermission: hasEditPermission, approvalProgress: approvalProgress, otherModeReviewStatus: otherModeReviewStatus, contentId: contentId, contentStatus: contentStatus, availableWorkflowStatuses: availableWorkflowStatuses, isPendingReviewBlockedByRequiredApproversChange: isPendingReviewBlockedByRequiredApproversChange } = (0, $laFNM.useApprovals)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [showLiveDocStartApprovalPopup, setShowLiveDocStartApprovalPopup] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const approvers = approvalRequest?.review?.approvers;
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const liveDocApprovalWorkflowStatus = availableWorkflowStatuses.find((status)=>status.allowsReviews);
    const handleApprovalStatusButtonClick = (0, $cozmU.useCallback)(()=>{
        if (rightSidebarContext.getCurrent()?.panelId === (0, $1vpkQ.APPROVALS_PANE_ID)) {
            onClose?.();
            return;
        }
        (0, $1vpkQ.openApprovalsPaneForContext)({
            contentId: contentId,
            contentStatus: contentStatus,
            rightSidebarContext: rightSidebarContext
        });
    }, [
        contentId,
        contentStatus,
        onClose,
        rightSidebarContext
    ]);
    const handleStartApprovalClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'startApproval',
                source: (0, $2QUbq.APPROVALS_ANALYTICS_SOURCE),
                attributes: {
                    contentId: contentId,
                    contentStatus: contentStatus
                }
            }
        }).fire();
        if (isLivePage && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) {
            setShowLiveDocStartApprovalPopup(true);
            return;
        }
        handleApprovalStatusButtonClick();
    }, [
        createAnalyticsEvent,
        contentId,
        contentStatus,
        handleApprovalStatusButtonClick,
        isLivePage
    ]);
    const handleViewApprovalHistoryClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'viewApprovalHistory',
                source: (0, $2QUbq.APPROVALS_ANALYTICS_SOURCE),
                attributes: {
                    contentId: contentId,
                    contentStatus: contentStatus
                }
            }
        }).fire();
        onClose?.();
        (0, $f28S3.openApprovalActivityPaneForContext)({
            contentId: contentId,
            contentStatus: contentStatus,
            rightSidebarContext: rightSidebarContext
        });
    }, [
        createAnalyticsEvent,
        contentId,
        contentStatus,
        onClose,
        rightSidebarContext
    ]);
    const handleConvertLiveDocToPage = (0, $cozmU.useCallback)(()=>{
        try {
            onConvertLiveDocToPage?.();
        } finally{
            onClose?.();
        }
    }, [
        onClose,
        onConvertLiveDocToPage
    ]);
    const handleBackFromLiveDocStartApprovalPopup = (0, $cozmU.useCallback)(()=>{
        setShowLiveDocStartApprovalPopup(false);
    }, []);
    const isActiveReview = !!approvalRequest?.review && approvalRequest?.review?.reviewStatus !== 'CANCELED';
    const approvalStatus = approvalRequest?.review?.reviewStatus;
    const isPendingReviewBlockedByRequiredApproversChangeForCurrentReview = isActiveReview && approvalStatus === 'PENDING' && isPendingReviewBlockedByRequiredApproversChange;
    const hasOtherModePendingReview = otherModeReviewStatus === 'PENDING';
    const canStartApproval = Boolean(activeWorkflowStatus?.allowsReviews) || Boolean(isLivePage && liveDocApprovalWorkflowStatus && onConvertLiveDocToPage && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true));
    const wouldShowStartApproval = !isActiveReview && canStartApproval && hasEditPermission;
    const showOtherModeWarning = hasOtherModePendingReview && wouldShowStartApproval;
    let approvalActivityContentStatus = 'CURRENT';
    let shouldFetchApprovalActivity = isPremium && Boolean(contentId) && contentStatus === 'CURRENT' && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true);
    if ((0, $9wGTI.fg)('cc_approvals_activity_log_edit_mode')) {
        approvalActivityContentStatus = contentStatus;
        shouldFetchApprovalActivity = isPremium && Boolean(contentId) && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true);
    }
    const { items: approvalActivityItems } = (0, $75uOu.useApprovalActivityHistory)({
        cloudId: cloudId,
        contentId: contentId,
        contentStatus: approvalActivityContentStatus,
        first: 1,
        skip: !shouldFetchApprovalActivity
    });
    const showApprovalActivityEntryPoint = shouldFetchApprovalActivity && approvalActivityItems.length > 0;
    const approvalCount = (0, $cozmU.useMemo)(()=>(approvers ?? []).filter((a)=>a.status === 'REVIEWER_APPROVED').length, [
        approvers
    ]);
    const displayName = activeWorkflowStatus?.name ?? contentState?.name;
    const timeData = updatedAt ? (0, $1c1fbaf2024b64b3$export$75233be2408e9faa)({
        lastRelevantDate: updatedAt,
        intl: intl
    }) : null;
    const shouldHideRecentUpdateMetadata = timeData?.type === 'relative' && timeData.value === 'now';
    const approvalStatusToVariant = {
        PENDING: (0, $71ab3b007df7d173$export$fe3858f0a023b119).IN_PROGRESS,
        APPROVED: (0, $71ab3b007df7d173$export$fe3858f0a023b119).APPROVED,
        DENIED: (0, $71ab3b007df7d173$export$fe3858f0a023b119).CHANGES_REQUESTED
    };
    const StatusButton = ()=>{
        if (!isPremium) return null;
        if (isActiveReview) {
            if (isPendingReviewBlockedByRequiredApproversChangeForCurrentReview) {
                const status_0 = intl.formatMessage($df5c0845c72ee01f$var$i18n.approvalNeedsAttention);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b46c8b8b93feb0bd$export$6f1e346faba6dd06), {
                    appearance: "warning",
                    ariaLabel: intl.formatMessage($df5c0845c72ee01f$var$i18n.openApprovalDetails, {
                        status: status_0
                    }),
                    onClick: handleApprovalStatusButtonClick
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    space: "space.100",
                    alignBlock: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
                    label: "",
                    color: "var(--ds-icon-warning, #E06C00)"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    size: "medium",
                    weight: "bold"
                }, status_0)));
            }
            const variant = approvalStatus ? approvalStatusToVariant[approvalStatus] : undefined;
            if (!variant) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $71ab3b007df7d173$export$c6f6523970aaa235), {
                approvalCount: approvalCount,
                approverCount: approvalProgress.total || 0,
                variant: variant,
                onClick: handleApprovalStatusButtonClick,
                approvers: approvers ?? []
            });
        }
        if (showLiveDocStartApprovalPopup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $32917b1aa1050d52$export$85a25e99367817c8), {
            onBack: handleBackFromLiveDocStartApprovalPopup,
            onConvertToPage: handleConvertLiveDocToPage
        });
        if (canStartApproval && hasEditPermission && !showOtherModeWarning) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $90f769427d65b87f$export$96dd91754b6dc986), {
            onClick: handleStartApprovalClick
        });
        return null;
    };
    const renderStatusIcon = ()=>{
        if (activeWorkflowStatus) {
            const isChangesRequested = activeWorkflowStatus.id === '3';
            let WorkflowIcon;
            let iconColor;
            if (isChangesRequested) {
                WorkflowIcon = (0, (/*@__PURE__*/$parcel$interopDefault($dB01C)));
                iconColor = "var(--ds-icon-accent-yellow, #B38600)";
            } else if (activeWorkflowStatus.allowsReviews) {
                WorkflowIcon = (0, (/*@__PURE__*/$parcel$interopDefault($k75o7)));
                iconColor = "var(--ds-icon-accent-blue, #357DE8)";
            } else {
                WorkflowIcon = (0, (/*@__PURE__*/$parcel$interopDefault($iZMIZ)));
                iconColor = "var(--ds-icon-accent-lime, #6A9A23)";
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WorkflowIcon, {
                label: "",
                color: iconColor
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4S6vT.ContentStateColor), {
            color: contentState?.color,
            appearance: "contentStateInfoPopup"
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3880951f7018d493$export$7f90d9bc9f9f2bd4), {
        rootRef: cardPlacement && (0, $6mKj3.expVal)('confluence_approvals_profile_card_updates', 'isEnabled', false) ? cardPlacement.setPopupElement : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $df5c0845c72ee01f$var$styles.statusInfo,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between",
        xcss: $df5c0845c72ee01f$var$styles.statusHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, renderStatusIcon(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "medium"
    }, displayName)), showApprovalActivityEntryPoint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fxbF1))),
        label: intl.formatMessage($df5c0845c72ee01f$var$i18n.viewApprovalHistory),
        onClick: handleViewApprovalHistoryClick,
        testId: "approval-activity-entry-point-button"
    })), !shouldHideRecentUpdateMetadata && (timeData || updatedBy || loading) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center",
        alignInline: loading ? 'center' : 'start',
        xcss: $df5c0845c72ee01f$var$styles.updateMetadata
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small",
        interactionName: "content-state-info-popup"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, timeData && updatedBy && timeData.type === 'relative' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, intl.formatMessage($df5c0845c72ee01f$var$i18n.updatedByUser, {
        time: timeData.value
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $61bfb0a94444c1f4$export$1b0eac9d6652f18c), updatedBy)), timeData && updatedBy && timeData.type === 'absolute' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, intl.formatMessage($df5c0845c72ee01f$var$i18n.updatedOnByUser, {
        date: timeData.value
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $61bfb0a94444c1f4$export$1b0eac9d6652f18c), updatedBy)), timeData && !updatedBy && timeData.type === 'relative' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, intl.formatMessage($df5c0845c72ee01f$var$i18n.updated, {
        time: timeData.value
    })), timeData && !updatedBy && timeData.type === 'absolute' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, intl.formatMessage($df5c0845c72ee01f$var$i18n.updatedOn, {
        date: timeData.value
    })), !timeData && updatedBy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, intl.formatMessage($df5c0845c72ee01f$var$i18n.updatedByUserOnly)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $61bfb0a94444c1f4$export$1b0eac9d6652f18c), updatedBy))))), showOtherModeWarning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $df5c0845c72ee01f$var$styles.otherModeWarningWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        appearance: "warning"
    }, intl.formatMessage(isViewMode ? $df5c0845c72ee01f$var$i18n.otherModeReviewWarningView : $df5c0845c72ee01f$var$i18n.otherModeReviewWarningEdit))), !(isViewMode && contentType === 'blogpost') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(StatusButton, null), canEdit && !(isViewMode && contentType === 'blogpost') && (isActiveReview && approvalStatus === 'PENDING' && onClearRequest ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3880951f7018d493$export$4ea950e74969538a), {
        onClick: onClearRequest,
        testId: "cancel-approval-footer-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium",
        color: "color.text.subtle"
    }, intl.formatMessage($df5c0845c72ee01f$var$i18n.cancelApproval))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3880951f7018d493$export$1d5dafbf93c17eee), {
        onClick: onChangeStatus
    })));
};
const $df5c0845c72ee01f$export$53d4fd7383e067f = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $6mKj3.expVal)("confluence_approvals_profile_card_updates", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $382e077ba784756c$export$f977b09e4fbab402), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df5c0845c72ee01f$var$ContentStateInfoPopupContent, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df5c0845c72ee01f$var$ContentStateInfoPopupContent, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};





















const $9e4d91f280782e61$var$styles = {
    body: "_4FKVYE5zaO"
};
const $9e4d91f280782e61$var$i18n = (0, $kSwu1.defineMessages)({
    heading: {
        id: "content-state.otherModeReviewBlockingPopup.heading",
        defaultMessage: "Approval in progress"
    },
    bodyViewMode: {
        id: "content-state.otherModeReviewBlockingPopup.body-view-mode",
        defaultMessage: "This page has a draft in review. Complete or cancel that review to start a new approval for the published page."
    },
    bodyEditMode: {
        id: "content-state.otherModeReviewBlockingPopup.body-edit-mode",
        defaultMessage: "The published version of this page is in review. Complete or cancel that review to start a new approval for this draft."
    }
});
const $9e4d91f280782e61$export$ef489f24b547890a = (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isViewMode: isViewMode, onChangeStatus: onChangeStatus } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== onChangeStatus) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3880951f7018d493$export$1d5dafbf93c17eee), {
            onClick: onChangeStatus
        });
        $[0] = onChangeStatus;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== formatMessage) {
        t2 = formatMessage($9e4d91f280782e61$var$i18n.heading);
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "xsmall"
        }, t2);
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    const t4 = isViewMode ? $9e4d91f280782e61$var$i18n.bodyViewMode : $9e4d91f280782e61$var$i18n.bodyEditMode;
    let t5;
    if ($[6] !== formatMessage || $[7] !== t4) {
        t5 = formatMessage(t4);
        $[6] = formatMessage;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle"
        }, t5);
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== t3 || $[12] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $9e4d91f280782e61$var$styles.body,
            space: "space.100"
        }, t3, t6);
        $[11] = t3;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== t1 || $[15] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3880951f7018d493$export$7f90d9bc9f9f2bd4), {
            footer: t1
        }, t7);
        $[14] = t1;
        $[15] = t7;
        $[16] = t8;
    } else t8 = $[16];
    return t8;
};



var $lJswu = parcelRequire("lJswu");














var $7sJoX = parcelRequire("7sJoX");





var $7ZB0A = parcelRequire("7ZB0A");





var $gFEZF = parcelRequire("gFEZF");


var $kRZje = parcelRequire("kRZje");








var $lpNn5 = parcelRequire("lpNn5");


var $3izAL = parcelRequire("3izAL");


var $kz1Yj = parcelRequire("kz1Yj");


var $buxP3 = parcelRequire("buxP3");


var $iquRY = parcelRequire("iquRY");

/* ApprovalsCompletedSpotlight.tsx generated by @compiled/babel-plugin v3.0.1 */ 















var $aWwYt = parcelRequire("aWwYt");













const $e3dc4f9522a67664$export$3c87e1f3199ca8e9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "100%",
        height: "auto",
        viewBox: "0 0 295 135",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        "clip-path": "url(#clip0_6509_14303)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "295",
        height: "135",
        fill: "#F8F8F8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        opacity: "0.02",
        "clip-path": "url(#clip1_6509_14303)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M40.776 53.4687C53.8564 50.2591 64.6048 49.4207 71.8615 49.4512C73.6829 49.4785 75.2974 49.5192 76.6724 49.5994C78.0619 49.7189 79.2445 49.8518 80.1684 50.0014C82.0681 50.2972 83.0557 50.676 83.173 51.0788C83.2903 51.4816 82.5563 51.9312 80.9756 52.4114C80.1735 52.6482 79.169 52.882 77.9576 53.1292C76.7607 53.4156 75.3378 53.6925 73.7271 54.0056C67.2652 55.2353 57.6417 56.9666 45.4707 60.2865C36.8568 62.685 28.5398 65.5711 20.6389 69.0661C12.7706 72.5348 5.02964 76.4619 -1.93422 80.8861C-8.87901 85.3331 -15.2336 90.4019 -20.0031 96.2614C-24.8154 102.092 -27.8865 108.791 -27.8654 115.975C-27.7689 123.162 -24.3697 130.715 -18.0249 137.812C-11.7083 144.92 -2.94061 151.523 6.98197 157.44C27.0958 169.314 51.3303 178.869 77.7606 185.628C92.7669 189.512 106.596 192.047 119.303 193.866C132.029 195.708 143.621 196.778 154.349 197.575C175.782 199.072 193.661 199.27 210.258 199.237C226.873 199.138 242.225 198.832 258.285 197.892C274.331 196.913 291.227 195.428 310.267 191.89C326.328 188.923 343.118 184.516 358.834 177.838C366.709 174.529 374.266 170.622 381.234 166.093C388.22 161.587 394.626 156.427 399.947 150.684C405.202 144.906 409.448 138.461 411.829 131.5C414.182 124.549 414.77 117.093 412.629 109.676C411.563 105.995 410.017 102.305 407.72 98.7602C406.717 96.9663 405.287 95.2482 404.068 93.5004C402.577 91.8185 401.278 90.0839 399.586 88.4873C393.299 81.9171 385.26 76.168 376.685 71.258C359.37 61.481 339.617 56.0211 320.877 53.2396C302.103 50.3959 284.311 49.9751 268.33 49.9845C252.298 50.0857 238.093 50.6564 226.294 51.4339C220.422 51.9094 215.066 52.2631 210.422 52.7961C208.096 53.0347 205.9 53.2569 203.888 53.4591C201.887 53.717 200.044 53.9485 198.385 54.1602L192.436 54.9142L186.578 55.7992C182.64 56.351 178.77 57.0272 174.923 57.7099C167.995 58.8811 158.346 60.8877 146.762 64.1054C135.221 67.3525 121.873 71.9874 108.543 79.0431C106.877 79.923 105.202 80.8357 103.504 81.7419C101.905 82.7462 100.279 83.7604 98.6238 84.7844C95.2435 86.8129 92.0719 89.0049 89.1709 91.4129C83.378 96.1959 78.6074 101.967 78.0338 108.546C77.294 114.99 81.4274 122.552 88.811 129.108C96.1002 135.637 106.65 140.846 118.423 144.665C124.317 146.594 130.518 148.237 136.942 149.625C140.136 150.384 143.361 150.941 146.606 151.608C149.863 152.138 153.122 152.757 156.411 153.172C169.575 155.083 183.057 155.934 196.491 155.856C223.392 155.673 249.966 151.343 274.238 143.485C298.497 135.676 320.804 124.452 339.829 111.316C344.396 108.028 348.386 104.528 351.167 100.623C353.907 96.7776 355.441 92.4223 355.261 88.0165C355.106 83.6174 353.201 79.3874 349.491 75.7164C345.809 72.0356 340.509 68.8775 334.697 66.6537C326.531 63.4795 317.512 62.3798 308.798 62.4755C300.056 62.581 291.528 63.8394 283.41 65.4576C267.21 68.7397 253.072 73.8441 241.002 79.9253C228.936 85.9902 218.848 93.0781 210.763 100.455C202.782 107.825 197.127 115.874 193.464 123.98C189.801 132.085 188.125 140.263 187.889 148.011C187.882 151.713 188.363 155.302 189.473 158.731C190.658 162.162 192.162 165.453 194.289 168.51C198.304 174.663 203.712 180.003 209.229 184.579C214.742 189.172 220.44 193.004 225.699 196.309C238.165 204.147 251.531 210.839 264.769 216.985C278.035 223.121 291.304 228.694 304.317 234.001C330.37 244.606 355.485 254.194 379.353 264.248C403.123 274.381 426.095 284.645 446.118 298.134C451.105 301.505 455.84 305.142 460.081 309.101C464.321 313.059 468.174 317.317 471 321.889C476.746 331.061 477.843 341.153 474.68 349.379C474.494 349.962 474.288 350.522 474.11 351.073C473.862 351.604 473.595 352.112 473.351 352.627C472.844 353.633 472.389 354.636 471.834 355.541C470.615 357.285 469.636 358.989 468.39 360.373C467.167 361.764 466.094 363.072 464.962 364.135C463.802 365.207 462.734 366.129 461.746 366.949C457.676 370.092 455.029 371.213 454.252 370.716C453.409 370.183 454.431 368.049 457.02 364.285C457.617 363.321 458.321 362.246 459.146 361.099C459.952 359.928 460.653 358.587 461.574 357.184C462.496 355.781 463.151 354.146 464.093 352.484C464.484 351.622 464.812 350.707 465.193 349.79C465.395 349.334 465.578 348.856 465.785 348.384C465.921 347.892 466.061 347.384 466.202 346.876C468.612 339.536 467.249 331.417 462.292 323.892C459.805 320.118 456.425 316.538 452.59 313.133C448.76 309.711 444.415 306.499 439.738 303.478C420.976 291.308 398.476 281.544 374.941 271.846C351.289 262.205 326.139 252.837 299.728 242.239C286.513 236.928 272.98 231.3 259.27 225.024C245.574 218.698 231.589 211.764 218.081 203.286C212.836 200.02 206.987 196.093 200.977 191.275C194.968 186.457 188.717 180.673 183.474 173.633C178.358 166.593 174.436 158.172 173.834 149.417C173.489 144.965 173.854 140.887 174.452 136.519C175.083 132.214 176.137 127.85 177.718 123.507C180.834 114.81 185.855 106.11 193.127 97.9965C196.74 93.9335 201.013 90.0531 205.609 86.3852C210.19 82.6781 215.281 79.1472 220.807 75.7894C231.854 69.0902 244.755 63.1324 259.595 58.6104C267.025 56.3608 274.938 54.4742 283.28 53.0589C291.627 51.6271 300.694 50.6236 310.645 50.9229C317.141 51.1312 323.851 51.9454 330.693 53.6602C337.498 55.4177 344.095 58.0173 350.1 61.4758C356.048 64.9541 361.46 69.36 365.172 74.4953C368.907 79.6371 370.581 85.1613 370.593 90.1732C370.637 95.6175 368.95 100.618 366.109 105.106C363.278 109.562 359.389 113.337 355.157 116.699C350.902 120.056 346.308 122.983 341.674 125.777C337.056 128.609 332.243 131.317 327.325 133.944C307.617 144.404 285.348 153.01 261.339 158.631C237.31 164.229 211.502 166.707 185.905 165.663C173.124 165.217 160.384 163.794 148.018 161.663C135.656 159.516 123.678 156.717 112.148 152.754C100.67 148.788 89.7517 143.441 81.2253 136.517C72.7988 129.69 66.7865 121.574 64.8409 113.541C63.894 109.522 64.0217 105.66 64.9019 102.2C65.8058 98.746 67.4105 95.6976 69.3248 92.9993C73.1726 87.6257 78.0466 83.5939 82.6551 80.247C92.0818 73.8053 100.231 69.3208 106.216 66.6012C112.058 63.7541 115.484 62.4789 115.484 62.4789C115.484 62.4789 116.74 61.9795 119.11 61.03C121.424 60.0117 125.11 58.8083 129.775 57.1877C139.19 54.0939 153.222 50.1067 171.479 46.9171C189.684 43.6423 212.096 41.319 237.332 40.3583C240.484 40.2595 243.688 40.1574 246.915 40.0618C250.156 40.0054 253.445 39.9622 256.762 39.909C263.392 39.8191 270.216 39.8535 277.21 40.0056C291.19 40.3426 305.948 41.2649 321.188 43.6609C336.423 46.0731 352.153 49.9098 367.262 56.2729C382.205 62.5902 396.194 71.1658 407.084 81.6712C412.519 86.9125 417.104 92.6592 420.42 98.6729C423.737 104.686 425.687 110.957 426.152 116.994C426.665 123.044 425.815 128.876 424.038 134.293C422.233 139.72 419.473 144.741 416.135 149.374C412.792 154.023 408.848 158.277 404.495 162.17C400.127 166.024 395.393 169.548 390.44 172.765C380.552 179.22 369.619 184.311 358.591 188.458C336.469 196.717 313.823 200.898 294.302 203.421C175.383 214.852 112.323 204.229 75.6111 194.875C47.6233 187.686 21.7911 177.477 -0.104841 164.423C-11.0088 157.829 -20.9531 150.336 -28.4577 141.736C-32.1981 137.44 -35.2263 132.864 -37.2862 128.185C-39.318 123.497 -40.367 118.745 -40.3077 114.211C-40.1565 105.117 -36.106 97.1718 -30.4964 90.6626C-24.8732 84.1043 -17.7737 78.73 -10.1393 74.0856C-2.4341 69.4607 5.67446 65.5823 14.1589 62.0899C22.6153 58.6074 31.5348 55.7467 40.7614 53.4294L40.776 53.4687Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M277.604 -1.48903C276.053 0.904158 273.976 2.44629 272.068 3.55908C270.141 4.64897 268.308 5.3063 266.773 5.71108C263.662 6.49118 261.664 6.2741 260.993 5.57717C260.28 4.85081 260.901 3.61181 262.525 1.87371C264.073 0.132401 266.891 -2.1575 268.561 -5.25842C269.676 -7.45452 269.45 -9.66867 268.019 -11.8453C266.541 -14.0351 263.774 -16.2462 260.472 -17.8113C257.298 -19.3766 253.225 -20.4494 248.931 -21.0896C244.59 -21.7428 239.891 -22.0188 234.887 -22.2028C215.034 -22.9815 193.654 -22.6478 172.26 -18.0327C166.213 -16.7413 160.93 -15.2739 156.283 -13.7189C151.698 -12.1115 147.688 -10.4688 144.191 -8.75462C137.146 -5.32294 131.975 -1.77888 127.651 1.82314C123.371 5.45459 119.976 9.18978 117.195 13.5532C114.466 17.9133 112.341 22.9344 111.605 29.2739C111.347 31.9538 111.321 34.8037 111.617 37.7778C111.959 40.7649 112.624 43.8761 113.623 47.0623C115.701 53.4213 119.09 60.09 123.955 66.4785C133.505 79.3474 148.802 90.9122 165.173 99.1409C173.349 103.288 181.725 106.714 189.847 109.312C197.928 112.057 205.755 113.885 212.796 115.338C226.972 118.092 238.193 118.76 244.37 119.021C246.197 119.121 248.032 119.099 249.868 119.165C251.689 119.193 253.535 119.315 255.351 119.27C256.979 119.262 258.96 119.262 261.247 119.26C263.539 119.241 266.101 119.067 268.999 118.969C271.878 118.847 274.975 118.486 278.37 118.243C280.043 118.071 281.763 117.823 283.554 117.595C285.344 117.367 287.205 117.158 289.055 116.805C296.634 115.673 304.787 113.747 313.244 111.181C321.729 108.606 330.397 105.182 338.113 100.613C345.809 96.021 352.423 90.1068 355.938 82.719C359.492 75.377 359.986 66.6955 355.563 58.4361C351.261 50.1044 342.592 42.135 332.258 36.0512C321.829 29.8529 309.648 25.3043 297.285 21.7814C279.717 16.8725 263.409 14.0225 248.796 12.5758C234.149 10.9785 221.318 11.1709 210.117 11.5316C187.82 12.7049 172.43 15.9992 162.203 18.5339C138.239 24.908 119.51 33.5753 105.23 43.79C97.9387 48.8468 91.2838 53.9912 88.5 59.8353C85.6207 65.5648 87.3996 72.5467 91.9001 79.2402C94.3397 82.9127 96.5112 85.7175 97.7048 87.7405C98.9219 89.77 99.2648 91.0111 98.5444 91.4116C97.8758 91.8088 96.1203 91.3588 93.5856 89.7764C91.0745 88.2005 87.6526 85.5086 84.3886 81.3261C81.4253 77.5265 79.0798 73.4215 77.8332 69.1088C76.6057 64.819 76.6369 60.2951 78.2029 56.2836C79.7409 52.282 82.4371 48.777 85.5183 45.6253C88.5849 42.4342 92.1982 39.747 95.8141 36.8665C110.416 25.4885 130.161 15.9027 155.673 9.07476C165.679 6.60259 181.294 2.77078 203.538 1.0537C204.916 0.940661 206.322 0.817765 207.751 0.70139C209.176 0.601409 210.677 0.593054 212.168 0.529024C215.164 0.440248 218.241 0.338257 221.388 0.255844C224.555 0.196347 227.865 0.352888 231.253 0.407773C232.943 0.451604 234.661 0.485561 236.379 0.519521C238.116 0.576396 239.892 0.767527 241.668 0.870216C255.93 1.65561 271.752 3.96563 288.581 7.96477C291.318 8.63301 294.068 9.2521 296.786 9.98588C299.5 10.736 302.224 11.5419 304.911 12.3904C310.303 14.1102 315.684 16.0561 320.913 18.2773C332.141 23.0563 343.568 29.3189 352.888 37.3268C357.528 41.3079 361.627 45.6859 364.91 50.35C368.142 55.0174 370.549 60.0035 371.67 64.9519C373.956 74.878 371.468 84.0663 366.635 91.5311C361.804 99.0843 354.516 104.865 346.94 109.296C339.313 113.731 331.409 116.961 324.076 119.413C320.367 120.61 316.92 121.774 313.532 122.636C311.857 123.09 310.257 123.548 308.704 123.93C307.131 124.289 305.615 124.628 304.179 124.954C301.32 125.645 298.676 126.113 296.351 126.529C294.026 126.945 292.087 127.343 290.409 127.532C287.134 127.985 285.339 128.229 285.339 128.229C285.339 128.229 284.676 128.328 283.412 128.49C282.134 128.613 280.23 128.792 277.781 129.015C275.369 129.283 272.326 129.447 268.799 129.618C265.301 129.868 261.225 129.818 256.76 129.888C247.747 129.778 236.908 129.198 224.832 127.395C212.775 125.614 199.482 122.61 186.12 118.017C172.711 113.499 159.317 107.275 147.197 99.6572C135.069 92.0719 124.396 82.9846 116.457 73.2946C108.564 63.6176 103.438 53.4885 101.116 44.152C98.7234 34.796 99.3468 26.2913 101.34 19.5408C104.43 9.37229 110.385 1.70635 116.67 -4.12228C122.964 -9.98368 129.644 -14.1159 135.817 -17.2419C148.286 -23.4776 158.481 -25.8976 166.123 -27.6299C177.804 -30.186 189.48 -31.3498 200.694 -31.8481C211.945 -32.3006 222.799 -32.0517 233.258 -31.3829C238.452 -31.0583 243.774 -30.6454 249.272 -29.6725C254.736 -28.6734 260.353 -27.1209 265.536 -24.3657C270.567 -21.7053 274.883 -18.1136 277.414 -13.8516C278.632 -11.7336 279.316 -9.42832 279.263 -7.30882C279.258 -5.17628 278.555 -3.18376 277.477 -1.48888L277.604 -1.48903Z",
        fill: "#101214"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M42.7754 35.4C42.7754 32.1415 45.4169 29.5 48.6754 29.5H334.088C337.346 29.5 339.988 32.1415 339.988 35.4V136.438H42.7754V35.4Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "61.9502",
        y: "47.2002",
        width: "97.35",
        height: "7.375",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "259.6",
        height: "7.375",
        transform: "matrix(-1 0 0 1 321.55 94.3994)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "155.613",
        height: "7.375",
        transform: "matrix(-1 0 0 1 217.562 112.1)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "91.4502",
        y: "64.8994",
        width: "27.2875",
        height: "7.375",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "78.5439",
        cy: "68.2188",
        r: "5.53125",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "68.9561",
        cy: "68.2188",
        r: "5.53125",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M219.69 36.7788C220.509 35.6029 219.584 34.7748 218.575 35.7731C217.145 37.1872 215.712 38.7375 213.957 40.8095C212.018 43.203 211.715 43.963 210.351 45.5397C209.207 46.8783 207.663 48.6705 206.139 50.1262C204.647 51.6085 203.323 52.894 202.807 53.3894C202.654 53.5368 202.511 53.6919 202.372 53.8507C201.381 55.0001 197.026 60.029 193.091 64.1883C190.36 67.1716 188.671 69.0168 187.789 69.981C185.709 72.261 184.242 74.0533 182.878 75.8871C182.831 75.9514 182.787 76.0119 182.747 76.0686C182.703 76.1329 182.663 76.1934 182.63 76.2463C182.597 76.4089 182.568 76.5791 182.579 76.6736C182.589 76.7644 182.608 76.8475 182.637 76.9156C182.696 77.0555 182.791 77.1538 182.9 77.203C183.014 77.2521 183.145 77.2483 183.284 77.1916C183.354 77.1614 183.423 77.1198 183.493 77.0631C183.562 77.0063 183.61 76.9837 183.661 76.9345C183.686 76.9232 183.716 76.9118 183.741 76.8967C183.771 76.8778 183.785 76.874 183.836 76.8286C185.537 75.3237 187.19 73.7092 189.285 71.4367C190.097 70.5519 192.002 68.9147 194.426 66.3473C194.821 65.9276 195.194 65.489 195.549 65.039C198.587 61.1294 202.99 56.4937 202.99 56.4937C202.99 56.4937 204.603 54.7355 206.555 52.6067C207.045 52.0735 207.554 51.5177 208.066 50.9619C208.578 50.406 209.093 49.8502 209.554 49.2831C210.497 48.1638 211.368 47.1278 212.018 46.3565C213.971 44.0273 214.915 42.9081 215.492 42.2199C217.237 40.1327 218.527 38.4463 219.687 36.7788H219.69Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M237.166 36.5668C237.272 36.253 236.365 35.3985 236.072 35.5346C235.868 35.6291 235.674 35.7426 235.484 35.8862L236.957 35.8144C236.815 35.6102 236.647 35.4136 236.434 35.2094C235.919 34.8048 235.63 34.888 235.326 34.5628C234.782 34.0524 234.091 32.9256 233.93 32.6534C233.904 32.6118 233.875 32.5815 233.838 32.5551C233.571 32.3698 232.419 31.5417 231.593 30.6418C230.964 30.0557 230.576 29.6927 230.372 29.5037C229.889 29.0613 229.447 28.8193 228.938 28.6681C228.66 28.5849 227.944 29.3978 228.05 29.6776C228.243 30.1843 228.518 30.6153 228.986 31.0729C229.172 31.2468 229.359 31.8366 229.871 32.3887C229.955 32.4794 230.057 32.5475 230.174 32.5967C231.202 33.0088 232.116 34.0259 232.116 34.0259C232.116 34.0259 233.586 35.4174 234.208 36.0035C234.679 36.4421 234.906 36.6538 235.045 36.7824C235.261 36.979 235.469 37.1378 235.678 37.2626L236.544 37.7882L236.877 37.2021C236.998 36.9941 237.089 36.7824 237.162 36.5631L237.166 36.5668Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M222.078 31.8333C221.368 32.8429 222.275 33.6899 223.175 32.8618C224.447 31.6896 225.712 30.3927 227.255 28.642C228.956 26.6116 229.201 25.9385 230.404 24.6114C230.901 24.0404 231.501 23.39 232.133 22.717C232.291 22.5506 232.452 22.3843 232.613 22.2141L233.055 21.8511C233.22 21.7528 233.373 21.6356 233.538 21.5486C233.706 21.4806 233.859 21.3747 234.024 21.3369C234.671 21.1138 235.286 21.1478 235.776 21.2915C236.269 21.4428 236.642 21.6583 236.843 21.7982C236.964 21.87 237.085 21.957 237.213 22.0288C237.443 22.1536 237.86 22.4334 238.364 22.9061C238.865 23.3787 239.458 24.0517 239.966 24.9138C240.478 25.7646 240.931 26.8082 241.107 27.8669C241.195 28.3887 241.209 28.9181 241.118 29.3529C241.07 29.5684 241.005 29.765 240.913 29.9163L240.88 29.973C240.88 29.973 240.869 29.9957 240.862 30.007C240.855 30.0222 240.862 30.007 240.793 30.0864L240.482 30.4305C238.182 33.0471 236.759 34.6654 236.013 35.5086C234.262 37.5088 233.04 39.0855 231.921 40.7114C231.307 41.6038 232.093 42.3449 232.898 41.6302C234.36 40.3295 235.765 38.9267 237.531 36.9379C238.215 36.1627 239.853 34.7524 241.901 32.5101C242.069 32.3286 242.23 32.1396 242.383 31.9468L242.628 31.6367L242.742 31.493L242.822 31.3456L242.954 31.0847C243.283 30.37 243.381 29.6176 243.374 28.9256C243.37 28.2261 243.25 27.5758 243.089 26.9632C242.771 25.7306 242.244 24.6643 241.725 23.7644C241.198 22.872 240.646 22.1687 240.218 21.6999C239.794 21.2272 239.513 20.9701 239.513 20.9701C239.513 20.9701 239.407 20.8756 239.213 20.7092C239.121 20.6223 238.99 20.5315 238.847 20.4181C238.705 20.3046 238.536 20.1836 238.335 20.0626C237.951 19.8055 237.447 19.5522 236.854 19.3404C236.255 19.14 235.542 19.0228 234.792 19.0833C234.046 19.1438 233.271 19.3934 232.623 19.8017C232.448 19.8887 232.305 20.0097 232.152 20.1194C231.998 20.2328 231.845 20.3387 231.709 20.4748C231.57 20.6033 231.431 20.7319 231.296 20.8605C231.172 20.9852 231.08 21.1025 230.974 21.2197C230.144 22.165 229.376 23.0422 228.806 23.6963C227.087 25.6663 226.261 26.6116 225.753 27.1939C224.217 28.9597 223.091 30.4003 222.085 31.8295L222.078 31.8333Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M193.175 84.2328C192.111 85.6129 193.007 86.475 194.258 85.2726C196.035 83.5711 197.83 81.7221 200.054 79.2606C202.526 76.4247 202.964 75.5475 204.69 73.6721C207.568 70.4694 212.673 65.3044 213.905 64.0642C214.088 63.8789 214.264 63.6899 214.432 63.4932C215.639 62.0829 220.937 55.9007 225.683 50.7546C227.336 48.9132 228.671 47.4234 229.731 46.2437C229.867 46.0887 229.998 45.9412 230.126 45.7975C230.305 45.582 230.459 45.3589 230.576 45.1283C230.817 44.6632 230.934 44.183 230.964 43.7368C231.022 42.8407 230.755 42.0996 230.437 41.5929C230.346 41.4417 230.24 41.3018 230.126 41.1656C230.071 41.0976 230.009 41.0371 229.951 40.9766C229.892 40.9161 229.823 40.848 229.786 40.8178C229.618 40.6665 229.45 40.5153 229.285 40.3678C228.953 40.0729 228.634 39.7893 228.32 39.5133C227.691 38.9612 227.091 38.447 226.51 37.9592C225.347 36.9837 224.261 36.1103 223.164 35.2708C221.961 34.3482 221.255 35.1725 222.29 36.2955C223.233 37.3164 224.202 38.326 225.281 39.3998C225.822 39.9368 226.389 40.4888 226.996 41.0635C227.3 41.3509 227.614 41.6458 227.936 41.9483C228.097 42.0996 228.261 42.2508 228.43 42.4058C228.481 42.4512 228.495 42.4701 228.517 42.4966C228.539 42.5231 228.569 42.542 228.587 42.5722C228.631 42.6251 228.671 42.6781 228.708 42.7386C228.825 42.9163 228.905 43.2037 228.868 43.5251C228.846 43.6876 228.795 43.854 228.708 44.009C228.66 44.0847 228.609 44.1603 228.547 44.2284C228.444 44.3304 228.342 44.4325 228.236 44.5422C227.183 45.5933 225.888 46.9016 224.426 48.4897C223.95 49.0077 223.493 49.5446 223.062 50.0929C219.332 54.8458 214.026 60.5818 214.026 60.5818C214.026 60.5818 206.23 69.2481 202.939 72.9083C200.463 75.6647 199.275 76.9919 198.544 77.8086C196.331 80.2815 194.678 82.2704 193.168 84.2252L193.175 84.2328Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M181.866 79.6945C182.122 78.7038 180.988 78.2236 180.498 79.1122C179.8 80.3751 179.156 81.7363 178.436 83.5323C177.679 85.5968 177.712 86.2018 177.138 87.5744C176.673 88.7427 175.975 90.2779 175.331 91.6391C175.171 91.9794 175.013 92.3084 174.867 92.6146C174.794 92.7697 174.721 92.9209 174.651 93.0646C174.527 93.3444 174.41 93.6091 174.297 93.8624C173.821 94.9325 173.448 95.7757 173.24 96.2483C173.112 96.5394 172.995 96.8268 172.892 97.0991C172.779 97.4053 172.6 97.8818 171.803 99.9311C172.713 99.364 174.801 98.1011 177.24 96.6491C178.004 96.1954 178.846 95.7 179.708 95.1858C180.443 94.7585 181.2 94.3275 181.939 93.9229C184.385 92.5012 185.899 91.624 186.689 91.1627C188.554 90.0737 189.889 89.1511 191.147 88.1453C191.838 87.5933 191.318 86.6329 190.503 86.9543C189.018 87.5366 187.559 88.2361 185.687 89.3099C184.959 89.7296 183.303 90.3422 181.146 91.5332C180.795 91.7261 180.454 91.9454 180.133 92.1874C179.551 92.6222 178.919 93.0608 178.286 93.4805C177.968 93.6885 177.65 93.8927 177.343 94.0931C176.926 94.3502 176.995 94.3237 176.886 94.3993C176.56 94.63 176.26 94.7888 176.172 94.8304C176.22 94.7245 176.235 94.6905 176.235 94.6905C176.235 94.6905 178.129 89.9225 178.93 87.9109C179.723 85.8993 180.107 84.9314 180.341 84.3339C181.047 82.5303 181.511 81.0897 181.873 79.6869L181.866 79.6945Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M182.553 76.7456C182.18 76.8779 182.283 78.1446 182.535 78.277C182.915 78.4736 183.303 78.6173 183.826 78.7458C184.429 78.8366 184.66 78.6437 185.054 78.8252C185.395 78.9538 185.804 79.2449 186.093 79.5437C186.385 79.8424 186.55 80.1335 186.583 80.2356C186.598 80.2659 186.616 80.2923 186.645 80.3074C186.751 80.3906 187.062 80.6515 187.413 81.0712C187.764 81.4872 188.144 82.043 188.397 82.6026C188.81 83.3626 188.985 83.8466 189.077 84.0886C189.285 84.6709 189.479 85.0339 189.706 85.4082C189.826 85.5935 190.876 85.8317 191.026 85.4611C191.278 84.8183 191.26 84.1226 191.008 83.3664C190.905 83.079 190.949 82.3493 190.569 81.5288C190.507 81.3964 190.422 81.2754 190.313 81.1771C189.841 80.7423 189.41 80.2054 189.069 79.7743C188.733 79.347 188.492 79.0181 188.492 79.0181C188.492 79.0181 188.389 78.9009 188.225 78.7156C188.031 78.5152 187.757 78.2543 187.439 78.035C186.81 77.5775 186.031 77.2296 185.559 77.0519C184.85 76.791 184.491 76.7229 184.276 76.6662C183.614 76.5225 183.062 76.5603 182.55 76.7381L182.553 76.7456Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M177.729 90.3952C177.587 90.4217 176.643 91.2308 176.581 91.3594C176.49 91.5409 176.464 91.6732 176.53 91.7678C176.654 91.8358 176.877 91.7073 176.91 91.8018C177.002 91.9266 176.899 92.369 176.877 92.4862C176.877 92.5013 176.877 92.5127 176.888 92.5164C176.972 92.5505 177.32 92.6979 177.473 92.9929C177.627 93.1592 177.74 93.2575 177.795 93.3067C177.934 93.4239 178.124 93.4126 178.362 93.2953C178.494 93.2311 179.104 92.3274 179.145 92.195C179.214 91.9493 179.24 91.8056 179.166 91.7262C179.134 91.6959 179.276 91.4199 179.236 91.2989C179.229 91.28 179.203 91.28 179.156 91.2989C178.951 91.3745 178.826 91.3367 178.753 91.2838C178.68 91.2271 178.662 91.159 178.662 91.159C178.662 91.159 178.417 90.8225 178.314 90.6788C178.227 90.5654 178.186 90.5124 178.161 90.4784C178.077 90.3801 177.934 90.3574 177.733 90.3952H177.729Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M168.438 101.285C168.661 101.259 168.87 101.24 169.063 101.202C169.257 101.16 169.433 101.115 169.597 101.066C169.923 100.971 170.19 100.873 170.402 100.775C170.618 100.673 170.753 100.578 170.874 100.476C170.994 100.382 170.954 100.317 170.954 100.268C170.943 100.219 170.928 100.177 170.899 100.143C170.87 100.113 170.83 100.087 170.778 100.083C170.753 100.083 170.724 100.083 170.705 100.068C170.691 100.053 170.724 100.087 170.746 100.117C170.764 100.14 170.778 100.162 170.786 100.174C170.804 100.204 170.811 100.223 170.815 100.227C170.826 100.283 170.735 99.7274 170.771 99.9619L170.76 99.9543L170.735 99.943C170.735 99.943 170.702 99.9278 170.683 99.9203C170.647 99.9051 170.607 99.89 170.563 99.8787C170.475 99.8522 170.376 99.8295 170.267 99.8068C170.043 99.769 169.769 99.7426 169.447 99.7388C169.126 99.7426 168.753 99.7501 168.328 99.7577C167.729 99.769 167.125 99.8144 166.518 99.7652C166.215 99.7539 165.911 99.7388 165.608 99.7274C165.304 99.7048 165.001 99.6556 164.694 99.6216C163.469 99.4892 162.24 99.1943 161.019 98.7632C158.576 97.9011 156.192 96.2753 154.225 93.7343C153.095 92.3088 152.363 90.9779 151.793 89.8095C151.223 88.6374 150.828 87.6089 150.491 86.6334C150.162 85.6578 149.899 84.7352 149.683 83.737C149.573 83.2379 149.482 82.7199 149.405 82.1678C149.369 81.8956 149.325 81.6007 149.321 81.3435C149.314 81.0411 149.31 80.731 149.303 80.402C149.259 79.3055 149.306 78.1031 149.358 76.844C149.409 76.2163 149.464 75.5735 149.515 74.9194C149.584 74.269 149.683 73.6111 149.767 72.9419C150.166 70.2837 150.846 67.5689 151.738 65.1187C152.623 62.6647 153.716 60.483 154.755 58.7928C155.797 57.1027 156.74 55.8738 157.307 55.2272C157.64 54.8416 157.954 54.4408 158.302 54.074C158.452 53.9038 158.635 53.6997 158.85 53.4614C159.066 53.227 159.333 52.985 159.615 52.6977C159.893 52.4065 160.229 52.1229 160.595 51.8167C160.949 51.4953 161.362 51.2003 161.801 50.8789C161.911 50.7995 162.021 50.7163 162.134 50.6369C162.251 50.5651 162.372 50.4895 162.492 50.4139C162.734 50.2664 162.982 50.1076 163.238 49.9526C163.769 49.6879 164.317 49.3778 164.92 49.1661C166.113 48.6972 167.462 48.3758 168.877 48.3909C170.292 48.4023 171.762 48.7766 173.119 49.5404C173.451 49.7446 173.806 49.9147 174.113 50.1756C174.428 50.4252 174.768 50.6369 175.057 50.9394L175.507 51.3629L175.733 51.5747L175.931 51.794C176.194 52.0851 176.428 52.4103 176.651 52.7468C177.51 54.1042 178.008 55.7717 177.935 57.3863C177.902 58.1841 177.744 59.0008 177.445 59.6814C177.137 60.3734 176.684 61.0086 176.143 61.5304C175.759 61.8972 175.338 62.2034 174.903 62.4454C174.464 62.6761 174.015 62.8349 173.572 62.9332C173.126 63.0239 172.695 63.0277 172.278 62.9861C171.868 62.9256 171.473 62.8084 171.108 62.6383C170.376 62.2866 169.769 61.7346 169.301 61.122C168.844 60.4944 168.508 59.8175 168.31 59.1521C167.915 57.8287 168.003 56.5355 168.23 55.4806C168.46 54.4143 168.833 53.556 169.177 52.8867C169.586 52.0927 170.058 51.3554 170.603 50.705C170.738 50.5424 170.859 50.3685 170.998 50.2135C171.14 50.0584 171.279 49.9072 171.418 49.7559C171.685 49.4421 171.996 49.1774 172.285 48.9014C173.47 47.8238 174.757 46.9844 176.07 46.3378C178.702 45.0522 181.408 44.4888 184.092 44.4586C184.462 44.4661 184.787 44.4586 185.069 44.4359C185.35 44.417 185.584 44.4056 185.778 44.3678C186.166 44.296 186.378 44.1712 186.403 44.0162C186.429 43.8649 186.261 43.6872 185.892 43.5095C185.705 43.4225 185.467 43.328 185.178 43.2562C184.886 43.1919 184.542 43.1352 184.147 43.0936C181.273 42.878 178.282 43.2864 175.309 44.5909C173.828 45.245 172.358 46.1374 170.987 47.336C170.65 47.6423 170.296 47.9372 169.985 48.2926C169.824 48.4628 169.66 48.6367 169.499 48.8107C169.338 48.9846 169.191 49.1812 169.038 49.3665C168.413 50.1076 167.857 50.9583 167.37 51.8923C166.997 52.6183 166.555 53.5711 166.226 54.8151C165.915 56.0591 165.703 57.6056 166.08 59.3827C166.273 60.2562 166.613 61.1485 167.129 62.0068C167.645 62.8614 168.35 63.6856 169.279 64.3398C169.74 64.6725 170.27 64.9334 170.833 65.1414C170.976 65.1868 171.122 65.2321 171.268 65.2775C171.415 65.3191 171.568 65.3418 171.718 65.372C172.022 65.4439 172.333 65.4514 172.647 65.4779C173.901 65.5044 175.188 65.1603 176.311 64.4835C177.777 63.61 178.955 62.2602 179.595 60.638C180.275 58.8798 180.344 56.9514 179.949 55.1403C179.551 53.3291 178.688 51.6352 177.463 50.2891C176.242 49.0111 174.867 47.9637 173.345 47.2642C171.832 46.5647 170.226 46.2357 168.738 46.2433C167.25 46.2546 165.9 46.5571 164.734 46.9239C163.589 47.3436 162.613 47.8011 161.852 48.2548C161.476 48.4893 161.125 48.6821 160.84 48.8787C160.558 49.0791 160.313 49.253 160.119 49.3929C159.721 49.6652 159.523 49.8391 159.523 49.8391C159.523 49.8391 159.223 50.0887 158.682 50.5386C158.163 51.0113 157.413 51.6994 156.587 52.6334C154.901 54.4748 152.937 57.3409 151.365 60.7628C150.572 62.4719 149.91 64.3284 149.336 66.2114C149.08 67.1643 148.802 68.1096 148.612 69.0738C148.381 70.0266 148.231 70.987 148.07 71.9247C147.979 72.3936 147.942 72.8625 147.88 73.3275C147.825 73.7926 147.76 74.2464 147.719 74.7001C147.686 75.1538 147.654 75.6 147.621 76.0348C147.588 76.4734 147.551 76.9007 147.548 77.3242C147.537 77.7439 147.526 78.156 147.515 78.5606C147.511 78.761 147.504 78.9614 147.5 79.1543C147.504 79.3509 147.507 79.5437 147.511 79.7366C147.518 80.1185 147.526 80.489 147.533 80.8444C147.537 81.0222 147.54 81.1961 147.544 81.37C147.544 81.5288 147.559 81.7519 147.577 81.9107C147.807 83.9298 148.209 85.6125 148.641 87.072C149.08 88.5277 149.562 89.7452 150.03 90.7737C150.996 92.8231 151.888 94.1162 152.612 95.0577C154.824 97.9087 157.633 99.7539 160.415 100.62C161.809 101.058 163.184 101.319 164.526 101.387C164.862 101.406 165.195 101.437 165.524 101.44C165.853 101.433 166.182 101.425 166.507 101.421C167.162 101.429 167.798 101.338 168.435 101.278L168.438 101.285Z",
        fill: "#101214"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_6509_14303"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "295",
        height: "135",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_6509_14303"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "560.228",
        height: "332.513",
        fill: "white",
        transform: "matrix(0.963857 0.266421 0.266421 -0.963857 -72.2754 226.095)"
    }))));





const $4279c914d30201b8$export$d1e18b19fc349680 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "100%",
        height: "auto",
        viewBox: "0 0 295 135",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        "clip-path": "url(#clip0_6509_2098)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "295",
        height: "135",
        fill: "#F8F8F8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        opacity: "0.02",
        "clip-path": "url(#clip1_6509_2098)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M47.3025 60.3497C59.7178 57.3033 69.9197 56.5075 76.8074 56.5365C78.5362 56.5624 80.0687 56.601 81.3737 56.6771C82.6926 56.7906 83.815 56.9167 84.692 57.0587C86.495 57.3394 87.4324 57.699 87.5438 58.0813C87.6551 58.4636 86.9584 58.8904 85.4581 59.3461C84.6968 59.5709 83.7434 59.7928 82.5935 60.0274C81.4575 60.2993 80.107 60.5621 78.5782 60.8593C72.4448 62.0264 63.3107 63.6697 51.7586 66.8208C43.5826 69.0973 35.6886 71.8367 28.1894 75.154C20.7212 78.4463 13.3738 82.1738 6.76406 86.3729C0.17239 90.5939 -5.85905 95.4049 -10.3861 100.967C-14.9536 106.5 -17.8686 112.859 -17.8485 119.677C-17.757 126.499 -14.5307 133.668 -8.50848 140.405C-2.513 147.151 5.80883 153.418 15.2269 159.035C34.3179 170.304 57.3202 179.374 82.4065 185.789C96.6499 189.475 109.776 191.882 121.837 193.608C133.915 195.357 144.918 196.373 155.101 197.128C175.444 198.55 192.414 198.737 208.167 198.706C223.937 198.612 238.508 198.321 253.752 197.429C268.982 196.5 285.019 195.091 303.09 191.733C318.335 188.916 334.271 184.734 349.188 178.395C356.662 175.255 363.836 171.546 370.449 167.247C377.08 162.97 383.16 158.072 388.211 152.622C393.199 147.138 397.228 141.02 399.488 134.413C401.722 127.816 402.28 120.739 400.247 113.699C399.236 110.205 397.769 106.703 395.589 103.338C394.637 101.636 393.279 100.005 392.122 98.3459C390.707 96.7494 389.474 95.103 387.868 93.5877C381.9 87.3515 374.27 81.8947 366.131 77.2345C349.697 67.9546 330.949 62.7723 313.161 60.1322C295.342 57.4331 278.454 57.0337 263.286 57.0426C248.069 57.1387 234.586 57.6804 223.388 58.4183C217.814 58.8696 212.73 59.2053 208.323 59.7112C206.114 59.9377 204.031 60.1486 202.121 60.3406C200.221 60.5854 198.473 60.8051 196.898 61.006L191.251 61.7217L185.69 62.5617C181.953 63.0854 178.28 63.7272 174.629 64.3752C168.052 65.4869 158.894 67.3914 147.899 70.4455C136.945 73.5275 124.276 77.9267 111.624 84.6237C110.043 85.4589 108.453 86.3251 106.841 87.1852C105.324 88.1385 103.78 89.1011 102.209 90.073C99.0005 91.9984 95.9902 94.079 93.2367 96.3645C87.7383 100.904 83.2104 106.382 82.6659 112.626C81.9637 118.743 85.8869 125.92 92.8951 132.143C99.8137 138.34 109.827 143.284 121.002 146.909C126.596 148.74 132.482 150.3 138.579 151.617C141.611 152.337 144.672 152.865 147.751 153.499C150.843 154.002 153.936 154.589 157.058 154.983C169.552 156.797 182.349 157.605 195.1 157.531C220.633 157.357 245.856 153.247 268.894 145.789C291.919 138.376 313.092 127.724 331.149 115.256C335.484 112.135 339.271 108.813 341.911 105.107C344.511 101.456 345.967 97.3225 345.797 93.1408C345.649 88.9653 343.842 84.9504 340.32 81.4661C336.825 77.9724 331.795 74.975 326.278 72.8642C318.528 69.8514 309.967 68.8077 301.696 68.8985C293.399 68.9987 285.305 70.193 277.599 71.7289C262.223 74.8442 248.804 79.689 237.347 85.4611C225.895 91.2176 216.32 97.945 208.646 104.947C201.071 111.942 195.704 119.582 192.227 127.275C188.75 134.969 187.159 142.731 186.935 150.085C186.928 153.598 187.385 157.005 188.439 160.259C189.564 163.516 190.991 166.64 193.01 169.541C196.82 175.382 201.953 180.45 207.19 184.793C212.423 189.152 217.831 192.79 222.823 195.927C234.655 203.366 247.341 209.718 259.906 215.552C272.498 221.376 285.092 226.665 297.443 231.702C322.171 241.768 346.009 250.868 368.664 260.411C391.225 270.029 413.029 279.772 432.034 292.574C436.767 295.774 441.262 299.226 445.287 302.984C449.311 306.741 452.968 310.782 455.651 315.122C461.104 323.827 462.146 333.406 459.144 341.213C458.967 341.767 458.771 342.299 458.603 342.822C458.367 343.326 458.113 343.808 457.882 344.296C457.401 345.251 456.969 346.203 456.442 347.062C455.285 348.717 454.356 350.335 453.173 351.649C452.013 352.969 450.994 354.21 449.92 355.219C448.819 356.237 447.805 357.112 446.867 357.891C443.004 360.874 440.492 361.937 439.755 361.465C438.954 360.96 439.924 358.934 442.382 355.362C442.948 354.447 443.616 353.426 444.399 352.337C445.165 351.226 445.83 349.954 446.704 348.622C447.579 347.29 448.201 345.738 449.095 344.161C449.466 343.342 449.778 342.475 450.139 341.604C450.331 341.171 450.505 340.717 450.701 340.269C450.83 339.803 450.963 339.32 451.096 338.838C453.384 331.871 452.09 324.165 447.386 317.022C445.024 313.44 441.817 310.043 438.177 306.81C434.542 303.562 430.418 300.514 425.978 297.647C408.171 286.095 386.814 276.828 364.476 267.623C342.027 258.472 318.155 249.58 293.088 239.521C280.545 234.481 267.7 229.139 254.687 223.182C241.687 217.178 228.413 210.596 215.592 202.549C210.614 199.449 205.062 195.722 199.358 191.149C193.654 186.576 187.721 181.086 182.745 174.404C177.889 167.722 174.167 159.729 173.595 151.419C173.268 147.194 173.614 143.323 174.181 139.177C174.78 135.091 175.781 130.948 177.282 126.827C180.239 118.572 185.005 110.314 191.907 102.613C195.336 98.7569 199.392 95.0738 203.754 91.5925C208.102 88.0738 212.934 84.7225 218.179 81.5354C228.665 75.1769 240.909 69.522 254.995 65.2299C262.047 63.0947 269.558 61.3041 277.476 59.9607C285.399 58.6017 294.004 57.6493 303.449 57.9333C309.615 58.1311 315.984 58.9038 322.478 60.5314C328.937 62.1995 335.199 64.6669 340.898 67.9496C346.543 71.2511 351.68 75.433 355.204 80.3071C358.749 85.1874 360.338 90.4308 360.349 95.1879C360.391 100.355 358.79 105.102 356.094 109.362C353.406 113.59 349.715 117.173 345.698 120.365C341.659 123.551 337.299 126.33 332.901 128.981C328.517 131.669 323.949 134.24 319.281 136.733C300.576 146.661 279.439 154.83 256.65 160.165C233.843 165.478 209.348 167.83 185.053 166.839C172.921 166.416 160.829 165.065 149.092 163.043C137.358 161.005 125.989 158.348 115.046 154.586C104.152 150.822 93.788 145.748 85.6951 139.175C77.697 132.696 71.9905 124.992 70.1438 117.367C69.2451 113.553 69.3663 109.887 70.2018 106.603C71.0597 103.325 72.5827 100.431 74.3998 97.8702C78.0519 92.7698 82.6781 88.943 87.0522 85.7664C95.9996 79.6522 103.734 75.3957 109.415 72.8144C114.96 70.112 118.212 68.9018 118.212 68.9018C118.212 68.9018 119.404 68.4277 121.654 67.5265C123.85 66.56 127.348 65.4177 131.776 63.8796C140.713 60.943 154.031 57.1586 171.36 54.1312C188.639 51.0229 209.911 48.8177 233.864 47.9059C236.856 47.8121 239.897 47.7152 242.96 47.6244C246.037 47.571 249.158 47.5299 252.307 47.4795C258.599 47.3941 265.076 47.4268 271.715 47.5711C284.984 47.891 298.991 48.7664 313.456 51.0405C327.916 53.3301 342.847 56.9717 357.187 63.0112C371.371 69.0074 384.649 77.1469 394.985 87.1181C400.144 92.0929 404.495 97.5475 407.643 103.255C410.791 108.963 412.642 114.915 413.083 120.645C413.57 126.387 412.763 131.922 411.076 137.064C409.363 142.215 406.744 146.981 403.575 151.378C400.403 155.791 396.659 159.828 392.527 163.524C388.381 167.182 383.888 170.527 379.187 173.58C369.802 179.707 359.425 184.539 348.958 188.475C327.96 196.314 306.465 200.282 287.937 202.677C175.065 213.527 115.212 203.444 80.3663 194.566C53.8017 187.742 29.283 178.052 8.50041 165.662C-1.84914 159.403 -11.2878 152.291 -18.4107 144.129C-21.961 140.051 -24.8352 135.708 -26.7904 131.267C-28.7189 126.817 -29.7145 122.307 -29.6583 118.003C-29.5148 109.372 -25.6701 101.831 -20.3458 95.6524C-15.0085 89.4275 -8.27004 84.3265 -1.02382 79.9182C6.28959 75.5286 13.9859 71.8473 22.0389 68.5325C30.0653 65.2271 38.5313 62.5118 47.2887 60.3124L47.3025 60.3497Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M272.088 8.1864C270.616 10.4579 268.645 11.9216 266.834 12.9778C265.005 14.0123 263.265 14.6362 261.809 15.0204C258.855 15.7608 256.959 15.5548 256.322 14.8933C255.645 14.2039 256.235 13.0279 257.776 11.3781C259.246 9.72537 261.92 7.55192 263.505 4.60869C264.563 2.52423 264.349 0.422659 262.991 -1.64332C261.588 -3.7217 258.962 -5.82038 255.828 -7.30592C252.815 -8.79161 248.949 -9.80988 244.874 -10.4175C240.753 -11.0375 236.293 -11.2995 231.543 -11.4741C212.7 -12.2132 192.407 -11.8965 172.101 -7.51604C166.361 -6.29032 161.347 -4.89757 156.936 -3.4216C152.585 -1.89595 148.778 -0.336749 145.459 1.29026C138.772 4.54744 133.864 7.9113 129.761 11.3302C125.698 14.777 122.475 18.3222 119.836 22.4638C117.245 26.6022 115.229 31.3679 114.53 37.3851C114.285 39.9287 114.26 42.6338 114.541 45.4566C114.866 48.2918 115.497 51.2449 116.445 54.269C118.418 60.3047 121.635 66.6343 126.252 72.6979C135.317 84.9125 149.835 95.8892 165.374 103.7C173.135 107.636 181.084 110.888 188.793 113.353C196.464 115.959 203.893 117.694 210.576 119.073C224.031 121.687 234.681 122.321 240.544 122.569C242.278 122.663 244.02 122.643 245.762 122.706C247.491 122.732 249.243 122.848 250.967 122.805C252.512 122.797 254.393 122.798 256.563 122.795C258.738 122.777 261.171 122.613 263.921 122.519C266.653 122.404 269.593 122.061 272.815 121.831C274.404 121.667 276.036 121.432 277.735 121.215C279.435 120.999 281.201 120.801 282.958 120.466C290.151 119.391 297.889 117.563 305.916 115.128C313.969 112.683 322.197 109.434 329.52 105.097C336.825 100.738 343.103 95.1248 346.439 88.1127C349.812 81.1439 350.281 72.9039 346.083 65.0644C342 57.1564 333.772 49.5922 323.963 43.8178C314.064 37.9346 302.503 33.6174 290.769 30.2736C274.094 25.6143 258.615 22.9092 244.745 21.5361C230.843 20.02 218.664 20.2026 208.033 20.5449C186.87 21.6586 172.262 24.7854 162.555 27.1912C139.81 33.2412 122.033 41.4678 108.479 51.1631C101.559 55.9628 95.2422 60.8456 92.5998 66.3925C89.867 71.8308 91.5555 78.4576 95.8271 84.8108C98.1427 88.2965 100.204 90.9587 101.337 92.8788C102.492 94.8051 102.817 95.9831 102.134 96.3633C101.499 96.7403 99.8327 96.3132 97.4269 94.8112C95.0435 93.3154 91.7956 90.7605 88.6976 86.7906C85.8849 83.1842 83.6587 79.2879 82.4755 75.1945C81.3104 71.1228 81.34 66.829 82.8264 63.0215C84.2861 59.2234 86.8452 55.8965 89.7698 52.9051C92.6805 49.8763 96.11 47.3257 99.5421 44.5917C113.401 33.7922 132.143 24.6938 156.357 18.213C165.854 15.8666 180.675 12.2296 201.789 10.5998C203.096 10.4926 204.431 10.3759 205.787 10.2654C207.14 10.1705 208.564 10.1626 209.98 10.1018C212.824 10.0176 215.744 9.92077 218.731 9.84256C221.736 9.78608 224.878 9.93466 228.095 9.98676C229.698 10.0284 231.329 10.0606 232.96 10.0928C234.608 10.1468 236.294 10.3282 237.979 10.4257C251.516 11.1711 266.534 13.3637 282.507 17.1595C285.105 17.7938 287.715 18.3814 290.295 19.0778C292.871 19.7899 295.457 20.5547 298.007 21.3601C303.125 22.9925 308.233 24.8394 313.195 26.9477C323.852 31.4836 334.699 37.4279 343.544 45.0286C347.949 48.8072 351.839 52.9626 354.956 57.3895C358.023 61.8196 360.307 66.5522 361.372 71.2489C363.542 80.6704 361.179 89.3915 356.593 96.4767C352.007 103.646 345.09 109.133 337.899 113.339C330.66 117.548 323.158 120.613 316.197 122.941C312.677 124.077 309.406 125.182 306.19 126C304.6 126.431 303.081 126.865 301.607 127.228C300.114 127.568 298.675 127.89 297.312 128.2C294.599 128.856 292.089 129.301 289.882 129.695C287.675 130.089 285.835 130.468 284.242 130.647C281.134 131.077 279.43 131.309 279.43 131.309C279.43 131.309 278.801 131.403 277.601 131.557C276.388 131.673 274.581 131.843 272.256 132.054C269.967 132.309 267.079 132.465 263.731 132.627C260.411 132.865 256.542 132.816 252.304 132.884C243.749 132.779 233.462 132.229 222 130.517C210.556 128.827 197.939 125.975 185.256 121.616C172.529 117.328 159.816 111.42 148.313 104.19C136.801 96.99 126.671 88.3648 119.135 79.1675C111.644 69.9825 106.779 60.3685 104.575 51.5067C102.303 42.6264 102.895 34.5542 104.787 28.1469C107.72 18.4955 113.372 11.2193 119.337 5.68705C125.312 0.123678 131.652 -3.79846 137.511 -6.76549C149.346 -12.6842 159.022 -14.9811 166.276 -16.6253C177.363 -19.0514 188.446 -20.156 199.089 -20.629C209.768 -21.0585 220.07 -20.8222 229.997 -20.1874C234.927 -19.8793 239.979 -19.4874 245.197 -18.564C250.384 -17.6158 255.715 -16.1422 260.634 -13.5271C265.409 -11.0019 269.506 -7.59289 271.908 -3.54758C273.064 -1.5373 273.713 0.6508 273.663 2.66253C273.658 4.68663 272.991 6.57784 271.968 8.18654L272.088 8.1864Z",
        fill: "#101214"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M72.3008 43.1996C72.3008 40.1068 74.808 37.5996 77.9008 37.5996H348.801C351.894 37.5996 354.401 40.1068 354.401 43.1996V139.1H72.3008V43.1996Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "90.5",
        y: "54.3994",
        width: "92.4",
        height: "7",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "246.4",
        height: "7",
        transform: "matrix(-1 0 0 1 336.9 93.5996)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "147.7",
        height: "7",
        transform: "matrix(-1 0 0 1 238.2 110.399)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "118.5",
        y: "71.1992",
        width: "25.9",
        height: "7",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "106.25",
        cy: "74.3496",
        r: "5.25",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "97.1504",
        cy: "74.3496",
        r: "5.25",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        "clip-path": "url(#clip2_6509_2098)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M47.5342 54.3963C46.7568 53.9604 45.0637 55.714 45.3984 56.4247C45.8732 57.4531 46.4554 58.4104 47.2851 59.5701C47.8048 60.1854 48.2144 60.5247 48.564 60.8248L48.6289 60.8796L48.7227 60.9833L48.9152 61.2063C49.0391 61.3517 49.1546 61.5032 49.269 61.6619C49.499 61.9721 49.7171 62.3098 49.9429 62.7816C50.398 63.6593 50.9237 64.8287 51.5125 66.2001C52.5124 65.2191 53.5647 64.1876 54.4513 63.3137C54.9352 62.8316 55.4108 62.3999 55.8162 62.0379C56.0582 61.819 56.1059 61.7973 56.2062 61.725C56.2897 61.6648 56.3648 61.6106 56.4233 61.5685C56.5224 61.5034 56.6022 61.4205 56.676 61.3292C57.153 60.6617 59.46 57.8056 62.0277 55.98C63.7426 54.5913 64.8666 53.8001 65.4489 53.393C66.8234 52.4212 67.7555 51.5399 68.5948 50.5033C69.0555 49.9364 68.005 48.0919 67.2576 48.2435C65.8944 48.5092 64.6088 49.0235 63.1172 50.0353C62.5372 50.428 61.001 50.8057 59.2984 52.0267C59.0228 52.2254 58.7845 52.467 58.5823 52.7587C57.7127 53.9821 56.5798 55.1923 55.6767 56.1225C54.7747 57.0456 54.0821 57.6782 54.0821 57.6782L53.1314 58.6745L52.6835 59.1624C52.5238 59.3282 52.3632 59.5456 52.2237 59.6778C52.1295 59.4856 52.0342 59.3005 51.9233 59.1202C51.8534 59.0056 51.7883 58.9066 51.7293 58.8159C51.5401 58.5271 51.3739 58.2788 51.2317 58.064C50.939 57.6404 50.7271 57.3553 50.5706 57.1382C49.5883 55.8283 48.596 54.9889 47.515 54.3784L47.5342 54.3963Z",
        fill: "#6A9A23"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M79.8814 39.7076C80.0406 39.9989 80.2033 40.2687 80.3624 40.5158C80.5048 40.7749 80.6279 41.0161 80.7629 41.2297C81.0245 41.663 81.2834 42.0222 81.5275 42.2904C82.0146 42.834 82.4584 43.0535 82.7846 42.9515C83.1109 42.8496 83.3065 42.4167 83.3044 41.6567C83.3075 41.2737 83.2576 40.8083 83.1535 40.2678C83.0937 40 83.0386 39.7034 82.9415 39.3927C82.8349 39.0951 82.7018 38.7785 82.5568 38.4453C80.9627 34.6319 78.5747 30.9848 75.2452 27.7307C71.9195 24.4994 67.652 21.5726 62.156 19.8995C59.0404 19.0106 56.37 18.6955 54.0738 18.8025C53.5006 18.8349 52.9535 18.7978 52.4225 18.8887C51.8939 18.9652 51.3879 19.038 50.8975 19.106C49.9082 19.2036 49.0215 19.5318 48.1524 19.7523C44.7807 20.8058 42.1224 22.1447 38.5784 24.5789C37.8254 25.0837 37.1064 25.6972 36.3382 26.2954C35.6062 26.9437 34.8382 27.5861 34.1138 28.3242C32.6419 29.7596 31.2068 31.378 29.9016 33.1502C28.5904 34.9141 27.3899 36.8139 26.3465 38.7908C25.2887 40.7654 24.4564 42.8504 23.7519 44.8749C22.3311 48.9515 21.6763 53.0344 21.5462 56.428C21.3995 59.8336 21.823 62.5426 22.1132 64.0278C22.2037 64.4703 22.2942 64.9127 22.4002 65.3503L22.7936 66.6531C23.3065 68.1745 24.3531 71.0435 26.6425 74.2985C27.8056 75.9032 29.2385 77.618 31.0407 79.1935C32.8344 80.7751 34.9283 82.28 37.294 83.5634C42.0053 86.164 47.8243 87.801 53.8465 88.0033C56.8522 88.1147 59.9151 87.874 62.8629 87.3417C63.6082 87.2487 64.3421 87.0432 65.0751 86.8892C65.8056 86.7053 66.5471 86.5896 67.2642 86.3519C67.9861 86.1297 68.7008 85.9064 69.4156 85.683C70.1352 85.4752 70.8159 85.1431 71.5149 84.8804C75.406 83.262 78.6532 81.1115 81.2198 78.7916C83.7937 76.4729 85.7016 74.0314 87.1686 71.7618C89.9981 67.1393 91.1866 63.3126 91.8599 60.7077C92.6483 57.6201 93.0267 54.6502 93.1437 51.8372C93.2679 49.0253 93.1174 46.3606 92.739 43.8285C91.9774 38.7932 90.508 34.2109 87.8314 30.2515C87.4939 29.6952 87.0672 29.2794 86.7257 28.929C86.3855 28.5714 86.0266 28.3288 85.7218 28.1614C85.1124 27.8266 84.6958 27.8032 84.4777 28.0112C84.2596 28.2192 84.2555 28.6537 84.4615 29.2476C84.5681 29.5452 84.7216 29.8725 84.8981 30.2846C85.0746 30.6967 85.3481 31.1025 85.5945 31.6292C87.5819 35.3367 88.6142 39.6121 89.0762 44.267C89.3101 46.5986 89.3555 49.0471 89.1812 51.6223C89.0081 54.1902 88.6225 56.886 87.9046 59.6754C87.3551 61.8356 86.1775 65.1405 83.7558 68.8851C82.5192 70.7349 80.991 72.6995 79.0039 74.5382C77.0108 76.3684 74.5935 78.0857 71.732 79.4949C69.8883 80.4496 67.9262 81.1786 65.9545 81.8766C64.8861 82.2343 63.7575 82.5085 62.623 82.8187C61.469 83.0224 60.2889 83.2956 59.107 83.4432C56.7424 83.7898 54.3129 83.8088 51.9364 83.6372C50.7465 83.5622 49.5763 83.3651 48.411 83.1835C47.2645 82.9311 46.1312 82.6883 45.0526 82.3364C42.8833 81.66 40.851 80.8215 39.0753 79.8108C35.5132 77.8096 32.9115 75.389 31.3712 73.4724C30.9932 72.9833 30.6586 72.5456 30.3661 72.1662C30.0999 71.7617 29.8757 71.4156 29.6926 71.1351C29.5095 70.8547 29.3673 70.6398 29.2888 70.487C29.2032 70.333 29.1645 70.253 29.1645 70.253C29.1645 70.253 29.0958 70.1312 28.9763 69.9127C28.8581 69.687 28.652 69.3659 28.443 68.9264C28.2424 68.4809 27.9672 67.9495 27.7095 67.3103C27.4757 66.6602 27.1506 65.9364 26.9267 65.0888C25.8411 61.7783 25.2846 56.8426 26.1542 51.526C26.5771 48.8732 27.3216 46.1471 28.3466 43.5108C29.3681 40.8961 30.718 38.3936 32.2413 36.1405C33.7646 33.8874 35.4829 31.8872 37.2172 30.2435C38.9526 28.5927 40.7171 27.308 42.2903 26.3389C44.6573 24.8864 46.9248 23.9561 48.9247 23.4028C49.4233 23.2846 49.8991 23.17 50.3666 23.0614C50.8232 22.929 51.2936 22.9389 51.7326 22.87C52.1752 22.8237 52.5974 22.7669 53.009 22.7304C53.4219 22.7309 53.8264 22.7376 54.2106 22.7335C57.2927 22.7835 59.4134 23.3044 60.9714 23.7931C65.7398 25.2229 69.583 27.7195 72.6696 30.4696C75.76 33.2423 78.1253 36.3474 79.8932 39.68L79.8814 39.7076Z",
        fill: "#6A9A23"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_6509_2098"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "295",
        height: "135",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_6509_2098"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "531.742",
        height: "315.605",
        fill: "white",
        transform: "matrix(0.963857 0.266421 0.266421 -0.963857 -60 224.198)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_6509_2098"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "70.5432",
        height: "69.0945",
        fill: "white",
        transform: "translate(28.1211 14.165) rotate(9.21254)"
    }))));









var $2K2hA = parcelRequire("2K2hA");


var $6OwHS = parcelRequire("6OwHS");


var $4enp7 = parcelRequire("4enp7");


var $6VFk2 = parcelRequire("6VFk2");


var $2Vz7H = parcelRequire("2Vz7H");


var $l3ydK = parcelRequire("l3ydK");


var $4AC39 = parcelRequire("4AC39");


var $gi4qj = parcelRequire("gi4qj");


var $uyMbP = parcelRequire("uyMbP");


var $3eYzF = parcelRequire("3eYzF");


var $8jXZv = parcelRequire("8jXZv");


var $9Zall = parcelRequire("9Zall");


var $dOlTT = parcelRequire("dOlTT");

const $12f4e4dea8469f82$var$MAX_DISMISSED_REVIEW_IDS = 200;
const $12f4e4dea8469f82$var$getDismissedReviewIds = ()=>{
    try {
        const stored = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_APPROVALS_COMPLETION_SPOTLIGHT_DISMISSED);
        if (stored) {
            const parsed = JSON.parse(stored);
            if (Array.isArray(parsed)) return parsed;
        }
    } catch  {}
    return [];
};
const $12f4e4dea8469f82$var$addDismissedReviewId = (reviewId)=>{
    try {
        const dismissed = $12f4e4dea8469f82$var$getDismissedReviewIds();
        if (!dismissed.includes(reviewId)) {
            const updated = [
                ...dismissed,
                reviewId
            ].slice(-$12f4e4dea8469f82$var$MAX_DISMISSED_REVIEW_IDS);
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_APPROVALS_COMPLETION_SPOTLIGHT_DISMISSED, JSON.stringify(updated));
        }
    } catch  {}
};
const $12f4e4dea8469f82$var$styles = {
    body: "_1ANEUSlpBW _1wydGW2ADO",
    spotlightTargetContainer: "_1mT5xdRAKS _3iDTPbvbI6",
    spotlightTargetAnchor: "_1mT5xdWVPG _0Bm75GPgdg _4ApkO2nlTt _39xV02Pgdg _0jFU0VPgdg _1pp6NdYbGa"
};
const $12f4e4dea8469f82$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    changesRequestedApprovalHeadline: {
        id: "approvals.completion-spotlight.denied-headline",
        defaultMessage: "Changes requested"
    },
    approvedApprovalHeadline: {
        id: "approvals.completion-spotlight.approved-headline",
        defaultMessage: "Page is approved"
    },
    changesRequestedApprovalBody: {
        id: "approvals.completion-spotlight.changes-requested-body",
        defaultMessage: "Everyone has responded, but one or more have requested changes be made before your page can be approved."
    },
    approvedApprovalBody: {
        id: "approvals.completion-spotlight.approved-body",
        defaultMessage: "Nice work! Everyone approved your page."
    },
    getDetailsCtaLabel: {
        id: "approvals.completion-spotlight.get-details-cta-label",
        defaultMessage: "Get details"
    }
});
const $12f4e4dea8469f82$export$bd4e7584535e90d7 = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { approvalRequest: approvalRequest, contentId: contentId, contentStatus: contentStatus, isCurrentUserRequestor: isCurrentUserRequestor } = (0, $laFNM.useApprovals)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const reviewId = approvalRequest?.review?.reviewId;
    const reviewStatus = approvalRequest?.review?.reviewStatus;
    const isCompleted = reviewStatus === 'APPROVED' || reviewStatus === 'DENIED';
    const isChangesRequested = reviewStatus === 'DENIED';
    const [isDismissed, setIsDismissed] = (0, $cozmU.useState)(()=>reviewId ? $12f4e4dea8469f82$var$getDismissedReviewIds().includes(reviewId) : false); // Reset dismissed state when reviewId changes (new approval cycle)
    (0, $cozmU.useEffect)(()=>{
        if (reviewId) setIsDismissed($12f4e4dea8469f82$var$getDismissedReviewIds().includes(reviewId));
    }, [
        reviewId
    ]);
    const dismiss = (0, $cozmU.useCallback)(()=>{
        setIsDismissed(true);
        if (reviewId) $12f4e4dea8469f82$var$addDismissedReviewId(reviewId);
    }, [
        reviewId
    ]);
    const dismissAndOpenApprovalsPane = (0, $cozmU.useCallback)(()=>{
        dismiss();
        (0, $1vpkQ.openApprovalsPaneForContext)({
            contentId: contentId,
            contentStatus: contentStatus,
            rightSidebarContext: rightSidebarContext
        });
    }, [
        contentId,
        contentStatus,
        dismiss,
        rightSidebarContext
    ]);
    const isVisible = isCurrentUserRequestor && isCompleted && !isDismissed; // Re-key the PopoverProvider whenever the object sidebar (details panel) opens or closes,
    // which shifts the page content left/right and moves the popup anchor's viewport position.
    // Remounting PopoverProvider forces Popper.js to recalculate from the updated anchor coordinates.
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const [popoverKey, setPopoverKey] = (0, $cozmU.useState)(0); // Use a ref so the effect below can read the latest isVisible without needing it as a
    // dependency — we only want to remount when the sidebar state changes, not when visibility changes.
    const isVisibleRef = (0, $cozmU.useRef)(isVisible);
    isVisibleRef.current = isVisible;
    (0, $cozmU.useEffect)(()=>{
        if (isVisibleRef.current) setPopoverKey((k)=>k + 1);
    }, [
        isObjectSidebarShown
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), {
        key: popoverKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $12f4e4dea8469f82$var$styles.spotlightTargetContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $12f4e4dea8469f82$var$styles.spotlightTargetAnchor
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null))), children(dismiss)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
        dismiss: dismiss,
        placement: "bottom-end",
        isVisible: isVisible,
        shouldDismissOnClickOutside: false,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
        testId: "spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, formatMessage(isChangesRequested ? $12f4e4dea8469f82$export$a7357cdd1f0b0168.changesRequestedApprovalHeadline : $12f4e4dea8469f82$export$a7357cdd1f0b0168.approvedApprovalHeadline)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OwHS.SpotlightMedia), null, isChangesRequested ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3dc4f9522a67664$export$3c87e1f3199ca8e9), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4279c914d30201b8$export$d1e18b19fc349680), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $12f4e4dea8469f82$var$styles.body
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage(isChangesRequested ? $12f4e4dea8469f82$export$a7357cdd1f0b0168.changesRequestedApprovalBody : $12f4e4dea8469f82$export$a7357cdd1f0b0168.approvedApprovalBody)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
        onClick: dismissAndOpenApprovalsPane
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $12f4e4dea8469f82$export$a7357cdd1f0b0168.getDetailsCtaLabel)))))));
};






var $Uu0Pb = parcelRequire("Uu0Pb");


var $iNJwL = parcelRequire("iNJwL");




/* eslint-disable check-file/filename-blocklist */ 


const $adbf40b583ec3a51$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    statusLabel: {
        id: "content-state.add-status.floating-toolbar",
        defaultMessage: "Status"
    },
    changeStatus: {
        id: "content-state.change-status",
        defaultMessage: "Change status"
    },
    setPageStatus: {
        id: "content-state.set-page-status",
        defaultMessage: "Set status"
    },
    setBlogStatus: {
        id: "content-state.set-blog-status",
        defaultMessage: "Set blog post status"
    },
    addCustomStatus: {
        id: "content-state.add-custom-status",
        defaultMessage: "Add custom status"
    },
    custom: {
        id: "content-state.custom",
        defaultMessage: "Custom"
    },
    suggested: {
        id: "content-state.suggested",
        defaultMessage: "Suggested"
    },
    save: {
        id: "content-state.save",
        defaultMessage: "Save"
    },
    cancel: {
        id: "content-state.cancel",
        defaultMessage: "Cancel"
    },
    remove: {
        id: "content-state.remove",
        defaultMessage: "Remove"
    },
    showMoreStatuses: {
        id: "content-state.show.more.statuses",
        defaultMessage: "Show more statuses"
    },
    maxLengthEditor: {
        id: "content-state.max.length.editor.creation",
        defaultMessage: "Max length of 20"
    },
    featureDisabled: {
        id: "content-state.feature.disabled.message",
        defaultMessage: "The content status feature is not enabled in this space."
    },
    errorFlagTitle: {
        id: "content-state.error.flag.title",
        defaultMessage: "We can\u2019t set your status"
    },
    errorFlagBody: {
        id: "content-state.error.flag.body",
        defaultMessage: "Refresh and try again."
    },
    removeErrorFlagTitle: {
        id: "content-state.remove-error.flag.title",
        defaultMessage: "Failed to remove content state"
    },
    removeErrorFlagBody: {
        id: "content-state.remove-error.flag.body",
        defaultMessage: "Refresh and try again."
    },
    noneText: {
        id: "content-state.none.text",
        defaultMessage: "None"
    },
    colorOptionAriaLabel: {
        id: "content-state.color-option.aria-label",
        defaultMessage: "{colorName} color option"
    },
    colorPickerButtonAriaLabel: {
        id: "content-state.color-picker-button.aria-label",
        defaultMessage: "Color picker, {colorName} selected"
    },
    removeButtonAriaLabel: {
        id: "content-state.remove-button.aria-label",
        defaultMessage: "Remove status"
    },
    colorPickerListboxAriaLabel: {
        id: "content-state.color-picker-listbox.aria-label",
        defaultMessage: "Status color options"
    },
    changeStatusButtonAriaLabel: {
        id: "content-state.change-status-button.aria-label",
        defaultMessage: "Change Status: {statusName}"
    }
});



var $3qCob = parcelRequire("3qCob");

const $32fca6e0bfcfd80d$var$contentStateNameStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.025',
    marginRight: 'space.025',
    marginTop: 'space.0',
    marginBottom: 'space.0'
});
const $32fca6e0bfcfd80d$var$subtleContentStateNameStyles = (0, $buxP3.xcss)({
    font: 'font.body.small',
    color: 'color.text.subtle'
});
const $32fca6e0bfcfd80d$var$detailPanelContentStateNameStyles = (0, $buxP3.xcss)({
    font: 'font.body',
    textOverflow: 'ellipsis',
    overflowX: 'hidden',
    whiteSpace: 'nowrap'
});
const $32fca6e0bfcfd80d$var$chevronDownIconWrapperStyles = (0, $buxP3.xcss)({
    marginRight: 'space.negative.050'
});
const $32fca6e0bfcfd80d$var$subtleEmptyStateLabelStyles = (0, $buxP3.xcss)({
    fontWeight: 'font.weight.regular'
});
const $32fca6e0bfcfd80d$var$compactEmptyStateIconStyles = (0, $buxP3.xcss)({
    marginInlineEnd: 'space.negative.025'
});
const $32fca6e0bfcfd80d$var$styles = {
    approvalStatusIcon: "_2Y7lL41Y8M"
};
const $32fca6e0bfcfd80d$var$determineSecondarySSRHex = (primaryColor)=>{
    const upperCasePrimaryColor = primaryColor?.toUpperCase(); // need toUpper since color we get from BE is lowercase
    switch(upperCasePrimaryColor){
        case '#2684FF':
            return '#e9f2ff';
        case '#57D9A3':
            return '#dcfff1';
        case '#FFC400':
            return '#fff7d6';
        case '#8777D9':
            return '#f3f0ff';
        case '#FF7452':
            return '#ffeceb';
        default:
            return '#e9f2ff';
    }
};
const $32fca6e0bfcfd80d$var$getContentStateButtonBackgroundColor = (isWarning, isSelected, isHovered, color, hoverColor, isPressed)=>{
    if (isWarning) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return 0, (0, $Uu0Pb.SECONDARY_COLORS).RED;
    if (isSelected) return color;
    if (isPressed) return "var(--ds-background-neutral-subtle-pressed, #0B120E24)";
    return isHovered ? hoverColor : color;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $32fca6e0bfcfd80d$var$HasContentStateButton = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "button" : t5;
        const { isDetailsPanel: isDetailsPanel, isSubtle: isSubtle, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDzXzM _30huDKYbGa _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _0wOv4Q7zJH _1UtDYzy7kJ _1kk5Tkf7mX _2xIroYnXvL _02aXbKsyl5 _3DEn3pVpNL _0QAuWQVrZW",
            __cmplp.isDetailsPanel ? "_0jFU0VoWWg" : "_0jFU0VUofl",
            __cmplp.isDetailsPanel ? "_2Zuz6Q1Y8M" : !__cmplp.isSubtle ? "_2Zuz6QgVvo" : "_2Zuz6QPgdg",
            __cmplp.isDetailsPanel ? "_1ZnuxbFQfX" : !__cmplp.isSubtle ? "_1ZnuxbgVvo" : "_1ZnuxbFQfX",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $32fca6e0bfcfd80d$var$ContentStateButtonBase = (t0)=>{
    const $ = (0, $bDgLe.c)(51);
    const { triggerProps: triggerProps, togglePopup: togglePopup, contentState: contentState, isSelected: isSelected, isWarning: isWarning, userOffline: userOffline, contentStateButtonRef: contentStateButtonRef, floatingToolbarButtonStyle: floatingToolbarButtonStyle, appearance: appearance, primaryColor: primaryColor, secondaryColor: secondaryColor, hoverColor: hoverColor, showChevron: showChevron, colorAppearance: colorAppearance, tooltipContent: tooltipContent, isDetailsPanel: isDetailsPanel } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isPressed, setIsPressed] = (0, $cozmU.useState)(false);
    if (!contentState) return null;
    const isContentStateSelectorDisabled = contentState.isCallerPermitted === false || userOffline;
    let t1;
    if ($[0] !== hoverColor || $[1] !== isHovered || $[2] !== isPressed || $[3] !== isSelected || $[4] !== isWarning || $[5] !== secondaryColor) {
        t1 = $32fca6e0bfcfd80d$var$getContentStateButtonBackgroundColor(isWarning, isSelected, isHovered, secondaryColor, hoverColor, isPressed);
        $[0] = hoverColor;
        $[1] = isHovered;
        $[2] = isPressed;
        $[3] = isSelected;
        $[4] = isWarning;
        $[5] = secondaryColor;
        $[6] = t1;
    } else t1 = $[6];
    let t2;
    if ($[7] !== floatingToolbarButtonStyle || $[8] !== t1) {
        t2 = {
            ...floatingToolbarButtonStyle,
            backgroundColor: t1
        };
        $[7] = floatingToolbarButtonStyle;
        $[8] = t1;
        $[9] = t2;
    } else t2 = $[9];
    const buttonStyles = t2;
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setIsHovered(true);
        t4 = ()=>setIsHovered(false);
        t5 = ()=>setIsPressed(true);
        t6 = ()=>setIsPressed(false);
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
        $[13] = t6;
    } else {
        t3 = $[10];
        t4 = $[11];
        t5 = $[12];
        t6 = $[13];
    }
    const t7 = appearance === "subtle";
    let t8;
    if ($[14] !== contentState.name || $[15] !== intl) {
        t8 = (0, $6mKj3.expValEquals)("a11y-fixes-week4-may-2026", "isEnabled", true) ? intl.formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).changeStatusButtonAriaLabel, {
            statusName: contentState.name
        }) : undefined;
        $[14] = contentState.name;
        $[15] = intl;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== colorAppearance || $[18] !== contentState.restrictionLevel || $[19] !== isWarning || $[20] !== primaryColor) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4S6vT.ContentStateColor), {
            dataTestId: "button-color-icon",
            appearance: colorAppearance,
            color: primaryColor,
            restrictionLevel: contentState.restrictionLevel,
            isWarning: isWarning
        });
        $[17] = colorAppearance;
        $[18] = contentState.restrictionLevel;
        $[19] = isWarning;
        $[20] = primaryColor;
        $[21] = t9;
    } else t9 = $[21];
    const t10 = appearance === "subtle" && $32fca6e0bfcfd80d$var$subtleContentStateNameStyles;
    const t11 = isDetailsPanel && $32fca6e0bfcfd80d$var$detailPanelContentStateNameStyles;
    let t12;
    if ($[22] !== t10 || $[23] !== t11) {
        t12 = [
            $32fca6e0bfcfd80d$var$contentStateNameStyles,
            t10,
            t11
        ];
        $[22] = t10;
        $[23] = t11;
        $[24] = t12;
    } else t12 = $[24];
    let t13;
    if ($[25] !== contentState.name || $[26] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: t12,
            testId: "content-state-name"
        }, contentState.name);
        $[25] = contentState.name;
        $[26] = t12;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== intl || $[29] !== showChevron) {
        t14 = showChevron && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $32fca6e0bfcfd80d$var$chevronDownIconWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            color: "currentColor",
            spacing: "compact",
            label: intl.formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).showMoreStatuses),
            testId: "content-state-chevron-down-icon",
            size: "small"
        }));
        $[28] = intl;
        $[29] = showChevron;
        $[30] = t14;
    } else t14 = $[30];
    let t15;
    if ($[31] !== appearance || $[32] !== buttonStyles || $[33] !== isContentStateSelectorDisabled || $[34] !== isDetailsPanel || $[35] !== secondaryColor || $[36] !== t13 || $[37] !== t14 || $[38] !== t7 || $[39] !== t8 || $[40] !== t9 || $[41] !== togglePopup || $[42] !== triggerProps) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($32fca6e0bfcfd80d$var$HasContentStateButton, {
            ...triggerProps,
            appearance: appearance,
            style: buttonStyles,
            onClick: togglePopup,
            disabled: isContentStateSelectorDisabled,
            color: secondaryColor,
            onMouseEnter: t3,
            onMouseLeave: t4,
            onMouseDown: t5,
            onMouseUp: t6,
            isSubtle: t7,
            isDetailsPanel: isDetailsPanel,
            "aria-label": t8,
            "data-testid": "content-state-trigger",
            type: "button"
        }, t9, t13, t14);
        $[31] = appearance;
        $[32] = buttonStyles;
        $[33] = isContentStateSelectorDisabled;
        $[34] = isDetailsPanel;
        $[35] = secondaryColor;
        $[36] = t13;
        $[37] = t14;
        $[38] = t7;
        $[39] = t8;
        $[40] = t9;
        $[41] = togglePopup;
        $[42] = triggerProps;
        $[43] = t15;
    } else t15 = $[43];
    const button = t15;
    let t16;
    if ($[44] !== button || $[45] !== intl || $[46] !== tooltipContent) {
        t16 = tooltipContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: intl.formatMessage(tooltipContent),
            position: "bottom"
        }, button) : button;
        $[44] = button;
        $[45] = intl;
        $[46] = tooltipContent;
        $[47] = t16;
    } else t16 = $[47];
    let t17;
    if ($[48] !== contentStateButtonRef || $[49] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: contentStateButtonRef
        }, t16);
        $[48] = contentStateButtonRef;
        $[49] = t16;
        $[50] = t17;
    } else t17 = $[50];
    return t17;
};
const $32fca6e0bfcfd80d$var$ContentStateButtonComponent = (t0)=>{
    const $ = (0, $bDgLe.c)(72);
    const { triggerProps: triggerProps, togglePopup: togglePopup, contentState: contentState, activeWorkflowStatus: activeWorkflowStatus, isSelected: isSelected, isWarning: isWarning, userOffline: userOffline, contentStateButtonRef: contentStateButtonRef, intl: t1, floatingToolbarButtonStyle: floatingToolbarButtonStyle, renderPlusButtonEmptyState: t2, isDetailsPanel: t3, canEdit: t4, useSubtleEmptyStateLabel: t5 } = t0;
    const { formatMessage: formatMessage } = t1;
    const renderPlusButtonEmptyState = t2 === undefined ? false : t2;
    const isDetailsPanel = t3 === undefined ? false : t3;
    const canEdit = t4 === undefined ? true : t4;
    const useSubtleEmptyStateLabel = t5 === undefined ? false : t5;
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    const [isWorkflowButtonHovered, setIsWorkflowButtonHovered] = (0, $cozmU.useState)(false);
    const [isWorkflowButtonPressed, setIsWorkflowButtonPressed] = (0, $cozmU.useState)(false);
    const getSecondaryColor = $32fca6e0bfcfd80d$var$_temp;
    let t6;
    if ($[0] !== isDetailsPanel) {
        t6 = (editorContentState)=>{
            const primaryColor_0 = editorContentState.color;
            const isVerifiedContentState = editorContentState?.restrictionLevel === "PAGE_OWNER" && editorContentState.name === "Verified";
            const shouldUseBylineButtonStyleProps = !isDetailsPanel;
            if (shouldUseBylineButtonStyleProps) return {
                appearance: "subtle",
                primaryColor: primaryColor_0,
                secondaryColor: getSecondaryColor({
                    primaryColor: primaryColor_0,
                    isNeutralBackground: true
                }),
                hoverColor: "var(--ds-surface-hovered, #F0F1F2)",
                showChevron: false,
                colorAppearance: isVerifiedContentState ? "contentStateButton" : "subtleContentStateButton"
            };
            const secondaryColor = getSecondaryColor({
                primaryColor: primaryColor_0,
                isNeutralBackground: isDetailsPanel
            });
            const hoverColor = isDetailsPanel ? "var(--ds-surface-hovered, #F0F1F2)" : (0, $3qCob.determineHoverColor)(secondaryColor);
            const colorAppearance = isDetailsPanel ? "rendererContentState" : "contentStateButton";
            return {
                appearance: "default",
                primaryColor: primaryColor_0,
                secondaryColor: secondaryColor,
                hoverColor: hoverColor,
                showChevron: !isDetailsPanel,
                colorAppearance: colorAppearance
            };
        };
        $[0] = isDetailsPanel;
        $[1] = t6;
    } else t6 = $[1];
    const getButtonProps = t6;
    const verifiedRestrictedTooltipContent = isRbacEnabled ? (0, $iNJwL.sharedi18n).verifiedRestrictedRbac : (0, $iNJwL.sharedi18n).verifiedRestricted;
    if (activeWorkflowStatus) {
        const isChangesRequested = activeWorkflowStatus.id === "3";
        let WorkflowIcon;
        let iconColor;
        if ($[2] !== activeWorkflowStatus.allowsReviews || $[3] !== isChangesRequested) {
            if (isChangesRequested) {
                WorkflowIcon = (0, (/*@__PURE__*/$parcel$interopDefault($dB01C)));
                iconColor = "var(--ds-icon-accent-yellow, #B38600)";
            } else if (activeWorkflowStatus.allowsReviews) {
                WorkflowIcon = (0, (/*@__PURE__*/$parcel$interopDefault($k75o7)));
                iconColor = "var(--ds-icon-accent-blue, #357DE8)";
            } else {
                WorkflowIcon = (0, (/*@__PURE__*/$parcel$interopDefault($iZMIZ)));
                iconColor = "var(--ds-icon-accent-lime, #6A9A23)";
            }
            $[2] = activeWorkflowStatus.allowsReviews;
            $[3] = isChangesRequested;
            $[4] = iconColor;
            $[5] = WorkflowIcon;
        } else {
            iconColor = $[4];
            WorkflowIcon = $[5];
        }
        const shouldUseSubtle = !isDetailsPanel;
        const secondaryColor_0 = shouldUseSubtle ? "var(--ds-elevation-surface-current, #FFFFFF)" : "var(--ds-background-neutral, #0515240F)";
        const hoveredWorkflowBackgroundColor = isWorkflowButtonHovered ? "var(--ds-background-neutral-subtle-hovered, #0515240F)" : secondaryColor_0;
        const workflowBackgroundColor = isWorkflowButtonPressed ? "var(--ds-background-neutral-subtle-pressed, #0B120E24)" : hoveredWorkflowBackgroundColor;
        let t7;
        if ($[6] !== floatingToolbarButtonStyle || $[7] !== workflowBackgroundColor) {
            t7 = {
                ...floatingToolbarButtonStyle,
                backgroundColor: workflowBackgroundColor
            };
            $[6] = floatingToolbarButtonStyle;
            $[7] = workflowBackgroundColor;
            $[8] = t7;
        } else t7 = $[8];
        const workflowButtonStyles = t7;
        let t8;
        if ($[9] !== WorkflowIcon || $[10] !== activeWorkflowStatus.name || $[11] !== formatMessage || $[12] !== iconColor || $[13] !== isDetailsPanel || $[14] !== isSelected || $[15] !== shouldUseSubtle || $[16] !== togglePopup || $[17] !== triggerProps || $[18] !== userOffline || $[19] !== workflowButtonStyles) {
            t8 = (dismissSpotlight)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($32fca6e0bfcfd80d$var$HasContentStateButton, {
                    ...triggerProps,
                    style: workflowButtonStyles,
                    onClick: ()=>{
                        dismissSpotlight?.();
                        togglePopup();
                    },
                    onMouseEnter: ()=>setIsWorkflowButtonHovered(true),
                    onMouseLeave: ()=>setIsWorkflowButtonHovered(false),
                    onMouseDown: ()=>setIsWorkflowButtonPressed(true),
                    onMouseUp: ()=>setIsWorkflowButtonPressed(false),
                    isSelected: isSelected,
                    disabled: userOffline,
                    isSubtle: shouldUseSubtle,
                    isDetailsPanel: isDetailsPanel,
                    "aria-label": (0, $6mKj3.expValEquals)("a11y-fixes-week4-may-2026", "isEnabled", true) ? formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).changeStatusButtonAriaLabel, {
                        statusName: activeWorkflowStatus.name
                    }) : undefined,
                    "data-testid": "content-state-trigger",
                    type: "button"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                    xcss: $32fca6e0bfcfd80d$var$styles.approvalStatusIcon
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WorkflowIcon, {
                    label: "",
                    size: "small",
                    color: iconColor
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                    xcss: [
                        $32fca6e0bfcfd80d$var$contentStateNameStyles,
                        shouldUseSubtle && $32fca6e0bfcfd80d$var$subtleContentStateNameStyles,
                        isDetailsPanel && $32fca6e0bfcfd80d$var$detailPanelContentStateNameStyles
                    ],
                    testId: "content-state-name"
                }, activeWorkflowStatus.name));
            $[9] = WorkflowIcon;
            $[10] = activeWorkflowStatus.name;
            $[11] = formatMessage;
            $[12] = iconColor;
            $[13] = isDetailsPanel;
            $[14] = isSelected;
            $[15] = shouldUseSubtle;
            $[16] = togglePopup;
            $[17] = triggerProps;
            $[18] = userOffline;
            $[19] = workflowButtonStyles;
            $[20] = t8;
        } else t8 = $[20];
        const workflowButton = t8;
        let t9;
        if ($[21] !== canEdit || $[22] !== formatMessage || $[23] !== workflowButton) {
            t9 = (dismissSpotlight_0)=>canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                    content: formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).changeStatus),
                    position: "bottom"
                }, workflowButton(dismissSpotlight_0)) : workflowButton(dismissSpotlight_0);
            $[21] = canEdit;
            $[22] = formatMessage;
            $[23] = workflowButton;
            $[24] = t9;
        } else t9 = $[24];
        const buttonNode = t9;
        let t10;
        if ($[25] !== buttonNode || $[26] !== isDetailsPanel) {
            t10 = !isDetailsPanel && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12f4e4dea8469f82$export$bd4e7584535e90d7), null, (dismiss)=>buttonNode(dismiss)) : buttonNode();
            $[25] = buttonNode;
            $[26] = isDetailsPanel;
            $[27] = t10;
        } else t10 = $[27];
        let t11;
        if ($[28] !== contentStateButtonRef || $[29] !== t10) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ref: contentStateButtonRef
            }, t10);
            $[28] = contentStateButtonRef;
            $[29] = t10;
            $[30] = t11;
        } else t11 = $[30];
        return t11;
    }
    if (contentState) {
        const tooltipContent = !canEdit ? (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).statusLabel : contentState.restrictionLevel === "PAGE_OWNER" ? verifiedRestrictedTooltipContent : (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).changeStatus;
        let t7;
        if ($[31] !== contentState || $[32] !== getButtonProps) {
            t7 = getButtonProps(contentState);
            $[31] = contentState;
            $[32] = getButtonProps;
            $[33] = t7;
        } else t7 = $[33];
        const buttonProps = t7;
        let t8;
        if ($[34] !== buttonProps || $[35] !== contentState || $[36] !== contentStateButtonRef || $[37] !== floatingToolbarButtonStyle || $[38] !== isDetailsPanel || $[39] !== isSelected || $[40] !== isWarning || $[41] !== togglePopup || $[42] !== tooltipContent || $[43] !== triggerProps || $[44] !== userOffline) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
                space: "space.0"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($32fca6e0bfcfd80d$var$ContentStateButtonBase, {
                triggerProps: triggerProps,
                togglePopup: togglePopup,
                contentState: contentState,
                isSelected: isSelected,
                isWarning: isWarning,
                userOffline: userOffline,
                contentStateButtonRef: contentStateButtonRef,
                floatingToolbarButtonStyle: floatingToolbarButtonStyle,
                tooltipContent: tooltipContent,
                isDetailsPanel: isDetailsPanel,
                ...buttonProps
            }));
            $[34] = buttonProps;
            $[35] = contentState;
            $[36] = contentStateButtonRef;
            $[37] = floatingToolbarButtonStyle;
            $[38] = isDetailsPanel;
            $[39] = isSelected;
            $[40] = isWarning;
            $[41] = togglePopup;
            $[42] = tooltipContent;
            $[43] = triggerProps;
            $[44] = userOffline;
            $[45] = t8;
        } else t8 = $[45];
        return t8;
    }
    if (renderPlusButtonEmptyState) {
        let t7;
        if ($[46] !== formatMessage) {
            t7 = formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).statusLabel);
            $[46] = formatMessage;
            $[47] = t7;
        } else t7 = $[47];
        let t8;
        if ($[48] !== t7 || $[49] !== togglePopup || $[50] !== triggerProps) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))),
                appearance: "subtle",
                label: t7,
                onClick: togglePopup,
                testId: "content-state-empty-state-add-icon"
            });
            $[48] = t7;
            $[49] = togglePopup;
            $[50] = triggerProps;
            $[51] = t8;
        } else t8 = $[51];
        return t8;
    }
    let t7;
    if ($[52] !== floatingToolbarButtonStyle || $[53] !== useSubtleEmptyStateLabel) {
        t7 = useSubtleEmptyStateLabel ? {
            ...floatingToolbarButtonStyle || {},
            height: 32,
            display: "flex",
            alignItems: "center"
        } : floatingToolbarButtonStyle || {};
        $[52] = floatingToolbarButtonStyle;
        $[53] = useSubtleEmptyStateLabel;
        $[54] = t7;
    } else t7 = $[54];
    let t8;
    if ($[55] !== useSubtleEmptyStateLabel) {
        t8 = useSubtleEmptyStateLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $32fca6e0bfcfd80d$var$compactEmptyStateIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kRZje))), {
            label: "",
            testId: "content-state-task-icon"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kRZje))), {
            label: "",
            testId: "content-state-task-icon"
        });
        $[55] = useSubtleEmptyStateLabel;
        $[56] = t8;
    } else t8 = $[56];
    const t9 = useSubtleEmptyStateLabel ? false : isSelected;
    const t10 = useSubtleEmptyStateLabel ? "default" : "compact";
    let t11;
    if ($[57] !== formatMessage || $[58] !== useSubtleEmptyStateLabel) {
        t11 = useSubtleEmptyStateLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            as: "span",
            xcss: $32fca6e0bfcfd80d$var$subtleEmptyStateLabelStyles
        }, formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).statusLabel)) : formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).statusLabel);
        $[57] = formatMessage;
        $[58] = useSubtleEmptyStateLabel;
        $[59] = t11;
    } else t11 = $[59];
    let t12;
    if ($[60] !== t10 || $[61] !== t11 || $[62] !== t7 || $[63] !== t8 || $[64] !== t9 || $[65] !== togglePopup || $[66] !== triggerProps || $[67] !== userOffline) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            ...triggerProps,
            appearance: "subtle",
            style: t7,
            onClick: togglePopup,
            iconBefore: t8,
            isSelected: t9,
            spacing: t10,
            testId: "content-state-trigger",
            isDisabled: userOffline
        }, t11));
        $[60] = t10;
        $[61] = t11;
        $[62] = t7;
        $[63] = t8;
        $[64] = t9;
        $[65] = togglePopup;
        $[66] = triggerProps;
        $[67] = userOffline;
        $[68] = t12;
    } else t12 = $[68];
    let t13;
    if ($[69] !== contentStateButtonRef || $[70] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: contentStateButtonRef
        }, t12);
        $[69] = contentStateButtonRef;
        $[70] = t12;
        $[71] = t13;
    } else t13 = $[71];
    return t13;
};
const $32fca6e0bfcfd80d$export$ee3b73f13be68d6d = (0, $kSwu1.injectIntl)($32fca6e0bfcfd80d$var$ContentStateButtonComponent);
function $32fca6e0bfcfd80d$var$_temp(t0) {
    const { primaryColor: primaryColor, isNeutralBackground: isNeutralBackground } = t0;
    if (isNeutralBackground) return "var(--ds-elevation-surface-current, #FFFFFF)";
    else return (0, $3qCob.determineSecondaryColor)(primaryColor);
}

















var $ec7900bbe9af5124$exports = {};
$ec7900bbe9af5124$exports = new URL("GenericError.42a632b0.svg", import.meta.url).toString();


















var $dTHYM = parcelRequire("dTHYM");
















var $9aYkv = parcelRequire("9aYkv");

















var $eh6Ml = parcelRequire("eh6Ml");














const $99a97a10d1a2aa69$var$SelectedColor = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isOpen: isOpen, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1odflos": (0, $9aYkv.default)(__cmplp.isOpen ? "var(--ds-border-inverse, #FFFFFF)" : __cmplp.color ? __cmplp.color : "var(--ds-border-accent-gray, #7D818A)"),
                "--_xexnhp": (0, $9aYkv.default)(__cmplp.color)
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_30huDKWtPV _0bjKvDS5Zs _39xV02ey7F _0jFU0Vey7F _0adFHsLl21 _2XsHFMFQfX _0KLXruBz3j",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $99a97a10d1a2aa69$var$ColorOption = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "button" : t2;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_xexnhp": (0, $9aYkv.default)(__cmplp.color)
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _30huDKPrhC _0bjKvDS5Zs _39xV02SPN1 _0jFU0VSPN1 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0KLXruBz3j _2xIroYJrlu _0wOv4Q7zJH",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $99a97a10d1a2aa69$var$ColorOptionWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0wOv4Q7zJH _2O5Vij7dHp _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _03trCdOgbZ",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $99a97a10d1a2aa69$var$DropDownContentWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuZHm0 _0hPCNLFlnN _39xV02CnfV _0jFU0VuNcX",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $99a97a10d1a2aa69$var$ButtonIconsWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $99a97a10d1a2aa69$var$chevronDownIconWrapperStyles = (0, $buxP3.xcss)({
    marginRight: 'space.negative.075'
});
const $99a97a10d1a2aa69$export$13cf15360203042f = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { selectedColor: selectedColor, onSelectColor: onSelectColor, isOpen: isOpen, onClose: onClose, onColorPickerToggle: onColorPickerToggle, userOffline: userOffline, colorPickerComponentRef: colorPickerComponentRef } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== intl || $[1] !== onSelectColor || $[2] !== selectedColor) {
        const colorsArray = [
            (0, $Uu0Pb.PRIMARY_COLORS).BLUE,
            (0, $Uu0Pb.PRIMARY_COLORS).GREEN,
            (0, $Uu0Pb.PRIMARY_COLORS).YELLOW,
            (0, $Uu0Pb.PRIMARY_COLORS).RED,
            (0, $Uu0Pb.PRIMARY_COLORS).PURPLE
        ];
        t1 = colorsArray.map((color)=>{
            const isSelected = selectedColor === color;
            const colorName = (0, $8miSe.colorCodeToColorName)(color);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($99a97a10d1a2aa69$var$ColorOptionWrapper, {
                onClick: ()=>onSelectColor(color),
                key: `${color}-option`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($99a97a10d1a2aa69$var$ColorOption, {
                color: color,
                "data-testid": `${(0, $8miSe.tokenToHex)(color)}-option`,
                "aria-label": intl.formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).colorOptionAriaLabel, {
                    colorName: colorName
                }),
                ...(0, $6mKj3.expValEquals)("a11y-fixes-week4-may-2026", "isEnabled", true) ? {
                    role: "option",
                    "aria-selected": isSelected
                } : {}
            }, isSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                label: "selected",
                color: "var(--ds-icon-subtle, #505258)"
            })));
        });
        $[0] = intl;
        $[1] = onSelectColor;
        $[2] = selectedColor;
        $[3] = t1;
    } else t1 = $[3];
    const statusColors = t1;
    let t2;
    let t3;
    if ($[4] !== isOpen) {
        t2 = ()=>{
            const colorPickerButton = document.getElementById("content-state-color-picker-button");
            if (!isOpen && colorPickerButton) setTimeout(()=>{
                colorPickerButton.focus();
            }, 0);
        };
        t3 = [
            isOpen
        ];
        $[4] = isOpen;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[7] !== intl || $[8] !== isOpen || $[9] !== onColorPickerToggle || $[10] !== selectedColor || $[11] !== userOffline) {
        t4 = (t5)=>{
            const { ...buttonProps } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                ...buttonProps,
                id: "content-state-color-picker-button",
                testId: "color-picker-popup-trigger",
                isSelected: isOpen,
                isDisabled: userOffline,
                onClick: onColorPickerToggle,
                "aria-label": intl.formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).colorPickerButtonAriaLabel, {
                    colorName: selectedColor ? (0, $8miSe.colorCodeToColorName)(selectedColor) : ""
                }),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($99a97a10d1a2aa69$var$ButtonIconsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($99a97a10d1a2aa69$var$SelectedColor, {
                    color: selectedColor || undefined,
                    isOpen: isOpen,
                    "data-testid": "selected-color"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                    xcss: $99a97a10d1a2aa69$var$chevronDownIconWrapperStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: "",
                    size: "small"
                })))
            });
        };
        $[7] = intl;
        $[8] = isOpen;
        $[9] = onColorPickerToggle;
        $[10] = selectedColor;
        $[11] = userOffline;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== colorPickerComponentRef || $[14] !== intl || $[15] !== statusColors) {
        t5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($99a97a10d1a2aa69$var$DropDownContentWrapper, {
                ref: colorPickerComponentRef,
                ...(0, $6mKj3.expValEquals)("a11y-fixes-week4-may-2026", "isEnabled", true) ? {
                    role: "listbox",
                    "aria-label": intl.formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).colorPickerListboxAriaLabel)
                } : {}
            }, statusColors);
        $[13] = colorPickerComponentRef;
        $[14] = intl;
        $[15] = statusColors;
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== isOpen || $[18] !== onClose || $[19] !== t4 || $[20] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
            isOpen: isOpen,
            onClose: onClose,
            testId: "color-picker-popup",
            placement: "bottom-start",
            zIndex: 700,
            shouldRenderToParent: true,
            trigger: t4,
            content: t5
        });
        $[17] = isOpen;
        $[18] = onClose;
        $[19] = t4;
        $[20] = t5;
        $[21] = t6;
    } else t6 = $[21];
    return t6;
};













var $4yg9g = parcelRequire("4yg9g");


var $dUI0h = parcelRequire("dUI0h");


var $7BfeF = parcelRequire("7BfeF");


var $9DzWa = parcelRequire("9DzWa");





const $c3e1925399b17e8a$var$ContentStateTextFieldComponent = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { onFocusTextField: onFocusTextField, showFormFooter: showFormFooter, userOffline: userOffline, intl: t1 } = t0;
    const { formatMessage: formatMessage } = t1;
    let t2;
    if ($[0] !== onFocusTextField) {
        t2 = (event)=>{
            if (event.key !== "Tab") onFocusTextField();
        };
        $[0] = onFocusTextField;
        $[1] = t2;
    } else t2 = $[1];
    const checkForTab = t2;
    const validateName = $c3e1925399b17e8a$var$_temp;
    let t3;
    if ($[2] !== checkForTab || $[3] !== formatMessage || $[4] !== onFocusTextField || $[5] !== showFormFooter || $[6] !== userOffline) {
        t3 = showFormFooter ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "name",
            validate: validateName
        }, (t4)=>{
            const { fieldProps: fieldProps, error: error } = t4;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
                ...fieldProps,
                placeholder: formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).addCustomStatus),
                "aria-label": formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).addCustomStatus),
                isCompact: true,
                autoComplete: "off",
                testId: "name-input",
                maxLength: 20,
                isDisabled: userOffline
            }), error === "REQUIRED" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, formatMessage((0, $iNJwL.sharedi18n).requiredErrorMessage)), !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9DzWa.HelperMessage), null, formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).maxLengthEditor)));
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "dummy-name"
        }, (t5)=>{
            const { fieldProps: fieldProps_0 } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
                ...fieldProps_0,
                onKeyDown: checkForTab,
                onMouseDown: onFocusTextField,
                isDisabled: userOffline,
                placeholder: formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).addCustomStatus),
                "aria-label": formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).addCustomStatus),
                isCompact: true,
                value: "",
                testId: "dummy-name-input"
            });
        });
        $[2] = checkForTab;
        $[3] = formatMessage;
        $[4] = onFocusTextField;
        $[5] = showFormFooter;
        $[6] = userOffline;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
const $c3e1925399b17e8a$export$c3a18725b7210022 = (0, $kSwu1.injectIntl)($c3e1925399b17e8a$var$ContentStateTextFieldComponent);
function $c3e1925399b17e8a$var$_temp(value) {
    if (!value) return "REQUIRED";
}


const $45bd28dec8e86674$var$TextFieldWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _39xV02qfN2",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $45bd28dec8e86674$var$ColorPickerButtonWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0adFHsgVvo _3iDTPbvbI6 _1RrJLiBwqQ _3138422ADO",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $45bd28dec8e86674$var$FormFooterWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isVisible: isVisible, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_37wbyuz9WS _3138428HPE _1FbZmu2ADO",
            __cmplp.isVisible ? "_3iDTPbQ4SZ" : "_3iDTPbYbGa",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $45bd28dec8e86674$var$ColorAndInputWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $45bd28dec8e86674$var$ContentStateFormComponent = (0, $7aRa9.withFlags)(({ onSubmit: onSubmit, onCancel: onCancel, showFormFooter: showFormFooter, selectedColor: selectedColor, onSelectColor: onSelectColor, isColorPickerOpen: isColorPickerOpen, onColorPickerToggle: onColorPickerToggle, onColorPickerClose: onColorPickerClose, onFocusTextField: onFocusTextField, userOffline: userOffline, colorPickerComponentRef: colorPickerComponentRef, flags: flags, intl: { formatMessage: formatMessage } })=>{
    const handleSubmit = (data)=>{
        const trimmedName = data.name.replace(/\s+/g, ' ').trim();
        if (trimmedName) onSubmit(trimmedName);
        else // show warning flag if user entered all whitespace
        flags.showWarningFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $iNJwL.sharedi18n).emptyStatusFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $iNJwL.sharedi18n).emptyStatusFlagDescription)
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: handleSubmit,
        testId: "content-state-form"
    }, ({ formProps: formProps })=>// eslint-disable-next-line @atlassian/a11y/no-noninteractive-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", {
            ref: formProps.ref,
            onKeyDown: formProps.onKeyDown
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45bd28dec8e86674$var$ColorAndInputWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45bd28dec8e86674$var$ColorPickerButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $99a97a10d1a2aa69$export$13cf15360203042f), {
            onColorPickerToggle: onColorPickerToggle,
            selectedColor: selectedColor,
            onSelectColor: onSelectColor,
            isOpen: isColorPickerOpen,
            onClose: onColorPickerClose,
            userOffline: userOffline,
            colorPickerComponentRef: colorPickerComponentRef
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45bd28dec8e86674$var$TextFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c3e1925399b17e8a$export$c3a18725b7210022), {
            onFocusTextField: onFocusTextField,
            showFormFooter: showFormFooter,
            userOffline: userOffline
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45bd28dec8e86674$var$FormFooterWrapper, {
            isVisible: showFormFooter,
            "data-testid": "content-state-form-footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            onClick: onCancel,
            spacing: "compact",
            appearance: "subtle",
            testId: "content-state-cancel"
        }, formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            testId: "content-state-submit",
            type: "submit",
            spacing: "compact",
            appearance: "primary",
            onClick: formProps.onSubmit
        }, formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).save)))));
});
const $45bd28dec8e86674$export$2ae5c8bd8129bb8e = /*#__PURE__*/ (0, $cozmU.memo)((0, $kSwu1.injectIntl)($45bd28dec8e86674$var$ContentStateFormComponent));





/**
 * @generated SignedSource<<deb8397ae34010de9febd3d34b875fc9>>
 * @relayHash c81edbedabd3a07bb4c131163defdd60
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 662dba7b6b58fc2f7fb7095611d6ca086899027bdfe189caf512accfcfab4815
const $5bafe07f9f90b739$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStateInput"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentState",
                    "variableName": "contentStateInput"
                }
            ],
            "concreteType": "ContentState",
            "kind": "LinkedField",
            "name": "setContentState",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "color"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "restrictionLevel"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentStateGroupSetContentStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentStateGroupSetContentStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c81edbedabd3a07bb4c131163defdd60",
            "id": "662dba7b6b58fc2f7fb7095611d6ca086899027bdfe189caf512accfcfab4815",
            "metadata": {},
            "name": "ContentStateGroupSetContentStateMutation",
            "operationKind": "mutation",
            "text": "mutation ContentStateGroupSetContentStateMutation($contentId:ID!,$contentStateInput:ContentStateInput!){setContentState(contentId:$contentId,contentState:$contentStateInput){name,color,id,restrictionLevel}}"
        }
    };
}();
$5bafe07f9f90b739$var$node.hash = "9bf862412febf809155ba549e5c2b02e";
var $5bafe07f9f90b739$export$2e2bcd8739ae039 = $5bafe07f9f90b739$var$node;







































var $3lWl0 = parcelRequire("3lWl0");



















const $0de1820bd94dcfc9$var$ContentStateWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "button" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _2sNsIgmnOE _30huDKYbGa _3iDTPbQ4SZ _0hPCNLDIqT _0wOv4Q7zJH _0jFU0VnlTt _39xV02N91d _0KLXru66of _1UtDYzy7kJ _2xIroYJrlu _02aXbKsyl5 _3DEn3pVpNL _0QAuWQjOvk _1eOmH6DMqu",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0de1820bd94dcfc9$var$contentStateNameStyles = (0, $buxP3.xcss)({
    textOverflow: 'ellipsis',
    overflowX: 'hidden',
    whiteSpace: 'nowrap'
});
const $0de1820bd94dcfc9$export$96e9e87da55ad40c = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { contentState: contentState, onClick: onClick, userOffline: userOffline } = t0;
    let t1;
    if ($[0] !== contentState.color || $[1] !== contentState.restrictionLevel) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4S6vT.ContentStateColor), {
            dataTestId: "content-state-color",
            appearance: "editorContentState",
            color: contentState.color,
            restrictionLevel: contentState.restrictionLevel
        });
        $[0] = contentState.color;
        $[1] = contentState.restrictionLevel;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [
            $0de1820bd94dcfc9$var$contentStateNameStyles
        ];
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== contentState.name) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: t2
        }, contentState.name);
        $[4] = contentState.name;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== onClick || $[7] !== t1 || $[8] !== t3 || $[9] !== userOffline) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0de1820bd94dcfc9$var$ContentStateWrapper, {
            "data-testid": "content-state",
            onClick: onClick,
            disabled: userOffline
        }, t1, t3);
        $[6] = onClick;
        $[7] = t1;
        $[8] = t3;
        $[9] = userOffline;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};



/* eslint-disable check-file/filename-blocklist */ const $c169b00c0122f30f$export$fa2d28b3b2819e2d = 'custom';
const $c169b00c0122f30f$export$b3c3dee917fc137d = 'suggested';





const $742e27b1b03e5e97$var$GroupLabel = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "h3" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIgmnOE _1DCdHi8HPE _1UtDYzZpcK _1kk5Tkf7mX _2XsHFMNHnM",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $742e27b1b03e5e97$var$ContentStateListWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "ul" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XghbEPgdg _4FKVYEPgdg _0aNu0LYbGa",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $742e27b1b03e5e97$export$b5eb02bd35e29271 = (t0)=>{
    const $ = (0, $bDgLe.c)(41);
    const { contentId: contentId, contentStateState: contentStateState, groupIsEnabled: groupIsEnabled, groupLabel: groupLabel, contentStates: contentStates, flags: flags, userOffline: userOffline, intl: t1, onUpdateSuccess: onUpdateSuccess, setIsContentStateMenuOpen: setIsContentStateMenuOpen } = t0;
    const { formatMessage: formatMessage } = t1;
    const originalContentState = (0, $cozmU.useRef)(contentStateState.state.contentState);
    const originalCustomStatesArray = (0, $cozmU.useRef)(contentStateState.state.customStatesArray);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [shouldSetAutomationFlag, setShouldSetAutomationFlag] = (0, $cozmU.useState)(false);
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if (!(0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).AUTOMATION_DISCOVER_SET_CONTENT_STATE) && (0, $9wGTI.fg)("cc_a4c_smart_button_changeboarding")) setShouldSetAutomationFlag(true);
        };
        t3 = [];
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    (0, $cozmU.useEffect)(t2, t3);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    let t4;
    if ($[2] !== contentId || $[3] !== contentStateState || $[4] !== createAnalyticsEvent || $[5] !== flags || $[6] !== isLivePage) {
        t4 = ()=>{
            contentStateState.setContentState(originalContentState.current);
            contentStateState.setCustomStatesArray(originalCustomStatesArray.current);
            flags.showErrorFlag({
                id: "content-state-error-flag",
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).errorFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).errorFlagBody)
            });
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    objectId: contentId,
                    name: "contentStateErrorFlag",
                    attributes: {
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        };
        $[2] = contentId;
        $[3] = contentStateState;
        $[4] = createAnalyticsEvent;
        $[5] = flags;
        $[6] = isLivePage;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== contentStateState || $[9] !== onUpdateSuccess) {
        t5 = ()=>{
            originalContentState.current = contentStateState.state.contentState;
            originalCustomStatesArray.current = contentStateState.state.customStatesArray;
            contentStateState.setIsUpdating(false);
            onUpdateSuccess?.();
        };
        $[8] = contentStateState;
        $[9] = onUpdateSuccess;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== contentId || $[12] !== isLivePage) {
        t6 = ()=>[
                {
                    query: (0, $3lWl0.default),
                    variables: {
                        contentId: contentId,
                        isDraft: !isLivePage,
                        shouldSkipContentStateLastUpdated: (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) ? false : !isLivePage,
                        isApprovalsFgOn: (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true),
                        format: (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) ? "MILLIS" : "USER_FRIENDLY"
                    }
                }
            ];
        $[11] = contentId;
        $[12] = isLivePage;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
        t7 = {
            onError: t4,
            onCompleted: t5,
            refetchQueries: t6
        };
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    const [setContentStateMutation] = (0, $308Wd.useMutationInterop)((0, $5bafe07f9f90b739$export$2e2bcd8739ae039), {
        ...t7,
        __callerPackage__: "content-state"
    });
    let t8;
    if ($[18] !== contentId || $[19] !== contentStateState || $[20] !== createAnalyticsEvent || $[21] !== isLivePage || $[22] !== setContentStateMutation || $[23] !== setIsContentStateMenuOpen || $[24] !== shouldSetAutomationFlag) {
        t8 = (newContentState, label, index)=>{
            contentStateState.setIsUpdating(true);
            setContentStateMutation({
                variables: {
                    contentId: contentId,
                    contentStateInput: {
                        color: (0, $8miSe.tokenToHex)(newContentState.color),
                        name: newContentState.name,
                        id: newContentState.id
                    }
                }
            });
            contentStateState.setContentState(newContentState);
            setIsContentStateMenuOpen(false);
            if (label === (0, $c169b00c0122f30f$export$fa2d28b3b2819e2d)) {
                const newCustomStatesArray = (0, $3qCob.createNewCustomStatesArrayWhenExistingCustomSelected)(contentStateState.state.customStatesArray, newContentState, index);
                contentStateState.setCustomStatesArray(newCustomStatesArray);
            }
            if (shouldSetAutomationFlag && (0, $9wGTI.fg)("cc_a4c_smart_button_changeboarding")) {
                (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).AUTOMATION_DISCOVER_SET_CONTENT_STATE, true);
                setShouldSetAutomationFlag(false);
            }
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    objectId: contentId,
                    actionSubjectId: "editorContentStateAdded",
                    source: "editorContentState",
                    attributes: {
                        type: label,
                        color: (0, $8miSe.colorCodeToColorName)(newContentState.color.toUpperCase()),
                        restrictionLevel: newContentState.restrictionLevel?.toUpperCase(),
                        uiLocation: "pageTitleSection",
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        };
        $[18] = contentId;
        $[19] = contentStateState;
        $[20] = createAnalyticsEvent;
        $[21] = isLivePage;
        $[22] = setContentStateMutation;
        $[23] = setIsContentStateMenuOpen;
        $[24] = shouldSetAutomationFlag;
        $[25] = t8;
    } else t8 = $[25];
    const handleClick = t8;
    let t9;
    if ($[26] !== contentStates || $[27] !== groupLabel || $[28] !== handleClick || $[29] !== userOffline) {
        let t10;
        if ($[31] !== groupLabel || $[32] !== handleClick || $[33] !== userOffline) {
            t10 = (contentState, index_0)=>{
                if (contentState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0de1820bd94dcfc9$export$96e9e87da55ad40c), {
                    contentState: contentState,
                    userOffline: userOffline,
                    onClick: ()=>handleClick(contentState, groupLabel, index_0),
                    key: `${groupLabel}-content-state-${index_0}`
                });
            };
            $[31] = groupLabel;
            $[32] = handleClick;
            $[33] = userOffline;
            $[34] = t10;
        } else t10 = $[34];
        t9 = contentStates.map(t10);
        $[26] = contentStates;
        $[27] = groupLabel;
        $[28] = handleClick;
        $[29] = userOffline;
        $[30] = t9;
    } else t9 = $[30];
    const contentStateList = t9;
    let t10;
    if ($[35] !== contentStateList || $[36] !== contentStates.length || $[37] !== formatMessage || $[38] !== groupIsEnabled || $[39] !== groupLabel) {
        t10 = groupIsEnabled && contentStates.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": `${groupLabel.toLowerCase()}-content-states`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($742e27b1b03e5e97$var$GroupLabel, null, groupLabel === (0, $c169b00c0122f30f$export$fa2d28b3b2819e2d) ? formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).custom) : formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).suggested)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($742e27b1b03e5e97$var$ContentStateListWrapper, {
            "aria-label": groupLabel
        }, contentStateList)) : null;
        $[35] = contentStateList;
        $[36] = contentStates.length;
        $[37] = formatMessage;
        $[38] = groupIsEnabled;
        $[39] = groupLabel;
        $[40] = t10;
    } else t10 = $[40];
    return t10;
};
const $742e27b1b03e5e97$export$710aa0e581cfaff9 = (0, $kSwu1.injectIntl)((0, $7aRa9.withFlags)($742e27b1b03e5e97$export$b5eb02bd35e29271));

















var $iDfTs = parcelRequire("iDfTs");








const $a14c780b3cacba28$var$RemoveButtonWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(6);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "button" : t2;
        let t3;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = (0, $9aYkv.default)((0, $Uu0Pb.PRIMARY_COLORS).RED);
            $[3] = t3;
        } else t3 = $[3];
        let t4;
        if ($[4] !== __cmpls) {
            t4 = {
                ...__cmpls,
                "--_1eacras": t3
            };
            $[4] = __cmpls;
            $[5] = t4;
        } else t4 = $[5];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmplp,
            style: t4,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_30huDKYbGa _0bjKvDzXzM _39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _0wOv4Q7zJH _2xIroY9Htv _0KLXrujOvk _1UtDYzy7kJ _02aXbKsyl5 _3DEn3pVpNL _24bGaTot27 _0QAuWQjOvk _1iy5hxDMqu _10n1R5T9KB _1eOmH6DMqu _0clgaMT9KB _3gzVzLDMqu _0CMRbkT9KB",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $a14c780b3cacba28$var$RemoveButtonPlaceholder = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_39xV02oWWg _0jFU0VoWWg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $a14c780b3cacba28$var$RemoveButtonComponent = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, hasContentState: hasContentState, userOffline: userOffline, intl: t1 } = t0;
    const { formatMessage: formatMessage } = t1;
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(false);
    let t2;
    if ($[0] !== onMouseEnter) {
        t2 = ()=>{
            setIsFocused(true);
            onMouseEnter();
        };
        $[0] = onMouseEnter;
        $[1] = t2;
    } else t2 = $[1];
    const handleOnFocus = t2;
    let t3;
    if ($[2] !== onMouseLeave) {
        t3 = ()=>{
            setIsFocused(false);
            onMouseLeave();
        };
        $[2] = onMouseLeave;
        $[3] = t3;
    } else t3 = $[3];
    const handleOnBlur = t3;
    let t4;
    if ($[4] !== isFocused || $[5] !== onMouseLeave) {
        t4 = ()=>{
            if (!isFocused) onMouseLeave();
        };
        $[4] = isFocused;
        $[5] = onMouseLeave;
        $[6] = t4;
    } else t4 = $[6];
    const handleOnMouseLeave = t4;
    let t5;
    if ($[7] !== formatMessage || $[8] !== handleOnBlur || $[9] !== handleOnFocus || $[10] !== handleOnMouseLeave || $[11] !== hasContentState || $[12] !== onClick || $[13] !== onMouseEnter || $[14] !== userOffline) {
        t5 = hasContentState ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).remove),
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a14c780b3cacba28$var$RemoveButtonWrapper, {
            onClick: onClick,
            "data-testid": "remove-button",
            onMouseEnter: onMouseEnter,
            onMouseLeave: handleOnMouseLeave,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            disabled: userOffline,
            "aria-label": formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).removeButtonAriaLabel)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a14c780b3cacba28$var$RemoveButtonPlaceholder, {
            "data-testid": "remove-button-placeholder"
        });
        $[7] = formatMessage;
        $[8] = handleOnBlur;
        $[9] = handleOnFocus;
        $[10] = handleOnMouseLeave;
        $[11] = hasContentState;
        $[12] = onClick;
        $[13] = onMouseEnter;
        $[14] = userOffline;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
};
const $a14c780b3cacba28$export$4e9d5ce1e6c22a94 = (0, $kSwu1.injectIntl)($a14c780b3cacba28$var$RemoveButtonComponent);




// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $35470e23ff8dc4a3$var$ContentStateMenuWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYEYopn _39xV027izC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $35470e23ff8dc4a3$var$HeaderWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XghbEfXap _3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $35470e23ff8dc4a3$var$FormWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XghbEfXap",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $35470e23ff8dc4a3$var$HorizontalDivider = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XghbEmNt7 _0KLXruDMqu _0jFU0VHZdu _39xV02e7g8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $35470e23ff8dc4a3$var$ContentStateGroupsWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2hWmdFkG2W",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $35470e23ff8dc4a3$var$ContentStateDisabledDiv = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $35470e23ff8dc4a3$var$FeatureDisabledGraphic = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "img" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0jFU0VG9sM _39xV02HMkp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $35470e23ff8dc4a3$var$FeatureDisabledTextWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "p" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XghbE8HPE _1UtDYzot27 _2fwxA5DIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $35470e23ff8dc4a3$var$ContentStateMenuComponent = (t0)=>{
    const $ = (0, $bDgLe.c)(66);
    const { contentId: contentId, contentStateState: contentStateState, contentType: contentType, isContentStateEnabled: isContentStateEnabled, isCustomEnabled: isCustomEnabled, defaultStatesArray: defaultStatesArray, customStatesArray: customStatesArray, isSuggestedEnabled: isSuggestedEnabled, isCreatingContentState: isCreatingContentState, selectedColor: selectedColor, onSelectColor: onSelectColor, isColorPickerOpen: isColorPickerOpen, onColorPickerClose: onColorPickerClose, onColorPickerToggle: onColorPickerToggle, onSubmit: onSubmit, onRemove: onRemove, onCancel: onCancel, onFocusTextField: onFocusTextField, onMouseEnterRemove: onMouseEnterRemove, onMouseLeaveRemove: onMouseLeaveRemove, userOffline: userOffline, onPopupClose: onPopupClose, contentStateButtonRef: contentStateButtonRef, intl: t1, onUpdateSuccess: onUpdateSuccess, isContentStateMenuOpen: isContentStateMenuOpen, setIsContentStateMenuOpen: setIsContentStateMenuOpen, updatePopup: updatePopup } = t0;
    const { formatMessage: formatMessage } = t1;
    const menuComponent = (0, $cozmU.useRef)(null);
    const colorPickerComponent = (0, $cozmU.useRef)(null);
    let t2;
    if ($[0] !== contentStateButtonRef || $[1] !== onPopupClose) {
        t2 = (event)=>{
            if (menuComponent?.current && event.target instanceof Node && !menuComponent?.current?.contains(event.target) && !colorPickerComponent?.current?.contains(event.target) && !contentStateButtonRef?.current?.contains(event.target)) onPopupClose();
        };
        $[0] = contentStateButtonRef;
        $[1] = onPopupClose;
        $[2] = t2;
    } else t2 = $[2];
    const handleClickOutside = t2;
    let t3;
    if ($[3] !== isColorPickerOpen || $[4] !== isContentStateMenuOpen || $[5] !== onColorPickerClose || $[6] !== onPopupClose) {
        t3 = (event_0)=>{
            if (event_0.key === "Escape" && isContentStateMenuOpen) {
                if (isColorPickerOpen) onColorPickerClose();
                else onPopupClose();
            }
        };
        $[3] = isColorPickerOpen;
        $[4] = isContentStateMenuOpen;
        $[5] = onColorPickerClose;
        $[6] = onPopupClose;
        $[7] = t3;
    } else t3 = $[7];
    const handleKeydown = t3;
    let t4;
    if ($[8] !== handleKeydown) {
        t4 = ()=>{
            document.addEventListener("keydown", handleKeydown);
            return ()=>{
                document.removeEventListener("keydown", handleKeydown);
            };
        };
        $[8] = handleKeydown;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== handleKeydown || $[11] !== isColorPickerOpen) {
        t5 = [
            isColorPickerOpen,
            handleKeydown
        ];
        $[10] = handleKeydown;
        $[11] = isColorPickerOpen;
        $[12] = t5;
    } else t5 = $[12];
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    let t7;
    if ($[13] !== handleClickOutside) {
        t6 = ()=>{
            document.addEventListener("mousedown", handleClickOutside);
            return ()=>{
                document.removeEventListener("mousedown", handleClickOutside);
            };
        };
        t7 = [
            handleClickOutside
        ];
        $[13] = handleClickOutside;
        $[14] = t6;
        $[15] = t7;
    } else {
        t6 = $[14];
        t7 = $[15];
    }
    (0, $cozmU.useEffect)(t6, t7);
    const didRender = (0, $cozmU.useRef)(false);
    let t8;
    if ($[16] !== updatePopup) {
        t8 = ()=>{
            if (!didRender.current) {
                didRender.current = true;
                return;
            }
            updatePopup();
        };
        $[16] = updatePopup;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== customStatesArray || $[19] !== defaultStatesArray || $[20] !== updatePopup) {
        t9 = [
            defaultStatesArray,
            customStatesArray,
            updatePopup
        ];
        $[18] = customStatesArray;
        $[19] = defaultStatesArray;
        $[20] = updatePopup;
        $[21] = t9;
    } else t9 = $[21];
    (0, $cozmU.useEffect)(t8, t9);
    let t10;
    if ($[22] !== contentType || $[23] !== formatMessage) {
        t10 = contentType === "blogpost" ? formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).setBlogStatus) : formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).setPageStatus);
        $[22] = contentType;
        $[23] = formatMessage;
        $[24] = t10;
    } else t10 = $[24];
    let t11;
    if ($[25] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall",
            as: "h2"
        }, t10);
        $[25] = t10;
        $[26] = t11;
    } else t11 = $[26];
    const t12 = !!contentStateState.state.contentState;
    let t13;
    if ($[27] !== onMouseEnterRemove || $[28] !== onMouseLeaveRemove || $[29] !== onRemove || $[30] !== t12 || $[31] !== userOffline) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a14c780b3cacba28$export$4e9d5ce1e6c22a94), {
            hasContentState: t12,
            onClick: onRemove,
            onMouseEnter: onMouseEnterRemove,
            onMouseLeave: onMouseLeaveRemove,
            userOffline: userOffline
        });
        $[27] = onMouseEnterRemove;
        $[28] = onMouseLeaveRemove;
        $[29] = onRemove;
        $[30] = t12;
        $[31] = userOffline;
        $[32] = t13;
    } else t13 = $[32];
    let t14;
    if ($[33] !== t11 || $[34] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($35470e23ff8dc4a3$var$HeaderWrapper, null, t11, t13);
        $[33] = t11;
        $[34] = t13;
        $[35] = t14;
    } else t14 = $[35];
    let t15;
    if ($[36] !== isColorPickerOpen || $[37] !== isContentStateEnabled || $[38] !== isCreatingContentState || $[39] !== isCustomEnabled || $[40] !== onCancel || $[41] !== onColorPickerClose || $[42] !== onColorPickerToggle || $[43] !== onFocusTextField || $[44] !== onSelectColor || $[45] !== onSubmit || $[46] !== selectedColor || $[47] !== userOffline) {
        t15 = isCustomEnabled && isContentStateEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($35470e23ff8dc4a3$var$FormWrapper, {
            "data-testid": "form-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $45bd28dec8e86674$export$2ae5c8bd8129bb8e), {
            onSubmit: onSubmit,
            onCancel: onCancel,
            showFormFooter: isCreatingContentState,
            selectedColor: selectedColor,
            onSelectColor: onSelectColor,
            isColorPickerOpen: isColorPickerOpen,
            onColorPickerToggle: onColorPickerToggle,
            onColorPickerClose: onColorPickerClose,
            onFocusTextField: onFocusTextField,
            userOffline: userOffline,
            colorPickerComponentRef: colorPickerComponent
        }));
        $[36] = isColorPickerOpen;
        $[37] = isContentStateEnabled;
        $[38] = isCreatingContentState;
        $[39] = isCustomEnabled;
        $[40] = onCancel;
        $[41] = onColorPickerClose;
        $[42] = onColorPickerToggle;
        $[43] = onFocusTextField;
        $[44] = onSelectColor;
        $[45] = onSubmit;
        $[46] = selectedColor;
        $[47] = userOffline;
        $[48] = t15;
    } else t15 = $[48];
    let t16;
    if ($[49] !== contentId || $[50] !== contentStateState || $[51] !== customStatesArray || $[52] !== defaultStatesArray || $[53] !== formatMessage || $[54] !== isContentStateEnabled || $[55] !== isCreatingContentState || $[56] !== isCustomEnabled || $[57] !== isSuggestedEnabled || $[58] !== onUpdateSuccess || $[59] !== setIsContentStateMenuOpen || $[60] !== userOffline) {
        t16 = isContentStateEnabled ? !isCreatingContentState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($35470e23ff8dc4a3$var$HorizontalDivider, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($35470e23ff8dc4a3$var$ContentStateGroupsWrapper, {
            "data-testid": "content-state-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $742e27b1b03e5e97$export$710aa0e581cfaff9), {
            contentId: contentId,
            contentStateState: contentStateState,
            groupIsEnabled: isCustomEnabled,
            groupLabel: (0, $c169b00c0122f30f$export$fa2d28b3b2819e2d),
            contentStates: customStatesArray,
            userOffline: userOffline,
            onUpdateSuccess: onUpdateSuccess,
            setIsContentStateMenuOpen: setIsContentStateMenuOpen
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $742e27b1b03e5e97$export$710aa0e581cfaff9), {
            contentId: contentId,
            contentStateState: contentStateState,
            groupIsEnabled: isSuggestedEnabled,
            groupLabel: (0, $c169b00c0122f30f$export$b3c3dee917fc137d),
            contentStates: defaultStatesArray,
            userOffline: userOffline,
            onUpdateSuccess: onUpdateSuccess,
            setIsContentStateMenuOpen: setIsContentStateMenuOpen
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($35470e23ff8dc4a3$var$ContentStateDisabledDiv, {
            "data-testid": "content-state-disabled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($35470e23ff8dc4a3$var$HorizontalDivider, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($35470e23ff8dc4a3$var$FeatureDisabledGraphic, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($ec7900bbe9af5124$exports))),
            alt: "content states disabled graphic"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($35470e23ff8dc4a3$var$FeatureDisabledTextWrapper, {
            "data-testid": "feature-disabled-text"
        }, formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).featureDisabled)));
        $[49] = contentId;
        $[50] = contentStateState;
        $[51] = customStatesArray;
        $[52] = defaultStatesArray;
        $[53] = formatMessage;
        $[54] = isContentStateEnabled;
        $[55] = isCreatingContentState;
        $[56] = isCustomEnabled;
        $[57] = isSuggestedEnabled;
        $[58] = onUpdateSuccess;
        $[59] = setIsContentStateMenuOpen;
        $[60] = userOffline;
        $[61] = t16;
    } else t16 = $[61];
    let t17;
    if ($[62] !== t14 || $[63] !== t15 || $[64] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($35470e23ff8dc4a3$var$ContentStateMenuWrapper, {
            ref: menuComponent
        }, t14, t15, t16);
        $[62] = t14;
        $[63] = t15;
        $[64] = t16;
        $[65] = t17;
    } else t17 = $[65];
    return t17;
};
const $35470e23ff8dc4a3$export$d369faa039f625c2 = (0, $kSwu1.injectIntl)($35470e23ff8dc4a3$var$ContentStateMenuComponent);






















































var $9d7Pd = parcelRequire("9d7Pd");


var $6IL1T = parcelRequire("6IL1T");


var $8FgJC = parcelRequire("8FgJC");


var $9KSWX = parcelRequire("9KSWX");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $hAgam = parcelRequire("hAgam");








var $6TaGl = parcelRequire("6TaGl");

















var $jWGRt = parcelRequire("jWGRt");




const $5d70772a7c73eccb$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    searchPlaceholder: {
        id: "content-state.menu.v2.search-placeholder",
        defaultMessage: "Search or add"
    },
    defaultWorkflow: {
        id: "content-state.menu.v2.default-workflow",
        defaultMessage: "Default workflow"
    },
    customStatuses: {
        id: "content-state.menu.v2.custom-statuses",
        defaultMessage: "Custom statuses"
    },
    addCustomStatus: {
        id: "content-state.menu.v2.add-custom-status.title",
        defaultMessage: "Add as custom status"
    },
    addCustomStatusDescription: {
        id: "content-state.menu.v2.add-custom-status.description",
        defaultMessage: "Only you can choose this"
    },
    noStatusFound: {
        id: "content-state.menu.v2.no-status-found",
        defaultMessage: "No status found"
    },
    addCustomStatusHeader: {
        id: "content-state.menu.v2.add-custom-status-view.header",
        defaultMessage: "Add custom status"
    },
    statusNamePlaceholder: {
        id: "content-state.menu.v2.status-name.placeholder",
        defaultMessage: "Status name"
    },
    cancel: {
        id: "content-state.menu.v2.cancel",
        defaultMessage: "Cancel"
    },
    save: {
        id: "content-state.menu.v2.save",
        defaultMessage: "Save"
    },
    changeStatus: {
        id: "content-state.menu.v2.change-status",
        defaultMessage: "Change status"
    },
    status: {
        id: "content-state.menu.v2.status",
        defaultMessage: "Status"
    },
    removeStatus: {
        id: "content-state.menu.v2.remove-status.aria-label",
        defaultMessage: "Remove status"
    },
    startApproval: {
        id: "content-state.menu.v2.start-approval",
        defaultMessage: "Start approval"
    },
    approvalBetaTag: {
        id: "content-state.menu-v2.beta-lozenge",
        defaultMessage: "Beta"
    },
    colorPickerLabel: {
        id: "content-state.menu.v2.color-picker.aria-label",
        defaultMessage: "Color picker selector"
    },
    colorOption: {
        id: "content-state.menu.v2.color-picker.option.aria-label",
        defaultMessage: "Color option"
    },
    featureDisabled: {
        id: "content-state.menu.v2.feature-disabled",
        defaultMessage: "The content status feature is not enabled in this space."
    },
    featureDisabledImg: {
        id: "content-state.menu.v2.feature-disabled-img",
        defaultMessage: "Content states disabled graphic"
    },
    delete: {
        id: "content-state.menu.v2.delete",
        defaultMessage: "Delete"
    },
    moreActions: {
        id: "content-state.menu.v2.more-actions.aria-label",
        defaultMessage: "More actions for custom status {statusName}"
    }
});


const $217fbcf232c8becc$var$styles = {
    dialog: "_4ouGXIsz7G _1EqgXlwBC3",
    statusMenuHeader: "_2Y7lL45zaO _0hPCNLDIqT _37wbyuI7V3 _46hvQm5zaO _0xmtko2ADO",
    row: "_0hPCNLDIqT _0KLXru66of _0wOv4Q7zJH _37wbyuI7V3",
    searchInput: "_2Y7lL45zaO _0Of8r22ADO",
    stickySearchInput: "_2Y7lL45zaO _0Of8r22ADO",
    after: "_03SyCPgVvo",
    workflowStatusBadge: "_2mHwu82ADO _0KLXru66of _0wOv4Q7zJH _1UtDYzKGUX _0hPCNLDIqT",
    workflowStatusLabel: "_2mHwu82ADO _0hPCNLDIqT",
    badgeWrapperStyles: "_0bjKvDcjp5 _4c065UFQfX _2Y7lL41Y8M _0KLXrunmFW",
    iconStyles: "_2XsHFMLl21",
    customRow: "_1mT5xdRAKS",
    moreActionsButton: "_1mT5xdWVPG _2IhTon715P _4ApkO22ADO _1VJPcakruI _42Yu6B7dHp",
    noStatusFound: "_4c065U8HPE _2Y7lL45zaO _2fwxA5DIqT",
    statusGroupHeading: "_2sNsIgd8bj _2Y7lL45zaO _1UtDYzZpcK _46hvQm5zaO _0xmtkogVvo",
    stickyScrollableContent: "_46hvQm2ADO"
};
const $217fbcf232c8becc$var$STICKY_APPROVAL_FOOTER_SCROLL_BODY_MAX_HEIGHT = 240;
const $217fbcf232c8becc$var$StatusOptionRow = (t0)=>{
    const $ = (0, $bDgLe.c)(35);
    const { option: option, onSelect: onSelect, isActive: isActive, onDelete: onDelete, deleteLabel: deleteLabel, moreActionsLabel: moreActionsLabel } = t0;
    let t1;
    if ($[0] !== onSelect || $[1] !== option) {
        t1 = ()=>{
            if (option && option.name) onSelect(option);
        };
        $[0] = onSelect;
        $[1] = option;
        $[2] = t1;
    } else t1 = $[2];
    const handleClick = t1;
    const showDelete = Boolean(onDelete) && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true);
    const [isMenuOpen, setIsMenuOpen] = (0, $cozmU.useState)(false);
    let t2;
    if ($[3] !== onDelete || $[4] !== option) {
        t2 = ()=>{
            setIsMenuOpen(false);
            onDelete?.(option);
        };
        $[3] = onDelete;
        $[4] = option;
        $[5] = t2;
    } else t2 = $[5];
    const handleDelete = t2;
    let t3;
    let t4;
    if ($[6] !== isMenuOpen) {
        t3 = ()=>{
            if (!isMenuOpen) return;
            const handleScroll = ()=>setIsMenuOpen(false);
            window.addEventListener("scroll", handleScroll, true);
            return ()=>window.removeEventListener("scroll", handleScroll, true);
        };
        t4 = [
            isMenuOpen
        ];
        $[6] = isMenuOpen;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    const optionKey = option.id ?? option.name ?? "unknown";
    let t5;
    if ($[9] !== option.color || $[10] !== option.restrictionLevel) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4S6vT.ContentStateColor), {
            color: option.color,
            restrictionLevel: option.restrictionLevel,
            appearance: "contentStateButton"
        });
        $[9] = option.color;
        $[10] = option.restrictionLevel;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== handleClick || $[13] !== isActive || $[14] !== option.name || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            isSelected: isActive,
            iconBefore: t5,
            onClick: handleClick
        }, option.name);
        $[12] = handleClick;
        $[13] = isActive;
        $[14] = option.name;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    const buttonItem = t6;
    if (!showDelete) return buttonItem;
    let t7;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (t8)=>{
            const { isOpen: isOpen } = t8;
            return setIsMenuOpen(isOpen);
        };
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== moreActionsLabel || $[19] !== optionKey) {
        t8 = (t9)=>{
            const { triggerRef: triggerRef, ...triggerProps } = t9;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                ref: triggerRef,
                appearance: "subtle",
                spacing: "compact",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                label: moreActionsLabel ?? "",
                testId: `custom-status-more-${optionKey}`
            });
        };
        $[18] = moreActionsLabel;
        $[19] = optionKey;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
            label: "",
            color: "var(--ds-icon-danger, #C9372C)"
        });
        $[21] = t9;
    } else t9 = $[21];
    const t10 = `delete-custom-status-${optionKey}`;
    const t11 = deleteLabel ?? "";
    let t12;
    if ($[22] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.danger"
        }, t11);
        $[22] = t11;
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] !== handleDelete || $[25] !== t10 || $[26] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            elemBefore: t9,
            onClick: handleDelete,
            testId: t10
        }, t12));
        $[24] = handleDelete;
        $[25] = t10;
        $[26] = t12;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== isMenuOpen || $[29] !== t13 || $[30] !== t8) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $217fbcf232c8becc$var$styles.moreActionsButton
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            placement: "bottom-end",
            isOpen: isMenuOpen,
            onOpenChange: t7,
            trigger: t8
        }, t13));
        $[28] = isMenuOpen;
        $[29] = t13;
        $[30] = t8;
        $[31] = t14;
    } else t14 = $[31];
    let t15;
    if ($[32] !== buttonItem || $[33] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $217fbcf232c8becc$var$styles.customRow
        }, buttonItem, t14);
        $[32] = buttonItem;
        $[33] = t14;
        $[34] = t15;
    } else t15 = $[34];
    return t15;
};
const $217fbcf232c8becc$var$WorkflowStatusOptionRow = (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { status: status, onSelect: onSelect } = t0;
    let t1;
    if ($[0] !== onSelect || $[1] !== status) {
        t1 = ()=>onSelect(status);
        $[0] = onSelect;
        $[1] = status;
        $[2] = t1;
    } else t1 = $[2];
    const handleClick = t1;
    const Icon = status.id === (0, $jWGRt.CHANGES_REQUESTED_STATUS_ID) ? (0, (/*@__PURE__*/$parcel$interopDefault($dB01C))) : (0, (/*@__PURE__*/$parcel$interopDefault($k75o7)));
    let t2;
    if ($[3] !== Icon) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $217fbcf232c8becc$var$styles.iconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: "",
            size: "small",
            color: "var(--ds-icon-accent-blue, #357DE8)",
            spacing: "none"
        }));
        $[3] = Icon;
        $[4] = t2;
    } else t2 = $[4];
    const t3 = `workflow-status-option-${status.id}`;
    let t4;
    if ($[5] !== status.allowsReviews || $[6] !== status.name) {
        t4 = status.allowsReviews ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).startApproval) : status.name;
        $[5] = status.allowsReviews;
        $[6] = status.name;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== status.allowsReviews) {
        t5 = status.allowsReviews && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: "discovery"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).approvalBetaTag));
        $[8] = status.allowsReviews;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t4 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $217fbcf232c8becc$var$styles.workflowStatusLabel
        }, t4, t5);
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== status.allowsReviews) {
        t7 = status.allowsReviews ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            size: "small",
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $217fbcf232c8becc$var$styles.workflowStatusBadge
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $217fbcf232c8becc$var$styles.badgeWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).startApproval))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            size: "small",
            label: ""
        }));
        $[13] = status.allowsReviews;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== t6 || $[16] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $217fbcf232c8becc$var$styles.row
        }, t6, t7);
        $[15] = t6;
        $[16] = t7;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== handleClick || $[19] !== t2 || $[20] !== t3 || $[21] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            iconBefore: t2,
            onClick: handleClick,
            testId: t3
        }, t8);
        $[18] = handleClick;
        $[19] = t2;
        $[20] = t3;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    return t9;
};
const $217fbcf232c8becc$var$ApprovalUpsellOptionRow = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onSelect: onSelect } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $217fbcf232c8becc$var$styles.iconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k75o7))), {
            label: "",
            size: "small",
            color: "var(--ds-icon-accent-blue, #357DE8)",
            spacing: "none"
        }));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).startApproval);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $217fbcf232c8becc$var$styles.row
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $217fbcf232c8becc$var$styles.workflowStatusLabel
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: "discovery"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).approvalBetaTag))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            size: "small",
            label: ""
        }));
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== onSelect) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            iconBefore: t1,
            onClick: onSelect,
            testId: "approval-upsell-option"
        }, t3);
        $[3] = onSelect;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
};
const $217fbcf232c8becc$var$ContentStateMenuV2SelectViewComponent = (t0)=>{
    const $ = (0, $bDgLe.c)(105);
    const { searchValue: searchValue, onSearchChange: onSearchChange, filteredDefaultSection: filteredDefaultSection, filteredCustomOptions: filteredCustomOptions, hasResults: hasResults, hasApprovalFooterOption: t1, isCustomEnabled: isCustomEnabled, currentContentState: currentContentState, hasActiveWorkflowStatus: t2, onSelectStatus: onSelectStatus, onSelectWorkflowStatus: onSelectWorkflowStatus, onSelectApprovalsUpsell: onSelectApprovalsUpsell, onAddCustomClick: onAddCustomClick, onDeleteCustomStatus: onDeleteCustomStatus, onRemoveStatus: onRemoveStatus, intl: t3 } = t0;
    const hasApprovalFooterOption = t1 === undefined ? false : t1;
    const hasActiveWorkflowStatus = t2 === undefined ? false : t2;
    const { formatMessage: formatMessage } = t3;
    let t4;
    if ($[0] !== onSearchChange) {
        t4 = (e)=>onSearchChange(e.currentTarget.value);
        $[0] = onSearchChange;
        $[1] = t4;
    } else t4 = $[1];
    const handleSearchChange = t4;
    let t5;
    if ($[2] !== filteredDefaultSection) {
        const nonApproval = [];
        let approval;
        for (const item of filteredDefaultSection)if ((item.type === "workflowStatus" && item.workflowStatus.allowsReviews || item.type === "approvalUpsell") && approval === undefined) approval = item;
        else nonApproval.push(item);
        t5 = {
            nonApprovalDefaultRows: nonApproval,
            approvalRow: approval
        };
        $[2] = filteredDefaultSection;
        $[3] = t5;
    } else t5 = $[3];
    const { nonApprovalDefaultRows: nonApprovalDefaultRows, approvalRow: approvalRow } = t5;
    let t6;
    if ($[4] !== filteredCustomOptions.length || $[5] !== isCustomEnabled) {
        t6 = filteredCustomOptions.length > 0 && (isCustomEnabled || !(0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true));
        $[4] = filteredCustomOptions.length;
        $[5] = isCustomEnabled;
        $[6] = t6;
    } else t6 = $[6];
    const showCustomSection = t6;
    let renderNoResultsSection;
    let renderScrollableStatusSections;
    let renderSearchSection;
    let renderStatusHeader;
    let t7;
    if ($[7] !== approvalRow || $[8] !== currentContentState || $[9] !== filteredCustomOptions || $[10] !== formatMessage || $[11] !== handleSearchChange || $[12] !== hasActiveWorkflowStatus || $[13] !== hasApprovalFooterOption || $[14] !== hasResults || $[15] !== isCustomEnabled || $[16] !== nonApprovalDefaultRows || $[17] !== onAddCustomClick || $[18] !== onDeleteCustomStatus || $[19] !== onRemoveStatus || $[20] !== onSelectApprovalsUpsell || $[21] !== onSelectStatus || $[22] !== onSelectWorkflowStatus || $[23] !== searchValue || $[24] !== showCustomSection) {
        t7 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const defaultSectionTitle = showCustomSection ? formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).defaultWorkflow) : undefined;
            const shouldRenderRemoveStatusButton = Boolean(currentContentState) || hasActiveWorkflowStatus;
            const shouldRenderStickyApprovalFooter = hasApprovalFooterOption;
            const hasVisibleStatusRowsAboveApprovalFooter = nonApprovalDefaultRows.length > 0 || showCustomSection;
            let t8;
            if ($[30] !== hasResults || $[31] !== searchValue) {
                t8 = !hasResults && Boolean(searchValue.trim());
                $[30] = hasResults;
                $[31] = searchValue;
                $[32] = t8;
            } else t8 = $[32];
            const hasNoResultsAction = t8;
            const shouldRenderStickyScrollableSection = hasVisibleStatusRowsAboveApprovalFooter || hasNoResultsAction;
            let t9;
            if ($[33] !== currentContentState?.id || $[34] !== onSelectApprovalsUpsell || $[35] !== onSelectStatus || $[36] !== onSelectWorkflowStatus) {
                t9 = (item_0)=>{
                    if (item_0.type === "contentState") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($217fbcf232c8becc$var$StatusOptionRow, {
                        key: item_0.contentState.id,
                        option: item_0.contentState,
                        onSelect: onSelectStatus,
                        isActive: currentContentState?.id === item_0.contentState.id
                    });
                    if (item_0.type === "workflowStatus") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($217fbcf232c8becc$var$WorkflowStatusOptionRow, {
                        key: `workflow-${item_0.workflowStatus.id}`,
                        status: item_0.workflowStatus,
                        onSelect: onSelectWorkflowStatus
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($217fbcf232c8becc$var$ApprovalUpsellOptionRow, {
                        key: "approval-upsell",
                        onSelect: onSelectApprovalsUpsell
                    });
                };
                $[33] = currentContentState?.id;
                $[34] = onSelectApprovalsUpsell;
                $[35] = onSelectStatus;
                $[36] = onSelectWorkflowStatus;
                $[37] = t9;
            } else t9 = $[37];
            const renderDefaultSectionItem = t9;
            let t10;
            if ($[38] !== formatMessage || $[39] !== onRemoveStatus || $[40] !== shouldRenderRemoveStatusButton) {
                t10 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                        xcss: $217fbcf232c8becc$var$styles.statusMenuHeader,
                        testId: "status-menu-header"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
                        as: "h2",
                        size: "medium"
                    }, formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).status)), shouldRenderRemoveStatusButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                        appearance: "subtle",
                        spacing: "compact",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                        label: formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).removeStatus),
                        onClick: onRemoveStatus,
                        testId: "status-menu-remove-button"
                    }));
                $[38] = formatMessage;
                $[39] = onRemoveStatus;
                $[40] = shouldRenderRemoveStatusButton;
                $[41] = t10;
            } else t10 = $[41];
            renderStatusHeader = t10;
            let t11;
            if ($[42] !== formatMessage || $[43] !== handleSearchChange || $[44] !== searchValue) {
                t11 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                        xcss: $217fbcf232c8becc$var$styles.searchInput
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
                        name: "status-search",
                        "aria-label": formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).searchPlaceholder),
                        placeholder: formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).searchPlaceholder),
                        maxLength: 20,
                        isCompact: true,
                        value: searchValue,
                        onChange: handleSearchChange,
                        autoComplete: (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) ? "off" : undefined,
                        elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                            xcss: $217fbcf232c8becc$var$styles.after
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                            label: ""
                        })),
                        testId: "status-search-input"
                    })));
                $[42] = formatMessage;
                $[43] = handleSearchChange;
                $[44] = searchValue;
                $[45] = t11;
            } else t11 = $[45];
            renderSearchSection = t11;
            let t12;
            if ($[46] !== formatMessage || $[47] !== handleSearchChange || $[48] !== searchValue) {
                t12 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                        xcss: $217fbcf232c8becc$var$styles.stickySearchInput
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
                        name: "status-search",
                        "aria-label": formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).searchPlaceholder),
                        placeholder: formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).searchPlaceholder),
                        maxLength: 20,
                        isCompact: true,
                        value: searchValue,
                        onChange: handleSearchChange,
                        autoComplete: (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) ? "off" : undefined,
                        elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                            xcss: $217fbcf232c8becc$var$styles.after
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                            label: ""
                        })),
                        testId: "status-search-input"
                    }));
                $[46] = formatMessage;
                $[47] = handleSearchChange;
                $[48] = searchValue;
                $[49] = t12;
            } else t12 = $[49];
            const renderStickySearchSection = t12;
            let t13;
            if ($[50] !== currentContentState?.id || $[51] !== filteredCustomOptions || $[52] !== formatMessage || $[53] !== onDeleteCustomStatus || $[54] !== onSelectStatus) {
                t13 = ()=>filteredCustomOptions.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($217fbcf232c8becc$var$StatusOptionRow, {
                            key: option.id,
                            option: option,
                            onSelect: onSelectStatus,
                            isActive: currentContentState?.id === option.id,
                            onDelete: onDeleteCustomStatus,
                            deleteLabel: formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).delete),
                            moreActionsLabel: formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).moreActions, {
                                statusName: option.name ?? ""
                            })
                        }));
                $[50] = currentContentState?.id;
                $[51] = filteredCustomOptions;
                $[52] = formatMessage;
                $[53] = onDeleteCustomStatus;
                $[54] = onSelectStatus;
                $[55] = t13;
            } else t13 = $[55];
            const renderCustomStatusRows = t13;
            let t14;
            if ($[56] !== formatMessage || $[57] !== hasResults || $[58] !== isCustomEnabled || $[59] !== onAddCustomClick || $[60] !== searchValue) {
                t14 = ()=>!hasResults && searchValue.trim() && (!isCustomEnabled && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                        xcss: $217fbcf232c8becc$var$styles.noStatusFound,
                        testId: "no-status-found",
                        role: "status"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                        color: "color.text.subtlest"
                    }, formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).noStatusFound)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
                            label: ""
                        }),
                        description: formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).addCustomStatusDescription),
                        onClick: onAddCustomClick,
                        testId: "add-custom-status-button"
                    }, formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).addCustomStatus))));
                $[56] = formatMessage;
                $[57] = hasResults;
                $[58] = isCustomEnabled;
                $[59] = onAddCustomClick;
                $[60] = searchValue;
                $[61] = t14;
            } else t14 = $[61];
            renderNoResultsSection = t14;
            renderScrollableStatusSections = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, nonApprovalDefaultRows.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
                    title: defaultSectionTitle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), null, nonApprovalDefaultRows.map(renderDefaultSectionItem))), showCustomSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
                    title: formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).customStatuses)
                }, renderCustomStatusRows()));
            const renderStickyStatusGroup = $217fbcf232c8becc$var$_temp;
            const renderStickyScrollableStatusSections = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, nonApprovalDefaultRows.length > 0 && renderStickyStatusGroup(defaultSectionTitle, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), null, nonApprovalDefaultRows.map(renderDefaultSectionItem))), showCustomSection && renderStickyStatusGroup(formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).customStatuses), renderCustomStatusRows()), renderNoResultsSection());
            let t15;
            if ($[62] !== approvalRow || $[63] !== onSelectApprovalsUpsell || $[64] !== onSelectWorkflowStatus) {
                t15 = (hasSeparator)=>{
                    if (approvalRow?.type === "workflowStatus") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
                        hasSeparator: hasSeparator
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($217fbcf232c8becc$var$WorkflowStatusOptionRow, {
                        key: `workflow-${approvalRow.workflowStatus.id}`,
                        status: approvalRow.workflowStatus,
                        onSelect: onSelectWorkflowStatus
                    }));
                    if (approvalRow?.type === "approvalUpsell") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
                        hasSeparator: hasSeparator
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($217fbcf232c8becc$var$ApprovalUpsellOptionRow, {
                        onSelect: onSelectApprovalsUpsell
                    }));
                    return null;
                };
                $[62] = approvalRow;
                $[63] = onSelectApprovalsUpsell;
                $[64] = onSelectWorkflowStatus;
                $[65] = t15;
            } else t15 = $[65];
            const renderApprovalFooterSection = t15;
            if (shouldRenderStickyApprovalFooter) {
                let t16;
                if ($[66] !== renderStatusHeader) {
                    t16 = renderStatusHeader();
                    $[66] = renderStatusHeader;
                    $[67] = t16;
                } else t16 = $[67];
                let t17;
                if ($[68] !== renderStickySearchSection) {
                    t17 = renderStickySearchSection();
                    $[68] = renderStickySearchSection;
                    $[69] = t17;
                } else t17 = $[69];
                const t18 = shouldRenderStickyScrollableSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
                    maxHeight: $217fbcf232c8becc$var$STICKY_APPROVAL_FOOTER_SCROLL_BODY_MAX_HEIGHT,
                    testId: "status-selector-scrollable-section"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $217fbcf232c8becc$var$styles.stickyScrollableContent
                }, renderStickyScrollableStatusSections()));
                let t19;
                if ($[70] !== hasVisibleStatusRowsAboveApprovalFooter || $[71] !== renderApprovalFooterSection) {
                    t19 = renderApprovalFooterSection(hasVisibleStatusRowsAboveApprovalFooter);
                    $[70] = hasVisibleStatusRowsAboveApprovalFooter;
                    $[71] = renderApprovalFooterSection;
                    $[72] = t19;
                } else t19 = $[72];
                let t20;
                if ($[73] !== t16 || $[74] !== t17 || $[75] !== t18 || $[76] !== t19) {
                    t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                        xcss: $217fbcf232c8becc$var$styles.dialog,
                        testId: "status-selector-popup-menu"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), null, t16, t17, t18, t19));
                    $[73] = t16;
                    $[74] = t17;
                    $[75] = t18;
                    $[76] = t19;
                    $[77] = t20;
                } else t20 = $[77];
                t7 = t20;
                break bb0;
            }
        }
        $[7] = approvalRow;
        $[8] = currentContentState;
        $[9] = filteredCustomOptions;
        $[10] = formatMessage;
        $[11] = handleSearchChange;
        $[12] = hasActiveWorkflowStatus;
        $[13] = hasApprovalFooterOption;
        $[14] = hasResults;
        $[15] = isCustomEnabled;
        $[16] = nonApprovalDefaultRows;
        $[17] = onAddCustomClick;
        $[18] = onDeleteCustomStatus;
        $[19] = onRemoveStatus;
        $[20] = onSelectApprovalsUpsell;
        $[21] = onSelectStatus;
        $[22] = onSelectWorkflowStatus;
        $[23] = searchValue;
        $[24] = showCustomSection;
        $[25] = renderNoResultsSection;
        $[26] = renderScrollableStatusSections;
        $[27] = renderSearchSection;
        $[28] = renderStatusHeader;
        $[29] = t7;
    } else {
        renderNoResultsSection = $[25];
        renderScrollableStatusSections = $[26];
        renderSearchSection = $[27];
        renderStatusHeader = $[28];
        t7 = $[29];
    }
    if (t7 !== Symbol.for("react.early_return_sentinel")) return t7;
    let t8;
    if ($[78] !== renderStatusHeader) {
        t8 = renderStatusHeader();
        $[78] = renderStatusHeader;
        $[79] = t8;
    } else t8 = $[79];
    let t9;
    if ($[80] !== renderSearchSection) {
        t9 = renderSearchSection();
        $[80] = renderSearchSection;
        $[81] = t9;
    } else t9 = $[81];
    let t10;
    if ($[82] !== renderScrollableStatusSections) {
        t10 = renderScrollableStatusSections();
        $[82] = renderScrollableStatusSections;
        $[83] = t10;
    } else t10 = $[83];
    let t11;
    if ($[84] !== approvalRow || $[85] !== nonApprovalDefaultRows.length || $[86] !== onSelectWorkflowStatus || $[87] !== showCustomSection) {
        t11 = approvalRow && approvalRow.type === "workflowStatus" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
            hasSeparator: nonApprovalDefaultRows.length > 0 || showCustomSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($217fbcf232c8becc$var$WorkflowStatusOptionRow, {
            key: `workflow-${approvalRow.workflowStatus.id}`,
            status: approvalRow.workflowStatus,
            onSelect: onSelectWorkflowStatus
        }));
        $[84] = approvalRow;
        $[85] = nonApprovalDefaultRows.length;
        $[86] = onSelectWorkflowStatus;
        $[87] = showCustomSection;
        $[88] = t11;
    } else t11 = $[88];
    let t12;
    if ($[89] !== approvalRow || $[90] !== nonApprovalDefaultRows.length || $[91] !== onSelectApprovalsUpsell || $[92] !== showCustomSection) {
        t12 = approvalRow && approvalRow.type === "approvalUpsell" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
            hasSeparator: nonApprovalDefaultRows.length > 0 || showCustomSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($217fbcf232c8becc$var$ApprovalUpsellOptionRow, {
            onSelect: onSelectApprovalsUpsell
        }));
        $[89] = approvalRow;
        $[90] = nonApprovalDefaultRows.length;
        $[91] = onSelectApprovalsUpsell;
        $[92] = showCustomSection;
        $[93] = t12;
    } else t12 = $[93];
    let t13;
    if ($[94] !== renderNoResultsSection) {
        t13 = renderNoResultsSection();
        $[94] = renderNoResultsSection;
        $[95] = t13;
    } else t13 = $[95];
    let t14;
    if ($[96] !== t10 || $[97] !== t11 || $[98] !== t12 || $[99] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
            isScrollable: true
        }, t10, t11, t12, t13);
        $[96] = t10;
        $[97] = t11;
        $[98] = t12;
        $[99] = t13;
        $[100] = t14;
    } else t14 = $[100];
    let t15;
    if ($[101] !== t14 || $[102] !== t8 || $[103] !== t9) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $217fbcf232c8becc$var$styles.dialog,
            testId: "status-selector-popup-menu"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
            maxHeight: 360
        }, t8, t9, t14));
        $[101] = t14;
        $[102] = t8;
        $[103] = t9;
        $[104] = t15;
    } else t15 = $[104];
    return t15;
};
const $217fbcf232c8becc$export$2736d93594f59257 = (0, $kSwu1.injectIntl)($217fbcf232c8becc$var$ContentStateMenuV2SelectViewComponent);
function $217fbcf232c8becc$var$_temp(title, children) {
    if (!title) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        role: "group",
        "aria-label": title
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "aria-hidden": true,
        xcss: $217fbcf232c8becc$var$styles.statusGroupHeading
    }, title), children);
}










































var $kdlgT = parcelRequire("kdlgT");











const $8363866a64cc2105$var$styles = {
    dialog: "_4ouGXIsz7G _1EqgXlwBC3",
    addCustomHeader: "_2mHwu82ADO _0hPCNLDIqT _0rIjyk5zaO",
    addCustomForm: "_2mHwu88HPE",
    colorAndName: "_2mHwu82ADO",
    formButtons: "_2mHwu82ADO _37wbyuz9WS",
    addCustomContainer: "_2Y7lL45zaO _4c065U5zaO",
    colorButtonContent: "_0jFU0VSPN1",
    colorPickerButton: "_0bjKvDKxmn _3vBAKHHKt7 _2V7sgONvrM _3hxITi6wH8 _0KLXru7Cj1"
};
const $8363866a64cc2105$var$colorsArray = [
    (0, $Uu0Pb.PRIMARY_COLORS).BLUE,
    (0, $Uu0Pb.PRIMARY_COLORS).GREEN,
    (0, $Uu0Pb.PRIMARY_COLORS).YELLOW,
    (0, $Uu0Pb.PRIMARY_COLORS).RED,
    (0, $Uu0Pb.PRIMARY_COLORS).PURPLE
];
const $8363866a64cc2105$var$ContentStateMenuV2CreateViewComponent = (t0)=>{
    const $ = (0, $bDgLe.c)(54);
    const { initialValue: initialValue, onBack: onBack, onSave: onSave, intl: t1 } = t0;
    const { formatMessage: formatMessage } = t1;
    const [statusName, setStatusName] = (0, $cozmU.useState)(initialValue);
    const [selectedColorId, setSelectedColorId] = (0, $cozmU.useState)($8363866a64cc2105$var$colorsArray[0] || "");
    let t2;
    if ($[0] !== onSave || $[1] !== selectedColorId || $[2] !== statusName) {
        t2 = ()=>{
            if (statusName.trim()) onSave(statusName.trim(), selectedColorId);
        };
        $[0] = onSave;
        $[1] = selectedColorId;
        $[2] = statusName;
        $[3] = t2;
    } else t2 = $[3];
    const handleSave = t2;
    let t3;
    if ($[4] !== onBack) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
            label: "Back",
            spacing: "compact",
            onClick: onBack,
            testId: "back-to-search-button"
        });
        $[4] = onBack;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== formatMessage) {
        t4 = formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).addCustomStatusHeader);
        $[6] = formatMessage;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "xsmall"
        }, t4);
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t3 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $8363866a64cc2105$var$styles.addCustomHeader
        }, t3, t5);
        $[10] = t3;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== formatMessage || $[14] !== selectedColorId) {
        t7 = (t8)=>{
            const { triggerRef: triggerRef, ...triggerProps } = t8;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $8363866a64cc2105$var$styles.colorPickerButton
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ...triggerProps,
                ref: triggerRef,
                appearance: "subtle",
                iconAfter: $8363866a64cc2105$var$_temp,
                "aria-label": formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).colorPickerLabel),
                testId: "color-picker-trigger"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                xcss: $8363866a64cc2105$var$styles.colorButtonContent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4S6vT.ContentStateColor), {
                color: selectedColorId,
                appearance: "contentStateButton"
            }))));
        };
        $[13] = formatMessage;
        $[14] = selectedColorId;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== formatMessage) {
        t8 = $8363866a64cc2105$var$colorsArray.map((color, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                key: color,
                onClick: ()=>setSelectedColorId(color || ""),
                testId: `color-option-${index}`,
                "aria-label": formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).colorOption)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                xcss: $8363866a64cc2105$var$styles.colorAndName
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4S6vT.ContentStateColor), {
                color: color,
                appearance: "contentStateButton"
            }))));
        $[16] = formatMessage;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, t8);
        $[18] = t8;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] !== t7 || $[21] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            trigger: t7,
            placement: "bottom-start"
        }, t9);
        $[20] = t7;
        $[21] = t9;
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (e)=>setStatusName(e.currentTarget.value);
        $[23] = t11;
    } else t11 = $[23];
    let t12;
    if ($[24] !== formatMessage) {
        t12 = formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).statusNamePlaceholder);
        $[24] = formatMessage;
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== statusName || $[27] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            value: statusName,
            onChange: t11,
            placeholder: t12,
            appearance: "standard",
            maxLength: 20,
            isCompact: true,
            testId: "custom-status-name-input"
        });
        $[26] = statusName;
        $[27] = t12;
        $[28] = t13;
    } else t13 = $[28];
    let t14;
    if ($[29] !== t10 || $[30] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $8363866a64cc2105$var$styles.colorAndName
        }, t10, t13);
        $[29] = t10;
        $[30] = t13;
        $[31] = t14;
    } else t14 = $[31];
    let t15;
    if ($[32] !== formatMessage) {
        t15 = formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).cancel);
        $[32] = formatMessage;
        $[33] = t15;
    } else t15 = $[33];
    let t16;
    if ($[34] !== onBack || $[35] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: onBack,
            testId: "cancel-custom-status-button"
        }, t15);
        $[34] = onBack;
        $[35] = t15;
        $[36] = t16;
    } else t16 = $[36];
    let t17;
    if ($[37] !== statusName) {
        t17 = statusName.trim();
        $[37] = statusName;
        $[38] = t17;
    } else t17 = $[38];
    const t18 = !t17;
    let t19;
    if ($[39] !== formatMessage) {
        t19 = formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).save);
        $[39] = formatMessage;
        $[40] = t19;
    } else t19 = $[40];
    let t20;
    if ($[41] !== handleSave || $[42] !== t18 || $[43] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleSave,
            isDisabled: t18,
            testId: "save-custom-status-button"
        }, t19);
        $[41] = handleSave;
        $[42] = t18;
        $[43] = t19;
        $[44] = t20;
    } else t20 = $[44];
    let t21;
    if ($[45] !== t16 || $[46] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $8363866a64cc2105$var$styles.formButtons
        }, t16, t20);
        $[45] = t16;
        $[46] = t20;
        $[47] = t21;
    } else t21 = $[47];
    let t22;
    if ($[48] !== t14 || $[49] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $8363866a64cc2105$var$styles.addCustomForm
        }, t14, t21);
        $[48] = t14;
        $[49] = t21;
        $[50] = t22;
    } else t22 = $[50];
    let t23;
    if ($[51] !== t22 || $[52] !== t6) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $8363866a64cc2105$var$styles.dialog,
            testId: "add-custom-status-view"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $8363866a64cc2105$var$styles.addCustomContainer
        }, t6, t22));
        $[51] = t22;
        $[52] = t6;
        $[53] = t23;
    } else t23 = $[53];
    return t23;
};
const $8363866a64cc2105$export$1b183f966e13e015 = (0, $kSwu1.injectIntl)($8363866a64cc2105$var$ContentStateMenuV2CreateViewComponent);
function $8363866a64cc2105$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: "",
        size: "small"
    });
}



















const $07266645e67f8a5c$var$styles = {
    dialog: "_2Y7lL45zaO _1EqgXlehCh _46hvQm5zaO _0xmtko2ADO",
    message: "_2XghbE8HPE _1UtDYzot27 _2fwxA5DIqT"
};
const $07266645e67f8a5c$var$ContentStateMenuV2DisabledViewComponent = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { intl: t1 } = t0;
    const { formatMessage: formatMessage } = t1;
    let t2;
    if ($[0] !== formatMessage) {
        t2 = formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).featureDisabledImg);
        $[0] = formatMessage;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "img",
            height: "var(--ds-space-1000, 80px)",
            width: "var(--ds-space-800, 64px)",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($ec7900bbe9af5124$exports))),
            alt: t2
        });
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== formatMessage) {
        t4 = formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).featureDisabled);
        $[4] = formatMessage;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "p",
            xcss: $07266645e67f8a5c$var$styles.message
        }, t4);
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== t3 || $[9] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $07266645e67f8a5c$var$styles.dialog,
            alignInline: "center",
            testId: "content-state-disabled-v2"
        }, t3, t5);
        $[8] = t3;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
};
const $07266645e67f8a5c$export$e173ca5f21a59a52 = (0, $kSwu1.injectIntl)($07266645e67f8a5c$var$ContentStateMenuV2DisabledViewComponent);



var $eeca34bbf5c80885$var$ConstentStateMenuViewTypes = /*#__PURE__*/ function(ConstentStateMenuViewTypes) {
    ConstentStateMenuViewTypes["SELECT"] = "select";
    ConstentStateMenuViewTypes["CREATE"] = "create";
    return ConstentStateMenuViewTypes;
}($eeca34bbf5c80885$var$ConstentStateMenuViewTypes || {});
const $eeca34bbf5c80885$var$getDefaultSectionItemName = (item, approvalUpsellLabel)=>{
    if (item.type === 'contentState') return item.contentState.name;
    if (item.type === 'workflowStatus') {
        if (item.workflowStatus.allowsReviews) return `${approvalUpsellLabel} ${item.workflowStatus.name}`;
        return item.workflowStatus.name;
    }
    return approvalUpsellLabel;
};
const $eeca34bbf5c80885$var$isApprovalFooterItem = (item)=>item.type === 'approvalUpsell' || item.type === 'workflowStatus' && item.workflowStatus.allowsReviews;
const $eeca34bbf5c80885$var$ContentStateMenuV2Component = (t0)=>{
    const $ = (0, $bDgLe.c)(58);
    const { contentStateState: contentStateState, contentType: contentType, isLivePage: isLivePage, defaultStatesArray: defaultStatesArray, customStatesArray: customStatesArray, onSelectExistingStatus: onSelectExistingStatus, onSaveCustomStatus: onSaveCustomStatus, onDeleteCustomStatus: onDeleteCustomStatus, onRemove: onRemove, setIsContentStateMenuOpen: setIsContentStateMenuOpen, workflowStatuses: t1, onSelectWorkflowStatus: onSelectWorkflowStatus, hasActiveWorkflowStatus: t2, showApprovalsUpsell: t3, onSelectApprovalsUpsell: onSelectApprovalsUpsell, intl: t4 } = t0;
    let t5;
    if ($[0] !== t1) {
        t5 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t5;
    } else t5 = $[1];
    const workflowStatuses = t5;
    const hasActiveWorkflowStatus = t2 === undefined ? false : t2;
    const showApprovalsUpsell = t3 === undefined ? false : t3;
    const { formatMessage: formatMessage } = t4;
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const [searchValue, setSearchValue] = (0, $cozmU.useState)("");
    const [currentView, setCurrentView] = (0, $cozmU.useState)("select");
    const menuRef = (0, $cozmU.useRef)(null);
    let t6;
    if ($[2] !== defaultStatesArray) {
        t6 = defaultStatesArray || [];
        $[2] = defaultStatesArray;
        $[3] = t6;
    } else t6 = $[3];
    let t7;
    if ($[4] !== t6) {
        t7 = t6.filter($eeca34bbf5c80885$var$_temp);
        $[4] = t6;
        $[5] = t7;
    } else t7 = $[5];
    const validDefaultStates = t7;
    let t8;
    if ($[6] !== customStatesArray) {
        t8 = customStatesArray || [];
        $[6] = customStatesArray;
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] !== t8) {
        t9 = t8.filter($eeca34bbf5c80885$var$_temp2);
        $[8] = t8;
        $[9] = t9;
    } else t9 = $[9];
    const validCustomStates = t9;
    let t10;
    if ($[10] !== contentType || $[11] !== isLivePage || $[12] !== isPremium || $[13] !== showApprovalsUpsell || $[14] !== validDefaultStates || $[15] !== workflowStatuses) {
        bb0: {
            const contentStateItems = validDefaultStates.map($eeca34bbf5c80885$var$_temp3);
            const shouldShowWorkflowStatuses = contentType === "page" && workflowStatuses.length > 0 && isPremium && (!isLivePage || (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true));
            const shouldShowApprovalsUpsell = contentType === "page" && showApprovalsUpsell && (!isLivePage || (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true));
            if (!shouldShowWorkflowStatuses && !shouldShowApprovalsUpsell) {
                t10 = contentStateItems;
                break bb0;
            }
            const workflowItems = shouldShowWorkflowStatuses ? workflowStatuses.map($eeca34bbf5c80885$var$_temp4) : [];
            const approvalUpsellItems = shouldShowApprovalsUpsell ? [
                {
                    type: "approvalUpsell"
                }
            ] : [];
            const restrictedIndex = contentStateItems.findIndex($eeca34bbf5c80885$var$_temp5);
            if (restrictedIndex !== -1) {
                const result = [
                    ...contentStateItems
                ];
                result.splice(restrictedIndex, 0, ...workflowItems);
                t10 = [
                    ...result,
                    ...approvalUpsellItems
                ];
                break bb0;
            }
            t10 = [
                ...contentStateItems,
                ...workflowItems,
                ...approvalUpsellItems
            ];
        }
        $[10] = contentType;
        $[11] = isLivePage;
        $[12] = isPremium;
        $[13] = showApprovalsUpsell;
        $[14] = validDefaultStates;
        $[15] = workflowStatuses;
        $[16] = t10;
    } else t10 = $[16];
    const mergedDefaultSection = t10;
    const [selectedContentState, setSelectedContentState] = (0, $cozmU.useState)(null);
    const currentContentState = selectedContentState ?? contentStateState.state.contentState;
    let t11;
    if ($[17] !== currentContentState?.id || $[18] !== onSelectExistingStatus || $[19] !== setIsContentStateMenuOpen) {
        t11 = (selectedStatus)=>{
            if (currentContentState?.id === selectedStatus.id) return;
            setSelectedContentState(selectedStatus);
            onSelectExistingStatus(selectedStatus);
            setIsContentStateMenuOpen(false);
            setSearchValue("");
        };
        $[17] = currentContentState?.id;
        $[18] = onSelectExistingStatus;
        $[19] = setIsContentStateMenuOpen;
        $[20] = t11;
    } else t11 = $[20];
    const handleSelectStatus = t11;
    let t12;
    if ($[21] !== onRemove) {
        t12 = ()=>{
            setSelectedContentState(null);
            onRemove();
        };
        $[21] = onRemove;
        $[22] = t12;
    } else t12 = $[22];
    const handleRemoveStatus = t12;
    let t13;
    if ($[23] !== onSelectApprovalsUpsell || $[24] !== setIsContentStateMenuOpen) {
        t13 = ()=>{
            setIsContentStateMenuOpen(false);
            setSearchValue("");
            onSelectApprovalsUpsell?.();
        };
        $[23] = onSelectApprovalsUpsell;
        $[24] = setIsContentStateMenuOpen;
        $[25] = t13;
    } else t13 = $[25];
    const handleSelectApprovalsUpsell = t13;
    let t14;
    bb1: {
        if (!searchValue.trim()) {
            t14 = mergedDefaultSection;
            break bb1;
        }
        let t15;
        if ($[26] !== formatMessage || $[27] !== mergedDefaultSection || $[28] !== searchValue) {
            const lowerQuery = searchValue.toLowerCase();
            const approvalUpsellLabel = formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).startApproval);
            t15 = mergedDefaultSection.filter((item_0)=>{
                const name = $eeca34bbf5c80885$var$getDefaultSectionItemName(item_0, approvalUpsellLabel);
                return name?.toLowerCase().includes(lowerQuery);
            });
            $[26] = formatMessage;
            $[27] = mergedDefaultSection;
            $[28] = searchValue;
            $[29] = t15;
        } else t15 = $[29];
        t14 = t15;
    }
    const filteredDefaultSection = t14;
    let t15;
    if ($[30] !== mergedDefaultSection) {
        t15 = mergedDefaultSection.some($eeca34bbf5c80885$var$isApprovalFooterItem);
        $[30] = mergedDefaultSection;
        $[31] = t15;
    } else t15 = $[31];
    const hasApprovalFooterOption = t15;
    let t16;
    bb2: {
        if (!searchValue.trim()) {
            t16 = validCustomStates;
            break bb2;
        }
        let t17;
        if ($[32] !== searchValue || $[33] !== validCustomStates) {
            const lowerQuery_0 = searchValue.toLowerCase();
            t17 = validCustomStates.filter((option)=>option.name?.toLowerCase().includes(lowerQuery_0));
            $[32] = searchValue;
            $[33] = validCustomStates;
            $[34] = t17;
        } else t17 = $[34];
        t16 = t17;
    }
    const filteredCustomOptions = t16;
    const hasResults = filteredDefaultSection.length > 0 || filteredCustomOptions.length > 0;
    let t17;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = ()=>{
            setCurrentView("create");
        };
        $[35] = t17;
    } else t17 = $[35];
    const handleAddCustomClick = t17;
    let t18;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = ()=>{
            setCurrentView("select");
        };
        $[36] = t18;
    } else t18 = $[36];
    const handleBackToSearch = t18;
    let t19;
    if ($[37] !== onSaveCustomStatus || $[38] !== setIsContentStateMenuOpen) {
        t19 = (statusName, colorId)=>{
            onSaveCustomStatus(statusName, colorId);
            setIsContentStateMenuOpen(false);
            setCurrentView("select");
            setSearchValue("");
        };
        $[37] = onSaveCustomStatus;
        $[38] = setIsContentStateMenuOpen;
        $[39] = t19;
    } else t19 = $[39];
    const handleSaveCustomStatus = t19;
    if (!contentStateState.state.isContentStateEnabled) {
        let t20;
        if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
            t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                ref: menuRef,
                testId: "content-state-menu-v2"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $07266645e67f8a5c$export$e173ca5f21a59a52), null));
            $[40] = t20;
        } else t20 = $[40];
        return t20;
    }
    if (currentView === "create") {
        let t20;
        if ($[41] !== handleSaveCustomStatus || $[42] !== searchValue) {
            t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                ref: menuRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8363866a64cc2105$export$1b183f966e13e015), {
                initialValue: searchValue,
                onBack: handleBackToSearch,
                onSave: handleSaveCustomStatus
            }));
            $[41] = handleSaveCustomStatus;
            $[42] = searchValue;
            $[43] = t20;
        } else t20 = $[43];
        return t20;
    }
    let t20;
    if ($[44] !== contentStateState.state.isCustomEnabled || $[45] !== currentContentState || $[46] !== filteredCustomOptions || $[47] !== filteredDefaultSection || $[48] !== handleRemoveStatus || $[49] !== handleSelectApprovalsUpsell || $[50] !== handleSelectStatus || $[51] !== hasActiveWorkflowStatus || $[52] !== hasApprovalFooterOption || $[53] !== hasResults || $[54] !== onDeleteCustomStatus || $[55] !== onSelectWorkflowStatus || $[56] !== searchValue) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: menuRef,
            testId: "content-state-menu-v2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $217fbcf232c8becc$export$2736d93594f59257), {
            searchValue: searchValue,
            onSearchChange: setSearchValue,
            filteredDefaultSection: filteredDefaultSection,
            filteredCustomOptions: filteredCustomOptions,
            hasResults: hasResults,
            hasApprovalFooterOption: hasApprovalFooterOption,
            isCustomEnabled: contentStateState.state.isCustomEnabled,
            currentContentState: currentContentState,
            hasActiveWorkflowStatus: hasActiveWorkflowStatus,
            onSelectStatus: handleSelectStatus,
            onSelectWorkflowStatus: onSelectWorkflowStatus,
            onSelectApprovalsUpsell: handleSelectApprovalsUpsell,
            onAddCustomClick: handleAddCustomClick,
            onDeleteCustomStatus: onDeleteCustomStatus,
            onRemoveStatus: handleRemoveStatus
        }));
        $[44] = contentStateState.state.isCustomEnabled;
        $[45] = currentContentState;
        $[46] = filteredCustomOptions;
        $[47] = filteredDefaultSection;
        $[48] = handleRemoveStatus;
        $[49] = handleSelectApprovalsUpsell;
        $[50] = handleSelectStatus;
        $[51] = hasActiveWorkflowStatus;
        $[52] = hasApprovalFooterOption;
        $[53] = hasResults;
        $[54] = onDeleteCustomStatus;
        $[55] = onSelectWorkflowStatus;
        $[56] = searchValue;
        $[57] = t20;
    } else t20 = $[57];
    return t20;
};
const $eeca34bbf5c80885$export$7cb66675cb7730f8 = (0, $kSwu1.injectIntl)($eeca34bbf5c80885$var$ContentStateMenuV2Component);
function $eeca34bbf5c80885$var$_temp(s) {
    return s !== null;
}
function $eeca34bbf5c80885$var$_temp2(s_0) {
    return s_0 !== null;
}
function $eeca34bbf5c80885$var$_temp3(s_1) {
    return {
        type: "contentState",
        contentState: s_1
    };
}
function $eeca34bbf5c80885$var$_temp4(s_2) {
    return {
        type: "workflowStatus",
        workflowStatus: s_2
    };
}
function $eeca34bbf5c80885$var$_temp5(item) {
    return item.type === "contentState" && item.contentState.restrictionLevel !== "NONE";
}















var $cJ0FD = parcelRequire("cJ0FD");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $aRGok = parcelRequire("aRGok");


var $cDs9S = parcelRequire("cDs9S");














var $lsxnT = parcelRequire("lsxnT");


var $f5Hmr = parcelRequire("f5Hmr");


var $1NBp8 = parcelRequire("1NBp8");







var $aad4dea99bffadb3$exports = {};
$aad4dea99bffadb3$exports = new URL("approvalsImageLight.4f648f5a.svg", import.meta.url).toString();


var $961a876060653a4b$exports = {};
$961a876060653a4b$exports = new URL("approvalsImageDark.c7c6ef30.svg", import.meta.url).toString();


const $dbca394cf11080fc$var$NEW_FEATURES_URL = (0, $1NBp8.ADMIN_NEW_FEATURES).toUrl();
const $dbca394cf11080fc$var$i18n = (0, $kSwu1.defineMessages)({
    heading: {
        id: "content-state.menu.v2.approvals-upsell.heading",
        defaultMessage: "Start requesting approval"
    },
    standardDescription: {
        id: "content-state.menu.v2.approvals-upsell.standard-description",
        defaultMessage: "Upgrade to Premium to request sign-off on Confluence pages and track approver decisions."
    },
    premiumDescription: {
        id: "content-state.menu.v2.approvals-upsell.premium-description",
        defaultMessage: "Enable approvals to request sign-off on Confluence pages and track approver decisions."
    },
    learnMore: {
        id: "content-state.menu.v2.approvals-upsell.learn-more",
        defaultMessage: "Learn more"
    },
    enableInSettings: {
        id: "content-state.menu.v2.approvals-upsell.enable-in-settings",
        defaultMessage: "Enable in Settings"
    }
});
const $dbca394cf11080fc$var$styles = {
    illustrationHeader: "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _3iDTPbQ4SZ _37wbyuDIqT _2C2kUQyzSk _1Lz9loyzSk",
    closeButton: "_1mT5xdWVPG _2IhTon2ADO _4ApkO22ADO"
};
const $dbca394cf11080fc$var$openInNewTab = (url)=>{
    window.open(url, '_blank', 'noopener,noreferrer');
};
const $dbca394cf11080fc$export$e8695a53661235a1 = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { onClose: onClose } = t0;
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const openLearnMore = $dbca394cf11080fc$var$_temp;
    const openNewFeaturesSettings = $dbca394cf11080fc$var$_temp2;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($aad4dea99bffadb3$exports))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($961a876060653a4b$exports))),
            alt: ""
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClose) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $dbca394cf11080fc$var$styles.illustrationHeader
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $dbca394cf11080fc$var$styles.closeButton
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cDs9S.CloseButton), {
            onClick: onClose
        })));
        $[1] = onClose;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $dbca394cf11080fc$var$i18n.heading)));
        $[3] = t3;
    } else t3 = $[3];
    const t4 = isPremium ? $dbca394cf11080fc$var$i18n.premiumDescription : $dbca394cf11080fc$var$i18n.standardDescription;
    let t5;
    if ($[4] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), t4)));
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: openLearnMore
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $dbca394cf11080fc$var$i18n.learnMore));
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== edition || $[8] !== isPremium) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100"
        }, t6, isPremium ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: openNewFeaturesSettings
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $dbca394cf11080fc$var$i18n.enableInSettings)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f5Hmr.UpgradeEditionButton), {
            analyticsProps: {
                actionSubjectId: "approvalsTryItFreeButton",
                attributes: {
                    currentEdition: edition
                },
                source: "approvalsStartApprovalUpsell"
            },
            appearance: "primary",
            targetEdition: (0, $euL71.ConfluenceEdition).PREMIUM
        })));
        $[7] = edition;
        $[8] = isPremium;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== Modal || $[11] !== onClose || $[12] !== t2 || $[13] !== t5 || $[14] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
            onClose: onClose,
            width: "small",
            testId: "approvals-upsell-modal",
            messageType: "engagement",
            messageId: "content-state-approvals-upsell-modal"
        }, t2, t3, t5, t7));
        $[10] = Modal;
        $[11] = onClose;
        $[12] = t2;
        $[13] = t5;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    return t8;
};
function $dbca394cf11080fc$var$_temp() {
    $dbca394cf11080fc$var$openInNewTab((0, $jWGRt.APPROVALS_LEARN_MORE_URL));
}
function $dbca394cf11080fc$var$_temp2() {
    $dbca394cf11080fc$var$openInNewTab($dbca394cf11080fc$var$NEW_FEATURES_URL);
}









const $1478047e1c32b5f4$export$fd37fef230d4b03a = ({ contentId: contentId, contentType: contentType, contentStateState: contentStateState, userOffline: userOffline, flags: flags, forceContentStatePlacementToTop: forceContentStatePlacementToTop, onUpdateSuccess: onUpdateSuccess, onContentStateMenuToggle: onContentStateMenuToggle, floatingToolbarButtonStyle: floatingToolbarButtonStyle, renderPlusButtonEmptyState: renderPlusButtonEmptyState, isDetailsPanel: isDetailsPanel, onClick: onClick, isViewMode: isViewMode, canEdit: canEdit = true })=>{
    const contentStateButtonRef = (0, $cozmU.useRef)(null);
    const [isContentStateMenuOpen, setIsContentStateMenuOpen] = (0, $cozmU.useState)(false);
    const [isShowingInfoPopup, setIsShowingInfoPopup] = (0, $cozmU.useState)(false);
    const [isShowingOtherModeBlockingPopup, setIsShowingOtherModeBlockingPopup] = (0, $cozmU.useState)(false);
    const [isShowingLiveDocStartApprovalPopup, setIsShowingLiveDocStartApprovalPopup] = (0, $cozmU.useState)(false);
    const [isCreatingContentState, setIsCreatingContentState] = (0, $cozmU.useState)(false);
    const [selectedColor, setSelectedColor] = (0, $cozmU.useState)(null);
    const [isColorPickerOpen, setIsColorPickerOpen] = (0, $cozmU.useState)(false);
    const [isHoveringRemove, setIsHoveringRemove] = (0, $cozmU.useState)(false);
    const [showChangeStatusModal, setShowChangeStatusModal] = (0, $cozmU.useState)(false);
    const [isApprovalsUpsellModalOpen, setIsApprovalsUpsellModalOpen] = (0, $cozmU.useState)(false);
    const approvalsPaneEntryPoint = isDetailsPanel ? 'detailsPanel' : 'byline';
    const liveDocConversionApprovalsPaneEntryPoint = isDetailsPanel ? 'detailsPanelLiveDocConversion' : 'bylineLiveDocConversion';
    const originalContentState = (0, $cozmU.useRef)(contentStateState.state.contentState);
    // Track if we're creating a NEW custom status (V1) vs selecting existing or V2 optimistic
    // Used to determine if onCompleted should update customStatesArray
    const isCreatingNewCustomStatusRef = (0, $cozmU.useRef)(false);
    // Snapshot of the custom statuses list taken right before an optimistic delete,
    // so the disable mutation's failure handler can restore it.
    const customStatesBeforeDeleteRef = (0, $cozmU.useRef)([]);
    // Snapshot of the applied page status taken right before an optimistic delete, so the
    // failure handler can restore it when the deleted status was the applied one.
    const contentStateBeforeDeleteRef = (0, $cozmU.useRef)(null);
    // True when the optimistic delete also cleared the applied page status.
    const didClearAppliedStatusOnDeleteRef = (0, $cozmU.useRef)(false);
    // Guards against concurrent deletes. The snapshot ref above only holds a single
    // in-flight operation, so we ignore additional delete clicks until the current
    // disable mutation resolves (success or failure).
    const isDeletingCustomStatusRef = (0, $cozmU.useRef)(false);
    // Restore the optimistically-removed option after a failed custom-status delete
    // (network error or a 200 with success: false / errors), and surface an error.
    const restoreAfterFailedDelete = (0, $cozmU.useCallback)(()=>{
        isDeletingCustomStatusRef.current = false;
        // Restore the rollback list before releasing the in-flight guard, so a refetch
        // can't overwrite it with stale server data.
        contentStateState.setCustomStatesArray(customStatesBeforeDeleteRef.current);
        if (didClearAppliedStatusOnDeleteRef.current) {
            contentStateState.setContentState(contentStateBeforeDeleteRef.current);
            didClearAppliedStatusOnDeleteRef.current = false;
            // The applied status is restored, so the keep-empty-trigger guard no longer applies.
            contentStateState.setKeepEmptyTriggerForContentId(null);
        }
        contentStateState.setIsOptimisticOperationPending(false);
        contentStateState.setIsUpdating(false);
        flags.showErrorFlag({
            id: 'content-state-delete-error-flag',
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).errorFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).errorFlagBody)
        });
    }, [
        contentStateState,
        flags
    ]);
    const setIsContentStateMenuOpenWithListener = (0, $cozmU.useCallback)((newValue)=>{
        onContentStateMenuToggle?.(newValue);
        setIsContentStateMenuOpen(newValue);
    }, [
        onContentStateMenuToggle
    ]);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const isSiteAdmin = (0, $8Lx5S.useIsAdmin)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    // Suppress the loading skeleton during SSR/initial-hydration to avoid a CLIENT_MISMATCH
    // hydration error: the server renders no skeleton (multiple sources of truth combine to
    // `false`), but the client's first render of the real ApprovalsProvider has
    // `approvalRequestLoading=true` (initial useState before useEffect runs the fetch).
    // Rendering the skeleton only after hydration completes keeps the first client render
    // identical to the server render. See PR #349185 / CCIMPORTER-1635 follow-up.
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const contentState = contentStateState.state.contentState;
    const contentStateLastUpdated = contentStateState.state.contentStateLastUpdated;
    // Approvals context hooks (safe to call unconditionally — returns defaults when provider absent)
    const { availableWorkflowStatuses: availableWorkflowStatuses, approvalRequest: approvalRequest, approvalRequestLoading: approvalRequestLoading, otherModeReviewStatus: otherModeReviewStatus, isContentApprovalsEnabled: isContentApprovalsEnabled, disallowFirstPublish: disallowFirstPublish } = (0, $laFNM.useApprovals)();
    const { createWorkflowApplication: createWorkflowApplication, cancelWorkflowApplication: cancelWorkflowApplication, clearApprovalRequestOptimistically: clearApprovalRequestOptimistically, requestLiveDocApprovalConversion: requestLiveDocApprovalConversion } = (0, $laFNM.useApprovalsDispatch)();
    const { openPublishModal: openPublishModal } = (0, $62JnS.usePublishModalMountActions)();
    const { handleCloseLiveDocConversionBlockedModal: handleCloseLiveDocConversionBlockedModal, handleLiveDocConversionBlockedByApproval: handleLiveDocConversionBlockedByApproval, isLiveDocConversionBlockedModalOpen: isLiveDocConversionBlockedModalOpen, shouldBlockLiveDocConversion: shouldBlockLiveDocConversion } = (0, $dNj8O.useLiveDocConversionBlockedModal)({
        contentId: contentId,
        contentType: contentType,
        createAnalyticsEvent: createAnalyticsEvent,
        disallowFirstPublish: disallowFirstPublish,
        isLivePage: isLivePage
    });
    const activeWorkflowStatus = (0, $cozmU.useMemo)(()=>{
        const activeStatusId = approvalRequest?.application?.workflowStatusId;
        if (!activeStatusId) return null;
        return availableWorkflowStatuses.find((s)=>s.id === activeStatusId) ?? null;
    }, [
        approvalRequest,
        availableWorkflowStatuses
    ]);
    // Memoize the review-eligible statuses — empty when space-level approvals toggle is off
    const reviewEligibleStatuses = (0, $cozmU.useMemo)(()=>isContentApprovalsEnabled ? availableWorkflowStatuses.filter((s_0)=>s_0.allowsReviews) : [], [
        availableWorkflowStatuses,
        isContentApprovalsEnabled
    ]);
    const hasSiteApprovalWorkflowStatus = (0, $cozmU.useMemo)(()=>availableWorkflowStatuses.some((status)=>status.allowsReviews), [
        availableWorkflowStatuses
    ]);
    const shouldShowApprovalsUpsell = isSiteAdmin && !approvalRequestLoading && !isContentApprovalsEnabled && !hasSiteApprovalWorkflowStatus;
    /**
   * True when there is an active approval review in an *end state* (APPROVED / DENIED).
   * These are the only reviews that surface the "Change status" action in the info popup;
   * PENDING reviews surface "Cancel approval" and are handled by the separate cancel flow.
   */ const hasEndStateApproval = !!activeWorkflowStatus && !!approvalRequest?.review && approvalRequest.review.reviewStatus !== 'CANCELED' && approvalRequest.review.reviewStatus !== 'PENDING';
    const respondedApproverData = (0, $cozmU.useMemo)(()=>{
        if (!approvalRequest?.review?.approvers) return [];
        return approvalRequest.review.approvers.reduce((acc, a)=>{
            if (a.status !== null && a.status !== 'PENDING_REVIEW') acc.push({
                name: a.name,
                src: a.avatarUrl,
                email: a.email,
                ...a.principalType === 'USER' && a.principalId ? {
                    userId: a.principalId
                } : {}
            });
            return acc;
        }, []);
    }, [
        approvalRequest
    ]);
    // Fetch user data for content state (skip when workflow status is active — that data comes from ApprovalsContext)
    const shouldFetchUserData = !activeWorkflowStatus && contentState?.lastModifierAaid && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true);
    const { updatedBy: contentStateUpdatedBy, loading: contentStateUserLoading } = (0, $1b65ee0f5f746ca1$export$54fd6c163aea68e2)(shouldFetchUserData ? contentState.lastModifierAaid : null);
    // Resolve update metadata: workflow status data from ApprovalsContext,
    // content state data from the query above
    const updatedBy = activeWorkflowStatus ? approvalRequest?.application?.applicationLastModifiedBy : contentStateUpdatedBy;
    const updatedAt = activeWorkflowStatus ? approvalRequest?.application?.applicationLastModifiedDate || undefined : contentStateLastUpdated ?? undefined;
    const userDataLoading = activeWorkflowStatus ? false : contentStateUserLoading;
    const [shouldSetAutomationFlag, setShouldSetAutomationFlag] = (0, $cozmU.useState)(()=>{
        return !(0, $17wUi.confluenceLocalStorageInstance)?.getItemAsBoolean((0, $1UApO.keys).AUTOMATION_DISCOVER_SET_CONTENT_STATE) && (0, $9wGTI.fg)('cc_a4c_smart_button_changeboarding');
    });
    const [removeContentStateMutation] = (0, $308Wd.useMutationInterop)((0, $da22f1c63dfdcbcc$export$2e2bcd8739ae039), {
        refetchQueries: ()=>[
                {
                    query: (0, $3lWl0.default),
                    variables: {
                        contentId: contentId,
                        isDraft: !isLivePage,
                        shouldSkipContentStateLastUpdated: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? false : !isLivePage,
                        isApprovalsFgOn: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
                        format: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? 'MILLIS' : 'USER_FRIENDLY'
                    }
                }
            ],
        onCompleted: ()=>{
            // During a custom-status delete this mutation is chained before the disable
            // mutation, which signals final completion; skip here to avoid firing twice.
            if (isDeletingCustomStatusRef.current) return;
            onUpdateSuccess?.();
        },
        __callerPackage__: "content-state"
    });
    const [setContentStateMutation] = (0, $308Wd.useMutationInterop)((0, $428215775b659cb2$export$2e2bcd8739ae039), {
        onError: ()=>{
            isCreatingNewCustomStatusRef.current = false;
            contentStateState.setContentState(originalContentState.current);
            flags.showErrorFlag({
                id: 'content-state-error-flag',
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).errorFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).errorFlagBody)
            });
            if ((0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) contentStateState.setIsOptimisticOperationPending(false);
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    objectId: contentId,
                    name: 'contentStateErrorFlag',
                    attributes: {
                        contentStatus: isViewMode ? 'CURRENT' : 'DRAFT',
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        },
        onCompleted: (data)=>{
            // Only update customStatesArray when creating a NEW custom status (V1 flow)
            // V2 handles this optimistically before the mutation
            if (data.setContentState && isCreatingNewCustomStatusRef.current) {
                // The approvals-beta flow adds an optimistic placeholder that must be reconciled
                // away; the legacy (gate-off) flow keeps its original dedupe behaviour untouched.
                const newCustomStatesArray = (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? (0, $3qCob.reconcileCustomStatesAfterCreate)(contentStateState.state.customStatesArray, data.setContentState) : (0, $3qCob.createNewCustomStatesArrayWhenNewCustomAdded)(contentStateState.state.customStatesArray, data.setContentState);
                contentStateState.setCustomStatesArray(newCustomStatesArray);
                // Swap the temp-id optimistic status for the server one so the menu keeps it selected.
                if (contentStateState.state.contentState?.id?.startsWith((0, $3qCob.OPTIMISTIC_CUSTOM_STATE_ID_PREFIX)) && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) contentStateState.setContentState(data.setContentState);
                isCreatingNewCustomStatusRef.current = false;
            }
            if (data.setContentState) originalContentState.current = data.setContentState;
            // Authoritative state applied; release the guard (gated to match the set).
            if ((0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) contentStateState.setIsOptimisticOperationPending(false);
            onUpdateSuccess?.();
        },
        refetchQueries: ()=>[
                {
                    query: (0, $3lWl0.default),
                    variables: {
                        contentId: contentId,
                        isDraft: !isLivePage,
                        shouldSkipContentStateLastUpdated: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? false : !isLivePage,
                        isApprovalsFgOn: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
                        format: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? 'MILLIS' : 'USER_FRIENDLY'
                    }
                }
            ],
        __callerPackage__: "content-state"
    });
    const [disableCustomContentStateMutation] = (0, $308Wd.useMutationInterop)((0, $1e808122b7ef428d$export$2e2bcd8739ae039), {
        onError: ()=>{
            restoreAfterFailedDelete();
        },
        onCompleted: (data_0)=>{
            // A 200 response can still represent a server-side failure: inspect the
            // payload's success/errors fields and treat a failure like onError so we
            // don't leave the UI in an optimistically-removed state.
            const payload = data_0?.confluence_disableCustomContentState;
            const failed = !payload?.success || (payload?.errors?.length ?? 0) > 0;
            if (failed) {
                restoreAfterFailedDelete();
                return;
            }
            // Disable persisted; clear the delete flags and release the guard.
            isDeletingCustomStatusRef.current = false;
            didClearAppliedStatusOnDeleteRef.current = false;
            contentStateState.setIsOptimisticOperationPending(false);
            contentStateState.setIsUpdating(false);
            onUpdateSuccess?.();
        },
        // Refetch the source query so the Apollo cache is updated and every
        // consumer of the available content states (not just this menu's local
        // optimistic copy) reflects the deletion.
        refetchQueries: ()=>[
                {
                    query: (0, $3lWl0.default),
                    variables: {
                        contentId: contentId,
                        isDraft: !isLivePage,
                        shouldSkipContentStateLastUpdated: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? false : !isLivePage,
                        isApprovalsFgOn: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
                        format: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? 'MILLIS' : 'USER_FRIENDLY'
                    }
                }
            ],
        __callerPackage__: "content-state"
    });
    const [setContentStateAndPublishMutation] = (0, $308Wd.useMutationInterop)((0, $6e181beeac9c50b9$export$2e2bcd8739ae039), {
        onError: ()=>{
            isCreatingNewCustomStatusRef.current = false;
            contentStateState.setContentState(originalContentState.current);
            flags.showErrorFlag({
                id: 'content-state-error-flag',
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).errorFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).errorFlagBody)
            });
            if ((0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) contentStateState.setIsOptimisticOperationPending(false);
            // TODO: Add robust error handling
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'contentState',
                    actionSubjectId: 'setContentStateAndPublish',
                    source: 'editorContentState',
                    attributes: {
                        contentId: contentId,
                        contentStatus: 'CURRENT',
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        },
        onCompleted: (data_1)=>{
            if (data_1.setContentStateAndPublish && isCreatingNewCustomStatusRef.current) {
                // The approvals-beta flow adds an optimistic placeholder that must be reconciled
                // away; the legacy (gate-off) flow keeps its original dedupe behaviour untouched.
                const newCustomStatesArray_0 = (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? (0, $3qCob.reconcileCustomStatesAfterCreate)(contentStateState.state.customStatesArray, data_1.setContentStateAndPublish) : (0, $3qCob.createNewCustomStatesArrayWhenNewCustomAdded)(contentStateState.state.customStatesArray, data_1.setContentStateAndPublish);
                contentStateState.setCustomStatesArray(newCustomStatesArray_0);
                // Swap the temp-id optimistic status for the server one so the menu keeps it selected.
                if (contentStateState.state.contentState?.id?.startsWith((0, $3qCob.OPTIMISTIC_CUSTOM_STATE_ID_PREFIX)) && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) contentStateState.setContentState(data_1.setContentStateAndPublish);
                isCreatingNewCustomStatusRef.current = false;
            }
            if (data_1.setContentStateAndPublish) originalContentState.current = data_1.setContentStateAndPublish;
            // Authoritative state applied; release the guard (gated to match the set).
            if ((0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) contentStateState.setIsOptimisticOperationPending(false);
            onUpdateSuccess?.();
        },
        refetchQueries: ()=>[
                {
                    query: (0, $3lWl0.default),
                    variables: {
                        contentId: contentId,
                        isDraft: false,
                        shouldSkipContentStateLastUpdated: false,
                        isApprovalsFgOn: true,
                        format: 'MILLIS'
                    }
                }
            ],
        __callerPackage__: "content-state"
    });
    const [removeContentStateAndPublishMutation] = (0, $308Wd.useMutationInterop)((0, $4f8f3df3514c68cc$export$2e2bcd8739ae039), {
        onError: (error)=>{
            // During a custom-status delete, restoreAfterFailedDelete (the `.catch()`) is the
            // single source of error recovery; this is an expected, fully-recovered error, so mark
            // it handled to silence monitoring and bail out to avoid a duplicate flag.
            if (isDeletingCustomStatusRef.current) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return;
            }
            contentStateState.setContentState(originalContentState.current);
            flags.showErrorFlag({
                id: 'content-state-remove-error-flag',
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).removeErrorFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).removeErrorFlagBody)
            });
            // TODO: Add robust error handling
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'contentState',
                    actionSubjectId: 'removeContentStateAndPublish',
                    source: 'editorContentState',
                    attributes: {
                        contentId: contentId,
                        contentStatus: 'CURRENT',
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        },
        refetchQueries: ()=>[
                {
                    query: (0, $3lWl0.default),
                    variables: {
                        contentId: contentId,
                        isDraft: false,
                        shouldSkipContentStateLastUpdated: false,
                        isApprovalsFgOn: true,
                        format: 'MILLIS'
                    }
                }
            ],
        onCompleted: ()=>{
            // During a custom-status delete this mutation is chained before the disable
            // mutation, which signals final completion; skip here to avoid firing twice.
            if (isDeletingCustomStatusRef.current) return;
            onUpdateSuccess?.();
        },
        __callerPackage__: "content-state"
    });
    const activeRemoveMutation = isViewMode && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? removeContentStateAndPublishMutation : removeContentStateMutation;
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const isApprovalsPaneOpen = rightSidebarContext.getCurrent()?.panelId === (0, $1vpkQ.APPROVALS_PANE_ID);
    const wasApprovalsPaneOpenRef = (0, $cozmU.useRef)(isApprovalsPaneOpen);
    // Close the content state info popup only at the moment the approvals pane opens,
    // not continuously while it is open — users should still be able to reopen the popup.
    // TODO: revisit this logic to see if it can be simplified.
    (0, $cozmU.useEffect)(()=>{
        if (isApprovalsPaneOpen && !wasApprovalsPaneOpenRef.current && isShowingInfoPopup) setIsShowingInfoPopup(false);
        wasApprovalsPaneOpenRef.current = isApprovalsPaneOpen;
    }, [
        isApprovalsPaneOpen,
        isShowingInfoPopup
    ]);
    // Reset color picker when menu closes
    (0, $cozmU.useEffect)(()=>{
        if (!isContentStateMenuOpen) {
            setSelectedColor(null);
            setIsColorPickerOpen(false);
        }
    }, [
        isContentStateMenuOpen
    ]);
    const applyExistingStatus = (0, $cozmU.useCallback)((selectedStatus)=>{
        if (isViewMode && !cloudId) return;
        isCreatingNewCustomStatusRef.current = false;
        contentStateState.setIsUpdating(true);
        if (isViewMode && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) setContentStateAndPublishMutation({
            variables: {
                contentId: contentId,
                contentStateInput: {
                    color: (0, $8miSe.tokenToHex)(selectedStatus.color),
                    name: selectedStatus.name,
                    id: selectedStatus.id
                },
                suppressDraftPropertyUpdate: true,
                cloudId: cloudId
            }
        });
        else setContentStateMutation({
            variables: {
                contentId: contentId,
                contentStateInput: {
                    color: (0, $8miSe.tokenToHex)(selectedStatus.color),
                    name: selectedStatus.name,
                    id: selectedStatus.id
                }
            }
        });
        contentStateState.setContentState(selectedStatus);
        const customStatesArray = contentStateState.state.customStatesArray;
        const customIndex = customStatesArray.findIndex((s_1)=>s_1 !== null && s_1.id === selectedStatus.id);
        if (customIndex !== -1) {
            const newCustomStatesArray_1 = (0, $3qCob.createNewCustomStatesArrayWhenExistingCustomSelected)(customStatesArray, selectedStatus, customIndex);
            contentStateState.setCustomStatesArray(newCustomStatesArray_1);
        }
        if (!isViewMode && shouldSetAutomationFlag && (0, $9wGTI.fg)('cc_a4c_smart_button_changeboarding')) {
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).AUTOMATION_DISCOVER_SET_CONTENT_STATE, true);
            setShouldSetAutomationFlag(false);
        }
        const isCustom = customIndex !== -1;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                objectId: contentId,
                actionSubjectId: 'editorContentStateAdded',
                source: 'editorContentState',
                attributes: {
                    type: isCustom ? 'custom' : 'suggested',
                    color: (0, $8miSe.colorCodeToColorName)(selectedStatus.color?.toUpperCase() || ''),
                    restrictionLevel: selectedStatus.restrictionLevel?.toUpperCase(),
                    uiLocation: 'pageTitleSection',
                    contentStatus: isViewMode ? 'CURRENT' : 'DRAFT',
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        contentStateState,
        createAnalyticsEvent,
        isLivePage,
        isViewMode,
        shouldSetAutomationFlag,
        setContentStateAndPublishMutation,
        setContentStateMutation,
        cloudId
    ]);
    const applyCustomStatus = (0, $cozmU.useCallback)((statusName, colorId)=>{
        if (isViewMode && !cloudId) return;
        if (!(0, $3qCob.isDuplicate)(contentStateState.state.contentState, {
            color: colorId.toLowerCase(),
            name: statusName
        })) {
            const newContentState = {
                color: colorId,
                name: statusName
            };
            contentStateState.setIsUpdating(true);
            // Guard the optimistic create across its refetch.
            if ((0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) contentStateState.setIsOptimisticOperationPending(true);
            isCreatingNewCustomStatusRef.current = true;
            const optimisticCustomState = {
                ...newContentState,
                id: `${(0, $3qCob.OPTIMISTIC_CUSTOM_STATE_ID_PREFIX)}${Date.now()}`
            };
            const updatedCustomStatesArray = [
                optimisticCustomState,
                ...contentStateState.state.customStatesArray
            ];
            contentStateState.setCustomStatesArray(updatedCustomStatesArray);
            if (isViewMode && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) setContentStateAndPublishMutation({
                variables: {
                    contentId: contentId,
                    contentStateInput: {
                        ...newContentState,
                        color: (0, $8miSe.tokenToHex)(colorId)
                    },
                    suppressDraftPropertyUpdate: true,
                    cloudId: cloudId
                }
            });
            else setContentStateMutation({
                variables: {
                    contentId: contentId,
                    contentStateInput: {
                        ...newContentState,
                        color: (0, $8miSe.tokenToHex)(colorId)
                    }
                }
            });
            // Apply the optimistic status. Behind the gate, carry the temp id so the V2 menu can
            // match it; onCompleted swaps in the server status. Non-gated keeps the id-less value.
            contentStateState.setContentState((0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? optimisticCustomState : newContentState);
        }
        if (!isViewMode && shouldSetAutomationFlag && (0, $9wGTI.fg)('cc_a4c_smart_button_changeboarding')) {
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).AUTOMATION_DISCOVER_SET_CONTENT_STATE, true);
            setShouldSetAutomationFlag(false);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                objectId: contentId,
                actionSubjectId: 'editorContentStateAdded',
                source: 'editorContentState',
                attributes: {
                    type: 'new custom',
                    color: (0, $8miSe.colorCodeToColorName)(colorId),
                    restrictionLevel: 'NONE',
                    uiLocation: 'pageTitleSection',
                    contentStatus: isViewMode ? 'CURRENT' : 'DRAFT',
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        contentStateState,
        createAnalyticsEvent,
        isLivePage,
        isViewMode,
        shouldSetAutomationFlag,
        setContentStateAndPublishMutation,
        setContentStateMutation,
        cloudId
    ]);
    const handleSelectExistingStatusV2 = (0, $cozmU.useCallback)((selectedStatus_0)=>{
        if (activeWorkflowStatus && approvalRequest?.review && approvalRequest.review.reviewStatus === 'PENDING') {
            setShowChangeStatusModal(true);
            return;
        }
        // End-state approval (APPROVED / DENIED): defer until the user confirms the
        // "Change status?" friction modal, then apply this selection in handleConfirmChangeStatus.
        if (hasEndStateApproval) {
            setPendingStatusChange({
                kind: 'existing',
                status: selectedStatus_0
            });
            setShowChangeStatusConfirmModal(true);
            return;
        }
        if (activeWorkflowStatus) {
            clearApprovalRequestOptimistically();
            cancelWorkflowApplication();
        }
        applyExistingStatus(selectedStatus_0);
    }, [
        activeWorkflowStatus,
        approvalRequest,
        hasEndStateApproval,
        cancelWorkflowApplication,
        clearApprovalRequestOptimistically,
        applyExistingStatus
    ]);
    const handleSaveCustomStatusV2 = (0, $cozmU.useCallback)((statusName_0, colorId_0)=>{
        if (activeWorkflowStatus && approvalRequest?.review && approvalRequest.review.reviewStatus === 'PENDING') {
            setShowChangeStatusModal(true);
            return;
        }
        // End-state approval (APPROVED / DENIED): defer until the user confirms the
        // "Change status?" friction modal, then apply this selection in handleConfirmChangeStatus.
        if (hasEndStateApproval) {
            setPendingStatusChange({
                kind: 'custom',
                name: statusName_0,
                colorId: colorId_0
            });
            setShowChangeStatusConfirmModal(true);
            return;
        }
        if (activeWorkflowStatus) {
            clearApprovalRequestOptimistically();
            cancelWorkflowApplication();
        }
        applyCustomStatus(statusName_0, colorId_0);
    }, [
        activeWorkflowStatus,
        approvalRequest,
        hasEndStateApproval,
        cancelWorkflowApplication,
        clearApprovalRequestOptimistically,
        applyCustomStatus
    ]);
    const handleDeleteCustomStatusV2 = (0, $cozmU.useCallback)((status_0)=>{
        if (!(0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) return;
        if (!status_0.id || !cloudId) return;
        // Capture the narrowed id so the closures below keep the non-null type.
        const contentStateId = status_0.id;
        // Only one delete may be in flight at a time; the snapshot refs hold a single
        // operation, so concurrent deletes would corrupt rollback on failure.
        if (isDeletingCustomStatusRef.current) return;
        isDeletingCustomStatusRef.current = true;
        const currentCustomStatesArray = contentStateState.state.customStatesArray;
        // Snapshot the option list for rollback on failure.
        customStatesBeforeDeleteRef.current = currentCustomStatesArray;
        // Mark in-flight before the mutation so the refetch can't clobber the optimistic update.
        contentStateState.setIsUpdating(true);
        contentStateState.setIsOptimisticOperationPending(true);
        const updatedCustomStatesArray_0 = currentCustomStatesArray.filter((customStatus)=>customStatus?.id !== status_0.id);
        contentStateState.setCustomStatesArray(updatedCustomStatesArray_0);
        const fireDisableMutation = ()=>disableCustomContentStateMutation({
                variables: {
                    cloudId: cloudId,
                    contentStateId: contentStateId
                }
            });
        // If the deleted status is applied, clear + persist its removal first, then chain the
        // disable mutation (one settled refetch, no byline flicker). Otherwise just disable.
        const appliedContentState = contentStateState.state.contentState;
        const deletedStatusIsApplied = !!appliedContentState && appliedContentState.id === status_0.id;
        didClearAppliedStatusOnDeleteRef.current = deletedStatusIsApplied;
        // In view mode, keep the empty add-status trigger visible after deleting the applied
        // status since the menu can't stay open. Scoped to this contentId so it resets on
        // navigation; a fresh container resets it on refresh.
        if (deletedStatusIsApplied && isViewMode) contentStateState.setKeepEmptyTriggerForContentId(contentId);
        if (deletedStatusIsApplied) {
            contentStateBeforeDeleteRef.current = appliedContentState;
            contentStateState.setContentState(null);
            activeRemoveMutation({
                variables: {
                    contentId: contentId,
                    ...isViewMode && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) && {
                        doPublish: true,
                        suppressDraftPropertyUpdate: true
                    }
                }
            }).then(()=>fireDisableMutation())// Roll the whole delete back on failure. The disable mutation's own onError
            // also calls restoreAfterFailedDelete (which clears this guard), so bail out if
            // it already ran to avoid a duplicate error flag.
            .catch(()=>{
                if (isDeletingCustomStatusRef.current) restoreAfterFailedDelete();
            });
        } else fireDisableMutation();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                objectId: contentId,
                actionSubjectId: 'editorContentStateDeleted',
                source: 'editorContentState',
                attributes: {
                    type: 'custom',
                    color: (0, $8miSe.colorCodeToColorName)(status_0.color ?? ''),
                    uiLocation: 'pageTitleSection',
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        activeRemoveMutation,
        cloudId,
        contentId,
        contentStateState,
        createAnalyticsEvent,
        disableCustomContentStateMutation,
        isLivePage,
        isViewMode,
        restoreAfterFailedDelete
    ]);
    const applyRemove = (0, $cozmU.useCallback)(()=>{
        isCreatingNewCustomStatusRef.current = false;
        if (contentStateState.state.contentState) {
            contentStateState.setIsUpdating(true);
            activeRemoveMutation({
                variables: {
                    contentId: contentId,
                    ...isViewMode && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) && {
                        doPublish: true,
                        suppressDraftPropertyUpdate: true
                    }
                }
            });
            contentStateState.setContentState(null);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    objectId: contentId,
                    actionSubjectId: 'editorContentStateRemoved',
                    source: 'editorContentState',
                    attributes: {
                        uiLocation: 'pageTitleSection',
                        contentStatus: isViewMode ? 'CURRENT' : 'DRAFT',
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        }
    }, [
        contentStateState,
        activeRemoveMutation,
        contentId,
        createAnalyticsEvent,
        isLivePage,
        isViewMode
    ]);
    const handleRemoveV2 = (0, $cozmU.useCallback)(()=>{
        if (activeWorkflowStatus && approvalRequest?.review && approvalRequest.review.reviewStatus === 'PENDING') {
            setShowChangeStatusModal(true);
            return;
        }
        // End-state approval (APPROVED / DENIED): defer until the user confirms the
        // "Change status?" friction modal, then apply the removal in handleConfirmChangeStatus.
        if (hasEndStateApproval) {
            setPendingStatusChange({
                kind: 'remove'
            });
            setShowChangeStatusConfirmModal(true);
            return;
        }
        if (activeWorkflowStatus) {
            clearApprovalRequestOptimistically();
            cancelWorkflowApplication();
        }
        setIsContentStateMenuOpenWithListener(false);
        applyRemove();
    }, [
        activeWorkflowStatus,
        approvalRequest,
        hasEndStateApproval,
        clearApprovalRequestOptimistically,
        cancelWorkflowApplication,
        setIsContentStateMenuOpenWithListener,
        applyRemove
    ]);
    // Performs the actual "start approval" work for a review-eligible status. This is the
    // guard-free core of handleSelectWorkflowStatus so it can be reused after the user confirms
    // the "Change status?" friction modal (where the end-state approval guard must not re-trigger).
    const startWorkflowStatus = (0, $cozmU.useCallback)(async (selectedStatus_1)=>{
        const previousContentState = contentStateState.state.contentState;
        const prevStateId = activeWorkflowStatus?.id || contentState?.id || null;
        const analyticsAttributes = {
            contentId: contentId,
            contentStatus: isViewMode ? 'CURRENT' : 'DRAFT',
            prevStateId: prevStateId,
            newStateId: selectedStatus_1.id,
            isNewStatusWorkflow: true
        };
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'inReviewStatus',
                source: (0, $2QUbq.APPROVALS_ANALYTICS_SOURCE),
                attributes: analyticsAttributes
            }
        }).fire();
        /**
     * Live-doc → convert-to-page popup interception.
     *
     * Approvals can't run on live docs, so when a review-eligible status is selected
     * here we close the status menu and show the convert-to-page intermediary popup.
     * The popup's CTA then dispatches the intent onto ApprovalsContext, which causes
     * PublishModalMountPoint to auto-open the publish modal in convert-to-page mode.
     *
     */ if (selectedStatus_1.allowsReviews && isLivePage && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) {
            setIsContentStateMenuOpenWithListener(false);
            setIsShowingLiveDocStartApprovalPopup(true);
            return;
        }
        if ((0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) {
            // New flow: no optimistic In-Review status, no createWorkflowApplication call.
            // The combined mutation is called later from StartApprovalPane.
            setIsContentStateMenuOpenWithListener(false);
            if (otherModeReviewStatus === 'PENDING') setIsShowingOtherModeBlockingPopup(true);
            else (0, $1vpkQ.openApprovalsPaneForContext)({
                contentId: contentId,
                contentStatus: isViewMode ? 'CURRENT' : 'DRAFT',
                entryPoint: approvalsPaneEntryPoint,
                rightSidebarContext: rightSidebarContext
            });
            return;
        }
        contentStateState.setIsUpdating(true);
        contentStateState.setContentState(null);
        setIsContentStateMenuOpenWithListener(false);
        try {
            const result = await createWorkflowApplication(selectedStatus_1);
            if (otherModeReviewStatus === 'PENDING') // Other mode already has an active pending review — show the info popup
            // (which renders the otherModeReviewWarning SectionMessage) instead of
            // opening the ApprovalsPane / StartApprovalPane.
            setIsShowingInfoPopup(true);
            else (0, $1vpkQ.openApprovalsPaneForContext)({
                contentId: contentId,
                contentStatus: isViewMode ? 'CURRENT' : 'DRAFT',
                entryPoint: approvalsPaneEntryPoint,
                rightSidebarContext: rightSidebarContext
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'created',
                    actionSubject: 'approvalWorkflowApplication',
                    source: (0, $2QUbq.APPROVALS_ANALYTICS_SOURCE),
                    attributes: {
                        ...analyticsAttributes,
                        applicationId: result.applicationId
                    }
                }
            }).fire();
            contentStateState.setIsUpdating(false);
        } catch (error_0) {
            contentStateState.setIsUpdating(false);
            contentStateState.setContentState(previousContentState);
            flags.showErrorFlag({
                id: 'workflow-status-error-flag',
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).errorFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).errorFlagBody)
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'approvalWorkflowApplication',
                    source: (0, $2QUbq.APPROVALS_ANALYTICS_SOURCE),
                    attributes: {
                        ...analyticsAttributes,
                        failureStatusCode: (0, $2QUbq.getFailureStatusCode)(error_0)
                    }
                }
            }).fire();
        }
    }, [
        otherModeReviewStatus,
        createWorkflowApplication,
        contentStateState,
        contentState,
        contentId,
        isLivePage,
        isViewMode,
        activeWorkflowStatus,
        createAnalyticsEvent,
        flags,
        setIsContentStateMenuOpenWithListener,
        setIsShowingLiveDocStartApprovalPopup,
        setIsShowingOtherModeBlockingPopup,
        rightSidebarContext,
        approvalsPaneEntryPoint
    ]);
    const handleSelectWorkflowStatus = (0, $cozmU.useCallback)((selectedStatus_2)=>{
        // End-state approval (APPROVED / DENIED): selecting "In Review" again must first
        // confirm via the "Change status?" friction modal. On confirm we cancel the old
        // approval and start a fresh approval request (handleConfirmChangeStatus).
        if (hasEndStateApproval) {
            setPendingStatusChange({
                kind: 'workflow',
                status: selectedStatus_2
            });
            setShowChangeStatusConfirmModal(true);
            return;
        }
        startWorkflowStatus(selectedStatus_2);
    }, [
        hasEndStateApproval,
        startWorkflowStatus
    ]);
    const handleSelectApprovalsUpsell = (0, $cozmU.useCallback)(()=>{
        setIsApprovalsUpsellModalOpen(true);
    }, []);
    const handleCloseApprovalsUpsellModal = (0, $cozmU.useCallback)(()=>{
        setIsApprovalsUpsellModalOpen(false);
    }, []);
    const handleColorPickerToggle = (0, $cozmU.useCallback)(()=>{
        setIsColorPickerOpen((prev)=>!prev);
    }, []);
    const handleColorPickerClose = (0, $cozmU.useCallback)(()=>{
        setIsColorPickerOpen(false);
    }, []);
    const handleSelectColor = (0, $cozmU.useCallback)((newColor)=>{
        setSelectedColor(newColor);
        setIsColorPickerOpen(false);
    }, []);
    const handleFocusTextField = (0, $cozmU.useCallback)(()=>{
        setIsCreatingContentState(true);
    }, []);
    const handleMouseEnterRemove = (0, $cozmU.useCallback)(()=>{
        setIsHoveringRemove(true);
    }, []);
    const handleMouseLeaveRemove = (0, $cozmU.useCallback)(()=>{
        setIsHoveringRemove(false);
    }, []);
    const handleContentStatePopupClose = (0, $cozmU.useCallback)(()=>{
        setIsShowingInfoPopup(false);
        setIsCreatingContentState(false);
        setIsContentStateMenuOpenWithListener(false);
    }, [
        setIsContentStateMenuOpenWithListener
    ]);
    const handleSubmit = (0, $cozmU.useCallback)((name)=>{
        if (!(0, $3qCob.isDuplicate)(contentStateState.state.contentState, {
            color: selectedColor?.toLowerCase() ?? null,
            name: name
        })) {
            const newContentState_0 = {
                color: selectedColor,
                name: name
            };
            contentStateState.setIsUpdating(true);
            // Mark that we're creating a new custom status so onCompleted updates the array
            isCreatingNewCustomStatusRef.current = true;
            setContentStateMutation({
                variables: {
                    contentId: contentId,
                    contentStateInput: {
                        ...newContentState_0,
                        color: (0, $8miSe.tokenToHex)(selectedColor)
                    }
                }
            });
            contentStateState.setContentState(newContentState_0);
        }
        if (shouldSetAutomationFlag && (0, $9wGTI.fg)('cc_a4c_smart_button_changeboarding')) {
            // This flag is used in AutomationMenuButtonWithSmartButtonSpotlight
            // It will check this flag to determine if it should show the spotlight
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).AUTOMATION_DISCOVER_SET_CONTENT_STATE, true);
            setShouldSetAutomationFlag(false);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                objectId: contentId,
                actionSubjectId: 'editorContentStateAdded',
                source: 'editorContentState',
                attributes: {
                    type: 'new custom',
                    color: (0, $8miSe.colorCodeToColorName)(selectedColor ?? ''),
                    restrictionLevel: 'NONE',
                    uiLocation: 'pageTitleSection',
                    contentStatus: isViewMode ? 'CURRENT' : 'DRAFT',
                    isLivePage: isLivePage
                }
            }
        }).fire();
        setIsCreatingContentState(false);
        setIsContentStateMenuOpenWithListener(false);
    }, [
        contentId,
        contentStateState,
        createAnalyticsEvent,
        isLivePage,
        isViewMode,
        selectedColor,
        setContentStateMutation,
        setIsContentStateMenuOpenWithListener,
        shouldSetAutomationFlag
    ]);
    const handleCancel = (0, $cozmU.useCallback)(()=>{
        setIsCreatingContentState(false);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                objectId: contentId,
                actionSubjectId: 'editorContentStateCancel',
                source: 'editorContentState',
                attributes: {
                    contentStatus: isViewMode ? 'CURRENT' : 'DRAFT',
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent,
        isLivePage,
        isViewMode
    ]);
    const handleRemove = (0, $cozmU.useCallback)(()=>{
        // check if state exists before mutating since the trash button still shows if the feature is disabled
        // (page might not have a content state)
        if (contentStateState.state.contentState) {
            removeContentStateMutation({
                variables: {
                    contentId: contentId
                }
            });
            setIsCreatingContentState(false);
            setIsHoveringRemove(false);
            contentStateState.setContentState(null);
            setIsContentStateMenuOpenWithListener(false);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                objectId: contentId,
                actionSubjectId: 'editorContentStateRemoved',
                source: 'editorContentState',
                attributes: {
                    uiLocation: 'pageTitleSection',
                    contentStatus: isViewMode ? 'CURRENT' : 'DRAFT',
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        contentStateState,
        createAnalyticsEvent,
        removeContentStateMutation,
        setIsCreatingContentState,
        setIsContentStateMenuOpenWithListener,
        isLivePage,
        isViewMode
    ]);
    const handlePopupToggle = (0, $cozmU.useCallback)(()=>{
        setIsContentStateMenuOpenWithListener(!isContentStateMenuOpen);
    }, [
        isContentStateMenuOpen,
        setIsContentStateMenuOpenWithListener
    ]);
    const handlePopupClose = (0, $cozmU.useCallback)(()=>{
        setIsShowingInfoPopup(false);
        setIsShowingOtherModeBlockingPopup(false);
        setIsShowingLiveDocStartApprovalPopup(false);
        setIsContentStateMenuOpenWithListener(false);
    }, [
        setIsContentStateMenuOpenWithListener
    ]);
    /**
   * Live-doc popup "Convert to page" CTA handler.
   *
   * Blocks conversion before opening the publish modal when the space requires approval before
   * first publish. Otherwise, records the approval-conversion intent so PublishModalContext opens
   * in convert-to-page mode and the converted page can auto-open the approvals pane. When EAP is
   * enabled, this flow opens the publish modal directly after recording the conversion intent.
   *
   */ const handleConvertLiveDocToPage = (0, $cozmU.useCallback)(()=>{
        if (shouldBlockLiveDocConversion) {
            handlePopupClose();
            handleLiveDocConversionBlockedByApproval();
            return;
        }
        requestLiveDocApprovalConversion(contentId, liveDocConversionApprovalsPaneEntryPoint);
        handlePopupClose();
        if ((0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) openPublishModal((0, $bTNHJ.APPROVALS_LIVE_DOC_PUBLISH_MODAL_SOURCE));
    }, [
        contentId,
        handleLiveDocConversionBlockedByApproval,
        handlePopupClose,
        openPublishModal,
        liveDocConversionApprovalsPaneEntryPoint,
        requestLiveDocApprovalConversion,
        shouldBlockLiveDocConversion
    ]);
    const handleBackFromLiveDocStartApprovalPopup = (0, $cozmU.useCallback)(()=>{
        setIsShowingLiveDocStartApprovalPopup(false);
        setIsContentStateMenuOpenWithListener(true);
    }, [
        setIsContentStateMenuOpenWithListener
    ]);
    const [showChangeStatusConfirmModal, setShowChangeStatusConfirmModal] = (0, $cozmU.useState)(false);
    // A status the user picked while an end-state approval is active, pending their
    // confirmation in the "Change status?" friction modal. Applied on confirm, cleared on dismiss.
    const [pendingStatusChange, setPendingStatusChange] = (0, $cozmU.useState)(null);
    const handleChangeStatus = (0, $cozmU.useCallback)(()=>{
        setIsShowingInfoPopup(false);
        // Defer the friction confirmation: just open the status menu. The "Change status?"
        // confirmation modal is now shown only once the user actually selects a different
        // (non-approval) status — see handleSelectExistingStatusV2 / handleSaveCustomStatusV2 /
        // handleRemoveV2.
        setIsContentStateMenuOpenWithListener(true);
    }, [
        setIsContentStateMenuOpenWithListener
    ]);
    const handleConfirmChangeStatus = (0, $cozmU.useCallback)(()=>{
        setShowChangeStatusConfirmModal(false);
        const pending = pendingStatusChange;
        setPendingStatusChange(null);
        if (!pending) {
            // Defensive: no deferred selection — just reopen the menu without cancelling the
            // existing approval (cancelling here would silently discard an active approval for
            // no reason if `pending` is ever null due to a stale closure or batched update).
            setIsContentStateMenuOpenWithListener(true);
            return;
        }
        // Cancel the existing approval so the selected status can be applied / a new approval
        // request can be started. The workflow application is deactivated; prior activity
        // remains available in audit logs (matching the modal copy).
        clearApprovalRequestOptimistically();
        cancelWorkflowApplication();
        setIsContentStateMenuOpenWithListener(false);
        switch(pending.kind){
            case 'existing':
                applyExistingStatus(pending.status);
                break;
            case 'custom':
                applyCustomStatus(pending.name, pending.colorId);
                break;
            case 'remove':
                applyRemove();
                break;
            case 'workflow':
                // Start a fresh approval request now that the previous approval has been cancelled.
                startWorkflowStatus(pending.status);
                break;
            default:
                pending;
        }
    }, [
        clearApprovalRequestOptimistically,
        cancelWorkflowApplication,
        pendingStatusChange,
        applyExistingStatus,
        applyCustomStatus,
        applyRemove,
        startWorkflowStatus,
        setIsContentStateMenuOpenWithListener
    ]);
    const handleCloseChangeStatusConfirmModal = (0, $cozmU.useCallback)(()=>{
        setShowChangeStatusConfirmModal(false);
        setPendingStatusChange(null);
        setIsShowingInfoPopup(true);
    }, []);
    const [showCancelApprovalModal, setShowCancelApprovalModal] = (0, $cozmU.useState)(false);
    const handleClearRequest = (0, $cozmU.useCallback)(()=>{
        setIsShowingInfoPopup(false);
        setShowCancelApprovalModal(true);
    }, []);
    const handleConfirmClearRequest = (0, $cozmU.useCallback)(()=>{
        setShowCancelApprovalModal(false);
        setIsContentStateMenuOpenWithListener(false);
        clearApprovalRequestOptimistically();
        cancelWorkflowApplication();
    }, [
        clearApprovalRequestOptimistically,
        cancelWorkflowApplication,
        setIsContentStateMenuOpenWithListener
    ]);
    const handleCloseCancelApprovalModal = (0, $cozmU.useCallback)(()=>{
        setShowCancelApprovalModal(false);
        setIsShowingInfoPopup(true);
    }, []);
    const handleConfirmCancelApproval = (0, $cozmU.useCallback)(()=>{
        setShowChangeStatusModal(false);
        setIsContentStateMenuOpenWithListener(false);
        clearApprovalRequestOptimistically();
        cancelWorkflowApplication();
    }, [
        clearApprovalRequestOptimistically,
        cancelWorkflowApplication,
        setIsContentStateMenuOpenWithListener
    ]);
    const handleCloseChangeStatusModal = (0, $cozmU.useCallback)(()=>{
        setShowChangeStatusModal(false);
        setIsContentStateMenuOpenWithListener(true);
    }, [
        setIsContentStateMenuOpenWithListener
    ]);
    const togglePopup = (0, $cozmU.useCallback)(()=>{
        const shouldShowInfoPopup = (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) && (isContentApprovalsEnabled && activeWorkflowStatus !== null || // Show the read-only info popup for view-only users who have a content state
        !canEdit && contentState !== null);
        if (shouldShowInfoPopup) {
            if (isShowingInfoPopup) setIsShowingInfoPopup(false);
            else setIsShowingInfoPopup(true);
        } else if (canEdit) // Only allow opening the content state menu if the user has edit permission
        handlePopupToggle();
        onClick?.();
    }, [
        isContentApprovalsEnabled,
        activeWorkflowStatus,
        isShowingInfoPopup,
        handlePopupToggle,
        onClick,
        canEdit,
        contentState
    ]);
    const renderTrigger = (0, $cozmU.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $32fca6e0bfcfd80d$export$ee3b73f13be68d6d), {
            triggerProps: {
                ...triggerProps
            },
            togglePopup: togglePopup,
            contentState: contentStateState.state.contentState,
            activeWorkflowStatus: activeWorkflowStatus,
            isSelected: isContentStateMenuOpen,
            isWarning: isHoveringRemove,
            userOffline: userOffline,
            contentStateButtonRef: contentStateButtonRef,
            floatingToolbarButtonStyle: floatingToolbarButtonStyle,
            renderPlusButtonEmptyState: renderPlusButtonEmptyState,
            isDetailsPanel: isDetailsPanel,
            canEdit: canEdit,
            useSubtleEmptyStateLabel: isViewMode && contentStateState.keepEmptyTriggerForContentId === contentId && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)
        }), [
        togglePopup,
        contentStateState.state.contentState,
        contentStateState.keepEmptyTriggerForContentId,
        contentId,
        activeWorkflowStatus,
        isContentStateMenuOpen,
        isHoveringRemove,
        userOffline,
        floatingToolbarButtonStyle,
        renderPlusButtonEmptyState,
        isDetailsPanel,
        canEdit,
        isViewMode
    ]);
    if (!renderServerPlaceholder && isContentApprovalsEnabled && approvalRequestLoading && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lJswu.ContentStateSkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        testId: "content-state-popup",
        isOpen: isContentStateMenuOpen || isShowingInfoPopup || isShowingOtherModeBlockingPopup || isShowingLiveDocStartApprovalPopup,
        onClose: handlePopupClose,
        placement: forceContentStatePlacementToTop ? 'top-end' : 'bottom-start',
        zIndex: (0, $jp2Q3.layers).dialog(),
        trigger: renderTrigger,
        content: ({ update: update })=>{
            if (isShowingOtherModeBlockingPopup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e4d91f280782e61$export$ef489f24b547890a), {
                isViewMode: isViewMode ?? false,
                onChangeStatus: ()=>{
                    setIsShowingOtherModeBlockingPopup(false);
                    handleChangeStatus();
                }
            });
            if (isShowingLiveDocStartApprovalPopup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $32917b1aa1050d52$export$85a25e99367817c8), {
                onBack: handleBackFromLiveDocStartApprovalPopup,
                onConvertToPage: handleConvertLiveDocToPage
            });
            if (isShowingInfoPopup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $df5c0845c72ee01f$export$53d4fd7383e067f), {
                contentState: contentState,
                activeWorkflowStatus: activeWorkflowStatus,
                updatedAt: updatedAt,
                updatedBy: updatedBy,
                loading: userDataLoading,
                onChangeStatus: handleChangeStatus,
                onClearRequest: handleClearRequest,
                onClose: handlePopupClose,
                onConvertLiveDocToPage: handleConvertLiveDocToPage,
                canEdit: canEdit,
                contentType: contentType,
                isViewMode: isViewMode
            });
            if ((0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eeca34bbf5c80885$export$7cb66675cb7730f8), {
                contentId: contentId,
                contentStateState: contentStateState,
                contentType: contentType,
                isLivePage: isLivePage,
                defaultStatesArray: contentStateState.state.defaultStatesArray || [],
                customStatesArray: contentStateState.state.customStatesArray || [],
                isContentStateEnabled: contentStateState.state.isContentStateEnabled,
                userOffline: userOffline,
                onSelectExistingStatus: handleSelectExistingStatusV2,
                onSaveCustomStatus: handleSaveCustomStatusV2,
                onDeleteCustomStatus: handleDeleteCustomStatusV2,
                onRemove: handleRemoveV2,
                isContentStateMenuOpen: isContentStateMenuOpen,
                setIsContentStateMenuOpen: setIsContentStateMenuOpenWithListener,
                workflowStatuses: reviewEligibleStatuses,
                onSelectWorkflowStatus: handleSelectWorkflowStatus,
                hasActiveWorkflowStatus: activeWorkflowStatus !== null,
                showApprovalsUpsell: shouldShowApprovalsUpsell,
                onSelectApprovalsUpsell: handleSelectApprovalsUpsell
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $35470e23ff8dc4a3$export$d369faa039f625c2), {
                contentId: contentId,
                contentStateState: contentStateState,
                contentType: contentType,
                isContentStateEnabled: contentStateState.state.isContentStateEnabled,
                isSuggestedEnabled: contentStateState.state.isSuggestedEnabled,
                isCustomEnabled: contentStateState.state.isCustomEnabled,
                customStatesArray: contentStateState.state.customStatesArray,
                defaultStatesArray: contentStateState.state.defaultStatesArray,
                isCreatingContentState: isCreatingContentState,
                selectedColor: selectedColor,
                onSelectColor: handleSelectColor,
                isColorPickerOpen: isColorPickerOpen,
                onColorPickerToggle: handleColorPickerToggle,
                onColorPickerClose: handleColorPickerClose,
                onPopupClose: handleContentStatePopupClose,
                onSubmit: handleSubmit,
                onCancel: handleCancel,
                onRemove: handleRemove,
                onFocusTextField: handleFocusTextField,
                onMouseEnterRemove: handleMouseEnterRemove,
                onMouseLeaveRemove: handleMouseLeaveRemove,
                userOffline: userOffline,
                contentStateButtonRef: contentStateButtonRef,
                onUpdateSuccess: onUpdateSuccess,
                isContentStateMenuOpen: isContentStateMenuOpen,
                setIsContentStateMenuOpen: setIsContentStateMenuOpenWithListener,
                updatePopup: update
            });
        }
    }), showChangeStatusModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9e4b1108156656e$export$e3890091771f43d6), {
        approverData: respondedApproverData,
        onCancelApproval: handleConfirmCancelApproval,
        onClose: handleCloseChangeStatusModal
    }), showCancelApprovalModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5fbc7aa463b11615$export$666ae2a1d01b224a), {
        approverData: respondedApproverData,
        showProfileCards: respondedApproverData.some(({ userId: userId })=>Boolean(userId)) && (0, $6mKj3.expValEquals)('confluence_approvals_profile_card_updates', 'isEnabled', true),
        onCancelApproval: handleConfirmClearRequest,
        onClose: handleCloseCancelApprovalModal
    }), showChangeStatusConfirmModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b4b201f77954c660$export$64f482d2cfabd4a), {
        variant: "changeStatus",
        onConfirm: handleConfirmChangeStatus,
        onClose: handleCloseChangeStatusConfirmModal
    }), isLivePage && (shouldBlockLiveDocConversion || isLiveDocConversionBlockedModalOpen) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bc1oR.LiveDocConversionBlockedModal), {
        isOpen: isLiveDocConversionBlockedModalOpen,
        onClose: handleCloseLiveDocConversionBlockedModal
    }), isApprovalsUpsellModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dbca394cf11080fc$export$e8695a53661235a1), {
        onClose: handleCloseApprovalsUpsellModal
    }));
};
const $1478047e1c32b5f4$export$80f871af2133e26f = (0, $7aRa9.withFlags)($1478047e1c32b5f4$export$fd37fef230d4b03a);
module.exports["EditorContentStateComponentImpl"] = $1478047e1c32b5f4$export$fd37fef230d4b03a;
module.exports["EditorContentStateComponent"] = $1478047e1c32b5f4$export$80f871af2133e26f;

});

parcelRegister("2QUbq", function(module, exports) {
/**
 * Approvals analytics utilities
 *
 * Shared constants and helpers for analytics events fired across the Approvals workflow.
 * All approval-related events should use the APPROVALS_ANALYTICS_SOURCE constant as their source.
 */ const $3b81570c8284038b$export$aafe3d1a02fab97e = 'ConfluenceApprovalsWorkflow';
const $3b81570c8284038b$export$a389a02f59f28efe = {
    type: 'sendUIEvent',
    data: {
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'invokeRovoAgent',
        source: $3b81570c8284038b$export$aafe3d1a02fab97e
    }
};
const $3b81570c8284038b$export$f1487629ac850cbf = (approvers, decisionChange)=>{
    const counts = approvers.reduce((acc, approver)=>{
        if (approver.status === 'REVIEWER_APPROVED') acc.approved++;
        else if (approver.status === 'REVIEWER_DENIED') acc.declined++;
        else if (approver.status === 'PENDING_REVIEW') acc.pending++;
        return acc;
    }, {
        approved: 0,
        declined: 0,
        pending: 0,
        total: approvers.length
    });
    if (decisionChange) {
        const { previousDecision: previousDecision = 'PENDING_REVIEW', newDecision: newDecision } = decisionChange;
        // Decrement the previous bucket (REVIEW_CANCELED is not a counted bucket; treat as no-op)
        if (previousDecision === 'REVIEWER_APPROVED') counts.approved--;
        else if (previousDecision === 'REVIEWER_DENIED') counts.declined--;
        else if (previousDecision === 'PENDING_REVIEW') counts.pending--;
        // Increment the new bucket
        if (newDecision === 'REVIEWER_APPROVED') counts.approved++;
        else counts.declined++;
    }
    return counts;
};
const $3b81570c8284038b$export$571dc04ca9eba9e2 = (error)=>{
    if (error == null || typeof error !== 'object') return null;
    const mutationError = error;
    const { extensions: extensions } = mutationError;
    if (extensions == null) return null;
    const ext = Array.isArray(extensions) ? extensions[0] : extensions;
    if (ext == null) return null;
    const { statusCode: statusCode } = ext;
    if (typeof statusCode === 'number') return statusCode;
    return null;
};
module.exports["APPROVALS_ANALYTICS_SOURCE"] = $3b81570c8284038b$export$aafe3d1a02fab97e;
module.exports["APPROVALS_INVOKE_ROVO_AGENT_CLICKED_EVENT"] = $3b81570c8284038b$export$a389a02f59f28efe;
module.exports["computeReviewStatusCounts"] = $3b81570c8284038b$export$f1487629ac850cbf;
module.exports["getFailureStatusCode"] = $3b81570c8284038b$export$571dc04ca9eba9e2;

});

parcelRegister("bc1oR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aRGok = parcelRequire("aRGok");


var $jmjWc = parcelRequire("jmjWc");


const $59dfe7259baf5548$var$LiveDocConversionBlockedModalContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "y_qAG",
    name: "LiveDocConversionBlockedModalContent",
    loader: async ()=>(await (parcelRequire("2GSdi"))).LiveDocConversionBlockedModal
});
const $59dfe7259baf5548$export$b1e3cd6c92cb101b = ({ isOpen: isOpen, onClose: onClose })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($59dfe7259baf5548$var$LiveDocConversionBlockedModalContent, {
        onClose: onClose
    }) : null);
};
module.exports["LiveDocConversionBlockedModal"] = $59dfe7259baf5548$export$b1e3cd6c92cb101b;

});

parcelRegister("2GSdi", function(module, exports) {

let $1f598eadbc048b0c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1f598eadbc048b0c$var$load("7Cd3Z").then(()=>parcelRequire('1QNK6'));

});

parcelRegister("dNj8O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $2QUbq = parcelRequire("2QUbq");

const $dbbc9dfadaa1b3f4$export$fdc305387ebecd56 = ({ contentId: contentId, contentType: contentType, createAnalyticsEvent: createAnalyticsEvent, disallowFirstPublish: disallowFirstPublish, isLivePage: isLivePage })=>{
    const [isLiveDocConversionBlockedModalOpen, setIsLiveDocConversionBlockedModalOpen] = (0, $cozmU.useState)(false);
    const isLiveDocConversionBlockedModalOpenRef = (0, $cozmU.useRef)(false);
    const shouldBlockLiveDocConversion = isLivePage && disallowFirstPublish === true && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true);
    const handleCloseLiveDocConversionBlockedModal = (0, $cozmU.useCallback)(()=>{
        isLiveDocConversionBlockedModalOpenRef.current = false;
        setIsLiveDocConversionBlockedModalOpen(false);
    }, []);
    const handleLiveDocConversionBlockedByApproval = (0, $cozmU.useCallback)(()=>{
        if (!isLiveDocConversionBlockedModalOpenRef.current) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'liveDocConversionBlockedScreen',
                source: (0, $2QUbq.APPROVALS_ANALYTICS_SOURCE),
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    isLivePage: isLivePage,
                    conversionSource: 'liveDocToPage'
                }
            }
        }).fire();
        isLiveDocConversionBlockedModalOpenRef.current = true;
        setIsLiveDocConversionBlockedModalOpen(true);
    }, [
        contentId,
        contentType,
        createAnalyticsEvent,
        isLivePage
    ]);
    return {
        handleCloseLiveDocConversionBlockedModal: handleCloseLiveDocConversionBlockedModal,
        handleLiveDocConversionBlockedByApproval: handleLiveDocConversionBlockedByApproval,
        isLiveDocConversionBlockedModalOpen: isLiveDocConversionBlockedModalOpen,
        shouldBlockLiveDocConversion: shouldBlockLiveDocConversion
    };
};
module.exports["useLiveDocConversionBlockedModal"] = $dbbc9dfadaa1b3f4$export$fdc305387ebecd56;

});

parcelRegister("eLZIq", function(module, exports) {

let $ac1553e3f11ac9fe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ac1553e3f11ac9fe$var$load("7AxCq").then(()=>parcelRequire('akN4j'));

});

parcelRegister("APlbQ", function(module, exports) {

let $06eb301da408d645$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $06eb301da408d645$var$load("kZCcz").then(()=>parcelRequire('7T100'));

});

parcelRegister("de8MJ", function(module, exports) {

let $9a1365ad302029bd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9a1365ad302029bd$var$load("kb6Db").then(()=>parcelRequire('k73x5'));

});

parcelRegister("bTNHJ", function(module, exports) {
const $40c64d99faad260f$export$e31693551d4a36b1 = 'approvals-live-doc';
module.exports["APPROVALS_LIVE_DOC_PUBLISH_MODAL_SOURCE"] = $40c64d99faad260f$export$e31693551d4a36b1;

});

parcelRegister("jln20", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lRhY3 = parcelRequire("lRhY3");


var $87whh = parcelRequire("87whh");


var $aWwYt = parcelRequire("aWwYt");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $cozmU.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $cozmU.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $cozmU.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $lRhY3.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $87whh.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars($8facebd0ecb5e0ee$var$_temp);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
function $8facebd0ecb5e0ee$var$_temp(prev) {
    return prev.length === 0 ? prev : [];
}
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("lRhY3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $3Ap09 = parcelRequire("3Ap09");

const $bc35f8d5f81a3a68$var$noop = (props)=>{};
const $bc35f8d5f81a3a68$export$5f5debba1692bf40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                open: $bc35f8d5f81a3a68$var$noop,
                close: $bc35f8d5f81a3a68$var$noop,
                setPanelWidth: $bc35f8d5f81a3a68$var$noop
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] !== context.close || $[2] !== context.open || $[3] !== context.setPanelWidth) {
        t0 = {
            open: context.open,
            close: context.close,
            setPanelWidth: context.setPanelWidth
        };
        $[1] = context.close;
        $[2] = context.open;
        $[3] = context.setPanelWidth;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : ()=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (!context) return {
        open: $bc35f8d5f81a3a68$var$noop,
        close: $bc35f8d5f81a3a68$var$noop,
        setPanelWidth: $bc35f8d5f81a3a68$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bc35f8d5f81a3a68$export$5f5debba1692bf40;

});

parcelRegister("3Ap09", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $63gyv = parcelRequire("63gyv");


var $7ssWV = parcelRequire("7ssWV");

const $4db84584556d15be$var$noop = ()=>{};
const $4db84584556d15be$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $4db84584556d15be$var$noop,
    onClose: $4db84584556d15be$var$noop
};
const $4db84584556d15be$export$f473d225913e225d = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $4db84584556d15be$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $4db84584556d15be$var$noop,
                onClose: $4db84584556d15be$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
      	When opening a new preview panel, if the current panel is of the same type we don't
      	want to close the panel, but rather swap out the content. If the panel types don't match
      	we close the current panel and open the new one.
      	ex: A Goals panel is already open, and user tries to open a different Goals panel.
      	Parent Products must pass their preview panel close functions to the Preview Panel provider
      	via the `onPreviewPanelClose` prop.
      */ if (state.panel && !(0, $7ssWV.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $4db84584556d15be$var$initialState.onOpen,
                onClose: params.onClose || $4db84584556d15be$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $4db84584556d15be$export$65ae37e9c61321f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth } = t0;
    let t1;
    if ($[0] !== initialWidth) {
        t1 = (0, $iDrrr.fg)("nin_glance_panel_initial_width_ssr") ? {
            initialWidth: initialWidth
        } : undefined;
        $[0] = initialWidth;
        $[1] = t1;
    } else t1 = $[1];
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $63gyv.usePanelWidth)(t1);
    let t2;
    if ($[2] !== initialPanel) {
        t2 = initialPanel && (0, $iDrrr.fg)("preview_panel_initial_state") ? {
            panel: initialPanel
        } : {};
        $[2] = initialPanel;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== onPreviewPanelClose || $[5] !== onPreviewPanelOpen || $[6] !== t2) {
        t3 = {
            ...$4db84584556d15be$var$initialState,
            ...t2,
            onPreviewPanelOpen: onPreviewPanelOpen,
            onPreviewPanelClose: onPreviewPanelClose
        };
        $[4] = onPreviewPanelClose;
        $[5] = onPreviewPanelOpen;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const [state, dispatch] = (0, $cozmU.useReducer)($4db84584556d15be$var$previewPanelsReducer, t3);
    let t4;
    if ($[8] !== onPanelWidthChanged || $[9] !== parentProduct || $[10] !== state) {
        t4 = (width)=>{
            onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
        };
        $[8] = onPanelWidthChanged;
        $[9] = parentProduct;
        $[10] = state;
        $[11] = t4;
    } else t4 = $[11];
    const setPanelWidth = t4;
    let t5;
    if ($[12] !== onPanelClosed) {
        t5 = (onClose)=>{
            dispatch?.({
                type: "CLOSE",
                onClose: onClose
            });
            onPanelClosed();
        };
        $[12] = onPanelClosed;
        $[13] = t5;
    } else t5 = $[13];
    const close = t5;
    let t6;
    if ($[14] !== onPanelOpened) {
        t6 = (params)=>{
            dispatch?.({
                type: "OPEN",
                params: params
            });
            onPanelOpened(params.width);
        };
        $[14] = onPanelOpened;
        $[15] = t6;
    } else t6 = $[15];
    const open = t6;
    let t7;
    if ($[16] !== close || $[17] !== open || $[18] !== panelWidth || $[19] !== setPanelWidth || $[20] !== state) {
        t7 = {
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        };
        $[16] = close;
        $[17] = open;
        $[18] = panelWidth;
        $[19] = setPanelWidth;
        $[20] = state;
        $[21] = t7;
    } else t7 = $[21];
    const context = t7;
    let t8;
    if ($[22] !== children || $[23] !== context) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4db84584556d15be$export$f473d225913e225d.Provider, {
            value: context
        }, children);
        $[22] = children;
        $[23] = context;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $63gyv.usePanelWidth)((0, $iDrrr.fg)('nin_glance_panel_initial_width_ssr') ? {
        initialWidth: initialWidth
    } : undefined);
    const [state, dispatch] = (0, $cozmU.useReducer)($4db84584556d15be$var$previewPanelsReducer, {
        ...$4db84584556d15be$var$initialState,
        ...initialPanel && (0, $iDrrr.fg)('preview_panel_initial_state') ? {
            panel: initialPanel
        } : {},
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $cozmU.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $cozmU.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $cozmU.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $cozmU.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4db84584556d15be$export$f473d225913e225d.Provider, {
        value: context
    }, children);
};
const $4db84584556d15be$export$609db4be92d0fad8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($4db84584556d15be$export$f473d225913e225d);
} : ()=>{
    return (0, $cozmU.useContext)($4db84584556d15be$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $4db84584556d15be$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $4db84584556d15be$export$609db4be92d0fad8;

});

parcelRegister("63gyv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $55fM8 = parcelRequire("55fM8");


var $9DHhW = parcelRequire("9DHhW");


var $7y9ez = parcelRequire("7y9ez");

const $4ad8ebf5df3a3b12$export$82b270f291af5a5 = ({ initialWidth: initialWidth } = {})=>{
    const [defaultWidth, setDefaultWidth] = (0, $cozmU.useState)((0, $7y9ez.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $cozmU.useState)(initialWidth ?? defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $cozmU.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $cozmU.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $cozmU.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $cozmU.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $cozmU.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $7y9ez.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $cozmU.useEffect)(()=>{
        const unbind = (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $4ad8ebf5df3a3b12$export$82b270f291af5a5;

});

parcelRegister("7y9ez", function(module, exports) {
const $c1ed100d044a4357$var$PANEL_DEFAULT_WIDTH = 400;
const $c1ed100d044a4357$var$PANEL_MAX_WIDTH = 1000;
const $c1ed100d044a4357$var$MINIMUM_WIDTH = 1800;
const $c1ed100d044a4357$var$PANEL_TO_WINDOW_WITH_RATIO = 0.3;
const $c1ed100d044a4357$export$29ceecbfeef33bfc = ()=>{
    const windowWidth = window.innerWidth;
    let width = $c1ed100d044a4357$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth >= $c1ed100d044a4357$var$MINIMUM_WIDTH) {
        const proposedPanelWidth = Math.round(windowWidth * $c1ed100d044a4357$var$PANEL_TO_WINDOW_WITH_RATIO);
        width = proposedPanelWidth < $c1ed100d044a4357$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $c1ed100d044a4357$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $c1ed100d044a4357$export$29ceecbfeef33bfc;

});

parcelRegister("7ssWV", function(module, exports) {

var $7avaU = parcelRequire("7avaU");

const $2fea0aef81deca52$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $7avaU.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $7avaU.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $2fea0aef81deca52$export$eb89e687f2b278d7;

});

parcelRegister("87whh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $3Ap09 = parcelRequire("3Ap09");

const $5fad2268a70a3d3b$export$c68e55e6e77f3d5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
} : (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5fad2268a70a3d3b$export$c68e55e6e77f3d5d;

});

parcelRegister("aWwYt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $lRhY3 = parcelRequire("lRhY3");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$21f0d255469350e0 = 3840;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    /**
   * Hide the sidebar immediately, bypassing the canClosePanel guard.
   * Use only when the caller has already confirmed with the user that it is
   * safe to discard any draft (e.g. after showing their own warning dialog).
   */ hideObjectSidebarForce: ()=>({ getState: getState, setState: setState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            if (!isObjectSidebarShown || !panel) return;
            panel.closeOptions?.onPanelClose?.();
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
        },
    /**
   * Legacy writer used by `ObjectSidebarPushPlaceholder`'s ResizeObserver
   * loop, which reports the inner content width (without push padding).
   * Prefer `setVisiblePanelWidth` from drag-resize call sites.
   */ setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    /**
   * Drag-resize writer. Takes the *visible* panel width directly (no
   * `−CONTENT_RIGHT_PADDING` at the call site). Same encoding as
   * `setPanelWidth`, so `panelWidth` consistently represents
   * "visible + push padding" regardless of which writer set it.
   */ setVisiblePanelWidth: (visiblePanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(visiblePanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $8s9DV.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $kBr4q.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $cozmU.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = showObjectSidebarWrapper;
    const memoizedActions = (0, $cozmU.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $cozmU.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["CONTENT_RIGHT_PADDING"] = $5371993c50b87836$export$c0cd7aea5be0e780;
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("8miSe", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $Uu0Pb = parcelRequire("Uu0Pb");

const $38122f14841a6560$export$b3a997d9e0eb41e = (color)=>{
    switch(color){
        case (0, $Uu0Pb.PRIMARY_COLORS).BLUE:
            return '#2684FF';
        case (0, $Uu0Pb.PRIMARY_COLORS).GREEN:
            return '#57D9A3';
        case (0, $Uu0Pb.PRIMARY_COLORS).YELLOW:
            return '#FFC400';
        case (0, $Uu0Pb.PRIMARY_COLORS).PURPLE:
            return '#8777D9';
        case (0, $Uu0Pb.PRIMARY_COLORS).RED:
            return '#FF7452';
        case (0, $Uu0Pb.PRIMARY_COLORS).VERIFIED:
            return '#1d7afc';
        default:
            return '#2684FF';
    }
};
const $38122f14841a6560$export$979ed8c2392c1cb4 = (color)=>{
    const upperCaseColor = color?.toUpperCase(); // need toUpper since color we get from BE is lowercase
    switch(upperCaseColor){
        case '#2684FF':
            return (0, $Uu0Pb.PRIMARY_COLORS).BLUE;
        case '#57D9A3':
            return (0, $Uu0Pb.PRIMARY_COLORS).GREEN;
        case '#FFC400':
            return (0, $Uu0Pb.PRIMARY_COLORS).YELLOW;
        case '#8777D9':
            return (0, $Uu0Pb.PRIMARY_COLORS).PURPLE;
        case '#FF7452':
            return (0, $Uu0Pb.PRIMARY_COLORS).RED;
        default:
            return color;
    }
};
function $38122f14841a6560$export$4407ed99ceb09a2c(colorCode) {
    const upperCaseColorCode = colorCode?.toUpperCase();
    switch(upperCaseColorCode){
        case (0, $Uu0Pb.PRIMARY_COLORS).BLUE.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).BLUE;
        case (0, $Uu0Pb.PRIMARY_COLORS).GREEN.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).GREEN;
        case (0, $Uu0Pb.PRIMARY_COLORS).YELLOW.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).YELLOW;
        case (0, $Uu0Pb.PRIMARY_COLORS).RED.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).RED;
        case (0, $Uu0Pb.PRIMARY_COLORS).PURPLE.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).PURPLE;
        default:
            return (0, $Uu0Pb.COLOR_NAMES).BLUE;
    }
}
module.exports["tokenToHex"] = $38122f14841a6560$export$b3a997d9e0eb41e;
module.exports["hexToToken"] = $38122f14841a6560$export$979ed8c2392c1cb4;
module.exports["colorCodeToColorName"] = $38122f14841a6560$export$4407ed99ceb09a2c;

});

parcelRegister("Uu0Pb", function(module, exports) {
const $1c48b1994652ad1b$export$af156f0af92331bd = {
    BLUE: "var(--ds-background-accent-blue-subtle, #669DF1)",
    GREEN: "var(--ds-background-accent-green-subtle, #4BCE97)",
    YELLOW: "var(--ds-background-accent-yellow-subtle, #EED12B)",
    RED: "var(--ds-background-accent-red-subtle, #F87168)",
    PURPLE: "var(--ds-background-accent-purple-subtle, #C97CF4)",
    VERIFIED: "var(--ds-icon-accent-blue, #357DE8)"
};
const $1c48b1994652ad1b$export$c70dda424cd479ac = {
    BLUE: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    GREEN: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    YELLOW: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    RED: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    PURPLE: "var(--ds-background-accent-purple-subtlest, #F8EEFE)"
};
const $1c48b1994652ad1b$export$8380141af31d7b6a = {
    BLUE: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    GREEN: "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    YELLOW: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    RED: "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    PURPLE: "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)"
};
const $1c48b1994652ad1b$export$e755b4518de49373 = {
    BLUE: 'blue',
    GREEN: 'green',
    YELLOW: 'yellow',
    RED: 'red',
    PURPLE: 'purple'
};
module.exports["PRIMARY_COLORS"] = $1c48b1994652ad1b$export$af156f0af92331bd;
module.exports["SECONDARY_COLORS"] = $1c48b1994652ad1b$export$c70dda424cd479ac;
module.exports["HOVER_COLORS"] = $1c48b1994652ad1b$export$8380141af31d7b6a;
module.exports["COLOR_NAMES"] = $1c48b1994652ad1b$export$e755b4518de49373;

});

parcelRegister("fxbF1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9089ed3f6a5fc310482f628accd47a0e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4f2fba9f65c2ddf$var$_react = $b4f2fba9f65c2ddf$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b4f2fba9f65c2ddf$var$_baseNew = $b4f2fba9f65c2ddf$var$_interopRequireDefault((parcelRequire("gElAV")));
function $b4f2fba9f65c2ddf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "History".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/history
 * Usage guidance:
 * Reserved for history and recent
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4f2fba9f65c2ddf$var$HistoryIcon = (props)=>/*#__PURE__*/ $b4f2fba9f65c2ddf$var$_react.default.createElement($b4f2fba9f65c2ddf$var$_baseNew.default, Object.assign({
        name: "HistoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1.5 8A6.5 6.5 0 1 0 8 1.5a6.36 6.36 0 0 0-4.651 2.005l1.298.26a.75.75 0 0 1-.09 1.483l-3.25.25A.75.75 0 0 1 .5 4.75V1.5l.013-.137a.75.75 0 0 1 1.456-.079l.34 1.138A7.86 7.86 0 0 1 8 0a8 8 0 1 1-8 8zm7.25-4.25v4.389l2.219 1.775-.938 1.172-2.5-2A.75.75 0 0 1 7.25 8.5V3.75z"/>`
    }, props));
$b4f2fba9f65c2ddf$var$HistoryIcon.displayName = 'HistoryIcon';
var $b4f2fba9f65c2ddf$var$_default = module.exports.default = $b4f2fba9f65c2ddf$var$HistoryIcon;

});

parcelRegister("k75o7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f8d1e17b87674fbe1aa567c2ca97644b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ea48a40f0e744b32$var$_react = $ea48a40f0e744b32$var$_interopRequireDefault((parcelRequire("cozmU")));

var $ea48a40f0e744b32$var$_baseNew = $ea48a40f0e744b32$var$_interopRequireDefault((parcelRequire("gElAV")));
function $ea48a40f0e744b32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWorkflowInReview".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/status-workflow-in-review
 * Usage guidance:
 * Reserved for representing statuses that signal consideration, assessment, and review
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ea48a40f0e744b32$var$StatusWorkflowInReviewIcon = (props)=>/*#__PURE__*/ $ea48a40f0e744b32$var$_react.default.createElement($ea48a40f0e744b32$var$_baseNew.default, Object.assign({
        name: "StatusWorkflowInReviewIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8 3a5 5 0 1 1-5 5h5z"/><path fill="currentcolor" d="M1.5 8A6.5 6.5 0 1 0 8 1.5V0a8 8 0 1 1-8 8z"/><path fill="currentcolor" d="m.812 7.053.743.097A7 7 0 0 0 1.5 8H0q0-.53.067-1.044zm2.03-3.01c-.343.447-.63.94-.849 1.469L.607 4.938a8 8 0 0 1 1.046-1.81zm2.67-2.05a6.5 6.5 0 0 0-1.469.85l-.914-1.19A8 8 0 0 1 4.938.607zM8 1.5q-.433 0-.85.055L7.053.812 6.956.067Q7.47.001 8 0z"/>`
    }, props));
$ea48a40f0e744b32$var$StatusWorkflowInReviewIcon.displayName = 'StatusWorkflowInReviewIcon';
var $ea48a40f0e744b32$var$_default = module.exports.default = $ea48a40f0e744b32$var$StatusWorkflowInReviewIcon;

});

parcelRegister("dB01C", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bd8f0119dabf4690393aa109b60bd96c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e5ec009a66cd424$var$_react = $9e5ec009a66cd424$var$_interopRequireDefault((parcelRequire("cozmU")));

var $9e5ec009a66cd424$var$_baseNew = $9e5ec009a66cd424$var$_interopRequireDefault((parcelRequire("gElAV")));
function $9e5ec009a66cd424$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWorkflowReturned".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/status-workflow-returned
 * Usage guidance:
 * Reserved for representing statuses that return to a previous state in the process such as "Redeploy", "Needs more information"
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9e5ec009a66cd424$var$StatusWorkflowReturnedIcon = (props)=>/*#__PURE__*/ $9e5ec009a66cd424$var$_react.default.createElement($9e5ec009a66cd424$var$_baseNew.default, Object.assign({
        name: "StatusWorkflowReturnedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/><path fill="currentcolor" d="M10.5 8.75A1.75 1.75 0 0 0 8.75 7H7.293l.358.628a.75.75 0 0 1-1.112.964l-2.25-1.75a.75.75 0 0 1 0-1.184l2.25-1.75a.75.75 0 0 1 1.112.964l-.358.628H8.75a3.25 3.25 0 0 1 0 6.5H7v-1.5h1.75a1.75 1.75 0 0 0 1.75-1.75"/>`
    }, props));
$9e5ec009a66cd424$var$StatusWorkflowReturnedIcon.displayName = 'StatusWorkflowReturnedIcon';
var $9e5ec009a66cd424$var$_default = module.exports.default = $9e5ec009a66cd424$var$StatusWorkflowReturnedIcon;

});

parcelRegister("f28S3", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $17wUi = parcelRequire("17wUi");

const $5d35b4c8a88cf3c5$export$1cf966ab51733f40 = 'approval-activity-pane';
const $5d35b4c8a88cf3c5$export$312e57b102de2eda = 400;
const $5d35b4c8a88cf3c5$export$d9243646277c1b68 = 'confluence.approvals.activityPane.contextKey';
const $5d35b4c8a88cf3c5$var$VALID_APPROVAL_ACTIVITY_CONTENT_STATUSES = [
    'CURRENT',
    'DRAFT'
];
const $5d35b4c8a88cf3c5$export$ebd91df43704fb21 = ({ contentId: contentId, contentStatus: contentStatus })=>`${contentId}:${contentStatus}`;
const $5d35b4c8a88cf3c5$export$7ebf9cc846d54fed = (contextKey)=>{
    if (!contextKey) return null;
    const statusSeparatorIndex = contextKey.lastIndexOf(':');
    if (statusSeparatorIndex <= 0 || statusSeparatorIndex === contextKey.length - 1) return null;
    const contentId = contextKey.slice(0, statusSeparatorIndex);
    const contentStatus = contextKey.slice(statusSeparatorIndex + 1);
    if (!$5d35b4c8a88cf3c5$var$VALID_APPROVAL_ACTIVITY_CONTENT_STATUSES.includes(contentStatus)) return null;
    return {
        contentId: contentId,
        contentStatus: contentStatus
    };
};
// Synchronous source of truth for the ownership helpers: session storage writes
// can be async, so an immediate
// read can miss. Storage is still written for durability across reloads.
let $5d35b4c8a88cf3c5$var$inMemoryContextKey = null;
let $5d35b4c8a88cf3c5$var$inMemoryBackAction = null;
const $5d35b4c8a88cf3c5$export$139dba4020acd3ec = ()=>$5d35b4c8a88cf3c5$var$inMemoryContextKey;
const $5d35b4c8a88cf3c5$export$515df3935cc07f4d = (contextKey)=>{
    $5d35b4c8a88cf3c5$var$inMemoryContextKey = contextKey;
    (0, $17wUi.confluenceSessionStorageInstance).setItem($5d35b4c8a88cf3c5$export$d9243646277c1b68, contextKey);
};
const $5d35b4c8a88cf3c5$export$1be1d79d24e4e109 = ({ contentId: contentId, contentStatus: contentStatus })=>{
    const contextKey = $5d35b4c8a88cf3c5$export$ebd91df43704fb21({
        contentId: contentId,
        contentStatus: contentStatus
    });
    if ($5d35b4c8a88cf3c5$var$inMemoryContextKey !== contextKey) return null;
    return $5d35b4c8a88cf3c5$var$inMemoryBackAction;
};
const $5d35b4c8a88cf3c5$var$setStoredApprovalActivityPaneBackAction = (backAction)=>{
    $5d35b4c8a88cf3c5$var$inMemoryBackAction = backAction ?? null;
};
const $5d35b4c8a88cf3c5$export$32575512fde29f65 = ()=>{
    $5d35b4c8a88cf3c5$var$inMemoryContextKey = null;
    $5d35b4c8a88cf3c5$var$inMemoryBackAction = null;
    (0, $17wUi.confluenceSessionStorageInstance).removeItem($5d35b4c8a88cf3c5$export$d9243646277c1b68);
};
const $5d35b4c8a88cf3c5$export$e0b014cdef5c4ad0 = ({ contextKey: contextKey, storedContextKey: storedContextKey })=>storedContextKey === contextKey;
const $5d35b4c8a88cf3c5$export$8160aab3b9f65497 = ({ isApprovalActivityEnabled: isApprovalActivityEnabled, isSidebarApprovalActivityPaneOpen: isSidebarApprovalActivityPaneOpen, contextKey: contextKey })=>{
    if (!isApprovalActivityEnabled || !isSidebarApprovalActivityPaneOpen) return false;
    return $5d35b4c8a88cf3c5$export$e0b014cdef5c4ad0({
        contextKey: contextKey,
        storedContextKey: $5d35b4c8a88cf3c5$export$139dba4020acd3ec()
    });
};
const $5d35b4c8a88cf3c5$export$cbee9c4602f01758 = ({ isApprovalActivityEnabled: isApprovalActivityEnabled, isSidebarApprovalActivityPaneOpen: isSidebarApprovalActivityPaneOpen, contextKey: contextKey, closeApprovalActivityPane: closeApprovalActivityPane })=>{
    // When disabled while the pane is still open, close it so it can't linger
    // with stale content; always clear ownership so a re-enable can't match it.
    if (!isApprovalActivityEnabled) {
        if (isSidebarApprovalActivityPaneOpen) closeApprovalActivityPane();
        $5d35b4c8a88cf3c5$export$32575512fde29f65();
        return;
    }
    if (!isSidebarApprovalActivityPaneOpen) {
        $5d35b4c8a88cf3c5$export$32575512fde29f65();
        return;
    }
    const storedContextKey = $5d35b4c8a88cf3c5$export$139dba4020acd3ec();
    if ($5d35b4c8a88cf3c5$export$e0b014cdef5c4ad0({
        contextKey: contextKey,
        storedContextKey: storedContextKey
    })) return;
    closeApprovalActivityPane();
    $5d35b4c8a88cf3c5$export$32575512fde29f65();
};
const $5d35b4c8a88cf3c5$export$88863c5159ce1de9 = ({ contentId: contentId, contentStatus: contentStatus, onBack: onBack, rightSidebarContext: rightSidebarContext })=>{
    if ((0, $9wGTI.fg)('cc_approvals_activity_log_edit_mode')) {
        $5d35b4c8a88cf3c5$export$515df3935cc07f4d($5d35b4c8a88cf3c5$export$ebd91df43704fb21({
            contentId: contentId,
            contentStatus: contentStatus
        }));
        if (onBack || $5d35b4c8a88cf3c5$var$inMemoryBackAction !== null) $5d35b4c8a88cf3c5$var$setStoredApprovalActivityPaneBackAction(onBack);
        rightSidebarContext.open($5d35b4c8a88cf3c5$export$1cf966ab51733f40, $5d35b4c8a88cf3c5$export$312e57b102de2eda);
        return;
    }
    rightSidebarContext.open($5d35b4c8a88cf3c5$export$1cf966ab51733f40, $5d35b4c8a88cf3c5$export$312e57b102de2eda);
    $5d35b4c8a88cf3c5$export$515df3935cc07f4d($5d35b4c8a88cf3c5$export$ebd91df43704fb21({
        contentId: contentId,
        contentStatus: 'CURRENT'
    }));
    if (onBack || $5d35b4c8a88cf3c5$var$inMemoryBackAction !== null) $5d35b4c8a88cf3c5$var$setStoredApprovalActivityPaneBackAction(onBack);
};
module.exports["APPROVAL_ACTIVITY_PANE_ID"] = $5d35b4c8a88cf3c5$export$1cf966ab51733f40;
module.exports["getApprovalActivityPaneContextKey"] = $5d35b4c8a88cf3c5$export$ebd91df43704fb21;
module.exports["getApprovalActivityPaneContextFromKey"] = $5d35b4c8a88cf3c5$export$7ebf9cc846d54fed;
module.exports["getStoredApprovalActivityPaneContextKey"] = $5d35b4c8a88cf3c5$export$139dba4020acd3ec;
module.exports["getStoredApprovalActivityPaneBackAction"] = $5d35b4c8a88cf3c5$export$1be1d79d24e4e109;
module.exports["clearStoredApprovalActivityPaneContextKey"] = $5d35b4c8a88cf3c5$export$32575512fde29f65;
module.exports["shouldRenderApprovalActivityPaneForContext"] = $5d35b4c8a88cf3c5$export$8160aab3b9f65497;
module.exports["syncApprovalActivityPaneContextOwnership"] = $5d35b4c8a88cf3c5$export$cbee9c4602f01758;
module.exports["openApprovalActivityPaneForContext"] = $5d35b4c8a88cf3c5$export$88863c5159ce1de9;

});

parcelRegister("4S6vT", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $Uu0Pb = parcelRequire("Uu0Pb");


var $8miSe = parcelRequire("8miSe");

const $87c020c14703301f$var$ContentStateColorSizes = {
    pageHistoryContentState: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            height: '10px',
            width: '10px',
            marginTop: 'space.0',
            marginBottom: 'space.0',
            marginLeft: 'space.050',
            marginRight: 'space.050'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.full',
            width: '10px',
            height: '10px'
        }),
        scale: 'scale(0.625)',
        viewbox: '0 0 10px 10px'
    },
    rendererContentState: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            height: '12px',
            width: '12px',
            marginTop: 'space.0',
            marginBottom: 'space.0',
            marginRight: 'space.100',
            marginLeft: 'space.100'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.xlarge',
            width: '12px',
            height: '12px'
        }),
        scale: 'scale(0.75)',
        viewbox: '0 0 12px 12px'
    },
    editorContentState: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            height: '16px',
            width: '16px',
            marginTop: 'space.0',
            marginBottom: 'space.0',
            marginLeft: 'space.400',
            marginRight: 'space.400'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.full',
            width: '16px',
            height: '16px'
        }),
        scale: 'scale(1)',
        viewbox: '0 0 16px 16px'
    },
    contentStateButton: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            height: '12px',
            width: '12px',
            marginRight: 'space.050'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.xlarge',
            width: '12px',
            height: '12px'
        }),
        scale: 'scale(0.75)',
        viewbox: '0 0 12px 12px'
    },
    spaceAdminContentState: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            maxHeight: '16px',
            maxWidth: '16px',
            marginRight: 'space.200'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.full',
            width: '16px',
            height: '16px'
        }),
        scale: 'scale(1)',
        viewbox: '0 0 16px 16px'
    },
    restoreContentStatesModal: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            maxHeight: '16px',
            maxWidth: '16px'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.full',
            width: '16px',
            height: '16px'
        }),
        scale: 'scale(1)',
        viewbox: '0 0 16px 16px'
    },
    subtleContentStateButton: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '24px',
            width: '24px',
            marginRight: 'space.negative.025'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.full',
            width: '10px',
            height: '10px'
        })
    },
    subtleRendererContentState: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '24px',
            width: '24px'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.full',
            width: '10px',
            height: '10px'
        })
    },
    contentStateInfoPopup: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            height: '16px',
            width: '16px',
            marginRight: 'space.100'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.full',
            width: '16px',
            height: '16px'
        }),
        scale: 'scale(1)',
        viewbox: '0 0 16px 16px'
    }
};
// The SVG defaults to 16x16
// We need to scale to different sizes
const $87c020c14703301f$var$CheckCircleSvg = (color, dataTestId, scale, viewbox)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "100%",
        height: "100%",
        viewBox: viewbox,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'block'
        },
        "data-testid": dataTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        transform: scale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.62505 0.990813C8.94443 -0.330271 7.05558 -0.330271 6.37496 0.990813C5.96598 1.78463 5.04334 2.1668 4.19284 1.89468C2.77742 1.4418 1.4418 2.77742 1.89468 4.19284C2.1668 5.04334 1.78463 5.96598 0.990813 6.37496C-0.330271 7.05558 -0.330271 8.94443 0.990813 9.62505C1.78463 10.034 2.1668 10.9567 1.89468 11.8072C1.4418 13.2226 2.77742 14.5582 4.19284 14.1053C5.04334 13.8332 5.96598 14.2154 6.37496 15.0092C7.05558 16.3303 8.94443 16.3303 9.62505 15.0092C10.034 14.2154 10.9567 13.8332 11.8072 14.1053C13.2226 14.5582 14.5582 13.2226 14.1053 11.8072C13.8332 10.9567 14.2154 10.034 15.0092 9.62505C16.3303 8.94443 16.3303 7.05558 15.0092 6.37496C14.2154 5.96598 13.8332 5.04334 14.1053 4.19284C14.5582 2.77742 13.2226 1.4418 11.8072 1.89468C10.9567 2.1668 10.034 1.78463 9.62505 0.990813ZM11.2176 5.5246L11.2951 5.59368C11.6175 5.91602 11.6405 6.42433 11.3642 6.77323L11.2951 6.85076L7.73956 10.4063C7.41722 10.7287 6.90894 10.7517 6.56003 10.4754L6.48251 10.4063L4.70473 8.62854C4.3576 8.28141 4.3576 7.71859 4.70473 7.37146C5.02707 7.04912 5.53535 7.02609 5.88425 7.30238L5.96178 7.37146L7.11117 8.52029L10.0381 5.59368C10.3604 5.27134 10.8687 5.24831 11.2176 5.5246Z",
        fill: color
    })));
const $87c020c14703301f$var$getDisplayedColor = (color, isWarning)=>{
    if (isWarning) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return Boolean(undefined) ? '#FF7452' : (0, $Uu0Pb.PRIMARY_COLORS).RED;
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return Boolean(undefined) ? color : (0, $8miSe.hexToToken)(color);
};
const $87c020c14703301f$export$5ac2229016dfa3b6 = (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { color: color, restrictionLevel: t1, appearance: appearance, isWarning: t2, dataTestId: dataTestId } = t0;
    const restrictionLevel = t1 === undefined ? "NONE" : t1;
    const isWarning = t2 === undefined ? false : t2;
    const { ColorContainerStyles: ColorContainerStyles, viewbox: viewbox, PlainContentStateColorStyles: PlainContentStateColorStyles, scale: scale } = $87c020c14703301f$var$ContentStateColorSizes[appearance];
    let T0;
    let t3;
    let t4;
    if ($[0] !== ColorContainerStyles || $[1] !== PlainContentStateColorStyles || $[2] !== color || $[3] !== dataTestId || $[4] !== isWarning || $[5] !== restrictionLevel || $[6] !== scale || $[7] !== viewbox) {
        const displayedColor = $87c020c14703301f$var$getDisplayedColor(color ?? "#2684FF", isWarning);
        const isRestrictedState = restrictionLevel !== "NONE" && !isWarning;
        T0 = (0, $3izAL.Box);
        t3 = ColorContainerStyles;
        t4 = isRestrictedState ? $87c020c14703301f$var$CheckCircleSvg(displayedColor, dataTestId, scale, viewbox) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            testId: dataTestId,
            xcss: PlainContentStateColorStyles,
            style: {
                backgroundColor: displayedColor,
                scale: scale
            }
        });
        $[0] = ColorContainerStyles;
        $[1] = PlainContentStateColorStyles;
        $[2] = color;
        $[3] = dataTestId;
        $[4] = isWarning;
        $[5] = restrictionLevel;
        $[6] = scale;
        $[7] = viewbox;
        $[8] = T0;
        $[9] = t3;
        $[10] = t4;
    } else {
        T0 = $[8];
        t3 = $[9];
        t4 = $[10];
    }
    let t5;
    if ($[11] !== T0 || $[12] !== t3 || $[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            xcss: t3
        }, t4);
        $[11] = T0;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
};
module.exports["ContentStateColor"] = $87c020c14703301f$export$5ac2229016dfa3b6;

});

parcelRegister("bg9GW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8328b4ddc95230a8$export$2e2bcd8739ae039);

var $jO73f = parcelRequire("jO73f");


var $g93kp = parcelRequire("g93kp");


var $3yGK6 = parcelRequire("3yGK6");


var $byLBW = parcelRequire("byLBW");

function $8328b4ddc95230a8$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $3yGK6.default)(2, arguments);
    var diff = (0, $g93kp.default)(dateLeft, dateRight) / (0, $jO73f.millisecondsInHour);
    return (0, $byLBW.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("jO73f", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e6b828148d99ab2b$export$dfd9b671c89acc8e = 7;
var $e6b828148d99ab2b$export$3913210603d8e9ae = 365.2425;
var $e6b828148d99ab2b$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e6b828148d99ab2b$export$91246f0b9bd9beff = 60000;
var $e6b828148d99ab2b$export$7f72910d6dfd237a = 3600000;
var $e6b828148d99ab2b$export$397c2d5776aa9055 = 1000;
var $e6b828148d99ab2b$export$4dec998e48f9c246 = -$e6b828148d99ab2b$export$81caae6e1cc7a622;
var $e6b828148d99ab2b$export$f2f5ae5a8e2d8f9f = 60;
var $e6b828148d99ab2b$export$3c58128db900d44e = 3;
var $e6b828148d99ab2b$export$80d7e435f744f319 = 12;
var $e6b828148d99ab2b$export$4db7641526e3241f = 4;
var $e6b828148d99ab2b$export$698aec755e92c695 = 3600;
var $e6b828148d99ab2b$export$a77c1a7ebebe2a5a = 60;
var $e6b828148d99ab2b$export$815a9362476d2fe3 = $e6b828148d99ab2b$export$698aec755e92c695 * 24;
var $e6b828148d99ab2b$export$34804a017b31e2fe = $e6b828148d99ab2b$export$815a9362476d2fe3 * 7;
var $e6b828148d99ab2b$export$7271e9e3478110d1 = $e6b828148d99ab2b$export$815a9362476d2fe3 * $e6b828148d99ab2b$export$3913210603d8e9ae;
var $e6b828148d99ab2b$export$8e6600bbdee7dabb = $e6b828148d99ab2b$export$7271e9e3478110d1 / 12;
var $e6b828148d99ab2b$export$be1dccf2de902d31 = $e6b828148d99ab2b$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e6b828148d99ab2b$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e6b828148d99ab2b$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e6b828148d99ab2b$export$397c2d5776aa9055;

});

parcelRegister("g93kp", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc101184c63d7a7a$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $bc101184c63d7a7a$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $3yGK6.default)(2, arguments);
    return (0, $dkBOe.default)(dateLeft).getTime() - (0, $dkBOe.default)(dateRight).getTime();
}

});

parcelRegister("byLBW", function(module, exports) {
var $86a7cd36e9b99950$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $86a7cd36e9b99950$var$defaultRoundingMethod = 'trunc';
function $86a7cd36e9b99950$export$b6474a47258c1211(method) {
    return method ? $86a7cd36e9b99950$var$roundingMap[method] : $86a7cd36e9b99950$var$roundingMap[$86a7cd36e9b99950$var$defaultRoundingMethod];
}
module.exports["getRoundingMethod"] = $86a7cd36e9b99950$export$b6474a47258c1211;

});

parcelRegister("fNtG8", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8027429ed7dcbe2$export$2e2bcd8739ae039);

var $jO73f = parcelRequire("jO73f");


var $g93kp = parcelRequire("g93kp");


var $3yGK6 = parcelRequire("3yGK6");


var $byLBW = parcelRequire("byLBW");

function $b8027429ed7dcbe2$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $3yGK6.default)(2, arguments);
    var diff = (0, $g93kp.default)(dateLeft, dateRight) / (0, $jO73f.millisecondsInMinute);
    return (0, $byLBW.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("kOLTT", function(module, exports) {

let $f27da23382222d5a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f27da23382222d5a$var$load("fECCi").then(()=>parcelRequire('aebWh'));

});

parcelRegister("j3QkC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $laFNM = parcelRequire("laFNM");


var $f43UY = parcelRequire("f43UY");

const $98505e88072c3ce6$var$countByStatus = (approvers)=>approvers.reduce((counts, approver)=>{
        if (approver.status === 'REVIEWER_APPROVED') counts.approved++;
        else if (approver.status === 'REVIEWER_DENIED') counts.denied++;
        counts.total++;
        return counts;
    }, {
        approved: 0,
        denied: 0,
        total: 0
    });
const $98505e88072c3ce6$var$i18n = (0, $kSwu1.defineMessages)({
    approvedLabel: {
        id: "approvals.progress-bar.approved-label",
        defaultMessage: "{count} {count, plural, one {approved} other {approved}}"
    },
    deniedLabel: {
        id: "approvals.progress-bar.denied-label",
        defaultMessage: "{count} {count, plural, one {denied} other {denied}}"
    },
    ariaLabel: {
        id: "approvals.progress-bar.aria-label",
        defaultMessage: "Approvals progress"
    }
});
const $98505e88072c3ce6$export$b67a8dfe7ce21df4 = ()=>{
    const { approvalRequest: approvalRequest } = (0, $laFNM.useApprovals)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const approvers = approvalRequest?.review?.approvers;
    const { approved: approved, denied: denied, total: total } = (0, $cozmU.useMemo)(()=>$98505e88072c3ce6$var$countByStatus(approvers ?? []), [
        approvers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f43UY.MultiColorProgressBar), {
        segments: [
            {
                count: approved,
                color: "var(--ds-icon-success, #6A9A23)",
                label: formatMessage($98505e88072c3ce6$var$i18n.approvedLabel, {
                    count: approved
                })
            },
            {
                count: denied,
                color: "var(--ds-icon-accent-gray, #7D818A)",
                label: formatMessage($98505e88072c3ce6$var$i18n.deniedLabel, {
                    count: denied
                })
            }
        ],
        total: total,
        ariaLabel: formatMessage($98505e88072c3ce6$var$i18n.ariaLabel)
    });
};
module.exports["ApprovalsProgressBar"] = $98505e88072c3ce6$export$b67a8dfe7ce21df4;

});

parcelRegister("f43UY", function(module, exports) {
/* MultiColorProgressBar.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $lpNn5 = parcelRequire("lpNn5");

const $41481707d81a074d$var$borderRadius = "var(--ds-radius-small, 4px)";
const $41481707d81a074d$var$defaultBarColor = "var(--ds-background-neutral-bold, #292A2E)";
const $41481707d81a074d$var$styles = {
    container: "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _0jFU0VZimw _1mT5xdRAKS _0KLXruDMqu",
    segment: "_23rrnHt19n _3iDTPbvLZJ _0jFU0VZimw _1mT5xdWVPG"
};
const $41481707d81a074d$var$getSegmentBorderRadius = (isFirst, isLast)=>{
    if (isFirst && isLast) return $41481707d81a074d$var$borderRadius;
    if (isFirst) return `${$41481707d81a074d$var$borderRadius} 0 0 ${$41481707d81a074d$var$borderRadius}`;
    if (isLast) return `0 ${$41481707d81a074d$var$borderRadius} ${$41481707d81a074d$var$borderRadius} 0`;
    return '0';
};
const $41481707d81a074d$export$6fe94d7699460647 = ({ segments: segments, total: total, ariaLabel: ariaLabel, testId: testId = 'multi-color-progress-bar' })=>{
    const clampedTotal = Math.max(total, 0); // Precalculate segments
    const segmentLayout = (0, $cozmU.useMemo)(()=>{
        const activeIndices = segments.reduce((set, segment, index)=>{
            if (segment.count > 0) set.add(index);
            return set;
        }, new Set());
        let cumulative = 0;
        let activeIndex = 0;
        const activeCount = activeIndices.size;
        return segments.map((segment, index)=>{
            const isActive = activeIndices.has(index);
            const widthPercent = isActive && clampedTotal > 0 ? segment.count / clampedTotal * 100 : 0;
            const leftPercent = cumulative;
            cumulative += widthPercent;
            const isFirstActive = isActive && activeIndex === 0;
            const isLastActive = isActive && activeIndex === activeCount - 1;
            const gap = isActive && !isFirstActive ? 1 : 0;
            if (isActive) activeIndex++;
            return {
                widthPercent: widthPercent,
                leftPercent: leftPercent,
                color: segment.color,
                label: segment.label,
                isFirst: isFirstActive,
                isLast: isLastActive,
                gap: gap
            };
        });
    }, [
        segments,
        clampedTotal
    ]);
    // Used only for aria-valuenow
    const totalCount = (0, $cozmU.useMemo)(()=>segmentLayout.reduce((sum, segment)=>sum + segment.widthPercent, 0), [
        segmentLayout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": 0,
        "aria-valuenow": clampedTotal > 0 ? Math.round(totalCount / 100 * clampedTotal) : 0,
        "aria-valuemax": clampedTotal,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $41481707d81a074d$var$styles.container
        ])
    }, clampedTotal > 0 && segmentLayout.map((layout, index)=>{
        const segment = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: {
                left: `calc(${layout.leftPercent}% + ${layout.gap}px)`,
                width: `calc(${layout.widthPercent}% - ${layout.gap}px)`,
                backgroundColor: layout.color ?? $41481707d81a074d$var$defaultBarColor,
                borderRadius: $41481707d81a074d$var$getSegmentBorderRadius(layout.isFirst, layout.isLast)
            },
            "data-testid": `${testId}--segment-${index}`,
            className: (0, $hekY6.default)([
                $41481707d81a074d$var$styles.segment
            ])
        });
        return layout.label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            key: index,
            content: layout.label
        }, segment) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: index
        }, segment);
    }));
};
module.exports["MultiColorProgressBar"] = $41481707d81a074d$export$6fe94d7699460647;

});

parcelRegister("lJswu", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $a9aSv = parcelRequire("a9aSv");

const $668f42f1e7477ee9$export$ad2edbf08e0f7b11 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "60px",
            height: "20px",
            isShimmering: true,
            testId: "content-state-skeleton"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["ContentStateSkeleton"] = $668f42f1e7477ee9$export$ad2edbf08e0f7b11;

});

parcelRegister("iquRY", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $24WXz = parcelRequire("24WXz");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $cccaa992351fdb79$export$dcac763621aee435 = ()=>{
    const $ = (0, $bDgLe.c)(9);
    const { cloudId: cloudId, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !isLoggedIn;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1,
            onError: $cccaa992351fdb79$var$_temp
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $24WXz.default), {
        ...t2,
        __callerPackage__: "space-utils"
    });
    const isNotPreRoles = data?.confluence_spaceRoleMode ? data.confluence_spaceRoleMode !== "PRE_ROLES" : false;
    const t3 = data?.confluence_spaceRoleMode;
    let t4;
    if ($[5] !== isNotPreRoles || $[6] !== loading || $[7] !== t3) {
        t4 = {
            spaceRoleMode: t3,
            isRbacEnabled: isNotPreRoles,
            loading: loading
        };
        $[5] = isNotPreRoles;
        $[6] = loading;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
};
function $cccaa992351fdb79$var$_temp(error) {
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
}
module.exports["useSpaceRoleMode"] = $cccaa992351fdb79$export$dcac763621aee435;

});

parcelRegister("24WXz", function(module, exports) {
/**
 * @generated SignedSource<<2ff02ee1cce578f61d9a435abf2def2c>>
 * @relayHash 60ed41889a4cd98154a0419dcf1f59f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82
const $016cc5cc0310f39a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "60ed41889a4cd98154a0419dcf1f59f5",
            "id": "568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82",
            "metadata": {},
            "name": "useSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query useSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$016cc5cc0310f39a$var$node.hash = "88c4ae8983cc6692099b2b1e1d7a4379";
var $016cc5cc0310f39a$export$2e2bcd8739ae039 = $016cc5cc0310f39a$var$node;
module.exports["default"] = $016cc5cc0310f39a$export$2e2bcd8739ae039;

});

parcelRegister("iNJwL", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $d22b8e53da9786d0$export$795eadcf91da84fd = (0, $kSwu1.defineMessages)({
    maxLength: {
        id: "content-state.status.create.status.max.length",
        defaultMessage: "Max length of 20"
    },
    requiredErrorMessage: {
        id: "content-state.status.maker.error.message",
        defaultMessage: "Required"
    },
    emptyStatusFlagTitle: {
        id: "content-state.status.empty.status.flag.title",
        defaultMessage: "Your status can\u2019t be saved"
    },
    emptyStatusFlagDescription: {
        id: "content-state.status.empty.status.flag.description",
        defaultMessage: "Statuses must contain symbols or alphanumeric characters."
    },
    verifiedRestricted: {
        id: "content-state.verified-restricted",
        defaultMessage: "This content is verified. Only its owner or an admin can change its status."
    },
    verifiedRestrictedRbac: {
        id: "content-state.verified-restricted-rbac",
        defaultMessage: "This content is verified. Only its owner or someone with permission to manage all content in the space can change its status."
    },
    pageStatus: {
        id: "content-state.page-status",
        defaultMessage: "Status"
    },
    verifiedContentSpotlightTitle: {
        id: "content-state.verified-content.spotlight.title",
        defaultMessage: "Verified Content"
    },
    verifiedContentSpotlightAction: {
        id: "content-state.verified-content.spotlight.action",
        defaultMessage: "Set up automation"
    },
    newSpotlightTitle: {
        id: "content-state.automation-discovery.verified-content.title",
        defaultMessage: "Want to manage your verified pages?"
    },
    newSpotlightBody: {
        id: "content-state.automation-discovery.verified-content.body",
        defaultMessage: "Use Confluence automation to schedule reviews for verified content."
    },
    newSpotlightCta: {
        id: "content-state.automation-discovery.manual-trigger.cta.text",
        defaultMessage: "Build rule"
    },
    newSpotlightDismiss: {
        id: "content-state.automation-discovery.manual-trigger.dismiss",
        defaultMessage: "Done"
    }
});
module.exports["sharedi18n"] = $d22b8e53da9786d0$export$795eadcf91da84fd;

});

parcelRegister("3qCob", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $Uu0Pb = parcelRequire("Uu0Pb");


var $8miSe = parcelRequire("8miSe");

const $41e22d3f43a50651$var$MAX_ALLOWED_CUSTOM_STATES = 3;
function $41e22d3f43a50651$export$86566dc9e85acb0c(primaryColor) {
    const tokenPrimaryColor = (0, $8miSe.hexToToken)(primaryColor ?? (0, $Uu0Pb.PRIMARY_COLORS).BLUE);
    switch(tokenPrimaryColor){
        case (0, $Uu0Pb.PRIMARY_COLORS).BLUE:
            return (0, $Uu0Pb.SECONDARY_COLORS).BLUE;
        case (0, $Uu0Pb.PRIMARY_COLORS).GREEN:
            return (0, $Uu0Pb.SECONDARY_COLORS).GREEN;
        case (0, $Uu0Pb.PRIMARY_COLORS).YELLOW:
            return (0, $Uu0Pb.SECONDARY_COLORS).YELLOW;
        case (0, $Uu0Pb.PRIMARY_COLORS).RED:
            return (0, $Uu0Pb.SECONDARY_COLORS).RED;
        case (0, $Uu0Pb.PRIMARY_COLORS).PURPLE:
            return (0, $Uu0Pb.SECONDARY_COLORS).PURPLE;
        default:
            return (0, $Uu0Pb.SECONDARY_COLORS).BLUE;
    }
}
function $41e22d3f43a50651$export$6844ce2c0353a555(secondaryColor) {
    const tokenSecondaryColor = (0, $8miSe.hexToToken)(secondaryColor ?? (0, $Uu0Pb.SECONDARY_COLORS).BLUE);
    switch(tokenSecondaryColor){
        case (0, $Uu0Pb.SECONDARY_COLORS).BLUE:
            return (0, $Uu0Pb.HOVER_COLORS).BLUE;
        case (0, $Uu0Pb.SECONDARY_COLORS).GREEN:
            return (0, $Uu0Pb.HOVER_COLORS).GREEN;
        case (0, $Uu0Pb.SECONDARY_COLORS).YELLOW:
            return (0, $Uu0Pb.HOVER_COLORS).YELLOW;
        case (0, $Uu0Pb.SECONDARY_COLORS).RED:
            return (0, $Uu0Pb.HOVER_COLORS).RED;
        case (0, $Uu0Pb.SECONDARY_COLORS).PURPLE:
            return (0, $Uu0Pb.HOVER_COLORS).PURPLE;
        default:
            return (0, $Uu0Pb.HOVER_COLORS).BLUE;
    }
}
function $41e22d3f43a50651$export$ccc9fe24e363c71e(oldContentState, newContentState) {
    if (!oldContentState) return false; // can't be duplicate if we don't even have a content state originally
    return oldContentState.name === newContentState.name && oldContentState.color === newContentState.color;
}
function $41e22d3f43a50651$export$a2f9d64eff18382c(customStatesArray, newCustomState) {
    for(let i = 0; i < customStatesArray.length; ++i){
        if ($41e22d3f43a50651$export$ccc9fe24e363c71e(customStatesArray[i], newCustomState)) return {
            index: i,
            id: customStatesArray[i]?.id
        };
    }
    // if we don't find a match just return null
    return null;
}
function $41e22d3f43a50651$export$cd8fa131e8c8f91e(oldCustomStatesArray, newCustomState) {
    /* Need to check if the state user entered matches an existing custom one in the array.
   If it's a duplicate, it means the state the user just typed in is one that already exists. We must find the index
   and id in the old array and handle it like if an existing custom state was selected
    */ const idAndIndex = $41e22d3f43a50651$export$a2f9d64eff18382c(oldCustomStatesArray, newCustomState);
    if (idAndIndex) // user typed in an existing custom state
    return $41e22d3f43a50651$export$1c741d2b42a2932b(oldCustomStatesArray, {
        ...newCustomState,
        id: idAndIndex.id
    }, idAndIndex.index);
    else {
        const newArray = [
            newCustomState,
            ...oldCustomStatesArray
        ];
        if (newArray.length > $41e22d3f43a50651$var$MAX_ALLOWED_CUSTOM_STATES) newArray.pop();
        return newArray;
    }
}
function $41e22d3f43a50651$export$1c741d2b42a2932b(oldCustomStatesArray, selectedCustomState, index) {
    // removed the selected custom state by index and then add it to the top of the new array
    const newArray = [
        ...oldCustomStatesArray
    ];
    newArray.splice(index, 1);
    newArray.unshift(selectedCustomState);
    return newArray;
}
const $41e22d3f43a50651$export$7366fe55fc696c82 = 'temp-';
function $41e22d3f43a50651$export$b63091a1c8126966(oldCustomStatesArray, newCustomState) {
    // Drop null entries, the optimistic placeholder, and any prior entry that matches the
    // newly-created state by name or id, so the server state is added exactly once. The type
    // guard narrows the result to ContentState[] (no nulls survive the filter).
    const withoutPlaceholders = oldCustomStatesArray.filter((state)=>state != null && !state.id?.startsWith($41e22d3f43a50651$export$7366fe55fc696c82) && state.name !== newCustomState.name && (newCustomState.id == null || state.id !== newCustomState.id));
    const newArray = [
        newCustomState,
        ...withoutPlaceholders
    ];
    if (newArray.length > $41e22d3f43a50651$var$MAX_ALLOWED_CUSTOM_STATES) newArray.length = $41e22d3f43a50651$var$MAX_ALLOWED_CUSTOM_STATES;
    return newArray;
}
function $41e22d3f43a50651$export$6d0553ade1700746(appliedContentState, refetchedCustomStatesArray, defaultStatesArray, locallyKnownCustomStatesArray) {
    const isAppliedCustom = !!appliedContentState?.id && !defaultStatesArray.some((s)=>s?.id === appliedContentState.id);
    const missingFromRefetch = isAppliedCustom && !refetchedCustomStatesArray.some((s)=>s?.id === appliedContentState?.id);
    const knownLocally = locallyKnownCustomStatesArray.some((s)=>s?.id === appliedContentState?.id);
    if (missingFromRefetch && knownLocally && appliedContentState) return [
        appliedContentState,
        ...refetchedCustomStatesArray
    ];
    return refetchedCustomStatesArray;
}
module.exports["determineSecondaryColor"] = $41e22d3f43a50651$export$86566dc9e85acb0c;
module.exports["determineHoverColor"] = $41e22d3f43a50651$export$6844ce2c0353a555;
module.exports["isDuplicate"] = $41e22d3f43a50651$export$ccc9fe24e363c71e;
module.exports["createNewCustomStatesArrayWhenNewCustomAdded"] = $41e22d3f43a50651$export$cd8fa131e8c8f91e;
module.exports["createNewCustomStatesArrayWhenExistingCustomSelected"] = $41e22d3f43a50651$export$1c741d2b42a2932b;
module.exports["OPTIMISTIC_CUSTOM_STATE_ID_PREFIX"] = $41e22d3f43a50651$export$7366fe55fc696c82;
module.exports["reconcileCustomStatesAfterCreate"] = $41e22d3f43a50651$export$b63091a1c8126966;
module.exports["reAddAppliedCustomStatusIfMissing"] = $41e22d3f43a50651$export$6d0553ade1700746;

});

parcelRegister("3lWl0", function(module, exports) {
/**
 * @generated SignedSource<<f94631fe88bfaea1f9346228f17314d1>>
 * @relayHash e78f45ef84b0309b46cad2982bdd129a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d9dbad7f6be18f479464c7740ecc608e88f02669cea51d9e028e75b6b84f4eb9
const $34dd87dd4e33f987$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "format"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isApprovalsFgOn"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldSkipAvailableContentStates"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldSkipContentStateLastUpdated"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldSkipEditOnlyFields"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "Variable",
        "name": "isDraft",
        "variableName": "isDraft"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "color"
    }, v11 = {
        "kind": "ScalarField",
        "name": "restrictionLevel"
    }, v12 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v7 /*: any*/ ,
                {
                    "args": [
                        v8 /*: any*/ 
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        {
                            "condition": "shouldSkipEditOnlyFields",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isCallerPermitted"
                                }
                            ]
                        },
                        {
                            "condition": "isApprovalsFgOn",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifierAaid"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldSkipContentStateLastUpdated",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "format",
                                    "variableName": "format"
                                },
                                v8 /*: any*/ 
                            ],
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "contentStateLastUpdated",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "shouldSkipAvailableContentStates",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        }
                    ],
                    "concreteType": "AvailableContentStates",
                    "kind": "LinkedField",
                    "name": "availableContentStates",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentState",
                            "kind": "LinkedField",
                            "name": "customContentStates",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "ContentState",
                            "kind": "LinkedField",
                            "name": "spaceContentStates",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EditorContentStateQuery",
            "selections": v12 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EditorContentStateQuery",
            "selections": v12 /*: any*/ 
        },
        "params": {
            "cacheID": "e78f45ef84b0309b46cad2982bdd129a",
            "id": "d9dbad7f6be18f479464c7740ecc608e88f02669cea51d9e028e75b6b84f4eb9",
            "metadata": {},
            "name": "EditorContentStateQuery",
            "operationKind": "query",
            "text": "query EditorContentStateQuery($contentId:ID!,$isDraft:Boolean!,$isApprovalsFgOn:Boolean!,$format:GraphQLDateFormat!,$shouldSkipContentStateLastUpdated:Boolean!,$shouldSkipAvailableContentStates:Boolean=false,$shouldSkipEditOnlyFields:Boolean=false){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel,isCallerPermitted@skip(if:$shouldSkipEditOnlyFields),lastModifierAaid@include(if:$isApprovalsFgOn)},contentStateLastUpdated(format:$format,isDraft:$isDraft)@skip(if:$shouldSkipContentStateLastUpdated){value}},availableContentStates(contentId:$contentId)@skip(if:$shouldSkipAvailableContentStates){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}}}"
        }
    };
}();
$34dd87dd4e33f987$var$node.hash = "f76426744ff28f16601d3ae4d51a17fb";
var $34dd87dd4e33f987$export$2e2bcd8739ae039 = $34dd87dd4e33f987$var$node;
module.exports["default"] = $34dd87dd4e33f987$export$2e2bcd8739ae039;

});

parcelRegister("jWGRt", function(module, exports) {
const $2beb71e9ce2a4a0d$export$16eeafc73450b798 = '1';
const $2beb71e9ce2a4a0d$export$5dcb757926e5c553 = '2';
const $2beb71e9ce2a4a0d$export$1fa7ec55e4b214fc = '3';
const $2beb71e9ce2a4a0d$export$60a5374cbd841135 = '-1';
const $2beb71e9ce2a4a0d$export$e4aeed0e7e008f87 = 'https://support.atlassian.com/confluence-cloud/docs/request-and-manage-approvals-in-confluence/';
module.exports["IN_REVIEW_STATUS_ID"] = $2beb71e9ce2a4a0d$export$16eeafc73450b798;
module.exports["APPROVED_STATUS_ID"] = $2beb71e9ce2a4a0d$export$5dcb757926e5c553;
module.exports["CHANGES_REQUESTED_STATUS_ID"] = $2beb71e9ce2a4a0d$export$1fa7ec55e4b214fc;
module.exports["NO_STATUS_CONTENT_STATE_ID"] = $2beb71e9ce2a4a0d$export$60a5374cbd841135;
module.exports["APPROVALS_LEARN_MORE_URL"] = $2beb71e9ce2a4a0d$export$e4aeed0e7e008f87;

});

parcelRegister("lsxnT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $cozmU.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $cozmU.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $cozmU.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("i3jcY", function(module, exports) {

const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return (window.location.search ?? '').includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("f5Hmr", function(module, exports) {
/**
 * Deprecated - This file will be removed in the future. Please reach out to #cc-ai-growth for details before use. Please read https://hello.atlassian.net/wiki/spaces/CE2/pages/2797298237/Contribution+Consumption+Guidelines+For+Common+Feature+Gate+Upsell+Component
 **/ 
var $jmjWc = parcelRequire("jmjWc");


const $430dd6df5b6da813$export$2f4bd8d23e81b246 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vvwA7",
    name: "UpgradeEditionButton",
    loader: async ()=>(await (parcelRequire("3PSYO"))).UpgradeEditionButton
});
module.exports["UpgradeEditionButton"] = $430dd6df5b6da813$export$2f4bd8d23e81b246;

});

parcelRegister("3PSYO", function(module, exports) {

let $2cb0c8628079012e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2cb0c8628079012e$var$load("1qlDN"),
    $2cb0c8628079012e$var$load("1yVM6")
]).then(()=>parcelRequire('ki6F7'));

});

parcelRegister("i1t43", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");

var $iMnC5 = parcelRequire("iMnC5");

const $7e44050607850249$var$styles = {
    base: "_0bjKvDcjp5 _0WKd3G4z3T",
    visitedLink: "_2nTuUYWfPD _3ADzdEWfPD _1warJ9WfPD _4scvAwWyeI",
    defaultAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0clgaMM7Tp _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8 _0CMRbkAwSC",
    defaultAppearanceMotion: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMM7Tp _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbkAwSC",
    subtleAppearance: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzZpcK _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _0CMRbky7kJ",
    subtleAppearanceMotion: "_00uqCYjOvk _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzZpcK _32C2rkjOvk _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbky7kJ",
    inverseAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0clgaMe5R3 _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8 _0CMRbke5R3",
    inverseAppearanceMotion: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMe5R3 _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbke5R3",
    iconWrapper: "_3iDTPbS8kF _1ANEUSLRg7 _1RrJLiQame _1mT5xdRAKS _2I62gzVQEB"
};
const $7e44050607850249$var$iconStyles = null;
const $7e44050607850249$var$LinkWithoutRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(30);
    let children;
    let htmlAttributes;
    let newWindowLabel;
    let t1;
    let target;
    let testId;
    if ($[0] !== t0) {
        const { children: t2, testId: t3, appearance: t4, newWindowLabel: t5, target: t6, className: _preventedClassName, style: _preventedStyle, ...t7 } = t0;
        children = t2;
        testId = t3;
        t1 = t4;
        newWindowLabel = t5;
        target = t6;
        htmlAttributes = t7;
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = newWindowLabel;
        $[4] = t1;
        $[5] = target;
        $[6] = testId;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        newWindowLabel = $[3];
        t1 = $[4];
        target = $[5];
        testId = $[6];
    }
    const appearance = t1 === undefined ? "default" : t1;
    let t2;
    if ($[7] !== appearance) {
        t2 = appearance === "default" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance);
        $[7] = appearance;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== appearance) {
        t3 = appearance === "subtle" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance);
        $[9] = appearance;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== appearance) {
        t4 = appearance === "inverse" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance);
        $[11] = appearance;
        $[12] = t4;
    } else t4 = $[12];
    const t5 = appearance !== "inverse" && $7e44050607850249$var$styles.visitedLink;
    let t6;
    if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
        t6 = (0, $w6R6I.cx)($7e44050607850249$var$styles.base, t2, t3, t4, t5);
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== target || $[19] !== testId) {
        t7 = target === "_blank" && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            as: "span",
            xcss: $7e44050607850249$var$styles.iconWrapper,
            testId: testId && `${testId}__icon`,
            children: [
                "\uFEFF",
                /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    className: (0, $hekY6.default)([
                        "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                        fill: "currentColor"
                    })
                })
            ]
        });
        $[18] = target;
        $[19] = testId;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== children || $[22] !== htmlAttributes || $[23] !== newWindowLabel || $[24] !== ref || $[25] !== t6 || $[26] !== t7 || $[27] !== target || $[28] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor), {
            ...htmlAttributes,
            target: target,
            ref: ref,
            xcss: t6,
            testId: testId,
            componentName: "Link",
            newWindowLabel: newWindowLabel,
            children: [
                children,
                t7
            ]
        });
        $[21] = children;
        $[22] = htmlAttributes;
        $[23] = newWindowLabel;
        $[24] = ref;
        $[25] = t6;
        $[26] = t7;
        $[27] = target;
        $[28] = testId;
        $[29] = t8;
    } else t8 = $[29];
    return t8;
} : ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $w6R6I.cx)($7e44050607850249$var$styles.base, appearance === 'default' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance), appearance === 'subtle' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance), appearance === 'inverse' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance), // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $7e44050607850249$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                as: "span",
                xcss: $7e44050607850249$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $hekY6.default)([
                            "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                        ]),
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    }); // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $7e44050607850249$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)($7e44050607850249$var$LinkWithoutRef);
var $7e44050607850249$export$2e2bcd8739ae039 = $7e44050607850249$var$Link;
module.exports["default"] = $7e44050607850249$export$2e2bcd8739ae039;

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

const $abc73c6f5c74c436$export$6d558eab13290f59 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
module.exports["useRouterLink"] = $abc73c6f5c74c436$export$6d558eab13290f59;

});

parcelRegister("ac2J9", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1,
            children: children
        });
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("gTPfK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");

const $6057e25d3e7f93e3$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
            const $ = (0, $bDgLe.c)(11);
            let analyticsContext;
            let rest;
            if ($[0] !== t0) {
                ({ analyticsContext: analyticsContext, ...rest } = t0);
                $[0] = t0;
                $[1] = analyticsContext;
                $[2] = rest;
            } else {
                analyticsContext = $[1];
                rest = $[2];
            }
            let t1;
            if ($[3] !== analyticsContext) {
                t1 = {
                    ...defaultData,
                    ...analyticsContext
                };
                $[3] = analyticsContext;
                $[4] = t1;
            } else t1 = $[4];
            const analyticsData = t1;
            const t2 = rest;
            let t3;
            if ($[5] !== ref || $[6] !== t2) {
                t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                    ...t2,
                    ref: ref
                });
                $[5] = ref;
                $[6] = t2;
                $[7] = t3;
            } else t3 = $[7];
            let t4;
            if ($[8] !== analyticsData || $[9] !== t3) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                    data: analyticsData
                }, t3);
                $[8] = analyticsData;
                $[9] = t3;
                $[10] = t4;
            } else t4 = $[10];
            return t4;
        } : ({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $cozmU.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                ...rest,
                ref: ref
            }));
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $6057e25d3e7f93e3$export$2e2bcd8739ae039 = $6057e25d3e7f93e3$var$withAnalyticsContext;
module.exports["default"] = $6057e25d3e7f93e3$export$2e2bcd8739ae039;

});

parcelRegister("as9lu", function(module, exports) {

var $aQ0yV = parcelRequire("aQ0yV");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/identity/user/manifest.ts
var $79c3c4c484846d28$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $aQ0yV.IdentityUserAriResourceOwner),
    resourceType: (0, $aQ0yV.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $79c3c4c484846d28$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $1gKSA.RegisteredAri) {
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $79c3c4c484846d28$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $79c3c4c484846d28$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $79c3c4c484846d28$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $79c3c4c484846d28$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $79c3c4c484846d28$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $79c3c4c484846d28$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
    constructor(opts){
        super(opts), this._userId = opts.resourceIdSegmentValues.userId;
    }
};
module.exports["IdentityUserAri"] = $79c3c4c484846d28$export$1e9d09c2be53e55e;

});

parcelRegister("aQ0yV", function(module, exports) {
// src/identity/user/types.ts
var $7e3f325f95b56bab$export$b4c14c54282a779d = "identity", $7e3f325f95b56bab$export$e9b50e20f4fbfb71 = "user";
module.exports["IdentityUserAriResourceOwner"] = $7e3f325f95b56bab$export$b4c14c54282a779d;
module.exports["IdentityUserAriResourceType"] = $7e3f325f95b56bab$export$e9b50e20f4fbfb71;

});

parcelRegister("k5sGX", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9fa87e3de3aa88c$export$2e2bcd8739ae039);

var $jO73f = parcelRequire("jO73f");


var $3yGK6 = parcelRequire("3yGK6");


var $kr6hK = parcelRequire("kr6hK");

function $e9fa87e3de3aa88c$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $3yGK6.default)(1, arguments);
    var additionalDigits = (0, $kr6hK.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $e9fa87e3de3aa88c$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $e9fa87e3de3aa88c$var$parseYear(dateStrings.date, additionalDigits);
        date = $e9fa87e3de3aa88c$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $e9fa87e3de3aa88c$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $e9fa87e3de3aa88c$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $e9fa87e3de3aa88c$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $e9fa87e3de3aa88c$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $e9fa87e3de3aa88c$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $e9fa87e3de3aa88c$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $e9fa87e3de3aa88c$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($e9fa87e3de3aa88c$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($e9fa87e3de3aa88c$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($e9fa87e3de3aa88c$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $e9fa87e3de3aa88c$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $e9fa87e3de3aa88c$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $e9fa87e3de3aa88c$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($e9fa87e3de3aa88c$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $e9fa87e3de3aa88c$var$parseDateUnit(captures[1]);
    var month = $e9fa87e3de3aa88c$var$parseDateUnit(captures[2]) - 1;
    var day = $e9fa87e3de3aa88c$var$parseDateUnit(captures[3]);
    var week = $e9fa87e3de3aa88c$var$parseDateUnit(captures[4]);
    var dayOfWeek = $e9fa87e3de3aa88c$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$e9fa87e3de3aa88c$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $e9fa87e3de3aa88c$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$e9fa87e3de3aa88c$var$validateDate(year, month, day) || !$e9fa87e3de3aa88c$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $e9fa87e3de3aa88c$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $e9fa87e3de3aa88c$var$parseTime(timeString) {
    var captures = timeString.match($e9fa87e3de3aa88c$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[1]);
    var minutes = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[2]);
    var seconds = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[3]);
    if (!$e9fa87e3de3aa88c$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jO73f.millisecondsInHour) + minutes * (0, $jO73f.millisecondsInMinute) + seconds * 1000;
}
function $e9fa87e3de3aa88c$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $e9fa87e3de3aa88c$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($e9fa87e3de3aa88c$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$e9fa87e3de3aa88c$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jO73f.millisecondsInHour) + minutes * (0, $jO73f.millisecondsInMinute));
}
function $e9fa87e3de3aa88c$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $e9fa87e3de3aa88c$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $e9fa87e3de3aa88c$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $e9fa87e3de3aa88c$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($e9fa87e3de3aa88c$var$daysInMonths[month] || ($e9fa87e3de3aa88c$var$isLeapYearIndex(year) ? 29 : 28));
}
function $e9fa87e3de3aa88c$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($e9fa87e3de3aa88c$var$isLeapYearIndex(year) ? 366 : 365);
}
function $e9fa87e3de3aa88c$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $e9fa87e3de3aa88c$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $e9fa87e3de3aa88c$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("jgqX6", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0646b18c90b3a18$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3c3I9 = parcelRequire("3c3I9");


var $eYSi7 = parcelRequire("eYSi7");


var $3yGK6 = parcelRequire("3yGK6");


var $2iY37 = parcelRequire("2iY37");

function $e0646b18c90b3a18$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var sign = (0, $eYSi7.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $3c3I9.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $eYSi7.default)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $2iY37.default)((0, $dkBOe.default)(dirtyDateLeft)) && difference === 1 && (0, $eYSi7.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("3c3I9", function(module, exports) {
$parcel$export(module.exports, "default", () => $25355f04f79cc351$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $25355f04f79cc351$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("eYSi7", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae80c86a80ef7d08$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $ae80c86a80ef7d08$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("2iY37", function(module, exports) {
$parcel$export(module.exports, "default", () => $1adbd7c5d1b8dbaa$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $1Ltep = parcelRequire("1Ltep");


var $WeoLw = parcelRequire("WeoLw");


var $3yGK6 = parcelRequire("3yGK6");

function $1adbd7c5d1b8dbaa$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    return (0, $1Ltep.default)(date).getTime() === (0, $WeoLw.default)(date).getTime();
}

});

parcelRegister("1Ltep", function(module, exports) {
$parcel$export(module.exports, "default", () => $1490daf4e920e8da$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $1490daf4e920e8da$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("WeoLw", function(module, exports) {
$parcel$export(module.exports, "default", () => $0af0962005736f62$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $0af0962005736f62$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("iKWdo", function(module, exports) {

var $j6gAQ = parcelRequire("j6gAQ");


var $1Rned = parcelRequire("1Rned");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $da79ae2b1521df52$var$uniqBy(array, iteratee) {
    return array && array.length ? $1Rned(array, $j6gAQ(iteratee, 2)) : [];
}
module.exports = $da79ae2b1521df52$var$uniqBy;

});

parcelRegister("1Rned", function(module, exports) {

var $dLza3 = parcelRequire("dLza3");


var $gqaVn = parcelRequire("gqaVn");


var $3wyDU = parcelRequire("3wyDU");


var $jG16D = parcelRequire("jG16D");


var $4sYWJ = parcelRequire("4sYWJ");


var $j8WYy = parcelRequire("j8WYy");

/** Used as the size to enable large array optimizations. */ var $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $15acc2503c30cdc7$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $gqaVn, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $3wyDU;
    } else if (length >= $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $4sYWJ(array);
        if (set) return $j8WYy(set);
        isCommon = false;
        includes = $jG16D;
        seen = new $dLza3;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $15acc2503c30cdc7$var$baseUniq;

});

parcelRegister("gqaVn", function(module, exports) {

var $62lK8 = parcelRequire("62lK8");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $bf478c6b28a93eba$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $62lK8(array, value, 0) > -1;
}
module.exports = $bf478c6b28a93eba$var$arrayIncludes;

});

parcelRegister("62lK8", function(module, exports) {

var $7jN2X = parcelRequire("7jN2X");


var $4Jcz7 = parcelRequire("4Jcz7");


var $jMyMb = parcelRequire("jMyMb");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $4653cbb84a510850$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $jMyMb(array, value, fromIndex) : $7jN2X(array, $4Jcz7, fromIndex);
}
module.exports = $4653cbb84a510850$var$baseIndexOf;

});

parcelRegister("7jN2X", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $55405a69ad8b093d$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $55405a69ad8b093d$var$baseFindIndex;

});

parcelRegister("4Jcz7", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $37151c9a2b945fe4$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $37151c9a2b945fe4$var$baseIsNaN;

});

parcelRegister("jMyMb", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e66d79db7455d8ea$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $e66d79db7455d8ea$var$strictIndexOf;

});

parcelRegister("3wyDU", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $290f3b94ccd981c7$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $290f3b94ccd981c7$var$arrayIncludesWith;

});

parcelRegister("4sYWJ", function(module, exports) {

var $lE8ES = parcelRequire("lE8ES");


var $jEK83 = parcelRequire("jEK83");


var $j8WYy = parcelRequire("j8WYy");

/** Used as references for various `Number` constants. */ var $34090d9ff4ab3dd6$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $34090d9ff4ab3dd6$var$createSet = !($lE8ES && 1 / $j8WYy(new $lE8ES([
    ,
    -0
]))[1] == $34090d9ff4ab3dd6$var$INFINITY) ? $jEK83 : function(values) {
    return new $lE8ES(values);
};
module.exports = $34090d9ff4ab3dd6$var$createSet;

});

parcelRegister("jEK83", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $e4f588fe3a77f67d$var$noop() {
// No operation performed.
}
module.exports = $e4f588fe3a77f67d$var$noop;

});

parcelRegister("cD1qu", function(module, exports) {
var $7825447594ee3eb0$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}({});
var $7825447594ee3eb0$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "current";
    ContentStatus["DRAFT"] = "draft";
    ContentStatus["ARCHIVED"] = "archived";
    return ContentStatus;
}({});
const $7825447594ee3eb0$export$5d7c5e13dde1e9b8 = [
    "draft"
];
const $7825447594ee3eb0$export$c75005e52070dee = [
    "current"
];
module.exports["PageMode"] = $7825447594ee3eb0$export$6ea4b0c62affbe44;
module.exports["ContentStatus"] = $7825447594ee3eb0$export$b2be22e9d5dd3927;
module.exports["DRAFT_STATUS"] = $7825447594ee3eb0$export$5d7c5e13dde1e9b8;
module.exports["CURRENT_STATUS"] = $7825447594ee3eb0$export$c75005e52070dee;

});

parcelRegister("9NPFC", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


const $60cc37ad75899268$var$tileSizePx = {
    xxsmall: 16,
    xsmall: 20,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
const $60cc37ad75899268$var$styles = {
    root: "_0bjKvD0O7w _4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _3iDTPbccYA _24h04i2Njc _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _2O5VijdnbC _4ouGXIdnbC _4kiQYAdnbC _1RrJLit2nV",
    border: "_2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67",
    inset: "_3B3jB1IZbP _0LETLXIZbP _4ACwSfIZbP _2Qxi4nIZbP",
    nonInset: "_49oNbqN91d _1tJeXfN91d _0VARMJN91d _27VeLCN91d _3B3jB1N91d _0LETLXN91d _4ACwSfN91d _2Qxi4nN91d _3G0Ib8iObl"
};
const $60cc37ad75899268$var$sizeMap = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F _4ya3eEuFDC",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1 _4ya3eExpxF",
    small: "_39xV02oWWg _0jFU0VoWWg _4ya3eEEbN9",
    medium: "_39xV02Uofl _0jFU0VUofl _4ya3eEey7F",
    large: "_39xV02UF4f _0jFU0VUF4f _4ya3eESPN1",
    xlarge: "_39xV02pJKa _0jFU0VpJKa _4ya3eEoWWg"
};
const $60cc37ad75899268$var$insetSizeMap = {
    xxsmall: "_49oNbquFDC _1tJeXfuFDC _0VARMJuFDC _27VeLCuFDC _0mzAWiNKBH _3woHNtNKBH _430i96NKBH _1GBPVvNKBH",
    xsmall: "_49oNbqxpxF _1tJeXfxpxF _0VARMJxpxF _27VeLCxpxF _0mzAWiqBG1 _3woHNtqBG1 _430i96qBG1 _1GBPVvqBG1",
    small: "_49oNbqEbN9 _1tJeXfEbN9 _0VARMJEbN9 _27VeLCEbN9 _0mzAWif9wp _3woHNtf9wp _430i96f9wp _1GBPVvf9wp",
    medium: "_49oNbqey7F _1tJeXfey7F _0VARMJey7F _27VeLCey7F _0mzAWiIRC9 _3woHNtIRC9 _430i96IRC9 _1GBPVvIRC9",
    large: "_49oNbqSPN1 _1tJeXfSPN1 _0VARMJSPN1 _27VeLCSPN1 _0mzAWiPcut _3woHNtPcut _430i96Pcut _1GBPVvPcut",
    xlarge: "_49oNbqoWWg _1tJeXfoWWg _0VARMJoWWg _27VeLCoWWg _0mzAWiY6u9 _3woHNtY6u9 _430i96Y6u9 _1GBPVvY6u9"
};
const $60cc37ad75899268$var$backgroundColorMap = {
    white: "_0KLXrut28M",
    black: "_0KLXru52mJ",
    transparent: "_0KLXrujOvk",
    'color.background.accent.lime.subtlest': "_0KLXruXL80",
    'color.background.accent.lime.subtler': "_0KLXruuKDS",
    'color.background.accent.lime.subtle': "_0KLXruZcd0",
    'color.background.accent.lime.bolder': "_0KLXrubYhN",
    'color.background.accent.red.subtlest': "_0KLXrusDFP",
    'color.background.accent.red.subtler': "_0KLXrubV9i",
    'color.background.accent.red.subtle': "_0KLXru0cUQ",
    'color.background.accent.red.bolder': "_0KLXruQrW1",
    'color.background.accent.orange.subtlest': "_0KLXru2QQR",
    'color.background.accent.orange.subtler': "_0KLXruwJ86",
    'color.background.accent.orange.subtle': "_0KLXruuwVU",
    'color.background.accent.orange.bolder': "_0KLXrux4f7",
    'color.background.accent.yellow.subtlest': "_0KLXru56u3",
    'color.background.accent.yellow.subtler': "_0KLXruLv9B",
    'color.background.accent.yellow.subtle': "_0KLXruC29w",
    'color.background.accent.yellow.bolder': "_0KLXruYB6L",
    'color.background.accent.green.subtlest': "_0KLXruV6wL",
    'color.background.accent.green.subtler': "_0KLXruNUep",
    'color.background.accent.green.subtle': "_0KLXru50ZN",
    'color.background.accent.green.bolder': "_0KLXrude1t",
    'color.background.accent.teal.subtlest': "_0KLXruuBpz",
    'color.background.accent.teal.subtler': "_0KLXrunfgW",
    'color.background.accent.teal.subtle': "_0KLXrufjGw",
    'color.background.accent.teal.bolder': "_0KLXruzHaB",
    'color.background.accent.blue.subtlest': "_0KLXruVva3",
    'color.background.accent.blue.subtler': "_0KLXrup9dS",
    'color.background.accent.blue.subtle': "_0KLXru28sy",
    'color.background.accent.blue.bolder': "_0KLXrutfbE",
    'color.background.accent.purple.subtlest': "_0KLXruB8KG",
    'color.background.accent.purple.subtler': "_0KLXruWOdT",
    'color.background.accent.purple.subtle': "_0KLXruf89Q",
    'color.background.accent.purple.bolder': "_0KLXruhdss",
    'color.background.accent.magenta.subtlest': "_0KLXru8frT",
    'color.background.accent.magenta.subtler': "_0KLXruXM4x",
    'color.background.accent.magenta.subtle': "_0KLXrupmfs",
    'color.background.accent.magenta.bolder': "_0KLXruxE6Y",
    'color.background.accent.gray.subtlest': "_0KLXrumhAQ",
    'color.background.accent.gray.subtler': "_0KLXruG6qS",
    'color.background.accent.gray.subtle': "_0KLXrueZ10",
    'color.background.accent.gray.bolder': "_0KLXrurxgm",
    'color.background.inverse.subtle': "_0KLXruB4sa",
    'color.background.neutral': "_0KLXruDMqu",
    'color.background.neutral.bold': "_0KLXrugozt",
    'color.background.brand.subtlest': "_0KLXrunl7T",
    'color.background.brand.bold': "_0KLXruDM2k",
    'color.background.brand.boldest': "_0KLXru2o0p",
    'color.background.danger': "_0KLXruhH7k",
    'color.background.danger.bold': "_0KLXruqsXs",
    'color.background.warning': "_0KLXruhxIM",
    'color.background.warning.bold': "_0KLXruKLKE",
    'color.background.success': "_0KLXruzaZe",
    'color.background.success.bold': "_0KLXruhbjP",
    'color.background.discovery': "_0KLXru94rk",
    'color.background.discovery.bold': "_0KLXruqjHC",
    'color.background.information': "_0KLXrugNg3",
    'color.background.information.bold': "_0KLXruASYT"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
const $60cc37ad75899268$var$Tile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Tile(props) {
    const $ = (0, $bDgLe.c)(17);
    const { children: children, label: label, size: t0, backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: t1, testId: testId } = props;
    const size = t0 === undefined ? "medium" : t0;
    const isInset = t1 === undefined ? true : t1;
    const containerRef = (0, $cozmU.useRef)(null);
    let t2;
    if ($[0] !== size) {
        t2 = ()=>{
            return;
        };
        $[0] = size;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== size) {
        t3 = [
            children,
            size
        ];
        $[2] = children;
        $[3] = size;
        $[4] = t3;
    } else t3 = $[4];
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = label !== "" ? label : undefined;
    const t5 = label !== "" ? "img" : undefined;
    const t6 = $60cc37ad75899268$var$sizeMap[size];
    const t7 = isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset;
    const t8 = isInset && $60cc37ad75899268$var$insetSizeMap[size];
    const t9 = $60cc37ad75899268$var$backgroundColorMap[backgroundColor || "color.background.neutral"];
    const t10 = hasBorder && $60cc37ad75899268$var$styles.border;
    let t11;
    if ($[5] !== t10 || $[6] !== t6 || $[7] !== t7 || $[8] !== t8 || $[9] !== t9) {
        t11 = (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            t6,
            t7,
            t8,
            t9,
            t10
        ]);
        $[5] = t10;
        $[6] = t6;
        $[7] = t7;
        $[8] = t8;
        $[9] = t9;
        $[10] = t11;
    } else t11 = $[10];
    let t12;
    if ($[11] !== children || $[12] !== t11 || $[13] !== t4 || $[14] !== t5 || $[15] !== testId) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            ref: containerRef,
            "data-testid": testId,
            "aria-label": t4,
            role: t5,
            className: t11,
            children: children
        });
        $[11] = children;
        $[12] = t11;
        $[13] = t4;
        $[14] = t5;
        $[15] = testId;
        $[16] = t12;
    } else t12 = $[16];
    return t12;
} : function Tile(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    const containerRef = (0, $cozmU.useRef)(null); // Dev-mode only: validate that raster images passed into the tile
    // are square and retina-compatible (at least 2x the rendered tile size).
    (0, $cozmU.useEffect)(()=>{
        return;
    }, [
        children,
        size
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ref: containerRef,
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            $60cc37ad75899268$var$sizeMap[size],
            isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset,
            isInset && $60cc37ad75899268$var$insetSizeMap[size],
            $60cc37ad75899268$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $60cc37ad75899268$var$styles.border
        ]),
        children: children
    });
};
var $60cc37ad75899268$export$2e2bcd8739ae039 = $60cc37ad75899268$var$Tile;
function $60cc37ad75899268$var$_temp(fn) {
    return fn();
}
module.exports["default"] = $60cc37ad75899268$export$2e2bcd8739ae039;

});

parcelRegister("4Qc44", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5936b606760a760$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $e5936b606760a760$export$2e2bcd8739ae039 = (0, $cozmU.forwardRef);

});

parcelRegister("iDdTC", function(module, exports) {

var $9aI7t = parcelRequire("9aI7t");


var $b5593 = parcelRequire("b5593");


var $b90aI = parcelRequire("b90aI");


var $1Ht4b = parcelRequire("1Ht4b");


var $aaEQD = parcelRequire("aaEQD");

const $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54 = {
    pageLoad: $1Ht4b.pageLoad,
    pageSegmentLoad: $aaEQD.pageSegmentLoad,
    interaction: $b90aI.interaction,
    custom: $b5593.custom,
    concurrent: $9aI7t.concurrent
};
module.exports["metrics"] = $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54;

});

parcelRegister("9aI7t", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $b5593 = parcelRequire("b5593");


var $b90aI = parcelRequire("b90aI");

const $95763ae236d73d99$var$concurrentMetrics = {};
const $95763ae236d73d99$var$getKey = (config, type)=>`${type}--${config.key}`;
const $95763ae236d73d99$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $95763ae236d73d99$var$ensurePath = (config, type)=>{
    const key = $95763ae236d73d99$var$getKey(config, type);
    if (!(key in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[key] = {};
};
const $95763ae236d73d99$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $95763ae236d73d99$var$getKey(config, type);
    if (concurrentKey in $95763ae236d73d99$var$concurrentMetrics && $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $95763ae236d73d99$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $95763ae236d73d99$var$validateConfig(config);
    $95763ae236d73d99$var$ensurePath(config, type);
    const metricFromCache = $95763ae236d73d99$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $lCTbz.BMEventsType).INLINE_RESULT ? (0, $b90aI.interaction) : (0, $b5593.custom);
    const metric = metricFactory(config);
    $95763ae236d73d99$var$concurrentMetrics[$95763ae236d73d99$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $95763ae236d73d99$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $95763ae236d73d99$export$370df09ecc3de059;

});

parcelRegister("b5593", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $lCTbz = parcelRequire("lCTbz");

const $39f57926a8ef795b$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).CUSTOM
    });
};
module.exports["custom"] = $39f57926a8ef795b$export$4c00f665f0d4b443;

});

parcelRegister("ipFlS", function(module, exports) {

var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $7IphZ = parcelRequire("7IphZ");

class $4db3d4178d03c3ea$export$efdd3e096bc27746 extends (0, $7IphZ.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $hvVQt.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $581yf.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $4db3d4178d03c3ea$export$efdd3e096bc27746;

});

parcelRegister("b90aI", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $lCTbz = parcelRequire("lCTbz");

const $060787d14b6a30d6$export$92473e6020ad89b4 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).INLINE_RESULT
    });
};
module.exports["interaction"] = $060787d14b6a30d6$export$92473e6020ad89b4;

});

parcelRegister("1Ht4b", function(module, exports) {

var $3L5Pu = parcelRequire("3L5Pu");


var $lCTbz = parcelRequire("lCTbz");

const $a55ff36d094d83ef$export$791d520f7e8058a5 = (config)=>{
    return new (0, $3L5Pu.PageLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_LOAD
    });
};
module.exports["pageLoad"] = $a55ff36d094d83ef$export$791d520f7e8058a5;

});

parcelRegister("3L5Pu", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $jk8rA = parcelRequire("jk8rA");


var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $lCTbz = parcelRequire("lCTbz");


var $2QFOI = parcelRequire("2QFOI");


var $wgCbG = parcelRequire("wgCbG");


var $eNslE = parcelRequire("eNslE");

class $bbca0ae0eaeecc15$export$3c51073271a9eac3 extends (0, $2QFOI.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $wgCbG.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $wgCbG.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $wgCbG.pageLoadMetaMetric).markFMP(mark);
            } else (0, $wgCbG.pageLoadMetaMetric).markFMP(this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $hvVQt.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $581yf.submitter).queue(data);
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $wgCbG.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $wgCbG.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $581yf.submitter).config.configChunk;
        if (!configChunk?.[(0, $lCTbz.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $eNslE.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $581yf.submitter).queue(webVitalMetric.getData());
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $bbca0ae0eaeecc15$export$3c51073271a9eac3;

});

parcelRegister("eNslE", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");

class $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7 extends (0, $7IphZ.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $lCTbz.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $7IphZ.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7;

});

parcelRegister("aaEQD", function(module, exports) {

var $h51B5 = parcelRequire("h51B5");


var $lCTbz = parcelRequire("lCTbz");

const $2eb5124fdb2b6158$export$94114666844d5f66 = (config)=>{
    return new (0, $h51B5.PageSegmentLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
module.exports["pageSegmentLoad"] = $2eb5124fdb2b6158$export$94114666844d5f66;

});

parcelRegister("h51B5", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");


var $ipFlS = parcelRequire("ipFlS");


var $wgCbG = parcelRequire("wgCbG");

class $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1 extends (0, $ipFlS.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $lCTbz.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $7IphZ.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $7IphZ.MetricState).STARTED) (0, $wgCbG.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1;

});

parcelRegister("fQ3iN", function(module, exports) {
/**
 * BM3 Deprecation Phase 2 — gated wrapper around the raw BM3 page-segment-load factory.
 *
 * This file is the canonical implementation behind the public name
 * `createPageSegmentLoadMetric` (re-exported from
 * `@confluence/browser-metrics/entry-points/metricConfigs.ts`). All Confluence consumers
 * call the gated variant by virtue of importing the public name; there is no separate
 * "raw" public entry point.
 *
 * When the `cc_bm3_deprecation_phase_2` gate is OFF (default), every method call delegates
 * verbatim to the underlying BM3 PageSegmentLoadMetric so existing behaviour and the BM3
 * `PAGE_SEGMENT_LOAD` analytics events are preserved.
 *
 * When the gate is ON, the BM3 calls are skipped and equivalent UFO custom marks / custom
 * data are emitted instead. This lets us roll out the removal of the BM3 page-segment-load
 * events incrementally — controlled by Statsig — without touching any of the ~25
 * perf.config files or ~20 imperative call sites. Consumers continue to use
 * `METRIC.start()`, `.stop()`, `.cancel()`, `.mark()`, `.markFMP()`,
 * `.startFromPageLoad()` exactly as before; the gate decision is centralised here.
 *
 * The gate `fg(...)` is evaluated **inline at the callsite of each method**, never aliased
 * or wrapped, in line with the feature-gate-and-experiment-usage AGENTS guidance. Per-method
 * (rather than per-construction) evaluation is required because perf.config modules are
 * imported very early in app boot — earlier than Statsig data is loaded — so a one-shot
 * `fg()` call at construction time would always read the default (false) value.
 *
 * Implementation note: rather than returning a *new* wrapper object, this helper mutates
 * the real BM3 metric instance by overriding selected methods with bound functions that
 * consult the gate. This preserves the metric's class identity, prototype chain, and
 * private internal state so it remains a fully drop-in substitute everywhere a BM3
 * PageSegmentLoadMetric is used (including in `pageLoadMetric.include[]` / `until[]`
 * arrays where BM3 walks the internal experience graph).
 *
 * Once the gate has fully ramped, this file's body will be replaced with a UFO-only
 * implementation and the BM3 dependency removed entirely.
 */ 
var $gXfti = parcelRequire("gXfti");


var $knAY5 = parcelRequire("knAY5");


var $9wGTI = parcelRequire("9wGTI");


var $3YpC9 = parcelRequire("3YpC9");


var $kw6I9 = parcelRequire("kw6I9");

function $a96d58ddd476e3f0$export$34f706592a2f7442(config) {
    const metric = (0, $kw6I9.createBM3PageSegmentLoadMetricRaw)(config);
    const key = config.key;
    // Capture the original methods before overriding them.
    const realStart = metric.start.bind(metric);
    const realStartFromPageLoad = metric.startFromPageLoad.bind(metric);
    const realStop = metric.stop.bind(metric);
    const realCancel = metric.cancel.bind(metric);
    const realMark = metric.mark.bind(metric);
    const realMarkFMP = metric.markFMP.bind(metric);
    metric.start = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStart(...args);
    };
    metric.startFromPageLoad = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStartFromPageLoad(...args);
    };
    metric.stop = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            const opts = args[0];
            if (opts?.customData) (0, $gXfti.addUFOCustomData)(opts.customData);
            return true;
        }
        return realStop(...args);
    };
    metric.cancel = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            // Note - there's no equivalent for cancel in UFO, so we use the end mark instead.
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            return;
        }
        return realCancel(...args);
    };
    metric.mark = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [name, timestamp] = args;
            (0, $knAY5.addUFOCustomMark)(name, timestamp);
            return;
        }
        return realMark(...args);
    };
    metric.markFMP = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [timestamp] = args;
            (0, $knAY5.addUFOCustomMark)(`fmp:${key}`, timestamp);
            return;
        }
        return realMarkFMP(...args);
    };
    return metric;
}
module.exports["createPageSegmentLoadMetric"] = $a96d58ddd476e3f0$export$34f706592a2f7442;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("kw6I9", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");

const $864083edfead32eb$export$2a2fe1e11b4e0413 = (0, $iDdTC.metrics).pageSegmentLoad;
module.exports["createBM3PageSegmentLoadMetricRaw"] = $864083edfead32eb$export$2a2fe1e11b4e0413;

});

parcelRegister("4nIKB", function(module, exports) {

var $7ZH1D = parcelRequire("7ZH1D");


var $04KxR = parcelRequire("04KxR");

function $330c05f262f9f947$export$c9058316764c140e(refs) {
    return (0, $04KxR.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $7ZH1D.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $330c05f262f9f947$export$c9058316764c140e;

});

parcelRegister("04KxR", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $00e47aba7bcb22e2$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $00e47aba7bcb22e2$export$35a19128eb4acba4;

});

parcelRegister("i9VoI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6UYek = parcelRequire("6UYek");

const $357775eda04c1a81$export$63ba9f3f1b368ae8 = ({ onDataReceived: onDataReceived, skip: skip = false, contentId: contentId, contentType: contentType, delta: delta, subscriberId: subscriberId })=>{
    const dispatch = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setContentId: setContentId, setContentType: setContentType, removeSubscriber: removeSubscriber, addSubscriber: addSubscriber } = dispatch || {};
    (0, $cozmU.useEffect)(()=>{
        if (skip || !addSubscriber || !contentId || !contentType || !removeSubscriber) return;
        setContentId?.(contentId);
        setContentType?.(contentType);
        const uniqueSubscriberId = addSubscriber({
            delta: delta,
            subscriberId: subscriberId,
            onSubscriptionData: onDataReceived
        });
        return ()=>{
            removeSubscriber({
                delta: delta,
                subscriberId: uniqueSubscriberId
            });
        };
    }, [
        skip,
        dispatch,
        contentId,
        contentType,
        setContentId,
        setContentType,
        addSubscriber,
        removeSubscriber,
        subscriberId,
        delta,
        onDataReceived
    ]);
    return null;
};
module.exports["useSubscriptionEvent"] = $357775eda04c1a81$export$63ba9f3f1b368ae8;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name || routeName === (0, $1NBp8.SPACE_SETTINGS_AGENT_CONTEXT).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("aSsfA", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("lfBMY", function(module, exports) {
var $93e6e1e47a4562a8$export$64e79c67b77e1326 = /*#__PURE__*/ function(OperationTypes) {
    OperationTypes["USE"] = "use";
    OperationTypes["LIMITED_USE"] = "limited_use";
    OperationTypes["EXTERNAL_COLLABORATOR_USE"] = "external_collaborator_use";
    OperationTypes["CREATE"] = "create";
    OperationTypes["READ"] = "read";
    OperationTypes["UPDATE"] = "update";
    OperationTypes["DELETE"] = "delete";
    OperationTypes["COPY"] = "copy";
    OperationTypes["MOVE"] = "move";
    OperationTypes["EXPORT"] = "export";
    OperationTypes["ARCHIVE"] = "archive";
    OperationTypes["PURGE"] = "purge";
    OperationTypes["PURGE_VERSION"] = "purge_version";
    OperationTypes["ADMINISTER"] = "administer";
    OperationTypes["RESTORE"] = "restore";
    OperationTypes["CREATE_SPACE"] = "create_space";
    OperationTypes["RESTRICT_CONTENT"] = "restrict_content";
    OperationTypes["CLEAR_PERMISSIONS"] = "clear_permissions";
    return OperationTypes;
}({});
module.exports["OperationTypes"] = $93e6e1e47a4562a8$export$64e79c67b77e1326;

});

parcelRegister("2wo33", function(module, exports) {

var $cFXjQ = parcelRequire("cFXjQ");


var $9Z22p = parcelRequire("9Z22p");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");




var $63cta = parcelRequire("63cta");


var $5rZJf = parcelRequire("5rZJf");

const $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    const permittedOperations = operationCheckResult?.content?.nodes?.[0]?.operations ?? [];
    const targetContentType = !!contentType ? contentType : operationCheckResult?.content?.nodes?.[0]?.type;
    if (!targetContentType) return false;
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === targetContentType);
};
const $fec7e6ab8c349d98$export$9df6fd1dd45ee771 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    // prettier-ignore
    const permittedOperations = operationCheckResult?.space?.operations ?? [];
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === contentType);
};
const $fec7e6ab8c349d98$export$e1260b60fe3f2784 = async ({ contentId: contentId, operation: operation, contentType: contentType })=>{
    const contentOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            query: (0, $63cta.ContentOperationsQuery),
            variables: {
                contentId: contentId,
                status: [
                    'current',
                    'archived',
                    'draft'
                ]
            },
            fetchPolicy: 'cache-first'
        } : {
            query: (0, $63cta.ContentOperationsQuery),
            variables: {
                contentId: contentId
            }
        },
        __callerPackage__: "entity-operations"
    });
    return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: contentOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$bcbdef0ac5f1ac47 = async ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const spaceOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $5rZJf.SpaceOperationsQuery),
        variables: {
            spaceKey: spaceKey
        },
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            fetchPolicy: 'cache-first'
        } : {},
        __callerPackage__: "entity-operations"
    });
    return $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: spaceOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$301dbe403ac05dd5 = ({ contentId: contentId, operation: operation, contentType: contentType, status: status })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $9Z22p.default), {
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            variables: {
                contentId: contentId,
                status: status ?? [
                    'current',
                    'archived',
                    'draft'
                ]
            },
            skip: !contentId,
            fetchPolicy: 'cache-first'
        } : {
            variables: {
                contentId: contentId,
                status: status
            },
            skip: !contentId
        },
        __callerPackage__: "entity-operations"
    });
    if (!contentId) return false;
    if (graphQLResult?.data) return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return undefined;
};
const $fec7e6ab8c349d98$export$1fefcc1c89f32022 = ({ spaceKey: spaceKey, operation: operation, contentType: contentType, skip: skip })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $cFXjQ.default), {
        variables: {
            spaceKey: spaceKey
        },
        skip: skip,
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            fetchPolicy: 'cache-first'
        } : {},
        __callerPackage__: "entity-operations"
    });
    // Only show the publish button if the user has permission to update (edit) this content.
    let canPerformOperation = undefined;
    if (graphQLResult?.data) canPerformOperation = $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return [
        canPerformOperation,
        graphQLResult
    ];
};
module.exports["canPerformSpaceOperation"] = $fec7e6ab8c349d98$export$9df6fd1dd45ee771;
module.exports["useCanPerformContentOperation"] = $fec7e6ab8c349d98$export$301dbe403ac05dd5;
module.exports["useCanPerformSpaceOperation"] = $fec7e6ab8c349d98$export$1fefcc1c89f32022;

});

parcelRegister("cFXjQ", function(module, exports) {
/**
 * @generated SignedSource<<1341e8100a34db255d375a90f5c4a762>>
 * @relayHash 66373ccec9c74286b704fa866e6f85ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b
const $718578d961a6d231$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "66373ccec9c74286b704fa866e6f85ed",
            "id": "1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b",
            "metadata": {},
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersSpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$718578d961a6d231$var$node.hash = "e5daa0845f1390f74a58e4fd57f9defb";
var $718578d961a6d231$export$2e2bcd8739ae039 = $718578d961a6d231$var$node;
module.exports["default"] = $718578d961a6d231$export$2e2bcd8739ae039;

});

parcelRegister("9Z22p", function(module, exports) {
/**
 * @generated SignedSource<<48d9ee7fb5d606ab817066b5f7172f92>>
 * @relayHash 74ad4c4ef681c6629c8477bfc21dc6ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58
const $16467728a654d6f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74ad4c4ef681c6629c8477bfc21dc6ca",
            "id": "e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58",
            "metadata": {},
            "name": "entityOperationsHelpersContentOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$16467728a654d6f6$var$node.hash = "0a581f032f7c1b6232f4634d5c3d1376";
var $16467728a654d6f6$export$2e2bcd8739ae039 = $16467728a654d6f6$var$node;
module.exports["default"] = $16467728a654d6f6$export$2e2bcd8739ae039;

});

parcelRegister("63cta", function(module, exports) {

var $8r0lJ = parcelRequire("8r0lJ");

const $bc89d0f4a052c761$export$a42cd9ccc4f06e9e = (0, $8r0lJ.default);
module.exports["ContentOperationsQuery"] = $bc89d0f4a052c761$export$a42cd9ccc4f06e9e;

});

parcelRegister("8r0lJ", function(module, exports) {
/**
 * @generated SignedSource<<d4c33eb851813f5d8bdf7b8ddf9d7fb7>>
 * @relayHash afd2c148a694798349dbf7c95e9faf5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a
const $9494deed8cae7257$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afd2c148a694798349dbf7c95e9faf5e",
            "id": "e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a",
            "metadata": {},
            "name": "ContentOperationsQuery",
            "operationKind": "query",
            "text": "query ContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$9494deed8cae7257$var$node.hash = "4ac4e53f1dd0ba665b3f48217ce7b74b";
var $9494deed8cae7257$export$2e2bcd8739ae039 = $9494deed8cae7257$var$node;
module.exports["default"] = $9494deed8cae7257$export$2e2bcd8739ae039;

});

parcelRegister("5rZJf", function(module, exports) {

var $3QLqz = parcelRequire("3QLqz");

const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $3QLqz.default);
module.exports["SpaceOperationsQuery"] = $8e7057c5d2ae7999$export$636a01496687d185;

});

parcelRegister("3QLqz", function(module, exports) {
/**
 * @generated SignedSource<<eaa114c9e42c98e4d30da80006b4df1f>>
 * @relayHash 5ff0445d5306228126745d8454e82696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6
const $5b7055a8a77b29df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ff0445d5306228126745d8454e82696",
            "id": "b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6",
            "metadata": {},
            "name": "SpaceOperationsQuery",
            "operationKind": "query",
            "text": "query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$5b7055a8a77b29df$var$node.hash = "5796c3a83a0773d6d932bd63d2fbf511";
var $5b7055a8a77b29df$export$2e2bcd8739ae039 = $5b7055a8a77b29df$var$node;
module.exports["default"] = $5b7055a8a77b29df$export$2e2bcd8739ae039;

});

parcelRegister("7lu50", function(module, exports) {
// old definition from tysy - not a real query being used
const $a928a12ca5fd59f3$export$adaf854818ff0d42 = (queryData)=>{
    return queryData?.entitlements?.externalCollaborator.isEntitled;
};
module.exports["getExternalCollaboratorEntitlementFromQuery"] = $a928a12ca5fd59f3$export$adaf854818ff0d42;

});

parcelRegister("fd6g2", function(module, exports) {
// "confluence.fe.custom.XXX"
const $88f9a74d7687653d$export$3fe4a04f712fdf3b = 'mentions-query';
const $88f9a74d7687653d$export$18a3d3c084ff47d0 = 'profile-card-query';
const $88f9a74d7687653d$export$95463e4d15a0dca9 = 'legacy-extension-loading';
const $88f9a74d7687653d$export$5a66bfdc2ac06329 = 'fabric-publish-page';
const $88f9a74d7687653d$export$96dfe3e664538004 = 'time-to-app-idle';
const $88f9a74d7687653d$export$18a3e97ff841447b = 'share-notif-from-restrictions';
const $88f9a74d7687653d$export$d0eb1faf5fa0dbc7 = 'tc-events-fetch';
const $88f9a74d7687653d$export$ec119fee4dbc7f75 = 'tc-subcals-fetch';
const $88f9a74d7687653d$export$693c7d831f137ed3 = 'tc-jira-projects-fetch';
module.exports["MENTIONS_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$3fe4a04f712fdf3b;
module.exports["PROFILE_CARD_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$18a3d3c084ff47d0;
module.exports["LEGACY_EXTENSION_LOADING_CUSTOM_KEY"] = $88f9a74d7687653d$export$95463e4d15a0dca9;
module.exports["FABRIC_PUBLISH_PAGE_KEY"] = $88f9a74d7687653d$export$5a66bfdc2ac06329;
module.exports["TIME_TO_APP_IDLE_KEY"] = $88f9a74d7687653d$export$96dfe3e664538004;
module.exports["TEAM_CALENDARS_EVENT_FETCH_KEY"] = $88f9a74d7687653d$export$d0eb1faf5fa0dbc7;
module.exports["TEAM_CALENDARS_SUBCALS_FETCH_KEY"] = $88f9a74d7687653d$export$ec119fee4dbc7f75;
module.exports["TEAM_CALENDARS_JIRA_PROJECTS_FETCH_KEY"] = $88f9a74d7687653d$export$693c7d831f137ed3;

});

parcelRegister("lSOAM", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");


var $8RwKN = parcelRequire("8RwKN");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $8RwKN.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const $2a47a9fc48674e91$export$c5aa7fcaede4a84d = (0, $iDdTC.metrics).pageLoad;
const $2a47a9fc48674e91$export$19ba7be4fcf34f3d = (0, $iDdTC.metrics).custom;
const $2a47a9fc48674e91$export$36d7a61d0660e29c = (0, $iDdTC.metrics).interaction;
const $2a47a9fc48674e91$var$concurrent = (0, $iDdTC.metrics).concurrent;
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createPageLoadMetric"] = $2a47a9fc48674e91$export$c5aa7fcaede4a84d;
module.exports["createCustomMetric"] = $2a47a9fc48674e91$export$19ba7be4fcf34f3d;
module.exports["createInteractionMetric"] = $2a47a9fc48674e91$export$36d7a61d0660e29c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("jyPfN", function(module, exports) {

var $foQ4a = parcelRequire("foQ4a");

const $10d1e40b190a4139$export$5a38a817745a0c6f = ()=>{
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    return {
        canViewUserProfile: !isExternalCollaborator
    };
};
module.exports["useViewUserProfile"] = $10d1e40b190a4139$export$5a38a817745a0c6f;

});

parcelRegister("6OL2O", function(module, exports) {
$parcel$export(module.exports, "getNavigateToTeamsApp", () => (parcelRequire("5t3NX")).getNavigateToTeamsApp);

var $5t3NX = parcelRequire("5t3NX");


});

parcelRegister("5t3NX", function(module, exports) {

var $hMCZS = parcelRequire("hMCZS");

const $57c6b51502cb940c$export$cfadab73fb247145 = (orgId, navActionPayload, shouldOpenInSameTab)=>{
    return (0, $hMCZS.navigateToTeamsApp)({
        hostProduct: 'confluence',
        orgId: orgId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["getNavigateToTeamsApp"] = $57c6b51502cb940c$export$cfadab73fb247145;

});

parcelRegister("4qzKl", function(module, exports) {
// TODO: remove once @confluence-classic/confluence-urls is added to next

var $jlIaF = parcelRequire("jlIaF");

const $7b986e69785602e5$export$3b6a64cfeda8b00 = (accountId, src, context = '')=>{
    if (!accountId) return '';
    return `${context}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$5f1a0e9946984804 = async (accountId, src)=>{
    if (!accountId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$cb80ef5511478588 = (teamId, src, context = '')=>{
    if (!teamId) return '';
    return `${context}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$470c1413f7223a06 = async (teamId, src)=>{
    if (!teamId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
// Replacement for the getAttributeNames DOM API since it's not supported by IE
const $7b986e69785602e5$var$getAttributeNames = (element)=>Array.from(element.attributes).map((attribute)=>attribute.name);
// Return only DOM elements that have the data-account-id attribute
const $7b986e69785602e5$var$withAccountId = (element)=>element.getAttribute('data-account-id');
// Returns React props that can be used to recreate a DOM element
const $7b986e69785602e5$var$getReactPropsFromDOMElement = (element)=>{
    const attributeToProp = {
        class: 'className'
    };
    const props = {};
    $7b986e69785602e5$var$getAttributeNames(element).forEach((attribute)=>{
        props[attributeToProp[attribute] || attribute] = element.getAttribute(attribute);
    });
    props.dangerouslySetInnerHTML = {
        __html: element.innerHTML
    };
    return props;
};
function $7b986e69785602e5$export$a98860edfb97e545(userElements) {
    return userElements.filter($7b986e69785602e5$var$withAccountId).map((element)=>{
        const props = $7b986e69785602e5$var$getReactPropsFromDOMElement(element);
        // Set this attribute to stop the old user profile hovers from binding
        props['data-user-hover-bound'] = 'true';
        // Ensure that links go to the same location as the profile card
        props.href = $7b986e69785602e5$export$3b6a64cfeda8b00(props['data-account-id'], null);
        const placeholder = window.document.createElement('span');
        if (!element.parentNode) return {};
        element.parentNode.replaceChild(placeholder, element);
        return {
            props: props,
            placeholder: placeholder
        };
    });
}
module.exports["getAtlassianPeopleProfileUrl"] = $7b986e69785602e5$export$3b6a64cfeda8b00;
module.exports["getAtlassianPeopleProfileUrlAsync"] = $7b986e69785602e5$export$5f1a0e9946984804;
module.exports["getTeamUrl"] = $7b986e69785602e5$export$cb80ef5511478588;
module.exports["replaceUserElementsWithPlaceholders"] = $7b986e69785602e5$export$a98860edfb97e545;

});


//# sourceMappingURL=EditorContentStateComponent.9af352a4.js.map
